/* tslint:disable */
/* eslint-disable */
/**
 * F8A Authentication Service API
 * Reactive authentication service built with Spring WebFlux providing:  ## Documents: - How we auth? [confluence link](https://f8a.atlassian.net/wiki/spaces/PT/pages/209879068/SSD+-+How+we+Auth) - How to use MFA? [confluence link](https://f8a.atlassian.net/wiki/spaces/PT/pages/209846412/SD+MFA+-+OTP+via+email+sms)  ## Features - **User Registration & Login**: Complete user lifecycle management - **Multi-Factor Authentication (MFA)**: TOTP-based 2FA support - **JWT Token Management**: Access and refresh token handling - **Keycloak Integration**: Enterprise identity management - **Profile Management**: User profile updates and management  ## Security - **Bearer Token Authentication**: JWT-based stateless authentication - **OAuth2 Resource Server**: Standards-compliant token validation - **Role-Based Access Control**: Fine-grained permission system  ## Architecture - **Reactive Programming**: Non-blocking I/O with Project Reactor - **Clean Architecture**: Domain-driven design with clear boundaries - **Microservice Ready**: Designed for distributed systems
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dev@f8a.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Configuration } from "./configuration";
import globalAxios, {
  AxiosPromise,
  AxiosInstance,
  AxiosRequestConfig,
} from "axios";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from "./common";
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  RequestArgs,
  BaseAPI,
  RequiredError,
} from "./base";

/**
 *
 * @export
 * @interface AccountInfoDto
 */
export interface AccountInfoDto {
  /**
   *
   * @type {any}
   * @memberof AccountInfoDto
   */
  userId?: any;
  /**
   *
   * @type {any}
   * @memberof AccountInfoDto
   */
  username?: any;
  /**
   *
   * @type {any}
   * @memberof AccountInfoDto
   */
  accountStatus?: any;
  /**
   *
   * @type {any}
   * @memberof AccountInfoDto
   */
  registrationDate?: any;
  /**
   *
   * @type {any}
   * @memberof AccountInfoDto
   */
  registrationChannel?: any;
  /**
   *
   * @type {any}
   * @memberof AccountInfoDto
   */
  lastPasswordChangedAt?: any;
}
/**
 *
 * @export
 * @interface ActorInfo
 */
export interface ActorInfo {
  /**
   *
   * @type {any}
   * @memberof ActorInfo
   */
  userId?: any;
  /**
   *
   * @type {any}
   * @memberof ActorInfo
   */
  username?: any;
  /**
   *
   * @type {any}
   * @memberof ActorInfo
   */
  fullName?: any;
}
/**
 *
 * @export
 * @interface ApiResponseMapStringObject
 */
export interface ApiResponseMapStringObject {
  /**
   *
   * @type {any}
   * @memberof ApiResponseMapStringObject
   */
  code?: any;
  /**
   *
   * @type {any}
   * @memberof ApiResponseMapStringObject
   */
  message?: any;
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof ApiResponseMapStringObject
   */
  data?: { [key: string]: any };
  /**
   *
   * @type {any}
   * @memberof ApiResponseMapStringObject
   */
  timestamp?: any;
  /**
   *
   * @type {any}
   * @memberof ApiResponseMapStringObject
   */
  traceId?: any;
  /**
   *
   * @type {any}
   * @memberof ApiResponseMapStringObject
   */
  success?: any;
}
/**
 *
 * @export
 * @interface ApiResponseMapStringString
 */
export interface ApiResponseMapStringString {
  /**
   *
   * @type {any}
   * @memberof ApiResponseMapStringString
   */
  code?: any;
  /**
   *
   * @type {any}
   * @memberof ApiResponseMapStringString
   */
  message?: any;
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof ApiResponseMapStringString
   */
  data?: { [key: string]: any };
  /**
   *
   * @type {any}
   * @memberof ApiResponseMapStringString
   */
  timestamp?: any;
  /**
   *
   * @type {any}
   * @memberof ApiResponseMapStringString
   */
  traceId?: any;
  /**
   *
   * @type {any}
   * @memberof ApiResponseMapStringString
   */
  success?: any;
}
/**
 *
 * @export
 * @interface ApprovalPendingCount
 */
export interface ApprovalPendingCount {
  /**
   *
   * @type {any}
   * @memberof ApprovalPendingCount
   */
  count?: any;
}
/**
 *
 * @export
 * @interface ApprovalRequestDetails
 */
export interface ApprovalRequestDetails {
  /**
   *
   * @type {any}
   * @memberof ApprovalRequestDetails
   */
  id?: any;
  /**
   *
   * @type {any}
   * @memberof ApprovalRequestDetails
   */
  requestType?: ApprovalRequestDetailsRequestTypeEnum;
  /**
   *
   * @type {any}
   * @memberof ApprovalRequestDetails
   */
  description?: any;
  /**
   *
   * @type {any}
   * @memberof ApprovalRequestDetails
   */
  status?: ApprovalRequestDetailsStatusEnum;
  /**
   *
   * @type {any}
   * @memberof ApprovalRequestDetails
   */
  createdAt?: any;
  /**
   *
   * @type {any}
   * @memberof ApprovalRequestDetails
   */
  processedAt?: any;
  /**
   *
   * @type {ActorInfo}
   * @memberof ApprovalRequestDetails
   */
  maker?: ActorInfo;
  /**
   *
   * @type {ActorInfo}
   * @memberof ApprovalRequestDetails
   */
  checker?: ActorInfo;
  /**
   *
   * @type {any}
   * @memberof ApprovalRequestDetails
   */
  checkerComment?: any;
  /**
   *
   * @type {any}
   * @memberof ApprovalRequestDetails
   */
  requestData?: any;
  /**
   *
   * @type {any}
   * @memberof ApprovalRequestDetails
   */
  oldData?: any;
}

export const ApprovalRequestDetailsRequestTypeEnum = {
  CreateUser: "CREATE_USER",
  UpdateUser: "UPDATE_USER",
  LockUser: "LOCK_USER",
  UnlockUser: "UNLOCK_USER",
  CreateRole: "CREATE_ROLE",
  UpdateRole: "UPDATE_ROLE",
  DeleteRole: "DELETE_ROLE",
} as const;

export type ApprovalRequestDetailsRequestTypeEnum =
  (typeof ApprovalRequestDetailsRequestTypeEnum)[keyof typeof ApprovalRequestDetailsRequestTypeEnum];
export const ApprovalRequestDetailsStatusEnum = {
  Pending: "PENDING",
  Approved: "APPROVED",
  Returned: "RETURNED",
  Closed: "CLOSED",
} as const;

export type ApprovalRequestDetailsStatusEnum =
  (typeof ApprovalRequestDetailsStatusEnum)[keyof typeof ApprovalRequestDetailsStatusEnum];

/**
 *
 * @export
 * @interface ApprovalRequestLite
 */
export interface ApprovalRequestLite {
  /**
   *
   * @type {any}
   * @memberof ApprovalRequestLite
   */
  id?: any;
  /**
   *
   * @type {any}
   * @memberof ApprovalRequestLite
   */
  requestType?: ApprovalRequestLiteRequestTypeEnum;
  /**
   *
   * @type {any}
   * @memberof ApprovalRequestLite
   */
  status?: ApprovalRequestLiteStatusEnum;
  /**
   *
   * @type {any}
   * @memberof ApprovalRequestLite
   */
  createdAt?: any;
  /**
   *
   * @type {any}
   * @memberof ApprovalRequestLite
   */
  updatedAt?: any;
  /**
   *
   * @type {ActorInfo}
   * @memberof ApprovalRequestLite
   */
  maker?: ActorInfo;
  /**
   *
   * @type {ActorInfo}
   * @memberof ApprovalRequestLite
   */
  checker?: ActorInfo;
}

export const ApprovalRequestLiteRequestTypeEnum = {
  CreateUser: "CREATE_USER",
  UpdateUser: "UPDATE_USER",
  LockUser: "LOCK_USER",
  UnlockUser: "UNLOCK_USER",
  CreateRole: "CREATE_ROLE",
  UpdateRole: "UPDATE_ROLE",
  DeleteRole: "DELETE_ROLE",
} as const;

export type ApprovalRequestLiteRequestTypeEnum =
  (typeof ApprovalRequestLiteRequestTypeEnum)[keyof typeof ApprovalRequestLiteRequestTypeEnum];
export const ApprovalRequestLiteStatusEnum = {
  Pending: "PENDING",
  Approved: "APPROVED",
  Returned: "RETURNED",
  Closed: "CLOSED",
} as const;

export type ApprovalRequestLiteStatusEnum =
  (typeof ApprovalRequestLiteStatusEnum)[keyof typeof ApprovalRequestLiteStatusEnum];

/**
 *
 * @export
 * @interface ApproveRequest
 */
export interface ApproveRequest {
  /**
   *
   * @type {any}
   * @memberof ApproveRequest
   */
  comment?: any;
}
/**
 *
 * @export
 * @interface AuditInfo
 */
export interface AuditInfo {
  /**
   *
   * @type {any}
   * @memberof AuditInfo
   */
  createdById?: any;
  /**
   *
   * @type {any}
   * @memberof AuditInfo
   */
  createdBy?: any;
  /**
   *
   * @type {any}
   * @memberof AuditInfo
   */
  createdByEmail?: any;
  /**
   *
   * @type {any}
   * @memberof AuditInfo
   */
  createdAt?: any;
  /**
   *
   * @type {any}
   * @memberof AuditInfo
   */
  updatedById?: any;
  /**
   *
   * @type {any}
   * @memberof AuditInfo
   */
  updatedBy?: any;
  /**
   *
   * @type {any}
   * @memberof AuditInfo
   */
  updatedByEmail?: any;
  /**
   *
   * @type {any}
   * @memberof AuditInfo
   */
  updatedAt?: any;
  /**
   *
   * @type {any}
   * @memberof AuditInfo
   */
  approvedById?: any;
  /**
   *
   * @type {any}
   * @memberof AuditInfo
   */
  approvedBy?: any;
  /**
   *
   * @type {any}
   * @memberof AuditInfo
   */
  approvedByEmail?: any;
  /**
   *
   * @type {any}
   * @memberof AuditInfo
   */
  approvedAt?: any;
}
/**
 *
 * @export
 * @interface AuditLogDetails
 */
export interface AuditLogDetails {
  /**
   *
   * @type {any}
   * @memberof AuditLogDetails
   */
  id?: any;
  /**
   *
   * @type {any}
   * @memberof AuditLogDetails
   */
  timestamp?: any;
  /**
   *
   * @type {any}
   * @memberof AuditLogDetails
   */
  intent?: any;
  /**
   *
   * @type {any}
   * @memberof AuditLogDetails
   */
  action?: any;
  /**
   *
   * @type {any}
   * @memberof AuditLogDetails
   */
  entityType?: any;
  /**
   *
   * @type {any}
   * @memberof AuditLogDetails
   */
  entityId?: any;
  /**
   *
   * @type {any}
   * @memberof AuditLogDetails
   */
  description?: any;
  /**
   *
   * @type {ActorInfo}
   * @memberof AuditLogDetails
   */
  actor?: ActorInfo;
  /**
   *
   * @type {any}
   * @memberof AuditLogDetails
   */
  comment?: any;
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof AuditLogDetails
   */
  oldValues?: { [key: string]: any };
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof AuditLogDetails
   */
  newValues?: { [key: string]: any };
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof AuditLogDetails
   */
  diffValues?: { [key: string]: any };
  /**
   *
   * @type {any}
   * @memberof AuditLogDetails
   */
  ipAddress?: any;
  /**
   *
   * @type {any}
   * @memberof AuditLogDetails
   */
  userAgent?: any;
  /**
   *
   * @type {any}
   * @memberof AuditLogDetails
   */
  requestId?: any;
  /**
   *
   * @type {any}
   * @memberof AuditLogDetails
   */
  traceId?: any;
  /**
   *
   * @type {any}
   * @memberof AuditLogDetails
   */
  requestMethod?: any;
  /**
   *
   * @type {any}
   * @memberof AuditLogDetails
   */
  requestUri?: any;
}
/**
 *
 * @export
 * @interface AuditLogExportFilter
 */
export interface AuditLogExportFilter {
  /**
   *
   * @type {any}
   * @memberof AuditLogExportFilter
   */
  actions?: any;
  /**
   *
   * @type {any}
   * @memberof AuditLogExportFilter
   */
  entityTypes?: any;
  /**
   *
   * @type {any}
   * @memberof AuditLogExportFilter
   */
  actorId?: any;
  /**
   *
   * @type {any}
   * @memberof AuditLogExportFilter
   */
  dateFrom?: any;
  /**
   *
   * @type {any}
   * @memberof AuditLogExportFilter
   */
  dateTo?: any;
  /**
   *
   * @type {any}
   * @memberof AuditLogExportFilter
   */
  actionCodes?: any;
  /**
   *
   * @type {any}
   * @memberof AuditLogExportFilter
   */
  entityTypeClassNames?: any;
}
/**
 *
 * @export
 * @interface AuditLogExportRequest
 */
export interface AuditLogExportRequest {
  /**
   *
   * @type {any}
   * @memberof AuditLogExportRequest
   */
  format?: AuditLogExportRequestFormatEnum;
  /**
   *
   * @type {any}
   * @memberof AuditLogExportRequest
   */
  scope?: AuditLogExportRequestScopeEnum;
  /**
   *
   * @type {AuditLogExportFilter}
   * @memberof AuditLogExportRequest
   */
  filter?: AuditLogExportFilter;
}

export const AuditLogExportRequestFormatEnum = {
  Excel: "EXCEL",
  Pdf: "PDF",
} as const;

export type AuditLogExportRequestFormatEnum =
  (typeof AuditLogExportRequestFormatEnum)[keyof typeof AuditLogExportRequestFormatEnum];
export const AuditLogExportRequestScopeEnum = {
  All: "ALL",
  Filtered: "FILTERED",
} as const;

export type AuditLogExportRequestScopeEnum =
  (typeof AuditLogExportRequestScopeEnum)[keyof typeof AuditLogExportRequestScopeEnum];

/**
 *
 * @export
 * @interface AuditLogLite
 */
export interface AuditLogLite {
  /**
   *
   * @type {any}
   * @memberof AuditLogLite
   */
  id?: any;
  /**
   *
   * @type {any}
   * @memberof AuditLogLite
   */
  timestamp?: any;
  /**
   *
   * @type {any}
   * @memberof AuditLogLite
   */
  intent?: any;
  /**
   *
   * @type {any}
   * @memberof AuditLogLite
   */
  action?: any;
  /**
   *
   * @type {any}
   * @memberof AuditLogLite
   */
  entityType?: any;
  /**
   *
   * @type {any}
   * @memberof AuditLogLite
   */
  description?: any;
  /**
   *
   * @type {ActorInfo}
   * @memberof AuditLogLite
   */
  actor?: ActorInfo;
}
/**
 *
 * @export
 * @interface AuthOverviewDto
 */
export interface AuthOverviewDto {
  /**
   *
   * @type {AccountInfoDto}
   * @memberof AuthOverviewDto
   */
  accountInfo?: AccountInfoDto;
  /**
   *
   * @type {TwoFactorAuthDto}
   * @memberof AuthOverviewDto
   */
  twoFactorAuth?: TwoFactorAuthDto;
}
/**
 *
 * @export
 * @interface AuthResourceLite
 */
export interface AuthResourceLite {
  /**
   *
   * @type {any}
   * @memberof AuthResourceLite
   */
  id?: any;
  /**
   *
   * @type {any}
   * @memberof AuthResourceLite
   */
  code?: any;
  /**
   *
   * @type {any}
   * @memberof AuthResourceLite
   */
  name?: any;
  /**
   *
   * @type {any}
   * @memberof AuthResourceLite
   */
  description?: any;
  /**
   *
   * @type {any}
   * @memberof AuthResourceLite
   */
  features?: any;
}
/**
 *
 * @export
 * @interface AuthRoleGroupDetails
 */
export interface AuthRoleGroupDetails {
  /**
   *
   * @type {any}
   * @memberof AuthRoleGroupDetails
   */
  id?: any;
  /**
   *
   * @type {any}
   * @memberof AuthRoleGroupDetails
   */
  code?: any;
  /**
   *
   * @type {any}
   * @memberof AuthRoleGroupDetails
   */
  name?: any;
  /**
   *
   * @type {any}
   * @memberof AuthRoleGroupDetails
   */
  description?: any;
  /**
   *
   * @type {any}
   * @memberof AuthRoleGroupDetails
   */
  refResourceId?: any;
  /**
   *
   * @type {any}
   * @memberof AuthRoleGroupDetails
   */
  refResourceCode?: any;
  /**
   *
   * @type {any}
   * @memberof AuthRoleGroupDetails
   */
  refResourceName?: any;
  /**
   *
   * @type {any}
   * @memberof AuthRoleGroupDetails
   */
  roleType?: AuthRoleGroupDetailsRoleTypeEnum;
  /**
   *
   * @type {any}
   * @memberof AuthRoleGroupDetails
   */
  status?: AuthRoleGroupDetailsStatusEnum;
  /**
   *
   * @type {any}
   * @memberof AuthRoleGroupDetails
   */
  roleCodes?: any;
  /**
   *
   * @type {any}
   * @memberof AuthRoleGroupDetails
   */
  assignedUserCount?: any;
  /**
   *
   * @type {AuditInfo}
   * @memberof AuthRoleGroupDetails
   */
  auditInfo?: AuditInfo;
}

export const AuthRoleGroupDetailsRoleTypeEnum = {
  Super: "SUPER",
  Maker: "MAKER",
  Checker: "CHECKER",
  Viewer: "VIEWER",
} as const;

export type AuthRoleGroupDetailsRoleTypeEnum =
  (typeof AuthRoleGroupDetailsRoleTypeEnum)[keyof typeof AuthRoleGroupDetailsRoleTypeEnum];
export const AuthRoleGroupDetailsStatusEnum = {
  Inactive: "INACTIVE",
  Active: "ACTIVE",
  Deleted: "DELETED",
} as const;

export type AuthRoleGroupDetailsStatusEnum =
  (typeof AuthRoleGroupDetailsStatusEnum)[keyof typeof AuthRoleGroupDetailsStatusEnum];

/**
 *
 * @export
 * @interface AuthRoleGroupLite
 */
export interface AuthRoleGroupLite {
  /**
   *
   * @type {any}
   * @memberof AuthRoleGroupLite
   */
  id?: any;
  /**
   *
   * @type {any}
   * @memberof AuthRoleGroupLite
   */
  code?: any;
  /**
   *
   * @type {any}
   * @memberof AuthRoleGroupLite
   */
  name?: any;
  /**
   *
   * @type {any}
   * @memberof AuthRoleGroupLite
   */
  description?: any;
  /**
   *
   * @type {any}
   * @memberof AuthRoleGroupLite
   */
  roleType?: AuthRoleGroupLiteRoleTypeEnum;
  /**
   *
   * @type {any}
   * @memberof AuthRoleGroupLite
   */
  status?: AuthRoleGroupLiteStatusEnum;
  /**
   *
   * @type {any}
   * @memberof AuthRoleGroupLite
   */
  refResourceId?: any;
  /**
   *
   * @type {any}
   * @memberof AuthRoleGroupLite
   */
  refResourceCode?: any;
  /**
   *
   * @type {any}
   * @memberof AuthRoleGroupLite
   */
  refResourceName?: any;
}

export const AuthRoleGroupLiteRoleTypeEnum = {
  Super: "SUPER",
  Maker: "MAKER",
  Checker: "CHECKER",
  Viewer: "VIEWER",
} as const;

export type AuthRoleGroupLiteRoleTypeEnum =
  (typeof AuthRoleGroupLiteRoleTypeEnum)[keyof typeof AuthRoleGroupLiteRoleTypeEnum];
export const AuthRoleGroupLiteStatusEnum = {
  Inactive: "INACTIVE",
  Active: "ACTIVE",
  Deleted: "DELETED",
} as const;

export type AuthRoleGroupLiteStatusEnum =
  (typeof AuthRoleGroupLiteStatusEnum)[keyof typeof AuthRoleGroupLiteStatusEnum];

/**
 *
 * @export
 * @interface AuthRoleLite
 */
export interface AuthRoleLite {
  /**
   *
   * @type {any}
   * @memberof AuthRoleLite
   */
  id?: any;
  /**
   *
   * @type {any}
   * @memberof AuthRoleLite
   */
  code?: any;
}
/**
 *
 * @export
 * @interface AvatarUploadResponse
 */
export interface AvatarUploadResponse {
  /**
   *
   * @type {any}
   * @memberof AvatarUploadResponse
   */
  avatarUrl?: any;
}
/**
 *
 * @export
 * @interface BackofficeAuthConfirmRequest
 */
export interface BackofficeAuthConfirmRequest {
  /**
   *
   * @type {any}
   * @memberof BackofficeAuthConfirmRequest
   */
  username: any;
  /**
   *
   * @type {any}
   * @memberof BackofficeAuthConfirmRequest
   */
  otp: any;
}
/**
 *
 * @export
 * @interface BackofficeAuthRequest
 */
export interface BackofficeAuthRequest {
  /**
   *
   * @type {any}
   * @memberof BackofficeAuthRequest
   */
  username: any;
  /**
   *
   * @type {any}
   * @memberof BackofficeAuthRequest
   */
  password: any;
  /**
   *
   * @type {any}
   * @memberof BackofficeAuthRequest
   */
  captchaToken?: any;
}
/**
 *
 * @export
 * @interface BackofficeAuthResendOtpRequest
 */
export interface BackofficeAuthResendOtpRequest {
  /**
   *
   * @type {any}
   * @memberof BackofficeAuthResendOtpRequest
   */
  username: any;
}
/**
 *
 * @export
 * @interface BackofficeAuthResponse
 */
export interface BackofficeAuthResponse {
  /**
   *
   * @type {any}
   * @memberof BackofficeAuthResponse
   */
  action?: BackofficeAuthResponseActionEnum;
  /**
   *
   * @type {any}
   * @memberof BackofficeAuthResponse
   */
  accessToken?: any;
  /**
   *
   * @type {any}
   * @memberof BackofficeAuthResponse
   */
  refreshToken?: any;
  /**
   *
   * @type {UserInfo}
   * @memberof BackofficeAuthResponse
   */
  userInfo?: UserInfo;
}

export const BackofficeAuthResponseActionEnum = {
  TokenCreated: "TOKEN_CREATED",
  OtpSentViaSms: "OTP_SENT_VIA_SMS",
  OtpSentViaEmail: "OTP_SENT_VIA_EMAIL",
  RequireChangePassword: "REQUIRE_CHANGE_PASSWORD",
  PasswordExpired: "PASSWORD_EXPIRED",
} as const;

export type BackofficeAuthResponseActionEnum =
  (typeof BackofficeAuthResponseActionEnum)[keyof typeof BackofficeAuthResponseActionEnum];

/**
 *
 * @export
 * @interface BoAdminResetPasswordRequest
 */
export interface BoAdminResetPasswordRequest {
  /**
   *
   * @type {any}
   * @memberof BoAdminResetPasswordRequest
   */
  password: any;
}
/**
 *
 * @export
 * @interface BoChangePasswordRequest
 */
export interface BoChangePasswordRequest {
  /**
   *
   * @type {any}
   * @memberof BoChangePasswordRequest
   */
  currentPassword: any;
  /**
   *
   * @type {any}
   * @memberof BoChangePasswordRequest
   */
  newPassword: any;
  /**
   *
   * @type {any}
   * @memberof BoChangePasswordRequest
   */
  confirmPassword: any;
}
/**
 *
 * @export
 * @interface BoChangePasswordResponse
 */
export interface BoChangePasswordResponse {
  /**
   *
   * @type {any}
   * @memberof BoChangePasswordResponse
   */
  action?: BoChangePasswordResponseActionEnum;
  /**
   *
   * @type {any}
   * @memberof BoChangePasswordResponse
   */
  remainSendAttempts?: any;
}

export const BoChangePasswordResponseActionEnum = {
  TokenCreated: "TOKEN_CREATED",
  OtpSentViaSms: "OTP_SENT_VIA_SMS",
  OtpSentViaEmail: "OTP_SENT_VIA_EMAIL",
  RequireChangePassword: "REQUIRE_CHANGE_PASSWORD",
  PasswordExpired: "PASSWORD_EXPIRED",
} as const;

export type BoChangePasswordResponseActionEnum =
  (typeof BoChangePasswordResponseActionEnum)[keyof typeof BoChangePasswordResponseActionEnum];

/**
 *
 * @export
 * @interface BoChangePasswordVerifyOtpRequest
 */
export interface BoChangePasswordVerifyOtpRequest {
  /**
   *
   * @type {any}
   * @memberof BoChangePasswordVerifyOtpRequest
   */
  otpCode: any;
}
/**
 *
 * @export
 * @interface BoCreateUserRequest
 */
export interface BoCreateUserRequest {
  /**
   *
   * @type {any}
   * @memberof BoCreateUserRequest
   */
  email: any;
  /**
   *
   * @type {any}
   * @memberof BoCreateUserRequest
   */
  firstName: any;
  /**
   *
   * @type {any}
   * @memberof BoCreateUserRequest
   */
  lastName: any;
  /**
   *
   * @type {any}
   * @memberof BoCreateUserRequest
   */
  phoneNumber?: any;
  /**
   *
   * @type {any}
   * @memberof BoCreateUserRequest
   */
  description?: any;
  /**
   *
   * @type {any}
   * @memberof BoCreateUserRequest
   */
  password: any;
  /**
   *
   * @type {any}
   * @memberof BoCreateUserRequest
   */
  adminType?: BoCreateUserRequestAdminTypeEnum;
  /**
   *
   * @type {any}
   * @memberof BoCreateUserRequest
   */
  groupIds?: any;
}

export const BoCreateUserRequestAdminTypeEnum = {
  Internal: "INTERNAL",
  Partner: "PARTNER",
} as const;

export type BoCreateUserRequestAdminTypeEnum =
  (typeof BoCreateUserRequestAdminTypeEnum)[keyof typeof BoCreateUserRequestAdminTypeEnum];

/**
 *
 * @export
 * @interface BoForceChangePasswordRequest
 */
export interface BoForceChangePasswordRequest {
  /**
   *
   * @type {any}
   * @memberof BoForceChangePasswordRequest
   */
  accessToken: any;
  /**
   *
   * @type {any}
   * @memberof BoForceChangePasswordRequest
   */
  newPassword: any;
  /**
   *
   * @type {any}
   * @memberof BoForceChangePasswordRequest
   */
  confirmPassword: any;
}
/**
 *
 * @export
 * @interface BoForgotPasswordRequest
 */
export interface BoForgotPasswordRequest {
  /**
   *
   * @type {any}
   * @memberof BoForgotPasswordRequest
   */
  username: any;
}
/**
 *
 * @export
 * @interface BoForgotPasswordResponse
 */
export interface BoForgotPasswordResponse {
  /**
   *
   * @type {any}
   * @memberof BoForgotPasswordResponse
   */
  action?: BoForgotPasswordResponseActionEnum;
  /**
   *
   * @type {any}
   * @memberof BoForgotPasswordResponse
   */
  remainSendAttempts?: any;
  /**
   *
   * @type {any}
   * @memberof BoForgotPasswordResponse
   */
  sessionId?: any;
}

export const BoForgotPasswordResponseActionEnum = {
  TokenCreated: "TOKEN_CREATED",
  OtpSentViaSms: "OTP_SENT_VIA_SMS",
  OtpSentViaEmail: "OTP_SENT_VIA_EMAIL",
  RequireChangePassword: "REQUIRE_CHANGE_PASSWORD",
  PasswordExpired: "PASSWORD_EXPIRED",
} as const;

export type BoForgotPasswordResponseActionEnum =
  (typeof BoForgotPasswordResponseActionEnum)[keyof typeof BoForgotPasswordResponseActionEnum];

/**
 *
 * @export
 * @interface BoMyProfileResponse
 */
export interface BoMyProfileResponse {
  /**
   *
   * @type {any}
   * @memberof BoMyProfileResponse
   */
  id?: any;
  /**
   *
   * @type {any}
   * @memberof BoMyProfileResponse
   */
  username?: any;
  /**
   *
   * @type {any}
   * @memberof BoMyProfileResponse
   */
  email?: any;
  /**
   *
   * @type {any}
   * @memberof BoMyProfileResponse
   */
  firstName?: any;
  /**
   *
   * @type {any}
   * @memberof BoMyProfileResponse
   */
  lastName?: any;
  /**
   *
   * @type {any}
   * @memberof BoMyProfileResponse
   */
  phoneNumber?: any;
  /**
   *
   * @type {any}
   * @memberof BoMyProfileResponse
   */
  status?: BoMyProfileResponseStatusEnum;
  /**
   *
   * @type {any}
   * @memberof BoMyProfileResponse
   */
  adminType?: BoMyProfileResponseAdminTypeEnum;
  /**
   *
   * @type {any}
   * @memberof BoMyProfileResponse
   */
  avatarUrl?: any;
  /**
   *
   * @type {any}
   * @memberof BoMyProfileResponse
   */
  roleGroups?: any;
}

export const BoMyProfileResponseStatusEnum = {
  Inactive: "INACTIVE",
  Active: "ACTIVE",
  Locked: "LOCKED",
} as const;

export type BoMyProfileResponseStatusEnum =
  (typeof BoMyProfileResponseStatusEnum)[keyof typeof BoMyProfileResponseStatusEnum];
export const BoMyProfileResponseAdminTypeEnum = {
  Internal: "INTERNAL",
  Partner: "PARTNER",
} as const;

export type BoMyProfileResponseAdminTypeEnum =
  (typeof BoMyProfileResponseAdminTypeEnum)[keyof typeof BoMyProfileResponseAdminTypeEnum];

/**
 *
 * @export
 * @interface BoResendOtpRequest
 */
export interface BoResendOtpRequest {
  /**
   *
   * @type {any}
   * @memberof BoResendOtpRequest
   */
  sessionId: any;
  /**
   *
   * @type {any}
   * @memberof BoResendOtpRequest
   */
  username: any;
}
/**
 *
 * @export
 * @interface BoSetNewPasswordRequest
 */
export interface BoSetNewPasswordRequest {
  /**
   *
   * @type {any}
   * @memberof BoSetNewPasswordRequest
   */
  username: any;
  /**
   *
   * @type {any}
   * @memberof BoSetNewPasswordRequest
   */
  verifiedOtpCredential: any;
  /**
   *
   * @type {any}
   * @memberof BoSetNewPasswordRequest
   */
  newPassword: any;
}
/**
 *
 * @export
 * @interface BoUpdateUserRequest
 */
export interface BoUpdateUserRequest {
  /**
   *
   * @type {any}
   * @memberof BoUpdateUserRequest
   */
  id: any;
  /**
   *
   * @type {any}
   * @memberof BoUpdateUserRequest
   */
  firstName: any;
  /**
   *
   * @type {any}
   * @memberof BoUpdateUserRequest
   */
  lastName: any;
  /**
   *
   * @type {any}
   * @memberof BoUpdateUserRequest
   */
  email: any;
  /**
   *
   * @type {any}
   * @memberof BoUpdateUserRequest
   */
  phoneNumber?: any;
  /**
   *
   * @type {any}
   * @memberof BoUpdateUserRequest
   */
  groupIds?: any;
}
/**
 *
 * @export
 * @interface BoUserInfo
 */
export interface BoUserInfo {
  /**
   *
   * @type {any}
   * @memberof BoUserInfo
   */
  id?: any;
  /**
   *
   * @type {any}
   * @memberof BoUserInfo
   */
  username?: any;
  /**
   *
   * @type {any}
   * @memberof BoUserInfo
   */
  email?: any;
  /**
   *
   * @type {any}
   * @memberof BoUserInfo
   */
  firstName?: any;
  /**
   *
   * @type {any}
   * @memberof BoUserInfo
   */
  lastName?: any;
  /**
   *
   * @type {any}
   * @memberof BoUserInfo
   */
  phoneNumber?: any;
  /**
   *
   * @type {any}
   * @memberof BoUserInfo
   */
  status?: BoUserInfoStatusEnum;
  /**
   *
   * @type {any}
   * @memberof BoUserInfo
   */
  adminType?: BoUserInfoAdminTypeEnum;
  /**
   *
   * @type {any}
   * @memberof BoUserInfo
   */
  avatarUrl?: any;
  /**
   *
   * @type {any}
   * @memberof BoUserInfo
   */
  createdAt?: any;
  /**
   *
   * @type {any}
   * @memberof BoUserInfo
   */
  lastLoginAt?: any;
  /**
   *
   * @type {AuditInfo}
   * @memberof BoUserInfo
   */
  auditInfo?: AuditInfo;
}

export const BoUserInfoStatusEnum = {
  Inactive: "INACTIVE",
  Active: "ACTIVE",
  Locked: "LOCKED",
} as const;

export type BoUserInfoStatusEnum =
  (typeof BoUserInfoStatusEnum)[keyof typeof BoUserInfoStatusEnum];
export const BoUserInfoAdminTypeEnum = {
  Internal: "INTERNAL",
  Partner: "PARTNER",
} as const;

export type BoUserInfoAdminTypeEnum =
  (typeof BoUserInfoAdminTypeEnum)[keyof typeof BoUserInfoAdminTypeEnum];

/**
 *
 * @export
 * @interface BoUserLite
 */
export interface BoUserLite {
  /**
   *
   * @type {any}
   * @memberof BoUserLite
   */
  id?: any;
  /**
   *
   * @type {any}
   * @memberof BoUserLite
   */
  username?: any;
  /**
   *
   * @type {any}
   * @memberof BoUserLite
   */
  email?: any;
  /**
   *
   * @type {any}
   * @memberof BoUserLite
   */
  firstName?: any;
  /**
   *
   * @type {any}
   * @memberof BoUserLite
   */
  lastName?: any;
  /**
   *
   * @type {any}
   * @memberof BoUserLite
   */
  phoneNumber?: any;
  /**
   *
   * @type {any}
   * @memberof BoUserLite
   */
  createdAt?: any;
  /**
   *
   * @type {any}
   * @memberof BoUserLite
   */
  status?: BoUserLiteStatusEnum;
  /**
   *
   * @type {any}
   * @memberof BoUserLite
   */
  adminType?: BoUserLiteAdminTypeEnum;
  /**
   *
   * @type {any}
   * @memberof BoUserLite
   */
  avatarUrl?: any;
  /**
   *
   * @type {any}
   * @memberof BoUserLite
   */
  resources?: any;
}

export const BoUserLiteStatusEnum = {
  Inactive: "INACTIVE",
  Active: "ACTIVE",
  Locked: "LOCKED",
} as const;

export type BoUserLiteStatusEnum =
  (typeof BoUserLiteStatusEnum)[keyof typeof BoUserLiteStatusEnum];
export const BoUserLiteAdminTypeEnum = {
  Internal: "INTERNAL",
  Partner: "PARTNER",
} as const;

export type BoUserLiteAdminTypeEnum =
  (typeof BoUserLiteAdminTypeEnum)[keyof typeof BoUserLiteAdminTypeEnum];

/**
 *
 * @export
 * @interface BoUserRoleGroups
 */
export interface BoUserRoleGroups {
  /**
   *
   * @type {any}
   * @memberof BoUserRoleGroups
   */
  userId?: any;
  /**
   *
   * @type {any}
   * @memberof BoUserRoleGroups
   */
  roleGroups?: any;
}
/**
 *
 * @export
 * @interface BoUserSecurity
 */
export interface BoUserSecurity {
  /**
   *
   * @type {any}
   * @memberof BoUserSecurity
   */
  userId?: any;
  /**
   *
   * @type {any}
   * @memberof BoUserSecurity
   */
  lastLoginIp?: any;
  /**
   *
   * @type {any}
   * @memberof BoUserSecurity
   */
  lastLoginAt?: any;
  /**
   *
   * @type {any}
   * @memberof BoUserSecurity
   */
  failedLoginAttempts?: any;
  /**
   *
   * @type {any}
   * @memberof BoUserSecurity
   */
  lastPasswordChangeAt?: any;
  /**
   *
   * @type {any}
   * @memberof BoUserSecurity
   */
  online?: any;
}
/**
 *
 * @export
 * @interface BoVerifyOtpRequest
 */
export interface BoVerifyOtpRequest {
  /**
   *
   * @type {any}
   * @memberof BoVerifyOtpRequest
   */
  sessionId: any;
  /**
   *
   * @type {any}
   * @memberof BoVerifyOtpRequest
   */
  username: any;
  /**
   *
   * @type {any}
   * @memberof BoVerifyOtpRequest
   */
  otp: any;
}
/**
 *
 * @export
 * @interface BoVerifyOtpResponse
 */
export interface BoVerifyOtpResponse {
  /**
   *
   * @type {any}
   * @memberof BoVerifyOtpResponse
   */
  verifiedOtpCredential?: any;
}
/**
 *
 * @export
 * @interface CancelMfaSessionRequest
 */
export interface CancelMfaSessionRequest {
  /**
   *
   * @type {any}
   * @memberof CancelMfaSessionRequest
   */
  sessionId?: any;
  /**
   *
   * @type {any}
   * @memberof CancelMfaSessionRequest
   */
  reason?: any;
}
/**
 *
 * @export
 * @interface ChangePasswordRequest
 */
export interface ChangePasswordRequest {
  /**
   *
   * @type {any}
   * @memberof ChangePasswordRequest
   */
  newPassword: any;
  /**
   *
   * @type {any}
   * @memberof ChangePasswordRequest
   */
  currentPassword: any;
  /**
   *
   * @type {any}
   * @memberof ChangePasswordRequest
   */
  confirmPassword: any;
  /**
   *
   * @type {any}
   * @memberof ChangePasswordRequest
   */
  logoutAllSessions?: any;
}
/**
 *
 * @export
 * @interface ChangePasswordResponse
 */
export interface ChangePasswordResponse {
  /**
   *
   * @type {any}
   * @memberof ChangePasswordResponse
   */
  success?: any;
}
/**
 *
 * @export
 * @interface CloseRequest
 */
export interface CloseRequest {
  /**
   *
   * @type {any}
   * @memberof CloseRequest
   */
  reason: any;
}
/**
 *
 * @export
 * @interface CommonResponse
 */
export interface CommonResponse {
  /**
   *
   * @type {any}
   * @memberof CommonResponse
   */
  success?: any;
}
/**
 *
 * @export
 * @interface CreateApprovalRequestResponse
 */
export interface CreateApprovalRequestResponse {
  /**
   *
   * @type {any}
   * @memberof CreateApprovalRequestResponse
   */
  approvalRequestId?: any;
}
/**
 *
 * @export
 * @interface CreateMerchantRoleRequest
 */
export interface CreateMerchantRoleRequest {
  /**
   *
   * @type {any}
   * @memberof CreateMerchantRoleRequest
   */
  code: any;
  /**
   *
   * @type {any}
   * @memberof CreateMerchantRoleRequest
   */
  name: any;
  /**
   *
   * @type {any}
   * @memberof CreateMerchantRoleRequest
   */
  scope: any;
  /**
   *
   * @type {any}
   * @memberof CreateMerchantRoleRequest
   */
  description?: any;
}
/**
 *
 * @export
 * @interface CreateMerchantUserRequest
 */
export interface CreateMerchantUserRequest {
  /**
   *
   * @type {any}
   * @memberof CreateMerchantUserRequest
   */
  phoneNumber: any;
  /**
   *
   * @type {any}
   * @memberof CreateMerchantUserRequest
   */
  email: any;
  /**
   *
   * @type {any}
   * @memberof CreateMerchantUserRequest
   */
  fullName: any;
  /**
   *
   * @type {any}
   * @memberof CreateMerchantUserRequest
   */
  merchantType: CreateMerchantUserRequestMerchantTypeEnum;
  /**
   *
   * @type {any}
   * @memberof CreateMerchantUserRequest
   */
  registrationChannel: CreateMerchantUserRequestRegistrationChannelEnum;
}

export const CreateMerchantUserRequestMerchantTypeEnum = {
  Personal: "PERSONAL",
  Organization: "ORGANIZATION",
} as const;

export type CreateMerchantUserRequestMerchantTypeEnum =
  (typeof CreateMerchantUserRequestMerchantTypeEnum)[keyof typeof CreateMerchantUserRequestMerchantTypeEnum];
export const CreateMerchantUserRequestRegistrationChannelEnum = {
  OperatorRegistered: "OPERATOR_REGISTERED",
  SelfRegister: "SELF_REGISTER",
} as const;

export type CreateMerchantUserRequestRegistrationChannelEnum =
  (typeof CreateMerchantUserRequestRegistrationChannelEnum)[keyof typeof CreateMerchantUserRequestRegistrationChannelEnum];

/**
 *
 * @export
 * @interface CreateMerchantUserResponse
 */
export interface CreateMerchantUserResponse {
  /**
   *
   * @type {any}
   * @memberof CreateMerchantUserResponse
   */
  merchantUserId?: any;
  /**
   *
   * @type {any}
   * @memberof CreateMerchantUserResponse
   */
  keycloakUserId?: any;
  /**
   *
   * @type {any}
   * @memberof CreateMerchantUserResponse
   */
  alreadyExists?: any;
}
/**
 *
 * @export
 * @interface CreateMfaSessionRequest
 */
export interface CreateMfaSessionRequest {
  /**
   *
   * @type {any}
   * @memberof CreateMfaSessionRequest
   */
  sourceType: CreateMfaSessionRequestSourceTypeEnum;
  /**
   *
   * @type {any}
   * @memberof CreateMfaSessionRequest
   */
  method: CreateMfaSessionRequestMethodEnum;
  /**
   *
   * @type {any}
   * @memberof CreateMfaSessionRequest
   */
  userId: any;
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof CreateMfaSessionRequest
   */
  contextData?: { [key: string]: any };
  /**
   *
   * @type {CreateMfaSessionRequestMetadata}
   * @memberof CreateMfaSessionRequest
   */
  metadata?: CreateMfaSessionRequestMetadata;
}

export const CreateMfaSessionRequestSourceTypeEnum = {
  Login: "LOGIN",
  ChangePassword: "CHANGE_PASSWORD",
  Withdraw: "WITHDRAW",
} as const;

export type CreateMfaSessionRequestSourceTypeEnum =
  (typeof CreateMfaSessionRequestSourceTypeEnum)[keyof typeof CreateMfaSessionRequestSourceTypeEnum];
export const CreateMfaSessionRequestMethodEnum = {
  Totp: "TOTP",
  OtpSms: "OTP_SMS",
  OtpEmail: "OTP_EMAIL",
  FaceLiveness: "FACE_LIVENESS",
} as const;

export type CreateMfaSessionRequestMethodEnum =
  (typeof CreateMfaSessionRequestMethodEnum)[keyof typeof CreateMfaSessionRequestMethodEnum];

/**
 *
 * @export
 * @interface CreateMfaSessionRequestMetadata
 */
export interface CreateMfaSessionRequestMetadata {
  [key: string]: any;

  /**
   *
   * @type {any}
   * @memberof CreateMfaSessionRequestMetadata
   */
  location?: any;
  /**
   *
   * @type {any}
   * @memberof CreateMfaSessionRequestMetadata
   */
  timestamp?: any;
  /**
   *
   * @type {any}
   * @memberof CreateMfaSessionRequestMetadata
   */
  ipAddress?: any;
  /**
   *
   * @type {any}
   * @memberof CreateMfaSessionRequestMetadata
   */
  userAgent?: any;
  /**
   *
   * @type {any}
   * @memberof CreateMfaSessionRequestMetadata
   */
  deviceId?: any;
  /**
   *
   * @type {any}
   * @memberof CreateMfaSessionRequestMetadata
   */
  deviceName?: any;
  /**
   *
   * @type {any}
   * @memberof CreateMfaSessionRequestMetadata
   */
  osInfo?: any;
  /**
   *
   * @type {any}
   * @memberof CreateMfaSessionRequestMetadata
   */
  empty?: any;
}
/**
 *
 * @export
 * @interface CreateMfaSessionResponse
 */
export interface CreateMfaSessionResponse {
  /**
   *
   * @type {any}
   * @memberof CreateMfaSessionResponse
   */
  sessionId?: any;
  /**
   *
   * @type {any}
   * @memberof CreateMfaSessionResponse
   */
  challengeId?: any;
  /**
   *
   * @type {any}
   * @memberof CreateMfaSessionResponse
   */
  sourceType?: CreateMfaSessionResponseSourceTypeEnum;
  /**
   *
   * @type {any}
   * @memberof CreateMfaSessionResponse
   */
  method?: CreateMfaSessionResponseMethodEnum;
  /**
   *
   * @type {any}
   * @memberof CreateMfaSessionResponse
   */
  maskedDestination?: any;
  /**
   *
   * @type {any}
   * @memberof CreateMfaSessionResponse
   */
  expiresAt?: any;
  /**
   *
   * @type {any}
   * @memberof CreateMfaSessionResponse
   */
  maxAttempts?: any;
  /**
   *
   * @type {any}
   * @memberof CreateMfaSessionResponse
   */
  nextStep?: any;
  /**
   *
   * @type {any}
   * @memberof CreateMfaSessionResponse
   */
  resendCooldown?: any;
}

export const CreateMfaSessionResponseSourceTypeEnum = {
  Login: "LOGIN",
  ChangePassword: "CHANGE_PASSWORD",
  Withdraw: "WITHDRAW",
} as const;

export type CreateMfaSessionResponseSourceTypeEnum =
  (typeof CreateMfaSessionResponseSourceTypeEnum)[keyof typeof CreateMfaSessionResponseSourceTypeEnum];
export const CreateMfaSessionResponseMethodEnum = {
  Totp: "TOTP",
  OtpSms: "OTP_SMS",
  OtpEmail: "OTP_EMAIL",
  FaceLiveness: "FACE_LIVENESS",
} as const;

export type CreateMfaSessionResponseMethodEnum =
  (typeof CreateMfaSessionResponseMethodEnum)[keyof typeof CreateMfaSessionResponseMethodEnum];

/**
 *
 * @export
 * @interface CreateResourceRequest
 */
export interface CreateResourceRequest {
  /**
   *
   * @type {any}
   * @memberof CreateResourceRequest
   */
  code: any;
  /**
   *
   * @type {any}
   * @memberof CreateResourceRequest
   */
  name: any;
  /**
   *
   * @type {any}
   * @memberof CreateResourceRequest
   */
  description?: any;
  /**
   *
   * @type {any}
   * @memberof CreateResourceRequest
   */
  features?: any;
}
/**
 *
 * @export
 * @interface CreateRoleGroupRequest
 */
export interface CreateRoleGroupRequest {
  /**
   *
   * @type {any}
   * @memberof CreateRoleGroupRequest
   */
  name: any;
  /**
   *
   * @type {any}
   * @memberof CreateRoleGroupRequest
   */
  description?: any;
  /**
   *
   * @type {any}
   * @memberof CreateRoleGroupRequest
   */
  refResourceId: any;
  /**
   *
   * @type {any}
   * @memberof CreateRoleGroupRequest
   */
  roleType: CreateRoleGroupRequestRoleTypeEnum;
  /**
   * Mapping of resource codes to their associated role codes
   * @type {any}
   * @memberof CreateRoleGroupRequest
   */
  roleCodes: any;
}

export const CreateRoleGroupRequestRoleTypeEnum = {
  Super: "SUPER",
  Maker: "MAKER",
  Checker: "CHECKER",
  Viewer: "VIEWER",
} as const;

export type CreateRoleGroupRequestRoleTypeEnum =
  (typeof CreateRoleGroupRequestRoleTypeEnum)[keyof typeof CreateRoleGroupRequestRoleTypeEnum];

/**
 *
 * @export
 * @interface CreateRoleRequest
 */
export interface CreateRoleRequest {
  /**
   * Role code with format: feature:action
   * @type {any}
   * @memberof CreateRoleRequest
   */
  code: any;
}
/**
 *
 * @export
 * @interface DisableEnableUserRequest
 */
export interface DisableEnableUserRequest {
  /**
   *
   * @type {any}
   * @memberof DisableEnableUserRequest
   */
  reason: any;
  /**
   *
   * @type {any}
   * @memberof DisableEnableUserRequest
   */
  performedBy: any;
}
/**
 *
 * @export
 * @interface DisableUserResponse
 */
export interface DisableUserResponse {
  /**
   *
   * @type {any}
   * @memberof DisableUserResponse
   */
  keycloakUserId?: any;
  /**
   *
   * @type {any}
   * @memberof DisableUserResponse
   */
  enabled?: any;
  /**
   *
   * @type {any}
   * @memberof DisableUserResponse
   */
  sessionsRevoked?: any;
}
/**
 *
 * @export
 * @interface EnableUserResponse
 */
export interface EnableUserResponse {
  /**
   *
   * @type {any}
   * @memberof EnableUserResponse
   */
  keycloakUserId?: any;
  /**
   *
   * @type {any}
   * @memberof EnableUserResponse
   */
  enabled?: any;
}
/**
 *
 * @export
 * @interface EndUserAuthRequest
 */
export interface EndUserAuthRequest {
  /**
   *
   * @type {any}
   * @memberof EndUserAuthRequest
   */
  phoneNumber: any;
  /**
   *
   * @type {any}
   * @memberof EndUserAuthRequest
   */
  password: any;
  /**
   *
   * @type {any}
   * @memberof EndUserAuthRequest
   */
  mfaSessionId?: any;
  /**
   *
   * @type {any}
   * @memberof EndUserAuthRequest
   */
  verificationCode?: any;
  /**
   *
   * @type {any}
   * @memberof EndUserAuthRequest
   */
  deviceFingerprintId?: any;
  /**
   *
   * @type {any}
   * @memberof EndUserAuthRequest
   */
  deviceName?: any;
  /**
   *
   * @type {any}
   * @memberof EndUserAuthRequest
   */
  osInfo?: any;
  /**
   *
   * @type {any}
   * @memberof EndUserAuthRequest
   */
  rememberMe?: any;
  /**
   *
   * @type {RequestMetadata}
   * @memberof EndUserAuthRequest
   */
  metadata?: RequestMetadata;
  /**
   *
   * @type {any}
   * @memberof EndUserAuthRequest
   */
  deviceToken?: any;
}
/**
 *
 * @export
 * @interface EndUserAuthResponse
 */
export interface EndUserAuthResponse {
  /**
   *
   * @type {any}
   * @memberof EndUserAuthResponse
   */
  expiresIn?: any;
  /**
   *
   * @type {UserInfo}
   * @memberof EndUserAuthResponse
   */
  user?: UserInfo;
  /**
   *
   * @type {any}
   * @memberof EndUserAuthResponse
   */
  accessToken?: any;
  /**
   *
   * @type {any}
   * @memberof EndUserAuthResponse
   */
  refreshToken?: any;
  /**
   *
   * @type {any}
   * @memberof EndUserAuthResponse
   */
  mfaRequired?: any;
  /**
   *
   * @type {any}
   * @memberof EndUserAuthResponse
   */
  mfaSessionId?: any;
  /**
   *
   * @type {any}
   * @memberof EndUserAuthResponse
   */
  steps?: any;
  /**
   *
   * @type {any}
   * @memberof EndUserAuthResponse
   */
  nextStep?: any;
  /**
   *
   * @type {any}
   * @memberof EndUserAuthResponse
   */
  remainingSteps?: any;
  /**
   *
   * @type {any}
   * @memberof EndUserAuthResponse
   */
  totpEnrolled?: any;
}
/**
 *
 * @export
 * @interface EndUserForgotPasswordRequest
 */
export interface EndUserForgotPasswordRequest {
  /**
   *
   * @type {any}
   * @memberof EndUserForgotPasswordRequest
   */
  phoneNumber: any;
}
/**
 *
 * @export
 * @interface EndUserForgotPasswordResponse
 */
export interface EndUserForgotPasswordResponse {
  /**
   *
   * @type {any}
   * @memberof EndUserForgotPasswordResponse
   */
  action?: EndUserForgotPasswordResponseActionEnum;
  /**
   *
   * @type {any}
   * @memberof EndUserForgotPasswordResponse
   */
  remainSendAttempts?: any;
}

export const EndUserForgotPasswordResponseActionEnum = {
  TokenCreated: "TOKEN_CREATED",
  OtpSentViaSms: "OTP_SENT_VIA_SMS",
  OtpSentViaEmail: "OTP_SENT_VIA_EMAIL",
  RequireChangePassword: "REQUIRE_CHANGE_PASSWORD",
  PasswordExpired: "PASSWORD_EXPIRED",
} as const;

export type EndUserForgotPasswordResponseActionEnum =
  (typeof EndUserForgotPasswordResponseActionEnum)[keyof typeof EndUserForgotPasswordResponseActionEnum];

/**
 *
 * @export
 * @interface EndUserResendLoginOtpRequest
 */
export interface EndUserResendLoginOtpRequest {
  /**
   *
   * @type {any}
   * @memberof EndUserResendLoginOtpRequest
   */
  mfaSessionId: any;
}
/**
 *
 * @export
 * @interface EndUserResendOtpRequest
 */
export interface EndUserResendOtpRequest {
  /**
   *
   * @type {any}
   * @memberof EndUserResendOtpRequest
   */
  phoneNumber: any;
}
/**
 *
 * @export
 * @interface EndUserResendOtpResponse
 */
export interface EndUserResendOtpResponse {
  /**
   *
   * @type {any}
   * @memberof EndUserResendOtpResponse
   */
  remainSendAttempts?: any;
}
/**
 *
 * @export
 * @interface EndUserResetPasswordRequest
 */
export interface EndUserResetPasswordRequest {
  /**
   *
   * @type {any}
   * @memberof EndUserResetPasswordRequest
   */
  phoneNumber: any;
  /**
   *
   * @type {any}
   * @memberof EndUserResetPasswordRequest
   */
  verifiedOtpCredential: any;
  /**
   *
   * @type {any}
   * @memberof EndUserResetPasswordRequest
   */
  newPassword: any;
  /**
   *
   * @type {any}
   * @memberof EndUserResetPasswordRequest
   */
  confirmPassword: any;
}
/**
 *
 * @export
 * @interface EndUserResetPasswordResponse
 */
export interface EndUserResetPasswordResponse {
  /**
   *
   * @type {any}
   * @memberof EndUserResetPasswordResponse
   */
  success?: any;
}
/**
 *
 * @export
 * @interface EndUserVerifyOtpRequest
 */
export interface EndUserVerifyOtpRequest {
  /**
   *
   * @type {any}
   * @memberof EndUserVerifyOtpRequest
   */
  phoneNumber: any;
  /**
   *
   * @type {any}
   * @memberof EndUserVerifyOtpRequest
   */
  otp: any;
}
/**
 *
 * @export
 * @interface EndUserVerifyOtpResponse
 */
export interface EndUserVerifyOtpResponse {
  /**
   *
   * @type {any}
   * @memberof EndUserVerifyOtpResponse
   */
  verifiedOtpCredential?: any;
}
/**
 *
 * @export
 * @interface ExportInitResponse
 */
export interface ExportInitResponse {
  /**
   *
   * @type {any}
   * @memberof ExportInitResponse
   */
  processId?: any;
  /**
   *
   * @type {any}
   * @memberof ExportInitResponse
   */
  recordCount?: any;
}
/**
 *
 * @export
 * @interface ExportProgressEvent
 */
export interface ExportProgressEvent {
  /**
   *
   * @type {any}
   * @memberof ExportProgressEvent
   */
  processId?: any;
  /**
   *
   * @type {any}
   * @memberof ExportProgressEvent
   */
  percent?: any;
  /**
   *
   * @type {any}
   * @memberof ExportProgressEvent
   */
  phase?: any;
  /**
   *
   * @type {any}
   * @memberof ExportProgressEvent
   */
  message?: any;
  /**
   *
   * @type {any}
   * @memberof ExportProgressEvent
   */
  fileName?: any;
  /**
   *
   * @type {any}
   * @memberof ExportProgressEvent
   */
  filePath?: any;
  /**
   *
   * @type {any}
   * @memberof ExportProgressEvent
   */
  recordCount?: any;
  /**
   *
   * @type {any}
   * @memberof ExportProgressEvent
   */
  fileSize?: any;
}
/**
 *
 * @export
 * @interface FirstLoginChangePasswordResponse
 */
export interface FirstLoginChangePasswordResponse {
  /**
   * Action completed. Always \"PASSWORD_CHANGED\" on success.
   * @type {any}
   * @memberof FirstLoginChangePasswordResponse
   */
  action?: any;
  /**
   * Frontend redirect target after password changed.
   * @type {any}
   * @memberof FirstLoginChangePasswordResponse
   */
  redirectUrl?: any;
}
/**
 *
 * @export
 * @interface GrantRolePermissionRequest
 */
export interface GrantRolePermissionRequest {
  /**
   *
   * @type {any}
   * @memberof GrantRolePermissionRequest
   */
  permissionId: any;
}
/**
 *
 * @export
 * @interface IssueMerchantCredentialRequest
 */
export interface IssueMerchantCredentialRequest {
  /**
   *
   * @type {any}
   * @memberof IssueMerchantCredentialRequest
   */
  merchantId: any;
  /**
   *
   * @type {any}
   * @memberof IssueMerchantCredentialRequest
   */
  merchantCode: any;
  /**
   *
   * @type {any}
   * @memberof IssueMerchantCredentialRequest
   */
  ownerEmail: any;
}
/**
 *
 * @export
 * @interface IssueMerchantCredentialResponse
 */
export interface IssueMerchantCredentialResponse {
  /**
   *
   * @type {any}
   * @memberof IssueMerchantCredentialResponse
   */
  credentialId?: any;
  /**
   *
   * @type {any}
   * @memberof IssueMerchantCredentialResponse
   */
  merchantId?: any;
  /**
   *
   * @type {any}
   * @memberof IssueMerchantCredentialResponse
   */
  clientId?: any;
  /**
   *
   * @type {any}
   * @memberof IssueMerchantCredentialResponse
   */
  secretKey?: any;
  /**
   *
   * @type {any}
   * @memberof IssueMerchantCredentialResponse
   */
  encryptKey?: any;
  /**
   *
   * @type {any}
   * @memberof IssueMerchantCredentialResponse
   */
  expiresAt?: any;
  /**
   *
   * @type {any}
   * @memberof IssueMerchantCredentialResponse
   */
  createdAt?: any;
}
/**
 *
 * @export
 * @interface LinkedDeviceDto
 */
export interface LinkedDeviceDto {
  /**
   *
   * @type {any}
   * @memberof LinkedDeviceDto
   */
  deviceName?: any;
  /**
   *
   * @type {any}
   * @memberof LinkedDeviceDto
   */
  osInfo?: any;
  /**
   *
   * @type {any}
   * @memberof LinkedDeviceDto
   */
  channel?: any;
  /**
   *
   * @type {any}
   * @memberof LinkedDeviceDto
   */
  deviceId?: any;
  /**
   *
   * @type {any}
   * @memberof LinkedDeviceDto
   */
  linkedAt?: any;
  /**
   *
   * @type {any}
   * @memberof LinkedDeviceDto
   */
  lastAccessAt?: any;
  /**
   *
   * @type {any}
   * @memberof LinkedDeviceDto
   */
  trustStatus?: any;
  /**
   *
   * @type {any}
   * @memberof LinkedDeviceDto
   */
  lastAuthMethod?: any;
}
/**
 *
 * @export
 * @interface LockMerchantAccountRequest
 */
export interface LockMerchantAccountRequest {
  /**
   *
   * @type {any}
   * @memberof LockMerchantAccountRequest
   */
  reason: any;
}
/**
 *
 * @export
 * @interface LoginHistoryDto
 */
export interface LoginHistoryDto {
  /**
   *
   * @type {any}
   * @memberof LoginHistoryDto
   */
  loginAt?: any;
  /**
   *
   * @type {any}
   * @memberof LoginHistoryDto
   */
  logoutAt?: any;
  /**
   *
   * @type {any}
   * @memberof LoginHistoryDto
   */
  channel?: any;
  /**
   *
   * @type {any}
   * @memberof LoginHistoryDto
   */
  authMethod?: any;
  /**
   *
   * @type {any}
   * @memberof LoginHistoryDto
   */
  ipAddress?: any;
  /**
   *
   * @type {any}
   * @memberof LoginHistoryDto
   */
  deviceName?: any;
  /**
   *
   * @type {any}
   * @memberof LoginHistoryDto
   */
  osInfo?: any;
  /**
   *
   * @type {any}
   * @memberof LoginHistoryDto
   */
  result?: any;
  /**
   *
   * @type {any}
   * @memberof LoginHistoryDto
   */
  sessionStatus?: any;
}
/**
 *
 * @export
 * @interface LogoutRequest
 */
export interface LogoutRequest {
  /**
   *
   * @type {any}
   * @memberof LogoutRequest
   */
  refreshToken?: any;
}
/**
 *
 * @export
 * @interface MerchantAccountResponse
 */
export interface MerchantAccountResponse {
  /**
   *
   * @type {any}
   * @memberof MerchantAccountResponse
   */
  id?: any;
  /**
   *
   * @type {any}
   * @memberof MerchantAccountResponse
   */
  keycloakUserId?: any;
  /**
   *
   * @type {any}
   * @memberof MerchantAccountResponse
   */
  phone?: any;
  /**
   *
   * @type {any}
   * @memberof MerchantAccountResponse
   */
  email?: any;
  /**
   *
   * @type {any}
   * @memberof MerchantAccountResponse
   */
  fullName?: any;
  /**
   *
   * @type {any}
   * @memberof MerchantAccountResponse
   */
  status?: any;
  /**
   *
   * @type {any}
   * @memberof MerchantAccountResponse
   */
  registrationChannel?: any;
  /**
   *
   * @type {any}
   * @memberof MerchantAccountResponse
   */
  merchantType?: any;
  /**
   *
   * @type {any}
   * @memberof MerchantAccountResponse
   */
  accountLevel?: any;
  /**
   *
   * @type {any}
   * @memberof MerchantAccountResponse
   */
  roleId?: any;
  /**
   *
   * @type {any}
   * @memberof MerchantAccountResponse
   */
  suspendedReason?: any;
  /**
   *
   * @type {any}
   * @memberof MerchantAccountResponse
   */
  suspendedAt?: any;
  /**
   *
   * @type {any}
   * @memberof MerchantAccountResponse
   */
  lockedReason?: any;
  /**
   *
   * @type {any}
   * @memberof MerchantAccountResponse
   */
  lockedAt?: any;
  /**
   *
   * @type {any}
   * @memberof MerchantAccountResponse
   */
  lastLoginAt?: any;
  /**
   *
   * @type {any}
   * @memberof MerchantAccountResponse
   */
  deletedAt?: any;
  /**
   *
   * @type {any}
   * @memberof MerchantAccountResponse
   */
  createdBy?: any;
  /**
   *
   * @type {any}
   * @memberof MerchantAccountResponse
   */
  createdAt?: any;
  /**
   *
   * @type {any}
   * @memberof MerchantAccountResponse
   */
  updatedBy?: any;
  /**
   *
   * @type {any}
   * @memberof MerchantAccountResponse
   */
  updatedAt?: any;
}
/**
 *
 * @export
 * @interface MerchantChangePasswordRequest
 */
export interface MerchantChangePasswordRequest {
  /**
   * Current password — verified via Keycloak grantToken.
   * @type {any}
   * @memberof MerchantChangePasswordRequest
   */
  currentPassword: any;
  /**
   * New password (≥8 chars + complexity).
   * @type {any}
   * @memberof MerchantChangePasswordRequest
   */
  newPassword: any;
  /**
   * Confirm new password.
   * @type {any}
   * @memberof MerchantChangePasswordRequest
   */
  confirmNewPassword: any;
}
/**
 *
 * @export
 * @interface MerchantChangePasswordSubmitRequest
 */
export interface MerchantChangePasswordSubmitRequest {
  /**
   * Session id from step 1.
   * @type {any}
   * @memberof MerchantChangePasswordSubmitRequest
   */
  sessionId: any;
  /**
   * Single-use opaque token from step 1 (128 hex chars).
   * @type {any}
   * @memberof MerchantChangePasswordSubmitRequest
   */
  token: any;
  /**
   * New password (must satisfy complexity policy).
   * @type {any}
   * @memberof MerchantChangePasswordSubmitRequest
   */
  newPassword: any;
  /**
   * Confirm new password (must equal newPassword).
   * @type {any}
   * @memberof MerchantChangePasswordSubmitRequest
   */
  confirmNewPassword: any;
}
/**
 *
 * @export
 * @interface MerchantChangePasswordVerifyRequest
 */
export interface MerchantChangePasswordVerifyRequest {
  /**
   * Current password (re-verify via Keycloak).
   * @type {any}
   * @memberof MerchantChangePasswordVerifyRequest
   */
  currentPassword: any;
}
/**
 *
 * @export
 * @interface MerchantChangePasswordVerifyResponse
 */
export interface MerchantChangePasswordVerifyResponse {
  /**
   * Step-2 session identifier (UUID v4).
   * @type {any}
   * @memberof MerchantChangePasswordVerifyResponse
   */
  sessionId?: any;
  /**
   * Single-use opaque session token (128 hex chars).
   * @type {any}
   * @memberof MerchantChangePasswordVerifyResponse
   */
  token?: any;
  /**
   * Session TTL in seconds.
   * @type {any}
   * @memberof MerchantChangePasswordVerifyResponse
   */
  expiresIn?: any;
}
/**
 *
 * @export
 * @interface MerchantFirstLoginChangePasswordRequest
 */
export interface MerchantFirstLoginChangePasswordRequest {
  /**
   *
   * @type {any}
   * @memberof MerchantFirstLoginChangePasswordRequest
   */
  sessionToken: any;
  /**
   *
   * @type {any}
   * @memberof MerchantFirstLoginChangePasswordRequest
   */
  newPassword: any;
  /**
   *
   * @type {any}
   * @memberof MerchantFirstLoginChangePasswordRequest
   */
  confirmNewPassword: any;
}
/**
 *
 * @export
 * @interface MerchantForgotPasswordRequestOtpRequest
 */
export interface MerchantForgotPasswordRequestOtpRequest {
  /**
   * Vietnamese phone number (D15 primary identifier).
   * @type {any}
   * @memberof MerchantForgotPasswordRequestOtpRequest
   */
  phone: any;
}
/**
 *
 * @export
 * @interface MerchantForgotPasswordSubmitRequest
 */
export interface MerchantForgotPasswordSubmitRequest {
  /**
   * Reset session token from verify-otp step.
   * @type {any}
   * @memberof MerchantForgotPasswordSubmitRequest
   */
  resetSessionToken: any;
  /**
   * New password meeting policy (≥8 chars + complexity).
   * @type {any}
   * @memberof MerchantForgotPasswordSubmitRequest
   */
  newPassword: any;
  /**
   * Confirm new password.
   * @type {any}
   * @memberof MerchantForgotPasswordSubmitRequest
   */
  confirmNewPassword: any;
}
/**
 *
 * @export
 * @interface MerchantForgotPasswordVerifyOtpRequest
 */
export interface MerchantForgotPasswordVerifyOtpRequest {
  /**
   * Vietnamese phone number.
   * @type {any}
   * @memberof MerchantForgotPasswordVerifyOtpRequest
   */
  phone: any;
  /**
   * 6-digit OTP from email.
   * @type {any}
   * @memberof MerchantForgotPasswordVerifyOtpRequest
   */
  otp: any;
}
/**
 *
 * @export
 * @interface MerchantForgotPasswordVerifyOtpResponse
 */
export interface MerchantForgotPasswordVerifyOtpResponse {
  /**
   * Reset session token (opaque, single-use, 5min TTL).
   * @type {any}
   * @memberof MerchantForgotPasswordVerifyOtpResponse
   */
  resetSessionToken?: any;
  /**
   * Token TTL in seconds.
   * @type {any}
   * @memberof MerchantForgotPasswordVerifyOtpResponse
   */
  expiresIn?: any;
}
/**
 *
 * @export
 * @interface MerchantLoginRequest
 */
export interface MerchantLoginRequest {
  /**
   * Vietnamese phone number — primary login identifier (D15). Format 0XXXXXXXXX or +84XXXXXXXXX.
   * @type {any}
   * @memberof MerchantLoginRequest
   */
  phone: any;
  /**
   * Account password. Plaintext over TLS — never logged.
   * @type {any}
   * @memberof MerchantLoginRequest
   */
  password: any;
}
/**
 *
 * @export
 * @interface MerchantLoginResponse
 */
export interface MerchantLoginResponse {
  /**
   * Login action result.
   * @type {any}
   * @memberof MerchantLoginResponse
   */
  action?: MerchantLoginResponseActionEnum;
  /**
   * Bearer token type. Only when action=TOKEN_ISSUED.
   * @type {any}
   * @memberof MerchantLoginResponse
   */
  tokenType?: any;
  /**
   * OAuth2 access token (Keycloak realm ewallet_merchant). Only when action=TOKEN_ISSUED.
   * @type {any}
   * @memberof MerchantLoginResponse
   */
  accessToken?: any;
  /**
   * OAuth2 refresh token. Only when action=TOKEN_ISSUED.
   * @type {any}
   * @memberof MerchantLoginResponse
   */
  refreshToken?: any;
  /**
   * Access token TTL in seconds. Only when action=TOKEN_ISSUED.
   * @type {any}
   * @memberof MerchantLoginResponse
   */
  expiresIn?: any;
  /**
   * Opaque single-use Redis session token (43 chars). Only when action=PASSWORD_CHANGE_REQUIRED. Use for POST /api/merchant-auth/v1/first-login/change-password.
   * @type {any}
   * @memberof MerchantLoginResponse
   */
  sessionToken?: any;
  /**
   * UI redirect target. Only when action=PASSWORD_CHANGE_REQUIRED.
   * @type {any}
   * @memberof MerchantLoginResponse
   */
  redirect?: any;
  /**
   * OTP delivery channel. Only when action=OTP_REQUIRED. Always SMS for merchant login (D28).
   * @type {any}
   * @memberof MerchantLoginResponse
   */
  channel?: MerchantLoginResponseChannelEnum;
  /**
   * OTP TTL in seconds. Only when action=OTP_REQUIRED.
   * @type {any}
   * @memberof MerchantLoginResponse
   */
  otpExpiresIn?: any;
  /**
   * Cooldown in seconds between resend attempts. Only when action=OTP_REQUIRED.
   * @type {any}
   * @memberof MerchantLoginResponse
   */
  resendCooldownSeconds?: any;
}

export const MerchantLoginResponseActionEnum = {
  TokenIssued: "TOKEN_ISSUED",
  PasswordChangeRequired: "PASSWORD_CHANGE_REQUIRED",
  OtpRequired: "OTP_REQUIRED",
} as const;

export type MerchantLoginResponseActionEnum =
  (typeof MerchantLoginResponseActionEnum)[keyof typeof MerchantLoginResponseActionEnum];
export const MerchantLoginResponseChannelEnum = {
  Sms: "SMS",
} as const;

export type MerchantLoginResponseChannelEnum =
  (typeof MerchantLoginResponseChannelEnum)[keyof typeof MerchantLoginResponseChannelEnum];

/**
 *
 * @export
 * @interface MerchantLogoutRequest
 */
export interface MerchantLogoutRequest {
  /**
   * OAuth2 refresh token to revoke. Keycloak invalidates entire session.
   * @type {any}
   * @memberof MerchantLogoutRequest
   */
  refreshToken: any;
}
/**
 *
 * @export
 * @interface MerchantPermissionResponse
 */
export interface MerchantPermissionResponse {
  /**
   *
   * @type {any}
   * @memberof MerchantPermissionResponse
   */
  id?: any;
  /**
   *
   * @type {any}
   * @memberof MerchantPermissionResponse
   */
  code?: any;
  /**
   *
   * @type {any}
   * @memberof MerchantPermissionResponse
   */
  name?: any;
  /**
   *
   * @type {any}
   * @memberof MerchantPermissionResponse
   */
  resource?: any;
  /**
   *
   * @type {any}
   * @memberof MerchantPermissionResponse
   */
  action?: any;
  /**
   *
   * @type {any}
   * @memberof MerchantPermissionResponse
   */
  description?: any;
  /**
   *
   * @type {any}
   * @memberof MerchantPermissionResponse
   */
  createdAt?: any;
  /**
   *
   * @type {any}
   * @memberof MerchantPermissionResponse
   */
  updatedAt?: any;
}
/**
 *
 * @export
 * @interface MerchantRefreshTokenRequest
 */
export interface MerchantRefreshTokenRequest {
  /**
   * OAuth2 refresh token from prior login response.
   * @type {any}
   * @memberof MerchantRefreshTokenRequest
   */
  refreshToken: any;
}
/**
 *
 * @export
 * @interface MerchantResendLoginOtpRequest
 */
export interface MerchantResendLoginOtpRequest {
  /**
   * Vietnamese phone number.
   * @type {any}
   * @memberof MerchantResendLoginOtpRequest
   */
  phone: any;
}
/**
 *
 * @export
 * @interface MerchantRoleCatalogSyncHistoryResponse
 */
export interface MerchantRoleCatalogSyncHistoryResponse {
  /**
   *
   * @type {any}
   * @memberof MerchantRoleCatalogSyncHistoryResponse
   */
  id?: any;
  /**
   *
   * @type {any}
   * @memberof MerchantRoleCatalogSyncHistoryResponse
   */
  configVersion?: any;
  /**
   *
   * @type {any}
   * @memberof MerchantRoleCatalogSyncHistoryResponse
   */
  checksum?: any;
  /**
   *
   * @type {any}
   * @memberof MerchantRoleCatalogSyncHistoryResponse
   */
  rolesCount?: any;
  /**
   *
   * @type {any}
   * @memberof MerchantRoleCatalogSyncHistoryResponse
   */
  permsCount?: any;
  /**
   *
   * @type {any}
   * @memberof MerchantRoleCatalogSyncHistoryResponse
   */
  groupsSynced?: any;
  /**
   *
   * @type {any}
   * @memberof MerchantRoleCatalogSyncHistoryResponse
   */
  outcome?: any;
  /**
   *
   * @type {any}
   * @memberof MerchantRoleCatalogSyncHistoryResponse
   */
  errorMessage?: any;
  /**
   *
   * @type {any}
   * @memberof MerchantRoleCatalogSyncHistoryResponse
   */
  syncedAt?: any;
  /**
   *
   * @type {any}
   * @memberof MerchantRoleCatalogSyncHistoryResponse
   */
  syncedBy?: any;
}
/**
 *
 * @export
 * @interface MerchantRoleResponse
 */
export interface MerchantRoleResponse {
  /**
   *
   * @type {any}
   * @memberof MerchantRoleResponse
   */
  id?: any;
  /**
   *
   * @type {any}
   * @memberof MerchantRoleResponse
   */
  code?: any;
  /**
   *
   * @type {any}
   * @memberof MerchantRoleResponse
   */
  name?: any;
  /**
   *
   * @type {any}
   * @memberof MerchantRoleResponse
   */
  scope?: any;
  /**
   *
   * @type {any}
   * @memberof MerchantRoleResponse
   */
  systemFlag?: any;
  /**
   *
   * @type {any}
   * @memberof MerchantRoleResponse
   */
  status?: any;
  /**
   *
   * @type {any}
   * @memberof MerchantRoleResponse
   */
  description?: any;
  /**
   *
   * @type {any}
   * @memberof MerchantRoleResponse
   */
  deletedAt?: any;
  /**
   *
   * @type {any}
   * @memberof MerchantRoleResponse
   */
  createdBy?: any;
  /**
   *
   * @type {any}
   * @memberof MerchantRoleResponse
   */
  createdAt?: any;
  /**
   *
   * @type {any}
   * @memberof MerchantRoleResponse
   */
  updatedBy?: any;
  /**
   *
   * @type {any}
   * @memberof MerchantRoleResponse
   */
  updatedAt?: any;
}
/**
 *
 * @export
 * @interface MerchantVerifyLoginOtpRequest
 */
export interface MerchantVerifyLoginOtpRequest {
  /**
   * Vietnamese phone number.
   * @type {any}
   * @memberof MerchantVerifyLoginOtpRequest
   */
  phone: any;
  /**
   * Account password (re-supply per D11).
   * @type {any}
   * @memberof MerchantVerifyLoginOtpRequest
   */
  password: any;
  /**
   * 6-digit OTP from SMS.
   * @type {any}
   * @memberof MerchantVerifyLoginOtpRequest
   */
  otp: any;
}
/**
 *
 * @export
 * @interface MfaEnrollOtpRequest
 */
export interface MfaEnrollOtpRequest {
  /**
   *
   * @type {any}
   * @memberof MfaEnrollOtpRequest
   */
  enrollSessionId: any;
  /**
   *
   * @type {any}
   * @memberof MfaEnrollOtpRequest
   */
  otpCode: any;
}
/**
 *
 * @export
 * @interface MfaEnrollRequest
 */
export interface MfaEnrollRequest {
  /**
   *
   * @type {any}
   * @memberof MfaEnrollRequest
   */
  method: MfaEnrollRequestMethodEnum;
  /**
   *
   * @type {any}
   * @memberof MfaEnrollRequest
   */
  pin?: any;
  /**
   *
   * @type {RequestMetadata}
   * @memberof MfaEnrollRequest
   */
  metadata?: RequestMetadata;
}

export const MfaEnrollRequestMethodEnum = {
  Totp: "TOTP",
  OtpSms: "OTP_SMS",
  OtpEmail: "OTP_EMAIL",
  FaceLiveness: "FACE_LIVENESS",
} as const;

export type MfaEnrollRequestMethodEnum =
  (typeof MfaEnrollRequestMethodEnum)[keyof typeof MfaEnrollRequestMethodEnum];

/**
 *
 * @export
 * @interface MfaEnrollResendOtpRequest
 */
export interface MfaEnrollResendOtpRequest {
  /**
   *
   * @type {any}
   * @memberof MfaEnrollResendOtpRequest
   */
  enrollSessionId: any;
}
/**
 *
 * @export
 * @interface MfaEnrollResendOtpResponse
 */
export interface MfaEnrollResendOtpResponse {
  /**
   *
   * @type {any}
   * @memberof MfaEnrollResendOtpResponse
   */
  remainingResends?: any;
  /**
   *
   * @type {any}
   * @memberof MfaEnrollResendOtpResponse
   */
  message?: any;
}
/**
 *
 * @export
 * @interface MfaEnrollResponse
 */
export interface MfaEnrollResponse {
  /**
   *
   * @type {any}
   * @memberof MfaEnrollResponse
   */
  method?: any;
  /**
   *
   * @type {any}
   * @memberof MfaEnrollResponse
   */
  secret?: any;
  /**
   *
   * @type {any}
   * @memberof MfaEnrollResponse
   */
  enrollmentId?: any;
  /**
   *
   * @type {any}
   * @memberof MfaEnrollResponse
   */
  deviceId?: any;
  /**
   *
   * @type {any}
   * @memberof MfaEnrollResponse
   */
  deviceName?: any;
  /**
   *
   * @type {any}
   * @memberof MfaEnrollResponse
   */
  qrCodeUrl?: any;
  /**
   *
   * @type {any}
   * @memberof MfaEnrollResponse
   */
  qrCodeImage?: any;
  /**
   *
   * @type {any}
   * @memberof MfaEnrollResponse
   */
  backupCodes?: any;
  /**
   *
   * @type {any}
   * @memberof MfaEnrollResponse
   */
  requiresVerification?: any;
  /**
   *
   * @type {any}
   * @memberof MfaEnrollResponse
   */
  nextStep?: any;
  /**
   *
   * @type {any}
   * @memberof MfaEnrollResponse
   */
  otpRequired?: any;
  /**
   *
   * @type {any}
   * @memberof MfaEnrollResponse
   */
  enrollSessionId?: any;
  /**
   *
   * @type {any}
   * @memberof MfaEnrollResponse
   */
  message?: any;
}
/**
 *
 * @export
 * @interface MfaEnrollVerifyResponse
 */
export interface MfaEnrollVerifyResponse {
  /**
   *
   * @type {any}
   * @memberof MfaEnrollVerifyResponse
   */
  deviceId?: any;
  /**
   *
   * @type {any}
   * @memberof MfaEnrollVerifyResponse
   */
  verified?: any;
  /**
   *
   * @type {any}
   * @memberof MfaEnrollVerifyResponse
   */
  message?: any;
}
/**
 *
 * @export
 * @interface MfaSessionStatusResponse
 */
export interface MfaSessionStatusResponse {
  /**
   *
   * @type {any}
   * @memberof MfaSessionStatusResponse
   */
  sessionId?: any;
  /**
   *
   * @type {any}
   * @memberof MfaSessionStatusResponse
   */
  sourceType?: MfaSessionStatusResponseSourceTypeEnum;
  /**
   *
   * @type {any}
   * @memberof MfaSessionStatusResponse
   */
  method?: MfaSessionStatusResponseMethodEnum;
  /**
   *
   * @type {any}
   * @memberof MfaSessionStatusResponse
   */
  state?: MfaSessionStatusResponseStateEnum;
  /**
   *
   * @type {any}
   * @memberof MfaSessionStatusResponse
   */
  remainingAttempts?: any;
  /**
   *
   * @type {any}
   * @memberof MfaSessionStatusResponse
   */
  totalAttempts?: any;
  /**
   *
   * @type {any}
   * @memberof MfaSessionStatusResponse
   */
  createdAt?: any;
  /**
   *
   * @type {any}
   * @memberof MfaSessionStatusResponse
   */
  expiresAt?: any;
  /**
   *
   * @type {any}
   * @memberof MfaSessionStatusResponse
   */
  timeRemaining?: any;
  /**
   *
   * @type {any}
   * @memberof MfaSessionStatusResponse
   */
  canResend?: any;
  /**
   *
   * @type {any}
   * @memberof MfaSessionStatusResponse
   */
  maskedDestination?: any;
  /**
   *
   * @type {any}
   * @memberof MfaSessionStatusResponse
   */
  isExpired?: any;
  /**
   *
   * @type {any}
   * @memberof MfaSessionStatusResponse
   */
  statusMessage?: any;
}

export const MfaSessionStatusResponseSourceTypeEnum = {
  Login: "LOGIN",
  ChangePassword: "CHANGE_PASSWORD",
  Withdraw: "WITHDRAW",
} as const;

export type MfaSessionStatusResponseSourceTypeEnum =
  (typeof MfaSessionStatusResponseSourceTypeEnum)[keyof typeof MfaSessionStatusResponseSourceTypeEnum];
export const MfaSessionStatusResponseMethodEnum = {
  Totp: "TOTP",
  OtpSms: "OTP_SMS",
  OtpEmail: "OTP_EMAIL",
  FaceLiveness: "FACE_LIVENESS",
} as const;

export type MfaSessionStatusResponseMethodEnum =
  (typeof MfaSessionStatusResponseMethodEnum)[keyof typeof MfaSessionStatusResponseMethodEnum];
export const MfaSessionStatusResponseStateEnum = {
  Active: "ACTIVE",
  Expired: "EXPIRED",
  Cancelled: "CANCELLED",
  Completed: "COMPLETED",
  Blocked: "BLOCKED",
} as const;

export type MfaSessionStatusResponseStateEnum =
  (typeof MfaSessionStatusResponseStateEnum)[keyof typeof MfaSessionStatusResponseStateEnum];

/**
 *
 * @export
 * @interface MfaVerificationResponse
 */
export interface MfaVerificationResponse {
  /**
   *
   * @type {any}
   * @memberof MfaVerificationResponse
   */
  sessionId?: any;
  /**
   *
   * @type {any}
   * @memberof MfaVerificationResponse
   */
  verified?: any;
  /**
   *
   * @type {any}
   * @memberof MfaVerificationResponse
   */
  error?: any;
  /**
   *
   * @type {any}
   * @memberof MfaVerificationResponse
   */
  result?: any;
}
/**
 *
 * @export
 * @interface MfaVerifyRequest
 */
export interface MfaVerifyRequest {
  /**
   *
   * @type {any}
   * @memberof MfaVerifyRequest
   */
  enrollmentId?: any;
  /**
   *
   * @type {any}
   * @memberof MfaVerifyRequest
   */
  verificationCode: any;
  /**
   *
   * @type {any}
   * @memberof MfaVerifyRequest
   */
  mfaSessionId?: any;
}
/**
 *
 * @export
 * @interface PageApprovalRequestLite
 */
export interface PageApprovalRequestLite {
  /**
   *
   * @type {any}
   * @memberof PageApprovalRequestLite
   */
  totalElements?: any;
  /**
   *
   * @type {any}
   * @memberof PageApprovalRequestLite
   */
  totalPages?: any;
  /**
   *
   * @type {any}
   * @memberof PageApprovalRequestLite
   */
  first?: any;
  /**
   *
   * @type {any}
   * @memberof PageApprovalRequestLite
   */
  last?: any;
  /**
   *
   * @type {any}
   * @memberof PageApprovalRequestLite
   */
  size?: any;
  /**
   *
   * @type {any}
   * @memberof PageApprovalRequestLite
   */
  content?: any;
  /**
   *
   * @type {any}
   * @memberof PageApprovalRequestLite
   */
  number?: any;
  /**
   *
   * @type {SortObject}
   * @memberof PageApprovalRequestLite
   */
  sort?: SortObject;
  /**
   *
   * @type {any}
   * @memberof PageApprovalRequestLite
   */
  numberOfElements?: any;
  /**
   *
   * @type {PageableObject}
   * @memberof PageApprovalRequestLite
   */
  pageable?: PageableObject;
  /**
   *
   * @type {any}
   * @memberof PageApprovalRequestLite
   */
  empty?: any;
}
/**
 *
 * @export
 * @interface PageAuditLogLite
 */
export interface PageAuditLogLite {
  /**
   *
   * @type {any}
   * @memberof PageAuditLogLite
   */
  totalElements?: any;
  /**
   *
   * @type {any}
   * @memberof PageAuditLogLite
   */
  totalPages?: any;
  /**
   *
   * @type {any}
   * @memberof PageAuditLogLite
   */
  first?: any;
  /**
   *
   * @type {any}
   * @memberof PageAuditLogLite
   */
  last?: any;
  /**
   *
   * @type {any}
   * @memberof PageAuditLogLite
   */
  size?: any;
  /**
   *
   * @type {any}
   * @memberof PageAuditLogLite
   */
  content?: any;
  /**
   *
   * @type {any}
   * @memberof PageAuditLogLite
   */
  number?: any;
  /**
   *
   * @type {SortObject}
   * @memberof PageAuditLogLite
   */
  sort?: SortObject;
  /**
   *
   * @type {any}
   * @memberof PageAuditLogLite
   */
  numberOfElements?: any;
  /**
   *
   * @type {PageableObject}
   * @memberof PageAuditLogLite
   */
  pageable?: PageableObject;
  /**
   *
   * @type {any}
   * @memberof PageAuditLogLite
   */
  empty?: any;
}
/**
 *
 * @export
 * @interface PageAuthRoleGroupLite
 */
export interface PageAuthRoleGroupLite {
  /**
   *
   * @type {any}
   * @memberof PageAuthRoleGroupLite
   */
  totalElements?: any;
  /**
   *
   * @type {any}
   * @memberof PageAuthRoleGroupLite
   */
  totalPages?: any;
  /**
   *
   * @type {any}
   * @memberof PageAuthRoleGroupLite
   */
  first?: any;
  /**
   *
   * @type {any}
   * @memberof PageAuthRoleGroupLite
   */
  last?: any;
  /**
   *
   * @type {any}
   * @memberof PageAuthRoleGroupLite
   */
  size?: any;
  /**
   *
   * @type {any}
   * @memberof PageAuthRoleGroupLite
   */
  content?: any;
  /**
   *
   * @type {any}
   * @memberof PageAuthRoleGroupLite
   */
  number?: any;
  /**
   *
   * @type {SortObject}
   * @memberof PageAuthRoleGroupLite
   */
  sort?: SortObject;
  /**
   *
   * @type {any}
   * @memberof PageAuthRoleGroupLite
   */
  numberOfElements?: any;
  /**
   *
   * @type {PageableObject}
   * @memberof PageAuthRoleGroupLite
   */
  pageable?: PageableObject;
  /**
   *
   * @type {any}
   * @memberof PageAuthRoleGroupLite
   */
  empty?: any;
}
/**
 *
 * @export
 * @interface PageBoUserLite
 */
export interface PageBoUserLite {
  /**
   *
   * @type {any}
   * @memberof PageBoUserLite
   */
  totalElements?: any;
  /**
   *
   * @type {any}
   * @memberof PageBoUserLite
   */
  totalPages?: any;
  /**
   *
   * @type {any}
   * @memberof PageBoUserLite
   */
  first?: any;
  /**
   *
   * @type {any}
   * @memberof PageBoUserLite
   */
  last?: any;
  /**
   *
   * @type {any}
   * @memberof PageBoUserLite
   */
  size?: any;
  /**
   *
   * @type {any}
   * @memberof PageBoUserLite
   */
  content?: any;
  /**
   *
   * @type {any}
   * @memberof PageBoUserLite
   */
  number?: any;
  /**
   *
   * @type {SortObject}
   * @memberof PageBoUserLite
   */
  sort?: SortObject;
  /**
   *
   * @type {any}
   * @memberof PageBoUserLite
   */
  numberOfElements?: any;
  /**
   *
   * @type {PageableObject}
   * @memberof PageBoUserLite
   */
  pageable?: PageableObject;
  /**
   *
   * @type {any}
   * @memberof PageBoUserLite
   */
  empty?: any;
}
/**
 *
 * @export
 * @interface PageResponseMerchantAccountResponse
 */
export interface PageResponseMerchantAccountResponse {
  /**
   *
   * @type {any}
   * @memberof PageResponseMerchantAccountResponse
   */
  size?: any;
  /**
   *
   * @type {any}
   * @memberof PageResponseMerchantAccountResponse
   */
  page?: any;
  /**
   *
   * @type {any}
   * @memberof PageResponseMerchantAccountResponse
   */
  total?: any;
  /**
   *
   * @type {any}
   * @memberof PageResponseMerchantAccountResponse
   */
  items?: any;
}
/**
 *
 * @export
 * @interface PageResponseMerchantPermissionResponse
 */
export interface PageResponseMerchantPermissionResponse {
  /**
   *
   * @type {any}
   * @memberof PageResponseMerchantPermissionResponse
   */
  size?: any;
  /**
   *
   * @type {any}
   * @memberof PageResponseMerchantPermissionResponse
   */
  page?: any;
  /**
   *
   * @type {any}
   * @memberof PageResponseMerchantPermissionResponse
   */
  total?: any;
  /**
   *
   * @type {any}
   * @memberof PageResponseMerchantPermissionResponse
   */
  items?: any;
}
/**
 *
 * @export
 * @interface PageResponseMerchantRoleResponse
 */
export interface PageResponseMerchantRoleResponse {
  /**
   *
   * @type {any}
   * @memberof PageResponseMerchantRoleResponse
   */
  size?: any;
  /**
   *
   * @type {any}
   * @memberof PageResponseMerchantRoleResponse
   */
  page?: any;
  /**
   *
   * @type {any}
   * @memberof PageResponseMerchantRoleResponse
   */
  total?: any;
  /**
   *
   * @type {any}
   * @memberof PageResponseMerchantRoleResponse
   */
  items?: any;
}
/**
 *
 * @export
 * @interface PageSessionInfo
 */
export interface PageSessionInfo {
  /**
   *
   * @type {any}
   * @memberof PageSessionInfo
   */
  totalElements?: any;
  /**
   *
   * @type {any}
   * @memberof PageSessionInfo
   */
  totalPages?: any;
  /**
   *
   * @type {any}
   * @memberof PageSessionInfo
   */
  first?: any;
  /**
   *
   * @type {any}
   * @memberof PageSessionInfo
   */
  last?: any;
  /**
   *
   * @type {any}
   * @memberof PageSessionInfo
   */
  size?: any;
  /**
   *
   * @type {any}
   * @memberof PageSessionInfo
   */
  content?: any;
  /**
   *
   * @type {any}
   * @memberof PageSessionInfo
   */
  number?: any;
  /**
   *
   * @type {SortObject}
   * @memberof PageSessionInfo
   */
  sort?: SortObject;
  /**
   *
   * @type {any}
   * @memberof PageSessionInfo
   */
  numberOfElements?: any;
  /**
   *
   * @type {PageableObject}
   * @memberof PageSessionInfo
   */
  pageable?: PageableObject;
  /**
   *
   * @type {any}
   * @memberof PageSessionInfo
   */
  empty?: any;
}
/**
 *
 * @export
 * @interface PageUserLite
 */
export interface PageUserLite {
  /**
   *
   * @type {any}
   * @memberof PageUserLite
   */
  totalElements?: any;
  /**
   *
   * @type {any}
   * @memberof PageUserLite
   */
  totalPages?: any;
  /**
   *
   * @type {any}
   * @memberof PageUserLite
   */
  first?: any;
  /**
   *
   * @type {any}
   * @memberof PageUserLite
   */
  last?: any;
  /**
   *
   * @type {any}
   * @memberof PageUserLite
   */
  size?: any;
  /**
   *
   * @type {any}
   * @memberof PageUserLite
   */
  content?: any;
  /**
   *
   * @type {any}
   * @memberof PageUserLite
   */
  number?: any;
  /**
   *
   * @type {SortObject}
   * @memberof PageUserLite
   */
  sort?: SortObject;
  /**
   *
   * @type {any}
   * @memberof PageUserLite
   */
  numberOfElements?: any;
  /**
   *
   * @type {PageableObject}
   * @memberof PageUserLite
   */
  pageable?: PageableObject;
  /**
   *
   * @type {any}
   * @memberof PageUserLite
   */
  empty?: any;
}
/**
 *
 * @export
 * @interface PageableObject
 */
export interface PageableObject {
  /**
   *
   * @type {any}
   * @memberof PageableObject
   */
  offset?: any;
  /**
   *
   * @type {SortObject}
   * @memberof PageableObject
   */
  sort?: SortObject;
  /**
   *
   * @type {any}
   * @memberof PageableObject
   */
  unpaged?: any;
  /**
   *
   * @type {any}
   * @memberof PageableObject
   */
  paged?: any;
  /**
   *
   * @type {any}
   * @memberof PageableObject
   */
  pageNumber?: any;
  /**
   *
   * @type {any}
   * @memberof PageableObject
   */
  pageSize?: any;
}
/**
 *
 * @export
 * @interface PortalFeature
 */
export interface PortalFeature {
  /**
   *
   * @type {any}
   * @memberof PortalFeature
   */
  name?: any;
  /**
   *
   * @type {any}
   * @memberof PortalFeature
   */
  description?: any;
  /**
   *
   * @type {any}
   * @memberof PortalFeature
   */
  code?: any;
}
/**
 *
 * @export
 * @interface PutRolesRequest
 */
export interface PutRolesRequest {
  /**
   *
   * @type {any}
   * @memberof PutRolesRequest
   */
  roleCodes?: any;
}
/**
 *
 * @export
 * @interface RefreshTokenRequest
 */
export interface RefreshTokenRequest {
  /**
   *
   * @type {any}
   * @memberof RefreshTokenRequest
   */
  refreshToken: any;
}
/**
 *
 * @export
 * @interface RegisterRequest
 */
export interface RegisterRequest {
  /**
   *
   * @type {any}
   * @memberof RegisterRequest
   */
  phoneNumber: any;
  /**
   *
   * @type {any}
   * @memberof RegisterRequest
   */
  password: any;
  /**
   *
   * @type {any}
   * @memberof RegisterRequest
   */
  verificationToken: any;
  /**
   *
   * @type {any}
   * @memberof RegisterRequest
   */
  deviceFingerprintId?: any;
  /**
   *
   * @type {RequestMetadata}
   * @memberof RegisterRequest
   */
  metadata?: RequestMetadata;
}
/**
 *
 * @export
 * @interface RejectRequest
 */
export interface RejectRequest {
  /**
   *
   * @type {any}
   * @memberof RejectRequest
   */
  reason: any;
}
/**
 *
 * @export
 * @interface ReloadMerchantRoleCatalogRequest
 */
export interface ReloadMerchantRoleCatalogRequest {
  /**
   * When true, hard-delete INACTIVE system roles + permissions missing from JSON. Default false (mark INACTIVE only). NEVER hard-deletes custom roles.
   * @type {any}
   * @memberof ReloadMerchantRoleCatalogRequest
   */
  forceDelete?: any;
  /**
   * When true, bypass Redis checksum-skip and force full re-evaluate. Default true (manual reload semantics — operator wants to re-sync).
   * @type {any}
   * @memberof ReloadMerchantRoleCatalogRequest
   */
  force?: any;
}
/**
 *
 * @export
 * @interface RequestMetadata
 */
export interface RequestMetadata {
  [key: string]: any;

  /**
   *
   * @type {any}
   * @memberof RequestMetadata
   */
  source?: any;
  /**
   *
   * @type {any}
   * @memberof RequestMetadata
   */
  publicKey?: any;
  /**
   *
   * @type {any}
   * @memberof RequestMetadata
   */
  algorithm?: any;
  /**
   *
   * @type {any}
   * @memberof RequestMetadata
   */
  timestamp?: any;
  /**
   *
   * @type {any}
   * @memberof RequestMetadata
   */
  deviceType?: any;
  /**
   *
   * @type {any}
   * @memberof RequestMetadata
   */
  ipAddress?: any;
  /**
   *
   * @type {any}
   * @memberof RequestMetadata
   */
  userAgent?: any;
  /**
   *
   * @type {any}
   * @memberof RequestMetadata
   */
  deviceId?: any;
  /**
   *
   * @type {any}
   * @memberof RequestMetadata
   */
  deviceName?: any;
  /**
   *
   * @type {any}
   * @memberof RequestMetadata
   */
  osInfo?: any;
  /**
   *
   * @type {any}
   * @memberof RequestMetadata
   */
  empty?: any;
}
/**
 *
 * @export
 * @interface ResendResponse
 */
export interface ResendResponse {
  /**
   *
   * @type {any}
   * @memberof ResendResponse
   */
  remainSendAttempts?: any;
}
/**
 *
 * @export
 * @interface ResourceGroupAssignment
 */
export interface ResourceGroupAssignment {
  /**
   *
   * @type {any}
   * @memberof ResourceGroupAssignment
   */
  userId?: any;
  /**
   *
   * @type {any}
   * @memberof ResourceGroupAssignment
   */
  resourceId?: any;
  /**
   *
   * @type {any}
   * @memberof ResourceGroupAssignment
   */
  resourceName?: any;
  /**
   *
   * @type {any}
   * @memberof ResourceGroupAssignment
   */
  groupId?: any;
  /**
   *
   * @type {any}
   * @memberof ResourceGroupAssignment
   */
  groupName?: any;
  /**
   *
   * @type {any}
   * @memberof ResourceGroupAssignment
   */
  roleType?: any;
}
/**
 *
 * @export
 * @interface RoleGroupAssignment
 */
export interface RoleGroupAssignment {
  /**
   *
   * @type {any}
   * @memberof RoleGroupAssignment
   */
  resourceId?: any;
  /**
   *
   * @type {any}
   * @memberof RoleGroupAssignment
   */
  resourceName?: any;
  /**
   *
   * @type {any}
   * @memberof RoleGroupAssignment
   */
  groupId?: any;
  /**
   *
   * @type {any}
   * @memberof RoleGroupAssignment
   */
  groupCode?: any;
  /**
   *
   * @type {any}
   * @memberof RoleGroupAssignment
   */
  groupName?: any;
  /**
   *
   * @type {any}
   * @memberof RoleGroupAssignment
   */
  roleType?: any;
  /**
   *
   * @type {any}
   * @memberof RoleGroupAssignment
   */
  roles?: any;
}
/**
 *
 * @export
 * @interface SendOtpRequest
 */
export interface SendOtpRequest {
  /**
   *
   * @type {any}
   * @memberof SendOtpRequest
   */
  phoneNumber: any;
  /**
   *
   * @type {any}
   * @memberof SendOtpRequest
   */
  countryCode: any;
  /**
   *
   * @type {any}
   * @memberof SendOtpRequest
   */
  language?: any;
  /**
   *
   * @type {any}
   * @memberof SendOtpRequest
   */
  purpose?: any;
  /**
   *
   * @type {RequestMetadata}
   * @memberof SendOtpRequest
   */
  metadata?: RequestMetadata;
}
/**
 *
 * @export
 * @interface SendOtpResponse
 */
export interface SendOtpResponse {
  /**
   *
   * @type {any}
   * @memberof SendOtpResponse
   */
  requestId?: any;
  /**
   *
   * @type {any}
   * @memberof SendOtpResponse
   */
  smsId?: any;
  /**
   *
   * @type {any}
   * @memberof SendOtpResponse
   */
  phoneNumber?: any;
  /**
   *
   * @type {any}
   * @memberof SendOtpResponse
   */
  remainingSendAttempt?: any;
  /**
   *
   * @type {any}
   * @memberof SendOtpResponse
   */
  otpSent?: any;
  /**
   *
   * @type {any}
   * @memberof SendOtpResponse
   */
  expiresAt?: any;
}
/**
 *
 * @export
 * @interface SessionInfo
 */
export interface SessionInfo {
  /**
   *
   * @type {any}
   * @memberof SessionInfo
   */
  sessionId?: any;
  /**
   *
   * @type {any}
   * @memberof SessionInfo
   */
  userId?: any;
  /**
   *
   * @type {any}
   * @memberof SessionInfo
   */
  ipAddress?: any;
  /**
   *
   * @type {any}
   * @memberof SessionInfo
   */
  browser?: any;
  /**
   *
   * @type {any}
   * @memberof SessionInfo
   */
  os?: any;
  /**
   *
   * @type {any}
   * @memberof SessionInfo
   */
  deviceType?: any;
  /**
   *
   * @type {any}
   * @memberof SessionInfo
   */
  createdAt?: any;
  /**
   *
   * @type {any}
   * @memberof SessionInfo
   */
  lastActivityAt?: any;
  /**
   *
   * @type {any}
   * @memberof SessionInfo
   */
  current?: any;
}
/**
 *
 * @export
 * @interface SortObject
 */
export interface SortObject {
  /**
   *
   * @type {any}
   * @memberof SortObject
   */
  empty?: any;
  /**
   *
   * @type {any}
   * @memberof SortObject
   */
  sorted?: any;
  /**
   *
   * @type {any}
   * @memberof SortObject
   */
  unsorted?: any;
}
/**
 *
 * @export
 * @interface SuspendMerchantAccountRequest
 */
export interface SuspendMerchantAccountRequest {
  /**
   *
   * @type {any}
   * @memberof SuspendMerchantAccountRequest
   */
  reason: any;
}
/**
 *
 * @export
 * @interface TwoFactorAuthDto
 */
export interface TwoFactorAuthDto {
  /**
   *
   * @type {any}
   * @memberof TwoFactorAuthDto
   */
  enabled?: any;
  /**
   *
   * @type {any}
   * @memberof TwoFactorAuthDto
   */
  method?: any;
  /**
   *
   * @type {any}
   * @memberof TwoFactorAuthDto
   */
  otpChannel?: any;
  /**
   *
   * @type {any}
   * @memberof TwoFactorAuthDto
   */
  lastVerifiedAt?: any;
}
/**
 *
 * @export
 * @interface TxnAuthInitiateRequest
 */
export interface TxnAuthInitiateRequest {
  /**
   *
   * @type {any}
   * @memberof TxnAuthInitiateRequest
   */
  userId: any;
  /**
   *
   * @type {any}
   * @memberof TxnAuthInitiateRequest
   */
  verifyLevel?: TxnAuthInitiateRequestVerifyLevelEnum;
  /**
   *
   * @type {any}
   * @memberof TxnAuthInitiateRequest
   */
  amount?: any;
  /**
   *
   * @type {any}
   * @memberof TxnAuthInitiateRequest
   */
  txnType?: TxnAuthInitiateRequestTxnTypeEnum;
}

export const TxnAuthInitiateRequestVerifyLevelEnum = {
  _1: "LEVEL_1",
  _2: "LEVEL_2",
  _3: "LEVEL_3",
} as const;

export type TxnAuthInitiateRequestVerifyLevelEnum =
  (typeof TxnAuthInitiateRequestVerifyLevelEnum)[keyof typeof TxnAuthInitiateRequestVerifyLevelEnum];
export const TxnAuthInitiateRequestTxnTypeEnum = {
  Deposit: "DEPOSIT",
  Withdrawal: "WITHDRAWAL",
  P2PTransfer: "P2P_TRANSFER",
  BankTransfer: "BANK_TRANSFER",
  BillPayment: "BILL_PAYMENT",
  LinkBank: "LINK_BANK",
  UnlinkBank: "UNLINK_BANK",
} as const;

export type TxnAuthInitiateRequestTxnTypeEnum =
  (typeof TxnAuthInitiateRequestTxnTypeEnum)[keyof typeof TxnAuthInitiateRequestTxnTypeEnum];

/**
 *
 * @export
 * @interface TxnAuthInitiateResponse
 */
export interface TxnAuthInitiateResponse {
  /**
   *
   * @type {any}
   * @memberof TxnAuthInitiateResponse
   */
  verifySessionId?: any;
  /**
   *
   * @type {any}
   * @memberof TxnAuthInitiateResponse
   */
  steps?: any;
}
/**
 *
 * @export
 * @interface TxnAuthSessionStatusResponse
 */
export interface TxnAuthSessionStatusResponse {
  /**
   *
   * @type {any}
   * @memberof TxnAuthSessionStatusResponse
   */
  verifySessionId?: any;
  /**
   *
   * @type {any}
   * @memberof TxnAuthSessionStatusResponse
   */
  verified?: any;
  /**
   *
   * @type {any}
   * @memberof TxnAuthSessionStatusResponse
   */
  verifyLevel?: TxnAuthSessionStatusResponseVerifyLevelEnum;
  /**
   *
   * @type {any}
   * @memberof TxnAuthSessionStatusResponse
   */
  userId?: any;
  /**
   *
   * @type {any}
   * @memberof TxnAuthSessionStatusResponse
   */
  completedAt?: any;
  /**
   *
   * @type {any}
   * @memberof TxnAuthSessionStatusResponse
   */
  txnType?: TxnAuthSessionStatusResponseTxnTypeEnum;
}

export const TxnAuthSessionStatusResponseVerifyLevelEnum = {
  _1: "LEVEL_1",
  _2: "LEVEL_2",
  _3: "LEVEL_3",
} as const;

export type TxnAuthSessionStatusResponseVerifyLevelEnum =
  (typeof TxnAuthSessionStatusResponseVerifyLevelEnum)[keyof typeof TxnAuthSessionStatusResponseVerifyLevelEnum];
export const TxnAuthSessionStatusResponseTxnTypeEnum = {
  Deposit: "DEPOSIT",
  Withdrawal: "WITHDRAWAL",
  P2PTransfer: "P2P_TRANSFER",
  BankTransfer: "BANK_TRANSFER",
  BillPayment: "BILL_PAYMENT",
  LinkBank: "LINK_BANK",
  UnlinkBank: "UNLINK_BANK",
} as const;

export type TxnAuthSessionStatusResponseTxnTypeEnum =
  (typeof TxnAuthSessionStatusResponseTxnTypeEnum)[keyof typeof TxnAuthSessionStatusResponseTxnTypeEnum];

/**
 *
 * @export
 * @interface TxnAuthVerifyRequest
 */
export interface TxnAuthVerifyRequest {
  /**
   *
   * @type {any}
   * @memberof TxnAuthVerifyRequest
   */
  verifySessionId: any;
  /**
   *
   * @type {any}
   * @memberof TxnAuthVerifyRequest
   */
  step: TxnAuthVerifyRequestStepEnum;
  /**
   *
   * @type {any}
   * @memberof TxnAuthVerifyRequest
   */
  pin?: any;
  /**
   *
   * @type {any}
   * @memberof TxnAuthVerifyRequest
   */
  code?: any;
  /**
   *
   * @type {any}
   * @memberof TxnAuthVerifyRequest
   */
  signature?: any;
  /**
   *
   * @type {any}
   * @memberof TxnAuthVerifyRequest
   */
  selfieBase64?: any;
  /**
   *
   * @type {any}
   * @memberof TxnAuthVerifyRequest
   */
  deviceFingerprintId?: any;
}

export const TxnAuthVerifyRequestStepEnum = {
  Pin: "VERIFY_PIN",
  Otp: "VERIFY_OTP",
  Face: "VERIFY_FACE",
} as const;

export type TxnAuthVerifyRequestStepEnum =
  (typeof TxnAuthVerifyRequestStepEnum)[keyof typeof TxnAuthVerifyRequestStepEnum];

/**
 *
 * @export
 * @interface TxnAuthVerifyResponse
 */
export interface TxnAuthVerifyResponse {
  /**
   *
   * @type {any}
   * @memberof TxnAuthVerifyResponse
   */
  verifySessionId?: any;
  /**
   *
   * @type {any}
   * @memberof TxnAuthVerifyResponse
   */
  stepResult?: any;
  /**
   *
   * @type {any}
   * @memberof TxnAuthVerifyResponse
   */
  verified?: any;
  /**
   *
   * @type {any}
   * @memberof TxnAuthVerifyResponse
   */
  nextStep?: TxnAuthVerifyResponseNextStepEnum;
  /**
   *
   * @type {any}
   * @memberof TxnAuthVerifyResponse
   */
  remainingSteps?: any;
  /**
   *
   * @type {any}
   * @memberof TxnAuthVerifyResponse
   */
  attemptsRemaining?: any;
  /**
   *
   * @type {any}
   * @memberof TxnAuthVerifyResponse
   */
  maxAttempts?: any;
}

export const TxnAuthVerifyResponseNextStepEnum = {
  Pin: "VERIFY_PIN",
  Otp: "VERIFY_OTP",
  Face: "VERIFY_FACE",
} as const;

export type TxnAuthVerifyResponseNextStepEnum =
  (typeof TxnAuthVerifyResponseNextStepEnum)[keyof typeof TxnAuthVerifyResponseNextStepEnum];

/**
 *
 * @export
 * @interface UpdateMerchantAccountRoleRequest
 */
export interface UpdateMerchantAccountRoleRequest {
  /**
   *
   * @type {any}
   * @memberof UpdateMerchantAccountRoleRequest
   */
  roleId: any;
}
/**
 *
 * @export
 * @interface UpdateMerchantRoleRequest
 */
export interface UpdateMerchantRoleRequest {
  /**
   *
   * @type {any}
   * @memberof UpdateMerchantRoleRequest
   */
  name: any;
  /**
   *
   * @type {any}
   * @memberof UpdateMerchantRoleRequest
   */
  description?: any;
}
/**
 *
 * @export
 * @interface UpdateMerchantRoleStatusRequest
 */
export interface UpdateMerchantRoleStatusRequest {
  /**
   *
   * @type {any}
   * @memberof UpdateMerchantRoleStatusRequest
   */
  status: any;
}
/**
 *
 * @export
 * @interface UpdateProfileRequest
 */
export interface UpdateProfileRequest {
  /**
   *
   * @type {any}
   * @memberof UpdateProfileRequest
   */
  userId: any;
  /**
   *
   * @type {any}
   * @memberof UpdateProfileRequest
   */
  firstName: any;
  /**
   *
   * @type {any}
   * @memberof UpdateProfileRequest
   */
  lastName: any;
  /**
   *
   * @type {any}
   * @memberof UpdateProfileRequest
   */
  dateOfBirth?: any;
  /**
   *
   * @type {any}
   * @memberof UpdateProfileRequest
   */
  nationality?: any;
  /**
   *
   * @type {UpdateProfileRequestMetadata}
   * @memberof UpdateProfileRequest
   */
  metadata?: UpdateProfileRequestMetadata;
}
/**
 *
 * @export
 * @interface UpdateProfileRequestMetadata
 */
export interface UpdateProfileRequestMetadata {
  [key: string]: any;

  /**
   *
   * @type {any}
   * @memberof UpdateProfileRequestMetadata
   */
  source?: any;
  /**
   *
   * @type {any}
   * @memberof UpdateProfileRequestMetadata
   */
  publicKey?: any;
  /**
   *
   * @type {any}
   * @memberof UpdateProfileRequestMetadata
   */
  algorithm?: any;
  /**
   *
   * @type {any}
   * @memberof UpdateProfileRequestMetadata
   */
  timestamp?: any;
  /**
   *
   * @type {any}
   * @memberof UpdateProfileRequestMetadata
   */
  deviceType?: any;
  /**
   *
   * @type {any}
   * @memberof UpdateProfileRequestMetadata
   */
  ipAddress?: any;
  /**
   *
   * @type {any}
   * @memberof UpdateProfileRequestMetadata
   */
  userAgent?: any;
  /**
   *
   * @type {any}
   * @memberof UpdateProfileRequestMetadata
   */
  deviceId?: any;
  /**
   *
   * @type {any}
   * @memberof UpdateProfileRequestMetadata
   */
  deviceName?: any;
  /**
   *
   * @type {any}
   * @memberof UpdateProfileRequestMetadata
   */
  osInfo?: any;
  /**
   *
   * @type {any}
   * @memberof UpdateProfileRequestMetadata
   */
  empty?: any;
}
/**
 *
 * @export
 * @interface UpdateProfileResponse
 */
export interface UpdateProfileResponse {
  /**
   *
   * @type {any}
   * @memberof UpdateProfileResponse
   */
  success?: any;
}
/**
 *
 * @export
 * @interface UpdateRoleGroupRequest
 */
export interface UpdateRoleGroupRequest {
  /**
   *
   * @type {any}
   * @memberof UpdateRoleGroupRequest
   */
  groupId: any;
  /**
   *
   * @type {any}
   * @memberof UpdateRoleGroupRequest
   */
  name: any;
  /**
   *
   * @type {any}
   * @memberof UpdateRoleGroupRequest
   */
  description?: any;
  /**
   *
   * @type {any}
   * @memberof UpdateRoleGroupRequest
   */
  roleType: UpdateRoleGroupRequestRoleTypeEnum;
  /**
   *
   * @type {any}
   * @memberof UpdateRoleGroupRequest
   */
  resourceId: any;
  /**
   *
   * @type {any}
   * @memberof UpdateRoleGroupRequest
   */
  roleCodes: any;
}

export const UpdateRoleGroupRequestRoleTypeEnum = {
  Super: "SUPER",
  Maker: "MAKER",
  Checker: "CHECKER",
  Viewer: "VIEWER",
} as const;

export type UpdateRoleGroupRequestRoleTypeEnum =
  (typeof UpdateRoleGroupRequestRoleTypeEnum)[keyof typeof UpdateRoleGroupRequestRoleTypeEnum];

/**
 *
 * @export
 * @interface UserInfo
 */
export interface UserInfo {
  /**
   *
   * @type {any}
   * @memberof UserInfo
   */
  id?: any;
  /**
   *
   * @type {any}
   * @memberof UserInfo
   */
  username?: any;
  /**
   *
   * @type {any}
   * @memberof UserInfo
   */
  email?: any;
  /**
   *
   * @type {any}
   * @memberof UserInfo
   */
  status?: any;
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof UserInfo
   */
  roleCodes?: { [key: string]: any };
  /**
   *
   * @type {any}
   * @memberof UserInfo
   */
  firstName?: any;
  /**
   *
   * @type {any}
   * @memberof UserInfo
   */
  lastName?: any;
}
/**
 *
 * @export
 * @interface UserInfoResponse
 */
export interface UserInfoResponse {
  /**
   *
   * @type {any}
   * @memberof UserInfoResponse
   */
  id?: any;
  /**
   *
   * @type {any}
   * @memberof UserInfoResponse
   */
  username?: any;
  /**
   *
   * @type {any}
   * @memberof UserInfoResponse
   */
  email?: any;
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof UserInfoResponse
   */
  roleCodes?: { [key: string]: any };
  /**
   *
   * @type {any}
   * @memberof UserInfoResponse
   */
  firstName?: any;
  /**
   *
   * @type {any}
   * @memberof UserInfoResponse
   */
  lastName?: any;
  /**
   *
   * @type {any}
   * @memberof UserInfoResponse
   */
  emailVerified?: any;
  /**
   *
   * @type {any}
   * @memberof UserInfoResponse
   */
  phoneNumber?: any;
  /**
   *
   * @type {any}
   * @memberof UserInfoResponse
   */
  phoneVerified?: any;
  /**
   *
   * @type {any}
   * @memberof UserInfoResponse
   */
  accountStatus?: UserInfoResponseAccountStatusEnum;
  /**
   *
   * @type {any}
   * @memberof UserInfoResponse
   */
  createdAt?: any;
}

export const UserInfoResponseAccountStatusEnum = {
  Active: "ACTIVE",
  Inactive: "INACTIVE",
} as const;

export type UserInfoResponseAccountStatusEnum =
  (typeof UserInfoResponseAccountStatusEnum)[keyof typeof UserInfoResponseAccountStatusEnum];

/**
 *
 * @export
 * @interface UserLite
 */
export interface UserLite {
  /**
   *
   * @type {any}
   * @memberof UserLite
   */
  id?: any;
  /**
   *
   * @type {any}
   * @memberof UserLite
   */
  username?: any;
  /**
   *
   * @type {any}
   * @memberof UserLite
   */
  email?: any;
  /**
   *
   * @type {any}
   * @memberof UserLite
   */
  familyName?: any;
  /**
   *
   * @type {any}
   * @memberof UserLite
   */
  givenName?: any;
}
/**
 *
 * @export
 * @interface VerifyMfaSessionRequest
 */
export interface VerifyMfaSessionRequest {
  /**
   *
   * @type {any}
   * @memberof VerifyMfaSessionRequest
   */
  sessionId: any;
  /**
   *
   * @type {any}
   * @memberof VerifyMfaSessionRequest
   */
  verificationCode: any;
  /**
   *
   * @type {any}
   * @memberof VerifyMfaSessionRequest
   */
  deviceId?: any;
  /**
   *
   * @type {any}
   * @memberof VerifyMfaSessionRequest
   */
  rememberDevice?: any;
}
/**
 *
 * @export
 * @interface VerifyOtpRequest
 */
export interface VerifyOtpRequest {
  /**
   *
   * @type {any}
   * @memberof VerifyOtpRequest
   */
  requestId: any;
  /**
   *
   * @type {any}
   * @memberof VerifyOtpRequest
   */
  phoneNumber: any;
  /**
   *
   * @type {any}
   * @memberof VerifyOtpRequest
   */
  otpCode: any;
}
/**
 *
 * @export
 * @interface VerifyOtpResponse
 */
export interface VerifyOtpResponse {
  /**
   *
   * @type {any}
   * @memberof VerifyOtpResponse
   */
  verified?: any;
  /**
   *
   * @type {any}
   * @memberof VerifyOtpResponse
   */
  phoneNumber?: any;
  /**
   *
   * @type {any}
   * @memberof VerifyOtpResponse
   */
  verifiedAt?: any;
  /**
   *
   * @type {any}
   * @memberof VerifyOtpResponse
   */
  attemptsRemaining?: any;
  /**
   *
   * @type {any}
   * @memberof VerifyOtpResponse
   */
  maxAttempts?: any;
  /**
   *
   * @type {any}
   * @memberof VerifyOtpResponse
   */
  verificationToken?: any;
}
/**
 *
 * @export
 * @interface VerifyPasswordRequest
 */
export interface VerifyPasswordRequest {
  /**
   *
   * @type {any}
   * @memberof VerifyPasswordRequest
   */
  password: any;
  /**
   *
   * @type {any}
   * @memberof VerifyPasswordRequest
   */
  feature: VerifyPasswordRequestFeatureEnum;
}

export const VerifyPasswordRequestFeatureEnum = {
  Login: "LOGIN",
  MfaEnroll: "MFA_ENROLL",
  ChangePin: "CHANGE_PIN",
  BiometricEnroll: "BIOMETRIC_ENROLL",
  GenerateSmartOtp: "GENERATE_SMART_OTP",
  Transfer: "TRANSFER",
  Topup: "TOPUP",
  Withdraw: "WITHDRAW",
  QrTransfer: "QR_TRANSFER",
  TxnAuth: "TXN_AUTH",
  RegistrationOtp: "REGISTRATION_OTP",
  ForgotPassword: "FORGOT_PASSWORD",
} as const;

export type VerifyPasswordRequestFeatureEnum =
  (typeof VerifyPasswordRequestFeatureEnum)[keyof typeof VerifyPasswordRequestFeatureEnum];

/**
 *
 * @export
 * @interface VerifyPasswordResponse
 */
export interface VerifyPasswordResponse {
  /**
   *
   * @type {any}
   * @memberof VerifyPasswordResponse
   */
  verified?: any;
  /**
   *
   * @type {any}
   * @memberof VerifyPasswordResponse
   */
  attemptsRemaining?: any;
  /**
   *
   * @type {any}
   * @memberof VerifyPasswordResponse
   */
  maxAttempts?: any;
}

/**
 * APIDocumentationApi - axios parameter creator
 * @export
 */
export const APIDocumentationApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Returns the health status of API documentation components
     * @summary API documentation health check
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getApiDocHealth: async (
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/docs/health`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Returns information about available API documentation endpoints and configuration
     * @summary Get API documentation information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getApiDocInfo: async (
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/docs/info`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * APIDocumentationApi - functional programming interface
 * @export
 */
export const APIDocumentationApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    APIDocumentationApiAxiosParamCreator(configuration);
  return {
    /**
     * Returns the health status of API documentation components
     * @summary API documentation health check
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getApiDocHealth(
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<ApiResponseMapStringString>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getApiDocHealth(options);
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Returns information about available API documentation endpoints and configuration
     * @summary Get API documentation information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getApiDocInfo(
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<ApiResponseMapStringObject>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getApiDocInfo(options);
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
  };
};

/**
 * APIDocumentationApi - factory interface
 * @export
 */
export const APIDocumentationApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = APIDocumentationApiFp(configuration);
  return {
    /**
     * Returns the health status of API documentation components
     * @summary API documentation health check
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getApiDocHealth(options?: any): AxiosPromise<ApiResponseMapStringString> {
      return localVarFp
        .getApiDocHealth(options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Returns information about available API documentation endpoints and configuration
     * @summary Get API documentation information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getApiDocInfo(options?: any): AxiosPromise<ApiResponseMapStringObject> {
      return localVarFp
        .getApiDocInfo(options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * APIDocumentationApi - object-oriented interface
 * @export
 * @class APIDocumentationApi
 * @extends {BaseAPI}
 */
export class APIDocumentationApi extends BaseAPI {
  /**
   * Returns the health status of API documentation components
   * @summary API documentation health check
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof APIDocumentationApi
   */
  public getApiDocHealth(options?: AxiosRequestConfig) {
    return APIDocumentationApiFp(this.configuration)
      .getApiDocHealth(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Returns information about available API documentation endpoints and configuration
   * @summary Get API documentation information
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof APIDocumentationApi
   */
  public getApiDocInfo(options?: AxiosRequestConfig) {
    return APIDocumentationApiFp(this.configuration)
      .getApiDocInfo(options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * BackOfficeEndUserAuthManagementApi - axios parameter creator
 * @export
 */
export const BackOfficeEndUserAuthManagementApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Get account information and 2FA status for end-user. Includes masked sensitive data (phone, email, IP addresses). Requires: ewallet:ew_end_user_auth:view permission
     * @summary Get Auth Overview
     * @param {any} userId End-user ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAuthOverview: async (
      userId: any,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      assertParamExists("getAuthOverview", "userId", userId);
      const localVarPath = `/bo/api/v1/users/{userId}/auth/overview`.replace(
        `{${"userId"}}`,
        encodeURIComponent(String(userId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Get linked devices and trust status for end-user. Includes device name, OS, channel, masked device ID, linked/last access time. Requires: ewallet:ew_end_user_auth:view permission
     * @summary Get Linked Devices
     * @param {any} userId End-user ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLinkedDevices: async (
      userId: any,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      assertParamExists("getLinkedDevices", "userId", userId);
      const localVarPath = `/bo/api/v1/users/{userId}/auth/devices`.replace(
        `{${"userId"}}`,
        encodeURIComponent(String(userId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Get last 10 login sessions for end-user with details: login/logout time, channel, auth method, device, IP (masked), result, status. Requires: ewallet:ew_end_user_auth:view permission
     * @summary Get Login History
     * @param {any} userId End-user ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLoginHistory: async (
      userId: any,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      assertParamExists("getLoginHistory", "userId", userId);
      const localVarPath =
        `/bo/api/v1/users/{userId}/auth/login-history`.replace(
          `{${"userId"}}`,
          encodeURIComponent(String(userId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * BackOfficeEndUserAuthManagementApi - functional programming interface
 * @export
 */
export const BackOfficeEndUserAuthManagementApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    BackOfficeEndUserAuthManagementApiAxiosParamCreator(configuration);
  return {
    /**
     * Get account information and 2FA status for end-user. Includes masked sensitive data (phone, email, IP addresses). Requires: ewallet:ew_end_user_auth:view permission
     * @summary Get Auth Overview
     * @param {any} userId End-user ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getAuthOverview(
      userId: any,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<AuthOverviewDto>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getAuthOverview(
        userId,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Get linked devices and trust status for end-user. Includes device name, OS, channel, masked device ID, linked/last access time. Requires: ewallet:ew_end_user_auth:view permission
     * @summary Get Linked Devices
     * @param {any} userId End-user ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getLinkedDevices(
      userId: any,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getLinkedDevices(userId, options);
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Get last 10 login sessions for end-user with details: login/logout time, channel, auth method, device, IP (masked), result, status. Requires: ewallet:ew_end_user_auth:view permission
     * @summary Get Login History
     * @param {any} userId End-user ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getLoginHistory(
      userId: any,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getLoginHistory(
        userId,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
  };
};

/**
 * BackOfficeEndUserAuthManagementApi - factory interface
 * @export
 */
export const BackOfficeEndUserAuthManagementApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = BackOfficeEndUserAuthManagementApiFp(configuration);
  return {
    /**
     * Get account information and 2FA status for end-user. Includes masked sensitive data (phone, email, IP addresses). Requires: ewallet:ew_end_user_auth:view permission
     * @summary Get Auth Overview
     * @param {any} userId End-user ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAuthOverview(userId: any, options?: any): AxiosPromise<AuthOverviewDto> {
      return localVarFp
        .getAuthOverview(userId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Get linked devices and trust status for end-user. Includes device name, OS, channel, masked device ID, linked/last access time. Requires: ewallet:ew_end_user_auth:view permission
     * @summary Get Linked Devices
     * @param {any} userId End-user ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLinkedDevices(userId: any, options?: any): AxiosPromise<any> {
      return localVarFp
        .getLinkedDevices(userId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Get last 10 login sessions for end-user with details: login/logout time, channel, auth method, device, IP (masked), result, status. Requires: ewallet:ew_end_user_auth:view permission
     * @summary Get Login History
     * @param {any} userId End-user ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLoginHistory(userId: any, options?: any): AxiosPromise<any> {
      return localVarFp
        .getLoginHistory(userId, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for getAuthOverview operation in BackOfficeEndUserAuthManagementApi.
 * @export
 * @interface BackOfficeEndUserAuthManagementApiGetAuthOverviewRequest
 */
export interface BackOfficeEndUserAuthManagementApiGetAuthOverviewRequest {
  /**
   * End-user ID
   * @type {any}
   * @memberof BackOfficeEndUserAuthManagementApiGetAuthOverview
   */
  readonly userId: any;
}

/**
 * Request parameters for getLinkedDevices operation in BackOfficeEndUserAuthManagementApi.
 * @export
 * @interface BackOfficeEndUserAuthManagementApiGetLinkedDevicesRequest
 */
export interface BackOfficeEndUserAuthManagementApiGetLinkedDevicesRequest {
  /**
   * End-user ID
   * @type {any}
   * @memberof BackOfficeEndUserAuthManagementApiGetLinkedDevices
   */
  readonly userId: any;
}

/**
 * Request parameters for getLoginHistory operation in BackOfficeEndUserAuthManagementApi.
 * @export
 * @interface BackOfficeEndUserAuthManagementApiGetLoginHistoryRequest
 */
export interface BackOfficeEndUserAuthManagementApiGetLoginHistoryRequest {
  /**
   * End-user ID
   * @type {any}
   * @memberof BackOfficeEndUserAuthManagementApiGetLoginHistory
   */
  readonly userId: any;
}

/**
 * BackOfficeEndUserAuthManagementApi - object-oriented interface
 * @export
 * @class BackOfficeEndUserAuthManagementApi
 * @extends {BaseAPI}
 */
export class BackOfficeEndUserAuthManagementApi extends BaseAPI {
  /**
   * Get account information and 2FA status for end-user. Includes masked sensitive data (phone, email, IP addresses). Requires: ewallet:ew_end_user_auth:view permission
   * @summary Get Auth Overview
   * @param {BackOfficeEndUserAuthManagementApiGetAuthOverviewRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackOfficeEndUserAuthManagementApi
   */
  public getAuthOverview(
    requestParameters: BackOfficeEndUserAuthManagementApiGetAuthOverviewRequest,
    options?: AxiosRequestConfig,
  ) {
    return BackOfficeEndUserAuthManagementApiFp(this.configuration)
      .getAuthOverview(requestParameters.userId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Get linked devices and trust status for end-user. Includes device name, OS, channel, masked device ID, linked/last access time. Requires: ewallet:ew_end_user_auth:view permission
   * @summary Get Linked Devices
   * @param {BackOfficeEndUserAuthManagementApiGetLinkedDevicesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackOfficeEndUserAuthManagementApi
   */
  public getLinkedDevices(
    requestParameters: BackOfficeEndUserAuthManagementApiGetLinkedDevicesRequest,
    options?: AxiosRequestConfig,
  ) {
    return BackOfficeEndUserAuthManagementApiFp(this.configuration)
      .getLinkedDevices(requestParameters.userId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Get last 10 login sessions for end-user with details: login/logout time, channel, auth method, device, IP (masked), result, status. Requires: ewallet:ew_end_user_auth:view permission
   * @summary Get Login History
   * @param {BackOfficeEndUserAuthManagementApiGetLoginHistoryRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackOfficeEndUserAuthManagementApi
   */
  public getLoginHistory(
    requestParameters: BackOfficeEndUserAuthManagementApiGetLoginHistoryRequest,
    options?: AxiosRequestConfig,
  ) {
    return BackOfficeEndUserAuthManagementApiFp(this.configuration)
      .getLoginHistory(requestParameters.userId, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * BackofficeApprovalManagementApi - axios parameter creator
 * @export
 */
export const BackofficeApprovalManagementApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Phê duyệt yêu cầu. Checker không được phê duyệt yêu cầu do chính mình tạo (nguyên tắc 4-eyes). Sau khi phê duyệt, hệ thống tự động thực thi hành động tương ứng (tạo user, cập nhật vai trò, v.v.).  Error codes: - `approval.request.not.found` (404) — Không tìm thấy yêu cầu phê duyệt - `approval.request.already.processed` (400) — Yêu cầu đã được xử lý - `approval.maker.cannot.approve.own.request` (400) — Maker không được phê duyệt yêu cầu của chính mình
     * @summary Approve Request
     * @param {any} approvalId Approval request ID
     * @param {ApproveRequest} approveRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    approve: async (
      approvalId: any,
      approveRequest: ApproveRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'approvalId' is not null or undefined
      assertParamExists("approve", "approvalId", approvalId);
      // verify required parameter 'approveRequest' is not null or undefined
      assertParamExists("approve", "approveRequest", approveRequest);
      const localVarPath = `/bo/api/v1/approvals/{approvalId}/approve`.replace(
        `{${"approvalId"}}`,
        encodeURIComponent(String(approvalId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        approveRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Hủy yêu cầu phê duyệt. Chỉ Maker (người tạo yêu cầu) mới có quyền hủy. Yêu cầu phải đang ở trạng thái PENDING. Bắt buộc nhập lý do hủy.  Error codes: - `approval.request.not.found` (404) — Không tìm thấy yêu cầu phê duyệt - `approval.request.already.processed` (400) — Yêu cầu đã được xử lý - `approval.only.maker.can.cancel.request` (403) — Chỉ Maker mới được hủy yêu cầu
     * @summary Cancel Request
     * @param {any} approvalId Approval request ID
     * @param {CloseRequest} closeRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cancel: async (
      approvalId: any,
      closeRequest: CloseRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'approvalId' is not null or undefined
      assertParamExists("cancel", "approvalId", approvalId);
      // verify required parameter 'closeRequest' is not null or undefined
      assertParamExists("cancel", "closeRequest", closeRequest);
      const localVarPath = `/bo/api/v1/approvals/{approvalId}/cancel`.replace(
        `{${"approvalId"}}`,
        encodeURIComponent(String(approvalId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        closeRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Đóng yêu cầu phê duyệt. Chỉ Checker mới có quyền thực hiện. Bắt buộc nhập lý do đóng.  Error codes: - `approval.request.not.found` (404) — Không tìm thấy yêu cầu phê duyệt - `approval.request.not.found.or.not.cancellable` (400) — Yêu cầu không tồn tại hoặc không thể đóng
     * @summary Close Request
     * @param {any} approvalId Approval request ID
     * @param {CloseRequest} closeRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    close: async (
      approvalId: any,
      closeRequest: CloseRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'approvalId' is not null or undefined
      assertParamExists("close", "approvalId", approvalId);
      // verify required parameter 'closeRequest' is not null or undefined
      assertParamExists("close", "closeRequest", closeRequest);
      const localVarPath = `/bo/api/v1/approvals/{approvalId}/close`.replace(
        `{${"approvalId"}}`,
        encodeURIComponent(String(approvalId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        closeRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Lấy số lượng yêu cầu phê duyệt đang chờ xử lý (dùng cho hiển thị badge thông báo)
     * @summary Get Approval Count
     * @param {any} [statuses] Filter by approval statuses
     * @param {any} [requestTypes] Filter by request type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    count: async (
      statuses?: any,
      requestTypes?: any,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/bo/api/v1/approvals/count`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      if (statuses !== undefined) {
        localVarQueryParameter["statuses"] = statuses;
      }

      if (requestTypes !== undefined) {
        localVarQueryParameter["requestTypes"] = requestTypes;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Lấy thông tin chi tiết yêu cầu phê duyệt: loại yêu cầu, dữ liệu thay đổi (before/after), người tạo (Maker), người phê duyệt (Checker), lý do từ chối, nhận xét.  Error codes: - `approval.request.not.found` (404) — Không tìm thấy yêu cầu phê duyệt
     * @summary Get Approval Request Details
     * @param {any} approvalId Approval request ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getApprovalDetails: async (
      approvalId: any,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'approvalId' is not null or undefined
      assertParamExists("getApprovalDetails", "approvalId", approvalId);
      const localVarPath = `/bo/api/v1/approvals/{approvalId}`.replace(
        `{${"approvalId"}}`,
        encodeURIComponent(String(approvalId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Lấy danh sách yêu cầu phê duyệt có phân trang. Hỗ trợ lọc theo: loại yêu cầu, trạng thái (PENDING/APPROVED/REJECTED/CLOSED), người tạo, khoảng ngày.
     * @summary List Approval Requests
     * @param {any} [search] Search by partial approval ID or maker username
     * @param {any} [entityId] Entity id
     * @param {any} [statuses] Filter by approval statuses
     * @param {any} [requestTypes] Filter by request type
     * @param {any} [dateFrom] Filter by date from (inclusive)
     * @param {any} [dateTo] Filter by date to (inclusive)
     * @param {any} [page] Zero-based page index (0..N)
     * @param {any} [size] The size of the page to be returned
     * @param {any} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getApprovalRequests: async (
      search?: any,
      entityId?: any,
      statuses?: any,
      requestTypes?: any,
      dateFrom?: any,
      dateTo?: any,
      page?: any,
      size?: any,
      sort?: any,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/bo/api/v1/approvals`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (entityId !== undefined) {
        localVarQueryParameter["entityId"] = entityId;
      }

      if (statuses !== undefined) {
        localVarQueryParameter["statuses"] = statuses;
      }

      if (requestTypes !== undefined) {
        localVarQueryParameter["requestTypes"] = requestTypes;
      }

      if (dateFrom !== undefined) {
        localVarQueryParameter["dateFrom"] = dateFrom;
      }

      if (dateTo !== undefined) {
        localVarQueryParameter["dateTo"] = dateTo;
      }

      if (page !== undefined) {
        localVarQueryParameter["page"] = page;
      }

      if (size !== undefined) {
        localVarQueryParameter["size"] = size;
      }

      if (sort !== undefined) {
        localVarQueryParameter["sort"] = sort;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Từ chối yêu cầu phê duyệt. Bắt buộc nhập lý do từ chối. Checker không được từ chối yêu cầu do chính mình tạo.  Error codes: - `approval.request.not.found` (404) — Không tìm thấy yêu cầu phê duyệt - `approval.request.already.processed` (400) — Yêu cầu đã được xử lý - `approval.maker.cannot.reject.own.request` (400) — Maker không được từ chối yêu cầu của chính mình
     * @summary Reject Request
     * @param {any} approvalId Approval request ID
     * @param {RejectRequest} rejectRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reject: async (
      approvalId: any,
      rejectRequest: RejectRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'approvalId' is not null or undefined
      assertParamExists("reject", "approvalId", approvalId);
      // verify required parameter 'rejectRequest' is not null or undefined
      assertParamExists("reject", "rejectRequest", rejectRequest);
      const localVarPath = `/bo/api/v1/approvals/{approvalId}/reject`.replace(
        `{${"approvalId"}}`,
        encodeURIComponent(String(approvalId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        rejectRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Cập nhật dữ liệu yêu cầu phê duyệt. Chỉ Maker (người tạo yêu cầu) mới có quyền cập nhật. Yêu cầu phải đang ở trạng thái PENDING.  Error codes: - `approval.request.not.found` (404) — Không tìm thấy yêu cầu phê duyệt - `approval.request.already.processed` (400) — Yêu cầu đã được xử lý - `approval.only.maker.can.update.request` (403) — Chỉ Maker mới được cập nhật yêu cầu
     * @summary Update Request Data
     * @param {any} approvalId Approval request ID
     * @param {any} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateRequestData: async (
      approvalId: any,
      body: any,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'approvalId' is not null or undefined
      assertParamExists("updateRequestData", "approvalId", approvalId);
      // verify required parameter 'body' is not null or undefined
      assertParamExists("updateRequestData", "body", body);
      const localVarPath =
        `/bo/api/v1/approvals/{approvalId}/request-data`.replace(
          `{${"approvalId"}}`,
          encodeURIComponent(String(approvalId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * BackofficeApprovalManagementApi - functional programming interface
 * @export
 */
export const BackofficeApprovalManagementApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    BackofficeApprovalManagementApiAxiosParamCreator(configuration);
  return {
    /**
     * Phê duyệt yêu cầu. Checker không được phê duyệt yêu cầu do chính mình tạo (nguyên tắc 4-eyes). Sau khi phê duyệt, hệ thống tự động thực thi hành động tương ứng (tạo user, cập nhật vai trò, v.v.).  Error codes: - `approval.request.not.found` (404) — Không tìm thấy yêu cầu phê duyệt - `approval.request.already.processed` (400) — Yêu cầu đã được xử lý - `approval.maker.cannot.approve.own.request` (400) — Maker không được phê duyệt yêu cầu của chính mình
     * @summary Approve Request
     * @param {any} approvalId Approval request ID
     * @param {ApproveRequest} approveRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async approve(
      approvalId: any,
      approveRequest: ApproveRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.approve(
        approvalId,
        approveRequest,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Hủy yêu cầu phê duyệt. Chỉ Maker (người tạo yêu cầu) mới có quyền hủy. Yêu cầu phải đang ở trạng thái PENDING. Bắt buộc nhập lý do hủy.  Error codes: - `approval.request.not.found` (404) — Không tìm thấy yêu cầu phê duyệt - `approval.request.already.processed` (400) — Yêu cầu đã được xử lý - `approval.only.maker.can.cancel.request` (403) — Chỉ Maker mới được hủy yêu cầu
     * @summary Cancel Request
     * @param {any} approvalId Approval request ID
     * @param {CloseRequest} closeRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cancel(
      approvalId: any,
      closeRequest: CloseRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.cancel(
        approvalId,
        closeRequest,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Đóng yêu cầu phê duyệt. Chỉ Checker mới có quyền thực hiện. Bắt buộc nhập lý do đóng.  Error codes: - `approval.request.not.found` (404) — Không tìm thấy yêu cầu phê duyệt - `approval.request.not.found.or.not.cancellable` (400) — Yêu cầu không tồn tại hoặc không thể đóng
     * @summary Close Request
     * @param {any} approvalId Approval request ID
     * @param {CloseRequest} closeRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async close(
      approvalId: any,
      closeRequest: CloseRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.close(
        approvalId,
        closeRequest,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Lấy số lượng yêu cầu phê duyệt đang chờ xử lý (dùng cho hiển thị badge thông báo)
     * @summary Get Approval Count
     * @param {any} [statuses] Filter by approval statuses
     * @param {any} [requestTypes] Filter by request type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async count(
      statuses?: any,
      requestTypes?: any,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<ApprovalPendingCount>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.count(
        statuses,
        requestTypes,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Lấy thông tin chi tiết yêu cầu phê duyệt: loại yêu cầu, dữ liệu thay đổi (before/after), người tạo (Maker), người phê duyệt (Checker), lý do từ chối, nhận xét.  Error codes: - `approval.request.not.found` (404) — Không tìm thấy yêu cầu phê duyệt
     * @summary Get Approval Request Details
     * @param {any} approvalId Approval request ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getApprovalDetails(
      approvalId: any,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<ApprovalRequestDetails>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getApprovalDetails(approvalId, options);
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Lấy danh sách yêu cầu phê duyệt có phân trang. Hỗ trợ lọc theo: loại yêu cầu, trạng thái (PENDING/APPROVED/REJECTED/CLOSED), người tạo, khoảng ngày.
     * @summary List Approval Requests
     * @param {any} [search] Search by partial approval ID or maker username
     * @param {any} [entityId] Entity id
     * @param {any} [statuses] Filter by approval statuses
     * @param {any} [requestTypes] Filter by request type
     * @param {any} [dateFrom] Filter by date from (inclusive)
     * @param {any} [dateTo] Filter by date to (inclusive)
     * @param {any} [page] Zero-based page index (0..N)
     * @param {any} [size] The size of the page to be returned
     * @param {any} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getApprovalRequests(
      search?: any,
      entityId?: any,
      statuses?: any,
      requestTypes?: any,
      dateFrom?: any,
      dateTo?: any,
      page?: any,
      size?: any,
      sort?: any,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PageApprovalRequestLite>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getApprovalRequests(
          search,
          entityId,
          statuses,
          requestTypes,
          dateFrom,
          dateTo,
          page,
          size,
          sort,
          options,
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Từ chối yêu cầu phê duyệt. Bắt buộc nhập lý do từ chối. Checker không được từ chối yêu cầu do chính mình tạo.  Error codes: - `approval.request.not.found` (404) — Không tìm thấy yêu cầu phê duyệt - `approval.request.already.processed` (400) — Yêu cầu đã được xử lý - `approval.maker.cannot.reject.own.request` (400) — Maker không được từ chối yêu cầu của chính mình
     * @summary Reject Request
     * @param {any} approvalId Approval request ID
     * @param {RejectRequest} rejectRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async reject(
      approvalId: any,
      rejectRequest: RejectRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.reject(
        approvalId,
        rejectRequest,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Cập nhật dữ liệu yêu cầu phê duyệt. Chỉ Maker (người tạo yêu cầu) mới có quyền cập nhật. Yêu cầu phải đang ở trạng thái PENDING.  Error codes: - `approval.request.not.found` (404) — Không tìm thấy yêu cầu phê duyệt - `approval.request.already.processed` (400) — Yêu cầu đã được xử lý - `approval.only.maker.can.update.request` (403) — Chỉ Maker mới được cập nhật yêu cầu
     * @summary Update Request Data
     * @param {any} approvalId Approval request ID
     * @param {any} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateRequestData(
      approvalId: any,
      body: any,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.updateRequestData(
          approvalId,
          body,
          options,
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
  };
};

/**
 * BackofficeApprovalManagementApi - factory interface
 * @export
 */
export const BackofficeApprovalManagementApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = BackofficeApprovalManagementApiFp(configuration);
  return {
    /**
     * Phê duyệt yêu cầu. Checker không được phê duyệt yêu cầu do chính mình tạo (nguyên tắc 4-eyes). Sau khi phê duyệt, hệ thống tự động thực thi hành động tương ứng (tạo user, cập nhật vai trò, v.v.).  Error codes: - `approval.request.not.found` (404) — Không tìm thấy yêu cầu phê duyệt - `approval.request.already.processed` (400) — Yêu cầu đã được xử lý - `approval.maker.cannot.approve.own.request` (400) — Maker không được phê duyệt yêu cầu của chính mình
     * @summary Approve Request
     * @param {any} approvalId Approval request ID
     * @param {ApproveRequest} approveRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    approve(
      approvalId: any,
      approveRequest: ApproveRequest,
      options?: any,
    ): AxiosPromise<void> {
      return localVarFp
        .approve(approvalId, approveRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Hủy yêu cầu phê duyệt. Chỉ Maker (người tạo yêu cầu) mới có quyền hủy. Yêu cầu phải đang ở trạng thái PENDING. Bắt buộc nhập lý do hủy.  Error codes: - `approval.request.not.found` (404) — Không tìm thấy yêu cầu phê duyệt - `approval.request.already.processed` (400) — Yêu cầu đã được xử lý - `approval.only.maker.can.cancel.request` (403) — Chỉ Maker mới được hủy yêu cầu
     * @summary Cancel Request
     * @param {any} approvalId Approval request ID
     * @param {CloseRequest} closeRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cancel(
      approvalId: any,
      closeRequest: CloseRequest,
      options?: any,
    ): AxiosPromise<void> {
      return localVarFp
        .cancel(approvalId, closeRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Đóng yêu cầu phê duyệt. Chỉ Checker mới có quyền thực hiện. Bắt buộc nhập lý do đóng.  Error codes: - `approval.request.not.found` (404) — Không tìm thấy yêu cầu phê duyệt - `approval.request.not.found.or.not.cancellable` (400) — Yêu cầu không tồn tại hoặc không thể đóng
     * @summary Close Request
     * @param {any} approvalId Approval request ID
     * @param {CloseRequest} closeRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    close(
      approvalId: any,
      closeRequest: CloseRequest,
      options?: any,
    ): AxiosPromise<void> {
      return localVarFp
        .close(approvalId, closeRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Lấy số lượng yêu cầu phê duyệt đang chờ xử lý (dùng cho hiển thị badge thông báo)
     * @summary Get Approval Count
     * @param {any} [statuses] Filter by approval statuses
     * @param {any} [requestTypes] Filter by request type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    count(
      statuses?: any,
      requestTypes?: any,
      options?: any,
    ): AxiosPromise<ApprovalPendingCount> {
      return localVarFp
        .count(statuses, requestTypes, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Lấy thông tin chi tiết yêu cầu phê duyệt: loại yêu cầu, dữ liệu thay đổi (before/after), người tạo (Maker), người phê duyệt (Checker), lý do từ chối, nhận xét.  Error codes: - `approval.request.not.found` (404) — Không tìm thấy yêu cầu phê duyệt
     * @summary Get Approval Request Details
     * @param {any} approvalId Approval request ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getApprovalDetails(
      approvalId: any,
      options?: any,
    ): AxiosPromise<ApprovalRequestDetails> {
      return localVarFp
        .getApprovalDetails(approvalId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Lấy danh sách yêu cầu phê duyệt có phân trang. Hỗ trợ lọc theo: loại yêu cầu, trạng thái (PENDING/APPROVED/REJECTED/CLOSED), người tạo, khoảng ngày.
     * @summary List Approval Requests
     * @param {any} [search] Search by partial approval ID or maker username
     * @param {any} [entityId] Entity id
     * @param {any} [statuses] Filter by approval statuses
     * @param {any} [requestTypes] Filter by request type
     * @param {any} [dateFrom] Filter by date from (inclusive)
     * @param {any} [dateTo] Filter by date to (inclusive)
     * @param {any} [page] Zero-based page index (0..N)
     * @param {any} [size] The size of the page to be returned
     * @param {any} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getApprovalRequests(
      search?: any,
      entityId?: any,
      statuses?: any,
      requestTypes?: any,
      dateFrom?: any,
      dateTo?: any,
      page?: any,
      size?: any,
      sort?: any,
      options?: any,
    ): AxiosPromise<PageApprovalRequestLite> {
      return localVarFp
        .getApprovalRequests(
          search,
          entityId,
          statuses,
          requestTypes,
          dateFrom,
          dateTo,
          page,
          size,
          sort,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Từ chối yêu cầu phê duyệt. Bắt buộc nhập lý do từ chối. Checker không được từ chối yêu cầu do chính mình tạo.  Error codes: - `approval.request.not.found` (404) — Không tìm thấy yêu cầu phê duyệt - `approval.request.already.processed` (400) — Yêu cầu đã được xử lý - `approval.maker.cannot.reject.own.request` (400) — Maker không được từ chối yêu cầu của chính mình
     * @summary Reject Request
     * @param {any} approvalId Approval request ID
     * @param {RejectRequest} rejectRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reject(
      approvalId: any,
      rejectRequest: RejectRequest,
      options?: any,
    ): AxiosPromise<void> {
      return localVarFp
        .reject(approvalId, rejectRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Cập nhật dữ liệu yêu cầu phê duyệt. Chỉ Maker (người tạo yêu cầu) mới có quyền cập nhật. Yêu cầu phải đang ở trạng thái PENDING.  Error codes: - `approval.request.not.found` (404) — Không tìm thấy yêu cầu phê duyệt - `approval.request.already.processed` (400) — Yêu cầu đã được xử lý - `approval.only.maker.can.update.request` (403) — Chỉ Maker mới được cập nhật yêu cầu
     * @summary Update Request Data
     * @param {any} approvalId Approval request ID
     * @param {any} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateRequestData(
      approvalId: any,
      body: any,
      options?: any,
    ): AxiosPromise<void> {
      return localVarFp
        .updateRequestData(approvalId, body, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for approve operation in BackofficeApprovalManagementApi.
 * @export
 * @interface BackofficeApprovalManagementApiApproveRequest
 */
export interface BackofficeApprovalManagementApiApproveRequest {
  /**
   * Approval request ID
   * @type {any}
   * @memberof BackofficeApprovalManagementApiApprove
   */
  readonly approvalId: any;

  /**
   *
   * @type {ApproveRequest}
   * @memberof BackofficeApprovalManagementApiApprove
   */
  readonly approveRequest: ApproveRequest;
}

/**
 * Request parameters for cancel operation in BackofficeApprovalManagementApi.
 * @export
 * @interface BackofficeApprovalManagementApiCancelRequest
 */
export interface BackofficeApprovalManagementApiCancelRequest {
  /**
   * Approval request ID
   * @type {any}
   * @memberof BackofficeApprovalManagementApiCancel
   */
  readonly approvalId: any;

  /**
   *
   * @type {CloseRequest}
   * @memberof BackofficeApprovalManagementApiCancel
   */
  readonly closeRequest: CloseRequest;
}

/**
 * Request parameters for close operation in BackofficeApprovalManagementApi.
 * @export
 * @interface BackofficeApprovalManagementApiCloseRequest
 */
export interface BackofficeApprovalManagementApiCloseRequest {
  /**
   * Approval request ID
   * @type {any}
   * @memberof BackofficeApprovalManagementApiClose
   */
  readonly approvalId: any;

  /**
   *
   * @type {CloseRequest}
   * @memberof BackofficeApprovalManagementApiClose
   */
  readonly closeRequest: CloseRequest;
}

/**
 * Request parameters for count operation in BackofficeApprovalManagementApi.
 * @export
 * @interface BackofficeApprovalManagementApiCountRequest
 */
export interface BackofficeApprovalManagementApiCountRequest {
  /**
   * Filter by approval statuses
   * @type {any}
   * @memberof BackofficeApprovalManagementApiCount
   */
  readonly statuses?: any;

  /**
   * Filter by request type
   * @type {any}
   * @memberof BackofficeApprovalManagementApiCount
   */
  readonly requestTypes?: any;
}

/**
 * Request parameters for getApprovalDetails operation in BackofficeApprovalManagementApi.
 * @export
 * @interface BackofficeApprovalManagementApiGetApprovalDetailsRequest
 */
export interface BackofficeApprovalManagementApiGetApprovalDetailsRequest {
  /**
   * Approval request ID
   * @type {any}
   * @memberof BackofficeApprovalManagementApiGetApprovalDetails
   */
  readonly approvalId: any;
}

/**
 * Request parameters for getApprovalRequests operation in BackofficeApprovalManagementApi.
 * @export
 * @interface BackofficeApprovalManagementApiGetApprovalRequestsRequest
 */
export interface BackofficeApprovalManagementApiGetApprovalRequestsRequest {
  /**
   * Search by partial approval ID or maker username
   * @type {any}
   * @memberof BackofficeApprovalManagementApiGetApprovalRequests
   */
  readonly search?: any;

  /**
   * Entity id
   * @type {any}
   * @memberof BackofficeApprovalManagementApiGetApprovalRequests
   */
  readonly entityId?: any;

  /**
   * Filter by approval statuses
   * @type {any}
   * @memberof BackofficeApprovalManagementApiGetApprovalRequests
   */
  readonly statuses?: any;

  /**
   * Filter by request type
   * @type {any}
   * @memberof BackofficeApprovalManagementApiGetApprovalRequests
   */
  readonly requestTypes?: any;

  /**
   * Filter by date from (inclusive)
   * @type {any}
   * @memberof BackofficeApprovalManagementApiGetApprovalRequests
   */
  readonly dateFrom?: any;

  /**
   * Filter by date to (inclusive)
   * @type {any}
   * @memberof BackofficeApprovalManagementApiGetApprovalRequests
   */
  readonly dateTo?: any;

  /**
   * Zero-based page index (0..N)
   * @type {any}
   * @memberof BackofficeApprovalManagementApiGetApprovalRequests
   */
  readonly page?: any;

  /**
   * The size of the page to be returned
   * @type {any}
   * @memberof BackofficeApprovalManagementApiGetApprovalRequests
   */
  readonly size?: any;

  /**
   * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @type {any}
   * @memberof BackofficeApprovalManagementApiGetApprovalRequests
   */
  readonly sort?: any;
}

/**
 * Request parameters for reject operation in BackofficeApprovalManagementApi.
 * @export
 * @interface BackofficeApprovalManagementApiRejectRequest
 */
export interface BackofficeApprovalManagementApiRejectRequest {
  /**
   * Approval request ID
   * @type {any}
   * @memberof BackofficeApprovalManagementApiReject
   */
  readonly approvalId: any;

  /**
   *
   * @type {RejectRequest}
   * @memberof BackofficeApprovalManagementApiReject
   */
  readonly rejectRequest: RejectRequest;
}

/**
 * Request parameters for updateRequestData operation in BackofficeApprovalManagementApi.
 * @export
 * @interface BackofficeApprovalManagementApiUpdateRequestDataRequest
 */
export interface BackofficeApprovalManagementApiUpdateRequestDataRequest {
  /**
   * Approval request ID
   * @type {any}
   * @memberof BackofficeApprovalManagementApiUpdateRequestData
   */
  readonly approvalId: any;

  /**
   *
   * @type {any}
   * @memberof BackofficeApprovalManagementApiUpdateRequestData
   */
  readonly body: any;
}

/**
 * BackofficeApprovalManagementApi - object-oriented interface
 * @export
 * @class BackofficeApprovalManagementApi
 * @extends {BaseAPI}
 */
export class BackofficeApprovalManagementApi extends BaseAPI {
  /**
   * Phê duyệt yêu cầu. Checker không được phê duyệt yêu cầu do chính mình tạo (nguyên tắc 4-eyes). Sau khi phê duyệt, hệ thống tự động thực thi hành động tương ứng (tạo user, cập nhật vai trò, v.v.).  Error codes: - `approval.request.not.found` (404) — Không tìm thấy yêu cầu phê duyệt - `approval.request.already.processed` (400) — Yêu cầu đã được xử lý - `approval.maker.cannot.approve.own.request` (400) — Maker không được phê duyệt yêu cầu của chính mình
   * @summary Approve Request
   * @param {BackofficeApprovalManagementApiApproveRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeApprovalManagementApi
   */
  public approve(
    requestParameters: BackofficeApprovalManagementApiApproveRequest,
    options?: AxiosRequestConfig,
  ) {
    return BackofficeApprovalManagementApiFp(this.configuration)
      .approve(
        requestParameters.approvalId,
        requestParameters.approveRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Hủy yêu cầu phê duyệt. Chỉ Maker (người tạo yêu cầu) mới có quyền hủy. Yêu cầu phải đang ở trạng thái PENDING. Bắt buộc nhập lý do hủy.  Error codes: - `approval.request.not.found` (404) — Không tìm thấy yêu cầu phê duyệt - `approval.request.already.processed` (400) — Yêu cầu đã được xử lý - `approval.only.maker.can.cancel.request` (403) — Chỉ Maker mới được hủy yêu cầu
   * @summary Cancel Request
   * @param {BackofficeApprovalManagementApiCancelRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeApprovalManagementApi
   */
  public cancel(
    requestParameters: BackofficeApprovalManagementApiCancelRequest,
    options?: AxiosRequestConfig,
  ) {
    return BackofficeApprovalManagementApiFp(this.configuration)
      .cancel(
        requestParameters.approvalId,
        requestParameters.closeRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Đóng yêu cầu phê duyệt. Chỉ Checker mới có quyền thực hiện. Bắt buộc nhập lý do đóng.  Error codes: - `approval.request.not.found` (404) — Không tìm thấy yêu cầu phê duyệt - `approval.request.not.found.or.not.cancellable` (400) — Yêu cầu không tồn tại hoặc không thể đóng
   * @summary Close Request
   * @param {BackofficeApprovalManagementApiCloseRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeApprovalManagementApi
   */
  public close(
    requestParameters: BackofficeApprovalManagementApiCloseRequest,
    options?: AxiosRequestConfig,
  ) {
    return BackofficeApprovalManagementApiFp(this.configuration)
      .close(
        requestParameters.approvalId,
        requestParameters.closeRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Lấy số lượng yêu cầu phê duyệt đang chờ xử lý (dùng cho hiển thị badge thông báo)
   * @summary Get Approval Count
   * @param {BackofficeApprovalManagementApiCountRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeApprovalManagementApi
   */
  public count(
    requestParameters: BackofficeApprovalManagementApiCountRequest = {},
    options?: AxiosRequestConfig,
  ) {
    return BackofficeApprovalManagementApiFp(this.configuration)
      .count(
        requestParameters.statuses,
        requestParameters.requestTypes,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Lấy thông tin chi tiết yêu cầu phê duyệt: loại yêu cầu, dữ liệu thay đổi (before/after), người tạo (Maker), người phê duyệt (Checker), lý do từ chối, nhận xét.  Error codes: - `approval.request.not.found` (404) — Không tìm thấy yêu cầu phê duyệt
   * @summary Get Approval Request Details
   * @param {BackofficeApprovalManagementApiGetApprovalDetailsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeApprovalManagementApi
   */
  public getApprovalDetails(
    requestParameters: BackofficeApprovalManagementApiGetApprovalDetailsRequest,
    options?: AxiosRequestConfig,
  ) {
    return BackofficeApprovalManagementApiFp(this.configuration)
      .getApprovalDetails(requestParameters.approvalId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Lấy danh sách yêu cầu phê duyệt có phân trang. Hỗ trợ lọc theo: loại yêu cầu, trạng thái (PENDING/APPROVED/REJECTED/CLOSED), người tạo, khoảng ngày.
   * @summary List Approval Requests
   * @param {BackofficeApprovalManagementApiGetApprovalRequestsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeApprovalManagementApi
   */
  public getApprovalRequests(
    requestParameters: BackofficeApprovalManagementApiGetApprovalRequestsRequest = {},
    options?: AxiosRequestConfig,
  ) {
    return BackofficeApprovalManagementApiFp(this.configuration)
      .getApprovalRequests(
        requestParameters.search,
        requestParameters.entityId,
        requestParameters.statuses,
        requestParameters.requestTypes,
        requestParameters.dateFrom,
        requestParameters.dateTo,
        requestParameters.page,
        requestParameters.size,
        requestParameters.sort,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Từ chối yêu cầu phê duyệt. Bắt buộc nhập lý do từ chối. Checker không được từ chối yêu cầu do chính mình tạo.  Error codes: - `approval.request.not.found` (404) — Không tìm thấy yêu cầu phê duyệt - `approval.request.already.processed` (400) — Yêu cầu đã được xử lý - `approval.maker.cannot.reject.own.request` (400) — Maker không được từ chối yêu cầu của chính mình
   * @summary Reject Request
   * @param {BackofficeApprovalManagementApiRejectRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeApprovalManagementApi
   */
  public reject(
    requestParameters: BackofficeApprovalManagementApiRejectRequest,
    options?: AxiosRequestConfig,
  ) {
    return BackofficeApprovalManagementApiFp(this.configuration)
      .reject(
        requestParameters.approvalId,
        requestParameters.rejectRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Cập nhật dữ liệu yêu cầu phê duyệt. Chỉ Maker (người tạo yêu cầu) mới có quyền cập nhật. Yêu cầu phải đang ở trạng thái PENDING.  Error codes: - `approval.request.not.found` (404) — Không tìm thấy yêu cầu phê duyệt - `approval.request.already.processed` (400) — Yêu cầu đã được xử lý - `approval.only.maker.can.update.request` (403) — Chỉ Maker mới được cập nhật yêu cầu
   * @summary Update Request Data
   * @param {BackofficeApprovalManagementApiUpdateRequestDataRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeApprovalManagementApi
   */
  public updateRequestData(
    requestParameters: BackofficeApprovalManagementApiUpdateRequestDataRequest,
    options?: AxiosRequestConfig,
  ) {
    return BackofficeApprovalManagementApiFp(this.configuration)
      .updateRequestData(
        requestParameters.approvalId,
        requestParameters.body,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * BackofficeAuditLogApi - axios parameter creator
 * @export
 */
export const BackofficeAuditLogApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Bắt đầu xuất audit log. Trả về processId để theo dõi tiến trình qua SSE hoặc polling. Hỗ trợ lọc dữ liệu trước khi xuất, định dạng PDF.  Error codes: - `auth.audit.log.export.no.data` (400) — Không có dữ liệu để xuất - `auth.audit.log.export.data.too.large` (400) — Dữ liệu xuất vượt quá giới hạn cho phép
     * @summary Initiate Audit Log Export
     * @param {AuditLogExportRequest} auditLogExportRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportAuditLogs: async (
      auditLogExportRequest: AuditLogExportRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'auditLogExportRequest' is not null or undefined
      assertParamExists(
        "exportAuditLogs",
        "auditLogExportRequest",
        auditLogExportRequest,
      );
      const localVarPath = `/bo/api/v1/audit-logs/export`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        auditLogExportRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Lấy chi tiết một bản ghi audit log: thông tin người thực hiện, chi tiết thay đổi (before/after), địa chỉ IP, user agent, thời gian thực hiện.  Error codes: - `audit.log.not.found` (404) — Không tìm thấy bản ghi audit log
     * @summary Get Audit Log Details
     * @param {any} logId Audit log ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAuditLogDetails: async (
      logId: any,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'logId' is not null or undefined
      assertParamExists("getAuditLogDetails", "logId", logId);
      const localVarPath = `/bo/api/v1/audit-logs/{logId}`.replace(
        `{${"logId"}}`,
        encodeURIComponent(String(logId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Lấy danh sách nhật ký hoạt động có phân trang. Hỗ trợ lọc theo: từ khóa tìm kiếm, loại hành động, loại đối tượng, người thực hiện, khoảng ngày.
     * @summary List Audit Logs
     * @param {any} [search] Search by actor name, email
     * @param {any} [actions] Filter by audit actions. Valid values: CREATE, UPDATE, DELETE, APPROVE, REJECT, CLOSE, LOCK, UNLOCK
     * @param {any} [entityTypes] Filter by entity types. Valid values: USER, ROLE, APPROVAL_REQUEST
     * @param {any} [dateFrom] Filter by date from (inclusive)
     * @param {any} [dateTo] Filter by date to (inclusive)
     * @param {any} [page] Zero-based page index (0..N)
     * @param {any} [size] The size of the page to be returned
     * @param {any} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAuditLogs: async (
      search?: any,
      actions?: any,
      entityTypes?: any,
      dateFrom?: any,
      dateTo?: any,
      page?: any,
      size?: any,
      sort?: any,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/bo/api/v1/audit-logs`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (actions !== undefined) {
        localVarQueryParameter["actions"] = actions;
      }

      if (entityTypes !== undefined) {
        localVarQueryParameter["entityTypes"] = entityTypes;
      }

      if (dateFrom !== undefined) {
        localVarQueryParameter["dateFrom"] = dateFrom;
      }

      if (dateTo !== undefined) {
        localVarQueryParameter["dateTo"] = dateTo;
      }

      if (page !== undefined) {
        localVarQueryParameter["page"] = page;
      }

      if (size !== undefined) {
        localVarQueryParameter["size"] = size;
      }

      if (sort !== undefined) {
        localVarQueryParameter["sort"] = sort;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Real-time export progress via Server-Sent Events. Auth via ?token=<jwt> query parameter.
     * @summary Subscribe to Export Progress (SSE)
     * @param {any} processId Export process ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getExportProgress: async (
      processId: any,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'processId' is not null or undefined
      assertParamExists("getExportProgress", "processId", processId);
      const localVarPath =
        `/bo/api/v1/public/sse/audit-logs/processes/{processId}`.replace(
          `{${"processId"}}`,
          encodeURIComponent(String(processId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication sseTokenQuery required
      await setApiKeyToObject(localVarQueryParameter, "token", configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Lấy trạng thái hiện tại của tiến trình xuất. Dùng như phương án dự phòng khi SSE không khả dụng.  Error codes: - `auth.audit.log.export.not.found` (404) — Không tìm thấy tiến trình xuất
     * @summary Get Export Status (Polling)
     * @param {any} processId Export process ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getExportStatus: async (
      processId: any,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'processId' is not null or undefined
      assertParamExists("getExportStatus", "processId", processId);
      const localVarPath =
        `/bo/api/v1/audit-logs/processes/{processId}/status`.replace(
          `{${"processId"}}`,
          encodeURIComponent(String(processId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * BackofficeAuditLogApi - functional programming interface
 * @export
 */
export const BackofficeAuditLogApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    BackofficeAuditLogApiAxiosParamCreator(configuration);
  return {
    /**
     * Bắt đầu xuất audit log. Trả về processId để theo dõi tiến trình qua SSE hoặc polling. Hỗ trợ lọc dữ liệu trước khi xuất, định dạng PDF.  Error codes: - `auth.audit.log.export.no.data` (400) — Không có dữ liệu để xuất - `auth.audit.log.export.data.too.large` (400) — Dữ liệu xuất vượt quá giới hạn cho phép
     * @summary Initiate Audit Log Export
     * @param {AuditLogExportRequest} auditLogExportRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async exportAuditLogs(
      auditLogExportRequest: AuditLogExportRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<ExportInitResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.exportAuditLogs(
        auditLogExportRequest,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Lấy chi tiết một bản ghi audit log: thông tin người thực hiện, chi tiết thay đổi (before/after), địa chỉ IP, user agent, thời gian thực hiện.  Error codes: - `audit.log.not.found` (404) — Không tìm thấy bản ghi audit log
     * @summary Get Audit Log Details
     * @param {any} logId Audit log ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getAuditLogDetails(
      logId: any,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<AuditLogDetails>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getAuditLogDetails(logId, options);
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Lấy danh sách nhật ký hoạt động có phân trang. Hỗ trợ lọc theo: từ khóa tìm kiếm, loại hành động, loại đối tượng, người thực hiện, khoảng ngày.
     * @summary List Audit Logs
     * @param {any} [search] Search by actor name, email
     * @param {any} [actions] Filter by audit actions. Valid values: CREATE, UPDATE, DELETE, APPROVE, REJECT, CLOSE, LOCK, UNLOCK
     * @param {any} [entityTypes] Filter by entity types. Valid values: USER, ROLE, APPROVAL_REQUEST
     * @param {any} [dateFrom] Filter by date from (inclusive)
     * @param {any} [dateTo] Filter by date to (inclusive)
     * @param {any} [page] Zero-based page index (0..N)
     * @param {any} [size] The size of the page to be returned
     * @param {any} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getAuditLogs(
      search?: any,
      actions?: any,
      entityTypes?: any,
      dateFrom?: any,
      dateTo?: any,
      page?: any,
      size?: any,
      sort?: any,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PageAuditLogLite>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getAuditLogs(
        search,
        actions,
        entityTypes,
        dateFrom,
        dateTo,
        page,
        size,
        sort,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Real-time export progress via Server-Sent Events. Auth via ?token=<jwt> query parameter.
     * @summary Subscribe to Export Progress (SSE)
     * @param {any} processId Export process ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getExportProgress(
      processId: any,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getExportProgress(processId, options);
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Lấy trạng thái hiện tại của tiến trình xuất. Dùng như phương án dự phòng khi SSE không khả dụng.  Error codes: - `auth.audit.log.export.not.found` (404) — Không tìm thấy tiến trình xuất
     * @summary Get Export Status (Polling)
     * @param {any} processId Export process ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getExportStatus(
      processId: any,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<ExportProgressEvent>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getExportStatus(
        processId,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
  };
};

/**
 * BackofficeAuditLogApi - factory interface
 * @export
 */
export const BackofficeAuditLogApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = BackofficeAuditLogApiFp(configuration);
  return {
    /**
     * Bắt đầu xuất audit log. Trả về processId để theo dõi tiến trình qua SSE hoặc polling. Hỗ trợ lọc dữ liệu trước khi xuất, định dạng PDF.  Error codes: - `auth.audit.log.export.no.data` (400) — Không có dữ liệu để xuất - `auth.audit.log.export.data.too.large` (400) — Dữ liệu xuất vượt quá giới hạn cho phép
     * @summary Initiate Audit Log Export
     * @param {AuditLogExportRequest} auditLogExportRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportAuditLogs(
      auditLogExportRequest: AuditLogExportRequest,
      options?: any,
    ): AxiosPromise<ExportInitResponse> {
      return localVarFp
        .exportAuditLogs(auditLogExportRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Lấy chi tiết một bản ghi audit log: thông tin người thực hiện, chi tiết thay đổi (before/after), địa chỉ IP, user agent, thời gian thực hiện.  Error codes: - `audit.log.not.found` (404) — Không tìm thấy bản ghi audit log
     * @summary Get Audit Log Details
     * @param {any} logId Audit log ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAuditLogDetails(
      logId: any,
      options?: any,
    ): AxiosPromise<AuditLogDetails> {
      return localVarFp
        .getAuditLogDetails(logId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Lấy danh sách nhật ký hoạt động có phân trang. Hỗ trợ lọc theo: từ khóa tìm kiếm, loại hành động, loại đối tượng, người thực hiện, khoảng ngày.
     * @summary List Audit Logs
     * @param {any} [search] Search by actor name, email
     * @param {any} [actions] Filter by audit actions. Valid values: CREATE, UPDATE, DELETE, APPROVE, REJECT, CLOSE, LOCK, UNLOCK
     * @param {any} [entityTypes] Filter by entity types. Valid values: USER, ROLE, APPROVAL_REQUEST
     * @param {any} [dateFrom] Filter by date from (inclusive)
     * @param {any} [dateTo] Filter by date to (inclusive)
     * @param {any} [page] Zero-based page index (0..N)
     * @param {any} [size] The size of the page to be returned
     * @param {any} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAuditLogs(
      search?: any,
      actions?: any,
      entityTypes?: any,
      dateFrom?: any,
      dateTo?: any,
      page?: any,
      size?: any,
      sort?: any,
      options?: any,
    ): AxiosPromise<PageAuditLogLite> {
      return localVarFp
        .getAuditLogs(
          search,
          actions,
          entityTypes,
          dateFrom,
          dateTo,
          page,
          size,
          sort,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Real-time export progress via Server-Sent Events. Auth via ?token=<jwt> query parameter.
     * @summary Subscribe to Export Progress (SSE)
     * @param {any} processId Export process ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getExportProgress(processId: any, options?: any): AxiosPromise<any> {
      return localVarFp
        .getExportProgress(processId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Lấy trạng thái hiện tại của tiến trình xuất. Dùng như phương án dự phòng khi SSE không khả dụng.  Error codes: - `auth.audit.log.export.not.found` (404) — Không tìm thấy tiến trình xuất
     * @summary Get Export Status (Polling)
     * @param {any} processId Export process ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getExportStatus(
      processId: any,
      options?: any,
    ): AxiosPromise<ExportProgressEvent> {
      return localVarFp
        .getExportStatus(processId, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for exportAuditLogs operation in BackofficeAuditLogApi.
 * @export
 * @interface BackofficeAuditLogApiExportAuditLogsRequest
 */
export interface BackofficeAuditLogApiExportAuditLogsRequest {
  /**
   *
   * @type {AuditLogExportRequest}
   * @memberof BackofficeAuditLogApiExportAuditLogs
   */
  readonly auditLogExportRequest: AuditLogExportRequest;
}

/**
 * Request parameters for getAuditLogDetails operation in BackofficeAuditLogApi.
 * @export
 * @interface BackofficeAuditLogApiGetAuditLogDetailsRequest
 */
export interface BackofficeAuditLogApiGetAuditLogDetailsRequest {
  /**
   * Audit log ID
   * @type {any}
   * @memberof BackofficeAuditLogApiGetAuditLogDetails
   */
  readonly logId: any;
}

/**
 * Request parameters for getAuditLogs operation in BackofficeAuditLogApi.
 * @export
 * @interface BackofficeAuditLogApiGetAuditLogsRequest
 */
export interface BackofficeAuditLogApiGetAuditLogsRequest {
  /**
   * Search by actor name, email
   * @type {any}
   * @memberof BackofficeAuditLogApiGetAuditLogs
   */
  readonly search?: any;

  /**
   * Filter by audit actions. Valid values: CREATE, UPDATE, DELETE, APPROVE, REJECT, CLOSE, LOCK, UNLOCK
   * @type {any}
   * @memberof BackofficeAuditLogApiGetAuditLogs
   */
  readonly actions?: any;

  /**
   * Filter by entity types. Valid values: USER, ROLE, APPROVAL_REQUEST
   * @type {any}
   * @memberof BackofficeAuditLogApiGetAuditLogs
   */
  readonly entityTypes?: any;

  /**
   * Filter by date from (inclusive)
   * @type {any}
   * @memberof BackofficeAuditLogApiGetAuditLogs
   */
  readonly dateFrom?: any;

  /**
   * Filter by date to (inclusive)
   * @type {any}
   * @memberof BackofficeAuditLogApiGetAuditLogs
   */
  readonly dateTo?: any;

  /**
   * Zero-based page index (0..N)
   * @type {any}
   * @memberof BackofficeAuditLogApiGetAuditLogs
   */
  readonly page?: any;

  /**
   * The size of the page to be returned
   * @type {any}
   * @memberof BackofficeAuditLogApiGetAuditLogs
   */
  readonly size?: any;

  /**
   * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @type {any}
   * @memberof BackofficeAuditLogApiGetAuditLogs
   */
  readonly sort?: any;
}

/**
 * Request parameters for getExportProgress operation in BackofficeAuditLogApi.
 * @export
 * @interface BackofficeAuditLogApiGetExportProgressRequest
 */
export interface BackofficeAuditLogApiGetExportProgressRequest {
  /**
   * Export process ID
   * @type {any}
   * @memberof BackofficeAuditLogApiGetExportProgress
   */
  readonly processId: any;
}

/**
 * Request parameters for getExportStatus operation in BackofficeAuditLogApi.
 * @export
 * @interface BackofficeAuditLogApiGetExportStatusRequest
 */
export interface BackofficeAuditLogApiGetExportStatusRequest {
  /**
   * Export process ID
   * @type {any}
   * @memberof BackofficeAuditLogApiGetExportStatus
   */
  readonly processId: any;
}

/**
 * BackofficeAuditLogApi - object-oriented interface
 * @export
 * @class BackofficeAuditLogApi
 * @extends {BaseAPI}
 */
export class BackofficeAuditLogApi extends BaseAPI {
  /**
   * Bắt đầu xuất audit log. Trả về processId để theo dõi tiến trình qua SSE hoặc polling. Hỗ trợ lọc dữ liệu trước khi xuất, định dạng PDF.  Error codes: - `auth.audit.log.export.no.data` (400) — Không có dữ liệu để xuất - `auth.audit.log.export.data.too.large` (400) — Dữ liệu xuất vượt quá giới hạn cho phép
   * @summary Initiate Audit Log Export
   * @param {BackofficeAuditLogApiExportAuditLogsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeAuditLogApi
   */
  public exportAuditLogs(
    requestParameters: BackofficeAuditLogApiExportAuditLogsRequest,
    options?: AxiosRequestConfig,
  ) {
    return BackofficeAuditLogApiFp(this.configuration)
      .exportAuditLogs(requestParameters.auditLogExportRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Lấy chi tiết một bản ghi audit log: thông tin người thực hiện, chi tiết thay đổi (before/after), địa chỉ IP, user agent, thời gian thực hiện.  Error codes: - `audit.log.not.found` (404) — Không tìm thấy bản ghi audit log
   * @summary Get Audit Log Details
   * @param {BackofficeAuditLogApiGetAuditLogDetailsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeAuditLogApi
   */
  public getAuditLogDetails(
    requestParameters: BackofficeAuditLogApiGetAuditLogDetailsRequest,
    options?: AxiosRequestConfig,
  ) {
    return BackofficeAuditLogApiFp(this.configuration)
      .getAuditLogDetails(requestParameters.logId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Lấy danh sách nhật ký hoạt động có phân trang. Hỗ trợ lọc theo: từ khóa tìm kiếm, loại hành động, loại đối tượng, người thực hiện, khoảng ngày.
   * @summary List Audit Logs
   * @param {BackofficeAuditLogApiGetAuditLogsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeAuditLogApi
   */
  public getAuditLogs(
    requestParameters: BackofficeAuditLogApiGetAuditLogsRequest = {},
    options?: AxiosRequestConfig,
  ) {
    return BackofficeAuditLogApiFp(this.configuration)
      .getAuditLogs(
        requestParameters.search,
        requestParameters.actions,
        requestParameters.entityTypes,
        requestParameters.dateFrom,
        requestParameters.dateTo,
        requestParameters.page,
        requestParameters.size,
        requestParameters.sort,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Real-time export progress via Server-Sent Events. Auth via ?token=<jwt> query parameter.
   * @summary Subscribe to Export Progress (SSE)
   * @param {BackofficeAuditLogApiGetExportProgressRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeAuditLogApi
   */
  public getExportProgress(
    requestParameters: BackofficeAuditLogApiGetExportProgressRequest,
    options?: AxiosRequestConfig,
  ) {
    return BackofficeAuditLogApiFp(this.configuration)
      .getExportProgress(requestParameters.processId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Lấy trạng thái hiện tại của tiến trình xuất. Dùng như phương án dự phòng khi SSE không khả dụng.  Error codes: - `auth.audit.log.export.not.found` (404) — Không tìm thấy tiến trình xuất
   * @summary Get Export Status (Polling)
   * @param {BackofficeAuditLogApiGetExportStatusRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeAuditLogApi
   */
  public getExportStatus(
    requestParameters: BackofficeAuditLogApiGetExportStatusRequest,
    options?: AxiosRequestConfig,
  ) {
    return BackofficeAuditLogApiFp(this.configuration)
      .getExportStatus(requestParameters.processId, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * BackofficeAuthenticationAuthorizationApi - axios parameter creator
 * @export
 */
export const BackofficeAuthenticationAuthorizationApiAxiosParamCreator =
  function (configuration?: Configuration) {
    return {
      /**
       * Xác thực mã OTP 6 chữ số được gửi qua email. - OTP có thời hạn 5 phút - Tối đa 5 lần nhập sai, sau đó khóa 15 phút - Nếu hợp lệ: cấp JWT access token và refresh token, ghi audit log  Response: - `action`: TOKEN_CREATED (đăng nhập thành công, trả accessToken + refreshToken)  Error codes:     - `auth.invalid.otp` (400) — Mã OTP không đúng, params[0] = số lần nhập còn lại - `auth.otp.has.expired` (400) — Mã OTP đã hết hạn - `auth.exceeded.maximum.otp.verification.attempts` (400) — Vượt quá 5 lần nhập sai - `auth.otp.temporarily.locked` (400) — Tạm khóa 15 phút do nhập sai quá nhiều     - `auth.mfa.session.not.found` (400) — Phiên MFA không tồn tại
       * @summary Confirm Login OTP
       * @param {BackofficeAuthConfirmRequest} backofficeAuthConfirmRequest
       * @param {*} [options] Override http request option.
       * @throws {RequiredError}
       */
      confirmLogin: async (
        backofficeAuthConfirmRequest: BackofficeAuthConfirmRequest,
        options: AxiosRequestConfig = {},
      ): Promise<RequestArgs> => {
        // verify required parameter 'backofficeAuthConfirmRequest' is not null or undefined
        assertParamExists(
          "confirmLogin",
          "backofficeAuthConfirmRequest",
          backofficeAuthConfirmRequest,
        );
        const localVarPath = `/bo/api/v1/authorization/confirm`;
        // use dummy base URL string because the URL constructor only accepts absolute URLs.
        const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
        let baseOptions;
        if (configuration) {
          baseOptions = configuration.baseOptions;
        }

        const localVarRequestOptions = {
          method: "POST",
          ...baseOptions,
          ...options,
        };
        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        localVarHeaderParameter["Content-Type"] = "application/json";

        setSearchParams(localVarUrlObj, localVarQueryParameter);
        let headersFromBaseOptions =
          baseOptions && baseOptions.headers ? baseOptions.headers : {};
        localVarRequestOptions.headers = {
          ...localVarHeaderParameter,
          ...headersFromBaseOptions,
          ...options.headers,
        };
        localVarRequestOptions.data = serializeDataIfNeeded(
          backofficeAuthConfirmRequest,
          localVarRequestOptions,
          configuration,
        );

        return {
          url: toPathString(localVarUrlObj),
          options: localVarRequestOptions,
        };
      },
      /**
       * Xác thực username/password, kiểm tra trạng thái tài khoản (Active/Locked/Inactive), tạo phiên MFA và gửi OTP qua email.     - Sau 3 lần đăng nhập sai: yêu cầu CAPTCHA - Sau 5 lần sai: tạm khóa tài khoản 15 phút  Response: - `action`: OTP_SENT_VIA_EMAIL (gửi OTP thành công) | REQUIRE_CHANGE_PASSWORD (cần đổi mật khẩu lần đầu/hết hạn)  Error codes:     - `auth.invalid.username.or.password` (401) — Sai username hoặc password, có thể có detail `requiresCaptcha: true` sau 3 lần sai - `auth.account.is.locked.due.to.security.policy` (401) — Tài khoản bị khóa - `auth.login.temporarily.locked` (400) — Tạm khóa do nhập sai mật khẩu quá nhiều lần (5 lần, khóa 15 phút)     - `auth.captcha.required` (400) — Yêu cầu CAPTCHA (sau 3 lần đăng nhập sai)     - `auth.captcha.invalid` (400) — CAPTCHA không hợp lệ - `auth.otp.temporarily.locked` (400) — Tạm khóa do nhập sai OTP quá nhiều lần - `auth.operation.not.supported` (500) — Phương thức MFA không được hỗ trợ
       * @summary Login
       * @param {BackofficeAuthRequest} backofficeAuthRequest
       * @param {*} [options] Override http request option.
       * @throws {RequiredError}
       */
      login: async (
        backofficeAuthRequest: BackofficeAuthRequest,
        options: AxiosRequestConfig = {},
      ): Promise<RequestArgs> => {
        // verify required parameter 'backofficeAuthRequest' is not null or undefined
        assertParamExists(
          "login",
          "backofficeAuthRequest",
          backofficeAuthRequest,
        );
        const localVarPath = `/bo/api/v1/authorization`;
        // use dummy base URL string because the URL constructor only accepts absolute URLs.
        const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
        let baseOptions;
        if (configuration) {
          baseOptions = configuration.baseOptions;
        }

        const localVarRequestOptions = {
          method: "POST",
          ...baseOptions,
          ...options,
        };
        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        localVarHeaderParameter["Content-Type"] = "application/json";

        setSearchParams(localVarUrlObj, localVarQueryParameter);
        let headersFromBaseOptions =
          baseOptions && baseOptions.headers ? baseOptions.headers : {};
        localVarRequestOptions.headers = {
          ...localVarHeaderParameter,
          ...headersFromBaseOptions,
          ...options.headers,
        };
        localVarRequestOptions.data = serializeDataIfNeeded(
          backofficeAuthRequest,
          localVarRequestOptions,
          configuration,
        );

        return {
          url: toPathString(localVarUrlObj),
          options: localVarRequestOptions,
        };
      },
      /**
       * Gửi lại mã OTP trong luồng đăng nhập. - Cooldown 60 giây giữa các lần gửi - Tối đa 3 lần gửi lại trong một phiên đăng nhập - OTP cũ bị vô hiệu hóa khi gửi mới  Response: - `remainSendAttempts`: số lần gửi lại OTP còn lại  Error codes: - `auth.otp.send.rate.limited` (400) — Vượt quá số lần gửi OTP cho phép - `auth.otp.temporarily.locked` (400) — Tạm khóa do nhập sai OTP quá nhiều lần - `auth.mfa.session.not.found` (400) — Phiên MFA không tồn tại hoặc đã hết hạn
       * @summary Resend Login OTP
       * @param {BackofficeAuthResendOtpRequest} backofficeAuthResendOtpRequest
       * @param {*} [options] Override http request option.
       * @throws {RequiredError}
       */
      loginMfa: async (
        backofficeAuthResendOtpRequest: BackofficeAuthResendOtpRequest,
        options: AxiosRequestConfig = {},
      ): Promise<RequestArgs> => {
        // verify required parameter 'backofficeAuthResendOtpRequest' is not null or undefined
        assertParamExists(
          "loginMfa",
          "backofficeAuthResendOtpRequest",
          backofficeAuthResendOtpRequest,
        );
        const localVarPath = `/bo/api/v1/authorization/otp/resend`;
        // use dummy base URL string because the URL constructor only accepts absolute URLs.
        const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
        let baseOptions;
        if (configuration) {
          baseOptions = configuration.baseOptions;
        }

        const localVarRequestOptions = {
          method: "POST",
          ...baseOptions,
          ...options,
        };
        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        localVarHeaderParameter["Content-Type"] = "application/json";

        setSearchParams(localVarUrlObj, localVarQueryParameter);
        let headersFromBaseOptions =
          baseOptions && baseOptions.headers ? baseOptions.headers : {};
        localVarRequestOptions.headers = {
          ...localVarHeaderParameter,
          ...headersFromBaseOptions,
          ...options.headers,
        };
        localVarRequestOptions.data = serializeDataIfNeeded(
          backofficeAuthResendOtpRequest,
          localVarRequestOptions,
          configuration,
        );

        return {
          url: toPathString(localVarUrlObj),
          options: localVarRequestOptions,
        };
      },
      /**
       * Hủy phiên đăng nhập và vô hiệu hóa token của người dùng
       * @summary Logout
       * @param {LogoutRequest} [logoutRequest]
       * @param {*} [options] Override http request option.
       * @throws {RequiredError}
       */
      logout: async (
        logoutRequest?: LogoutRequest,
        options: AxiosRequestConfig = {},
      ): Promise<RequestArgs> => {
        const localVarPath = `/bo/api/v1/authorization`;
        // use dummy base URL string because the URL constructor only accepts absolute URLs.
        const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
        let baseOptions;
        if (configuration) {
          baseOptions = configuration.baseOptions;
        }

        const localVarRequestOptions = {
          method: "DELETE",
          ...baseOptions,
          ...options,
        };
        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        // authentication userInfo required
        await setApiKeyToObject(
          localVarHeaderParameter,
          "X-Userinfo",
          configuration,
        );

        localVarHeaderParameter["Content-Type"] = "application/json";

        setSearchParams(localVarUrlObj, localVarQueryParameter);
        let headersFromBaseOptions =
          baseOptions && baseOptions.headers ? baseOptions.headers : {};
        localVarRequestOptions.headers = {
          ...localVarHeaderParameter,
          ...headersFromBaseOptions,
          ...options.headers,
        };
        localVarRequestOptions.data = serializeDataIfNeeded(
          logoutRequest,
          localVarRequestOptions,
          configuration,
        );

        return {
          url: toPathString(localVarUrlObj),
          options: localVarRequestOptions,
        };
      },
      /**
       * Sử dụng refresh token để cấp lại access token mới khi token hiện tại hết hạn.  Error codes: - `auth.refresh.token.not.found.or.invalid` (400) — Refresh token không hợp lệ - `auth.failed.to.refresh.token` (401) — Không thể làm mới token
       * @summary Refresh Access Token
       * @param {RefreshTokenRequest} refreshTokenRequest
       * @param {*} [options] Override http request option.
       * @throws {RequiredError}
       */
      refresh: async (
        refreshTokenRequest: RefreshTokenRequest,
        options: AxiosRequestConfig = {},
      ): Promise<RequestArgs> => {
        // verify required parameter 'refreshTokenRequest' is not null or undefined
        assertParamExists(
          "refresh",
          "refreshTokenRequest",
          refreshTokenRequest,
        );
        const localVarPath = `/bo/api/v1/authorization`;
        // use dummy base URL string because the URL constructor only accepts absolute URLs.
        const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
        let baseOptions;
        if (configuration) {
          baseOptions = configuration.baseOptions;
        }

        const localVarRequestOptions = {
          method: "PUT",
          ...baseOptions,
          ...options,
        };
        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        localVarHeaderParameter["Content-Type"] = "application/json";

        setSearchParams(localVarUrlObj, localVarQueryParameter);
        let headersFromBaseOptions =
          baseOptions && baseOptions.headers ? baseOptions.headers : {};
        localVarRequestOptions.headers = {
          ...localVarHeaderParameter,
          ...headersFromBaseOptions,
          ...options.headers,
        };
        localVarRequestOptions.data = serializeDataIfNeeded(
          refreshTokenRequest,
          localVarRequestOptions,
          configuration,
        );

        return {
          url: toPathString(localVarUrlObj),
          options: localVarRequestOptions,
        };
      },
    };
  };

/**
 * BackofficeAuthenticationAuthorizationApi - functional programming interface
 * @export
 */
export const BackofficeAuthenticationAuthorizationApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    BackofficeAuthenticationAuthorizationApiAxiosParamCreator(configuration);
  return {
    /**
     * Xác thực mã OTP 6 chữ số được gửi qua email. - OTP có thời hạn 5 phút - Tối đa 5 lần nhập sai, sau đó khóa 15 phút - Nếu hợp lệ: cấp JWT access token và refresh token, ghi audit log  Response: - `action`: TOKEN_CREATED (đăng nhập thành công, trả accessToken + refreshToken)  Error codes:     - `auth.invalid.otp` (400) — Mã OTP không đúng, params[0] = số lần nhập còn lại - `auth.otp.has.expired` (400) — Mã OTP đã hết hạn - `auth.exceeded.maximum.otp.verification.attempts` (400) — Vượt quá 5 lần nhập sai - `auth.otp.temporarily.locked` (400) — Tạm khóa 15 phút do nhập sai quá nhiều     - `auth.mfa.session.not.found` (400) — Phiên MFA không tồn tại
     * @summary Confirm Login OTP
     * @param {BackofficeAuthConfirmRequest} backofficeAuthConfirmRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async confirmLogin(
      backofficeAuthConfirmRequest: BackofficeAuthConfirmRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<BackofficeAuthResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.confirmLogin(
        backofficeAuthConfirmRequest,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Xác thực username/password, kiểm tra trạng thái tài khoản (Active/Locked/Inactive), tạo phiên MFA và gửi OTP qua email.     - Sau 3 lần đăng nhập sai: yêu cầu CAPTCHA - Sau 5 lần sai: tạm khóa tài khoản 15 phút  Response: - `action`: OTP_SENT_VIA_EMAIL (gửi OTP thành công) | REQUIRE_CHANGE_PASSWORD (cần đổi mật khẩu lần đầu/hết hạn)  Error codes:     - `auth.invalid.username.or.password` (401) — Sai username hoặc password, có thể có detail `requiresCaptcha: true` sau 3 lần sai - `auth.account.is.locked.due.to.security.policy` (401) — Tài khoản bị khóa - `auth.login.temporarily.locked` (400) — Tạm khóa do nhập sai mật khẩu quá nhiều lần (5 lần, khóa 15 phút)     - `auth.captcha.required` (400) — Yêu cầu CAPTCHA (sau 3 lần đăng nhập sai)     - `auth.captcha.invalid` (400) — CAPTCHA không hợp lệ - `auth.otp.temporarily.locked` (400) — Tạm khóa do nhập sai OTP quá nhiều lần - `auth.operation.not.supported` (500) — Phương thức MFA không được hỗ trợ
     * @summary Login
     * @param {BackofficeAuthRequest} backofficeAuthRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async login(
      backofficeAuthRequest: BackofficeAuthRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<BackofficeAuthResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.login(
        backofficeAuthRequest,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Gửi lại mã OTP trong luồng đăng nhập. - Cooldown 60 giây giữa các lần gửi - Tối đa 3 lần gửi lại trong một phiên đăng nhập - OTP cũ bị vô hiệu hóa khi gửi mới  Response: - `remainSendAttempts`: số lần gửi lại OTP còn lại  Error codes: - `auth.otp.send.rate.limited` (400) — Vượt quá số lần gửi OTP cho phép - `auth.otp.temporarily.locked` (400) — Tạm khóa do nhập sai OTP quá nhiều lần - `auth.mfa.session.not.found` (400) — Phiên MFA không tồn tại hoặc đã hết hạn
     * @summary Resend Login OTP
     * @param {BackofficeAuthResendOtpRequest} backofficeAuthResendOtpRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async loginMfa(
      backofficeAuthResendOtpRequest: BackofficeAuthResendOtpRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResendResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.loginMfa(
        backofficeAuthResendOtpRequest,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Hủy phiên đăng nhập và vô hiệu hóa token của người dùng
     * @summary Logout
     * @param {LogoutRequest} [logoutRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async logout(
      logoutRequest?: LogoutRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.logout(
        logoutRequest,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Sử dụng refresh token để cấp lại access token mới khi token hiện tại hết hạn.  Error codes: - `auth.refresh.token.not.found.or.invalid` (400) — Refresh token không hợp lệ - `auth.failed.to.refresh.token` (401) — Không thể làm mới token
     * @summary Refresh Access Token
     * @param {RefreshTokenRequest} refreshTokenRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async refresh(
      refreshTokenRequest: RefreshTokenRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<BackofficeAuthResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.refresh(
        refreshTokenRequest,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
  };
};

/**
 * BackofficeAuthenticationAuthorizationApi - factory interface
 * @export
 */
export const BackofficeAuthenticationAuthorizationApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = BackofficeAuthenticationAuthorizationApiFp(configuration);
  return {
    /**
     * Xác thực mã OTP 6 chữ số được gửi qua email. - OTP có thời hạn 5 phút - Tối đa 5 lần nhập sai, sau đó khóa 15 phút - Nếu hợp lệ: cấp JWT access token và refresh token, ghi audit log  Response: - `action`: TOKEN_CREATED (đăng nhập thành công, trả accessToken + refreshToken)  Error codes:     - `auth.invalid.otp` (400) — Mã OTP không đúng, params[0] = số lần nhập còn lại - `auth.otp.has.expired` (400) — Mã OTP đã hết hạn - `auth.exceeded.maximum.otp.verification.attempts` (400) — Vượt quá 5 lần nhập sai - `auth.otp.temporarily.locked` (400) — Tạm khóa 15 phút do nhập sai quá nhiều     - `auth.mfa.session.not.found` (400) — Phiên MFA không tồn tại
     * @summary Confirm Login OTP
     * @param {BackofficeAuthConfirmRequest} backofficeAuthConfirmRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    confirmLogin(
      backofficeAuthConfirmRequest: BackofficeAuthConfirmRequest,
      options?: any,
    ): AxiosPromise<BackofficeAuthResponse> {
      return localVarFp
        .confirmLogin(backofficeAuthConfirmRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Xác thực username/password, kiểm tra trạng thái tài khoản (Active/Locked/Inactive), tạo phiên MFA và gửi OTP qua email.     - Sau 3 lần đăng nhập sai: yêu cầu CAPTCHA - Sau 5 lần sai: tạm khóa tài khoản 15 phút  Response: - `action`: OTP_SENT_VIA_EMAIL (gửi OTP thành công) | REQUIRE_CHANGE_PASSWORD (cần đổi mật khẩu lần đầu/hết hạn)  Error codes:     - `auth.invalid.username.or.password` (401) — Sai username hoặc password, có thể có detail `requiresCaptcha: true` sau 3 lần sai - `auth.account.is.locked.due.to.security.policy` (401) — Tài khoản bị khóa - `auth.login.temporarily.locked` (400) — Tạm khóa do nhập sai mật khẩu quá nhiều lần (5 lần, khóa 15 phút)     - `auth.captcha.required` (400) — Yêu cầu CAPTCHA (sau 3 lần đăng nhập sai)     - `auth.captcha.invalid` (400) — CAPTCHA không hợp lệ - `auth.otp.temporarily.locked` (400) — Tạm khóa do nhập sai OTP quá nhiều lần - `auth.operation.not.supported` (500) — Phương thức MFA không được hỗ trợ
     * @summary Login
     * @param {BackofficeAuthRequest} backofficeAuthRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    login(
      backofficeAuthRequest: BackofficeAuthRequest,
      options?: any,
    ): AxiosPromise<BackofficeAuthResponse> {
      return localVarFp
        .login(backofficeAuthRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Gửi lại mã OTP trong luồng đăng nhập. - Cooldown 60 giây giữa các lần gửi - Tối đa 3 lần gửi lại trong một phiên đăng nhập - OTP cũ bị vô hiệu hóa khi gửi mới  Response: - `remainSendAttempts`: số lần gửi lại OTP còn lại  Error codes: - `auth.otp.send.rate.limited` (400) — Vượt quá số lần gửi OTP cho phép - `auth.otp.temporarily.locked` (400) — Tạm khóa do nhập sai OTP quá nhiều lần - `auth.mfa.session.not.found` (400) — Phiên MFA không tồn tại hoặc đã hết hạn
     * @summary Resend Login OTP
     * @param {BackofficeAuthResendOtpRequest} backofficeAuthResendOtpRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loginMfa(
      backofficeAuthResendOtpRequest: BackofficeAuthResendOtpRequest,
      options?: any,
    ): AxiosPromise<ResendResponse> {
      return localVarFp
        .loginMfa(backofficeAuthResendOtpRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Hủy phiên đăng nhập và vô hiệu hóa token của người dùng
     * @summary Logout
     * @param {LogoutRequest} [logoutRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    logout(logoutRequest?: LogoutRequest, options?: any): AxiosPromise<void> {
      return localVarFp
        .logout(logoutRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Sử dụng refresh token để cấp lại access token mới khi token hiện tại hết hạn.  Error codes: - `auth.refresh.token.not.found.or.invalid` (400) — Refresh token không hợp lệ - `auth.failed.to.refresh.token` (401) — Không thể làm mới token
     * @summary Refresh Access Token
     * @param {RefreshTokenRequest} refreshTokenRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    refresh(
      refreshTokenRequest: RefreshTokenRequest,
      options?: any,
    ): AxiosPromise<BackofficeAuthResponse> {
      return localVarFp
        .refresh(refreshTokenRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for confirmLogin operation in BackofficeAuthenticationAuthorizationApi.
 * @export
 * @interface BackofficeAuthenticationAuthorizationApiConfirmLoginRequest
 */
export interface BackofficeAuthenticationAuthorizationApiConfirmLoginRequest {
  /**
   *
   * @type {BackofficeAuthConfirmRequest}
   * @memberof BackofficeAuthenticationAuthorizationApiConfirmLogin
   */
  readonly backofficeAuthConfirmRequest: BackofficeAuthConfirmRequest;
}

/**
 * Request parameters for login operation in BackofficeAuthenticationAuthorizationApi.
 * @export
 * @interface BackofficeAuthenticationAuthorizationApiLoginRequest
 */
export interface BackofficeAuthenticationAuthorizationApiLoginRequest {
  /**
   *
   * @type {BackofficeAuthRequest}
   * @memberof BackofficeAuthenticationAuthorizationApiLogin
   */
  readonly backofficeAuthRequest: BackofficeAuthRequest;
}

/**
 * Request parameters for loginMfa operation in BackofficeAuthenticationAuthorizationApi.
 * @export
 * @interface BackofficeAuthenticationAuthorizationApiLoginMfaRequest
 */
export interface BackofficeAuthenticationAuthorizationApiLoginMfaRequest {
  /**
   *
   * @type {BackofficeAuthResendOtpRequest}
   * @memberof BackofficeAuthenticationAuthorizationApiLoginMfa
   */
  readonly backofficeAuthResendOtpRequest: BackofficeAuthResendOtpRequest;
}

/**
 * Request parameters for logout operation in BackofficeAuthenticationAuthorizationApi.
 * @export
 * @interface BackofficeAuthenticationAuthorizationApiLogoutRequest
 */
export interface BackofficeAuthenticationAuthorizationApiLogoutRequest {
  /**
   *
   * @type {LogoutRequest}
   * @memberof BackofficeAuthenticationAuthorizationApiLogout
   */
  readonly logoutRequest?: LogoutRequest;
}

/**
 * Request parameters for refresh operation in BackofficeAuthenticationAuthorizationApi.
 * @export
 * @interface BackofficeAuthenticationAuthorizationApiRefreshRequest
 */
export interface BackofficeAuthenticationAuthorizationApiRefreshRequest {
  /**
   *
   * @type {RefreshTokenRequest}
   * @memberof BackofficeAuthenticationAuthorizationApiRefresh
   */
  readonly refreshTokenRequest: RefreshTokenRequest;
}

/**
 * BackofficeAuthenticationAuthorizationApi - object-oriented interface
 * @export
 * @class BackofficeAuthenticationAuthorizationApi
 * @extends {BaseAPI}
 */
export class BackofficeAuthenticationAuthorizationApi extends BaseAPI {
  /**
   * Xác thực mã OTP 6 chữ số được gửi qua email. - OTP có thời hạn 5 phút - Tối đa 5 lần nhập sai, sau đó khóa 15 phút - Nếu hợp lệ: cấp JWT access token và refresh token, ghi audit log  Response: - `action`: TOKEN_CREATED (đăng nhập thành công, trả accessToken + refreshToken)  Error codes:     - `auth.invalid.otp` (400) — Mã OTP không đúng, params[0] = số lần nhập còn lại - `auth.otp.has.expired` (400) — Mã OTP đã hết hạn - `auth.exceeded.maximum.otp.verification.attempts` (400) — Vượt quá 5 lần nhập sai - `auth.otp.temporarily.locked` (400) — Tạm khóa 15 phút do nhập sai quá nhiều     - `auth.mfa.session.not.found` (400) — Phiên MFA không tồn tại
   * @summary Confirm Login OTP
   * @param {BackofficeAuthenticationAuthorizationApiConfirmLoginRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeAuthenticationAuthorizationApi
   */
  public confirmLogin(
    requestParameters: BackofficeAuthenticationAuthorizationApiConfirmLoginRequest,
    options?: AxiosRequestConfig,
  ) {
    return BackofficeAuthenticationAuthorizationApiFp(this.configuration)
      .confirmLogin(requestParameters.backofficeAuthConfirmRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Xác thực username/password, kiểm tra trạng thái tài khoản (Active/Locked/Inactive), tạo phiên MFA và gửi OTP qua email.     - Sau 3 lần đăng nhập sai: yêu cầu CAPTCHA - Sau 5 lần sai: tạm khóa tài khoản 15 phút  Response: - `action`: OTP_SENT_VIA_EMAIL (gửi OTP thành công) | REQUIRE_CHANGE_PASSWORD (cần đổi mật khẩu lần đầu/hết hạn)  Error codes:     - `auth.invalid.username.or.password` (401) — Sai username hoặc password, có thể có detail `requiresCaptcha: true` sau 3 lần sai - `auth.account.is.locked.due.to.security.policy` (401) — Tài khoản bị khóa - `auth.login.temporarily.locked` (400) — Tạm khóa do nhập sai mật khẩu quá nhiều lần (5 lần, khóa 15 phút)     - `auth.captcha.required` (400) — Yêu cầu CAPTCHA (sau 3 lần đăng nhập sai)     - `auth.captcha.invalid` (400) — CAPTCHA không hợp lệ - `auth.otp.temporarily.locked` (400) — Tạm khóa do nhập sai OTP quá nhiều lần - `auth.operation.not.supported` (500) — Phương thức MFA không được hỗ trợ
   * @summary Login
   * @param {BackofficeAuthenticationAuthorizationApiLoginRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeAuthenticationAuthorizationApi
   */
  public login(
    requestParameters: BackofficeAuthenticationAuthorizationApiLoginRequest,
    options?: AxiosRequestConfig,
  ) {
    return BackofficeAuthenticationAuthorizationApiFp(this.configuration)
      .login(requestParameters.backofficeAuthRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Gửi lại mã OTP trong luồng đăng nhập. - Cooldown 60 giây giữa các lần gửi - Tối đa 3 lần gửi lại trong một phiên đăng nhập - OTP cũ bị vô hiệu hóa khi gửi mới  Response: - `remainSendAttempts`: số lần gửi lại OTP còn lại  Error codes: - `auth.otp.send.rate.limited` (400) — Vượt quá số lần gửi OTP cho phép - `auth.otp.temporarily.locked` (400) — Tạm khóa do nhập sai OTP quá nhiều lần - `auth.mfa.session.not.found` (400) — Phiên MFA không tồn tại hoặc đã hết hạn
   * @summary Resend Login OTP
   * @param {BackofficeAuthenticationAuthorizationApiLoginMfaRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeAuthenticationAuthorizationApi
   */
  public loginMfa(
    requestParameters: BackofficeAuthenticationAuthorizationApiLoginMfaRequest,
    options?: AxiosRequestConfig,
  ) {
    return BackofficeAuthenticationAuthorizationApiFp(this.configuration)
      .loginMfa(requestParameters.backofficeAuthResendOtpRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Hủy phiên đăng nhập và vô hiệu hóa token của người dùng
   * @summary Logout
   * @param {BackofficeAuthenticationAuthorizationApiLogoutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeAuthenticationAuthorizationApi
   */
  public logout(
    requestParameters: BackofficeAuthenticationAuthorizationApiLogoutRequest = {},
    options?: AxiosRequestConfig,
  ) {
    return BackofficeAuthenticationAuthorizationApiFp(this.configuration)
      .logout(requestParameters.logoutRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Sử dụng refresh token để cấp lại access token mới khi token hiện tại hết hạn.  Error codes: - `auth.refresh.token.not.found.or.invalid` (400) — Refresh token không hợp lệ - `auth.failed.to.refresh.token` (401) — Không thể làm mới token
   * @summary Refresh Access Token
   * @param {BackofficeAuthenticationAuthorizationApiRefreshRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeAuthenticationAuthorizationApi
   */
  public refresh(
    requestParameters: BackofficeAuthenticationAuthorizationApiRefreshRequest,
    options?: AxiosRequestConfig,
  ) {
    return BackofficeAuthenticationAuthorizationApiFp(this.configuration)
      .refresh(requestParameters.refreshTokenRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * BackofficeChangePasswordApi - axios parameter creator
 * @export
 */
export const BackofficeChangePasswordApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Bắt đầu luồng đổi mật khẩu: xác thực mật khẩu hiện tại, validate mật khẩu mới, và gửi OTP qua email đã đăng ký.  Response: - `action`: OTP_SENT_VIA_EMAIL - `remainSendAttempts`: số lần gửi lại OTP còn lại  Error codes: - `auth.current.password.is.incorrect` (400) — Mật khẩu hiện tại không đúng - `auth.new.password.cannot.be.same.as.old.password` (400) — Mật khẩu mới trùng mật khẩu cũ - `auth.input.validation.failed` (400) — Mật khẩu không đáp ứng yêu cầu bảo mật - `auth.session.not.found.or.expired` (401) — Phiên đăng nhập không tồn tại hoặc hết hạn
     * @summary Initiate Change Password
     * @param {BoChangePasswordRequest} boChangePasswordRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    changePasswordRequest: async (
      boChangePasswordRequest: BoChangePasswordRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'boChangePasswordRequest' is not null or undefined
      assertParamExists(
        "changePasswordRequest",
        "boChangePasswordRequest",
        boChangePasswordRequest,
      );
      const localVarPath = `/bo/api/v1/authorization/change-password`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        boChangePasswordRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Gửi lại mã OTP cho luồng đổi mật khẩu. Cooldown 60 giây, OTP cũ bị vô hiệu hóa khi gửi mới.  Response: - `remainSendAttempts`: số lần gửi lại OTP còn lại  Error codes:     - `auth.otp.send.rate.limited` (400) — Chưa hết cooldown 60 giây - `auth.otp.temporarily.locked` (400) — Tạm khóa do nhập sai OTP quá nhiều - `auth.session.not.found.or.expired` (401) — Phiên đổi mật khẩu không tồn tại
     * @summary Resend Change Password OTP
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resendOtp1: async (
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/bo/api/v1/authorization/change-password/resend-otp`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Xác thực mã OTP và cập nhật mật khẩu mới. - OTP có thời hạn 5 phút - Sau 5 lần nhập sai: hủy yêu cầu, vô hiệu hóa OTP, khóa tạm 15 phút - Sau thành công: cập nhật passwordChangedAt, hủy tất cả phiên đăng nhập  Error codes: - `auth.invalid.otp` (400) — Mã OTP không đúng, params[0] = số lần nhập còn lại - `auth.otp.has.expired` (400) — Mã OTP đã hết hạn - `auth.exceeded.maximum.otp.verification.attempts` (400) — Vượt quá 5 lần nhập sai - `auth.otp.temporarily.locked` (400) — Tạm khóa 15 phút do nhập sai quá nhiều - `auth.session.not.found.or.expired` (401) — Phiên đổi mật khẩu không tồn tại
     * @summary Verify OTP and Complete Password Change
     * @param {BoChangePasswordVerifyOtpRequest} boChangePasswordVerifyOtpRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    verifyOtp2: async (
      boChangePasswordVerifyOtpRequest: BoChangePasswordVerifyOtpRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'boChangePasswordVerifyOtpRequest' is not null or undefined
      assertParamExists(
        "verifyOtp2",
        "boChangePasswordVerifyOtpRequest",
        boChangePasswordVerifyOtpRequest,
      );
      const localVarPath = `/bo/api/v1/authorization/change-password/verify-otp`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        boChangePasswordVerifyOtpRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * BackofficeChangePasswordApi - functional programming interface
 * @export
 */
export const BackofficeChangePasswordApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    BackofficeChangePasswordApiAxiosParamCreator(configuration);
  return {
    /**
     * Bắt đầu luồng đổi mật khẩu: xác thực mật khẩu hiện tại, validate mật khẩu mới, và gửi OTP qua email đã đăng ký.  Response: - `action`: OTP_SENT_VIA_EMAIL - `remainSendAttempts`: số lần gửi lại OTP còn lại  Error codes: - `auth.current.password.is.incorrect` (400) — Mật khẩu hiện tại không đúng - `auth.new.password.cannot.be.same.as.old.password` (400) — Mật khẩu mới trùng mật khẩu cũ - `auth.input.validation.failed` (400) — Mật khẩu không đáp ứng yêu cầu bảo mật - `auth.session.not.found.or.expired` (401) — Phiên đăng nhập không tồn tại hoặc hết hạn
     * @summary Initiate Change Password
     * @param {BoChangePasswordRequest} boChangePasswordRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async changePasswordRequest(
      boChangePasswordRequest: BoChangePasswordRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<BoChangePasswordResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.changePasswordRequest(
          boChangePasswordRequest,
          options,
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Gửi lại mã OTP cho luồng đổi mật khẩu. Cooldown 60 giây, OTP cũ bị vô hiệu hóa khi gửi mới.  Response: - `remainSendAttempts`: số lần gửi lại OTP còn lại  Error codes:     - `auth.otp.send.rate.limited` (400) — Chưa hết cooldown 60 giây - `auth.otp.temporarily.locked` (400) — Tạm khóa do nhập sai OTP quá nhiều - `auth.session.not.found.or.expired` (401) — Phiên đổi mật khẩu không tồn tại
     * @summary Resend Change Password OTP
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async resendOtp1(
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResendResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.resendOtp1(options);
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Xác thực mã OTP và cập nhật mật khẩu mới. - OTP có thời hạn 5 phút - Sau 5 lần nhập sai: hủy yêu cầu, vô hiệu hóa OTP, khóa tạm 15 phút - Sau thành công: cập nhật passwordChangedAt, hủy tất cả phiên đăng nhập  Error codes: - `auth.invalid.otp` (400) — Mã OTP không đúng, params[0] = số lần nhập còn lại - `auth.otp.has.expired` (400) — Mã OTP đã hết hạn - `auth.exceeded.maximum.otp.verification.attempts` (400) — Vượt quá 5 lần nhập sai - `auth.otp.temporarily.locked` (400) — Tạm khóa 15 phút do nhập sai quá nhiều - `auth.session.not.found.or.expired` (401) — Phiên đổi mật khẩu không tồn tại
     * @summary Verify OTP and Complete Password Change
     * @param {BoChangePasswordVerifyOtpRequest} boChangePasswordVerifyOtpRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async verifyOtp2(
      boChangePasswordVerifyOtpRequest: BoChangePasswordVerifyOtpRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.verifyOtp2(
        boChangePasswordVerifyOtpRequest,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
  };
};

/**
 * BackofficeChangePasswordApi - factory interface
 * @export
 */
export const BackofficeChangePasswordApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = BackofficeChangePasswordApiFp(configuration);
  return {
    /**
     * Bắt đầu luồng đổi mật khẩu: xác thực mật khẩu hiện tại, validate mật khẩu mới, và gửi OTP qua email đã đăng ký.  Response: - `action`: OTP_SENT_VIA_EMAIL - `remainSendAttempts`: số lần gửi lại OTP còn lại  Error codes: - `auth.current.password.is.incorrect` (400) — Mật khẩu hiện tại không đúng - `auth.new.password.cannot.be.same.as.old.password` (400) — Mật khẩu mới trùng mật khẩu cũ - `auth.input.validation.failed` (400) — Mật khẩu không đáp ứng yêu cầu bảo mật - `auth.session.not.found.or.expired` (401) — Phiên đăng nhập không tồn tại hoặc hết hạn
     * @summary Initiate Change Password
     * @param {BoChangePasswordRequest} boChangePasswordRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    changePasswordRequest(
      boChangePasswordRequest: BoChangePasswordRequest,
      options?: any,
    ): AxiosPromise<BoChangePasswordResponse> {
      return localVarFp
        .changePasswordRequest(boChangePasswordRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Gửi lại mã OTP cho luồng đổi mật khẩu. Cooldown 60 giây, OTP cũ bị vô hiệu hóa khi gửi mới.  Response: - `remainSendAttempts`: số lần gửi lại OTP còn lại  Error codes:     - `auth.otp.send.rate.limited` (400) — Chưa hết cooldown 60 giây - `auth.otp.temporarily.locked` (400) — Tạm khóa do nhập sai OTP quá nhiều - `auth.session.not.found.or.expired` (401) — Phiên đổi mật khẩu không tồn tại
     * @summary Resend Change Password OTP
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resendOtp1(options?: any): AxiosPromise<ResendResponse> {
      return localVarFp
        .resendOtp1(options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Xác thực mã OTP và cập nhật mật khẩu mới. - OTP có thời hạn 5 phút - Sau 5 lần nhập sai: hủy yêu cầu, vô hiệu hóa OTP, khóa tạm 15 phút - Sau thành công: cập nhật passwordChangedAt, hủy tất cả phiên đăng nhập  Error codes: - `auth.invalid.otp` (400) — Mã OTP không đúng, params[0] = số lần nhập còn lại - `auth.otp.has.expired` (400) — Mã OTP đã hết hạn - `auth.exceeded.maximum.otp.verification.attempts` (400) — Vượt quá 5 lần nhập sai - `auth.otp.temporarily.locked` (400) — Tạm khóa 15 phút do nhập sai quá nhiều - `auth.session.not.found.or.expired` (401) — Phiên đổi mật khẩu không tồn tại
     * @summary Verify OTP and Complete Password Change
     * @param {BoChangePasswordVerifyOtpRequest} boChangePasswordVerifyOtpRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    verifyOtp2(
      boChangePasswordVerifyOtpRequest: BoChangePasswordVerifyOtpRequest,
      options?: any,
    ): AxiosPromise<void> {
      return localVarFp
        .verifyOtp2(boChangePasswordVerifyOtpRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for changePasswordRequest operation in BackofficeChangePasswordApi.
 * @export
 * @interface BackofficeChangePasswordApiChangePasswordRequestRequest
 */
export interface BackofficeChangePasswordApiChangePasswordRequestRequest {
  /**
   *
   * @type {BoChangePasswordRequest}
   * @memberof BackofficeChangePasswordApiChangePasswordRequest
   */
  readonly boChangePasswordRequest: BoChangePasswordRequest;
}

/**
 * Request parameters for verifyOtp2 operation in BackofficeChangePasswordApi.
 * @export
 * @interface BackofficeChangePasswordApiVerifyOtp2Request
 */
export interface BackofficeChangePasswordApiVerifyOtp2Request {
  /**
   *
   * @type {BoChangePasswordVerifyOtpRequest}
   * @memberof BackofficeChangePasswordApiVerifyOtp2
   */
  readonly boChangePasswordVerifyOtpRequest: BoChangePasswordVerifyOtpRequest;
}

/**
 * BackofficeChangePasswordApi - object-oriented interface
 * @export
 * @class BackofficeChangePasswordApi
 * @extends {BaseAPI}
 */
export class BackofficeChangePasswordApi extends BaseAPI {
  /**
   * Bắt đầu luồng đổi mật khẩu: xác thực mật khẩu hiện tại, validate mật khẩu mới, và gửi OTP qua email đã đăng ký.  Response: - `action`: OTP_SENT_VIA_EMAIL - `remainSendAttempts`: số lần gửi lại OTP còn lại  Error codes: - `auth.current.password.is.incorrect` (400) — Mật khẩu hiện tại không đúng - `auth.new.password.cannot.be.same.as.old.password` (400) — Mật khẩu mới trùng mật khẩu cũ - `auth.input.validation.failed` (400) — Mật khẩu không đáp ứng yêu cầu bảo mật - `auth.session.not.found.or.expired` (401) — Phiên đăng nhập không tồn tại hoặc hết hạn
   * @summary Initiate Change Password
   * @param {BackofficeChangePasswordApiChangePasswordRequestRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeChangePasswordApi
   */
  public changePasswordRequest(
    requestParameters: BackofficeChangePasswordApiChangePasswordRequestRequest,
    options?: AxiosRequestConfig,
  ) {
    return BackofficeChangePasswordApiFp(this.configuration)
      .changePasswordRequest(requestParameters.boChangePasswordRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Gửi lại mã OTP cho luồng đổi mật khẩu. Cooldown 60 giây, OTP cũ bị vô hiệu hóa khi gửi mới.  Response: - `remainSendAttempts`: số lần gửi lại OTP còn lại  Error codes:     - `auth.otp.send.rate.limited` (400) — Chưa hết cooldown 60 giây - `auth.otp.temporarily.locked` (400) — Tạm khóa do nhập sai OTP quá nhiều - `auth.session.not.found.or.expired` (401) — Phiên đổi mật khẩu không tồn tại
   * @summary Resend Change Password OTP
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeChangePasswordApi
   */
  public resendOtp1(options?: AxiosRequestConfig) {
    return BackofficeChangePasswordApiFp(this.configuration)
      .resendOtp1(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Xác thực mã OTP và cập nhật mật khẩu mới. - OTP có thời hạn 5 phút - Sau 5 lần nhập sai: hủy yêu cầu, vô hiệu hóa OTP, khóa tạm 15 phút - Sau thành công: cập nhật passwordChangedAt, hủy tất cả phiên đăng nhập  Error codes: - `auth.invalid.otp` (400) — Mã OTP không đúng, params[0] = số lần nhập còn lại - `auth.otp.has.expired` (400) — Mã OTP đã hết hạn - `auth.exceeded.maximum.otp.verification.attempts` (400) — Vượt quá 5 lần nhập sai - `auth.otp.temporarily.locked` (400) — Tạm khóa 15 phút do nhập sai quá nhiều - `auth.session.not.found.or.expired` (401) — Phiên đổi mật khẩu không tồn tại
   * @summary Verify OTP and Complete Password Change
   * @param {BackofficeChangePasswordApiVerifyOtp2Request} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeChangePasswordApi
   */
  public verifyOtp2(
    requestParameters: BackofficeChangePasswordApiVerifyOtp2Request,
    options?: AxiosRequestConfig,
  ) {
    return BackofficeChangePasswordApiFp(this.configuration)
      .verifyOtp2(requestParameters.boChangePasswordVerifyOtpRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * BackofficeForceChangePasswordApi - axios parameter creator
 * @export
 */
export const BackofficeForceChangePasswordApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Đổi mật khẩu tạm thời sau lần đăng nhập đầu tiên hoặc khi mật khẩu hết hạn (>180 ngày). Yêu cầu token đổi mật khẩu hợp lệ. Sau thành công, hủy tất cả phiên cũ.  Error codes: - `auth.session.not.found.or.expired` (401) — Token đổi mật khẩu không hợp lệ hoặc hết hạn - `auth.input.validation.failed` (400) — Mật khẩu không đáp ứng yêu cầu bảo mật
     * @summary Force Change Password
     * @param {BoForceChangePasswordRequest} boForceChangePasswordRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    changePassword: async (
      boForceChangePasswordRequest: BoForceChangePasswordRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'boForceChangePasswordRequest' is not null or undefined
      assertParamExists(
        "changePassword",
        "boForceChangePasswordRequest",
        boForceChangePasswordRequest,
      );
      const localVarPath = `/bo/api/v1/authorization/force-change-password`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        boForceChangePasswordRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * BackofficeForceChangePasswordApi - functional programming interface
 * @export
 */
export const BackofficeForceChangePasswordApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    BackofficeForceChangePasswordApiAxiosParamCreator(configuration);
  return {
    /**
     * Đổi mật khẩu tạm thời sau lần đăng nhập đầu tiên hoặc khi mật khẩu hết hạn (>180 ngày). Yêu cầu token đổi mật khẩu hợp lệ. Sau thành công, hủy tất cả phiên cũ.  Error codes: - `auth.session.not.found.or.expired` (401) — Token đổi mật khẩu không hợp lệ hoặc hết hạn - `auth.input.validation.failed` (400) — Mật khẩu không đáp ứng yêu cầu bảo mật
     * @summary Force Change Password
     * @param {BoForceChangePasswordRequest} boForceChangePasswordRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async changePassword(
      boForceChangePasswordRequest: BoForceChangePasswordRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.changePassword(
        boForceChangePasswordRequest,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
  };
};

/**
 * BackofficeForceChangePasswordApi - factory interface
 * @export
 */
export const BackofficeForceChangePasswordApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = BackofficeForceChangePasswordApiFp(configuration);
  return {
    /**
     * Đổi mật khẩu tạm thời sau lần đăng nhập đầu tiên hoặc khi mật khẩu hết hạn (>180 ngày). Yêu cầu token đổi mật khẩu hợp lệ. Sau thành công, hủy tất cả phiên cũ.  Error codes: - `auth.session.not.found.or.expired` (401) — Token đổi mật khẩu không hợp lệ hoặc hết hạn - `auth.input.validation.failed` (400) — Mật khẩu không đáp ứng yêu cầu bảo mật
     * @summary Force Change Password
     * @param {BoForceChangePasswordRequest} boForceChangePasswordRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    changePassword(
      boForceChangePasswordRequest: BoForceChangePasswordRequest,
      options?: any,
    ): AxiosPromise<void> {
      return localVarFp
        .changePassword(boForceChangePasswordRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for changePassword operation in BackofficeForceChangePasswordApi.
 * @export
 * @interface BackofficeForceChangePasswordApiChangePasswordRequest
 */
export interface BackofficeForceChangePasswordApiChangePasswordRequest {
  /**
   *
   * @type {BoForceChangePasswordRequest}
   * @memberof BackofficeForceChangePasswordApiChangePassword
   */
  readonly boForceChangePasswordRequest: BoForceChangePasswordRequest;
}

/**
 * BackofficeForceChangePasswordApi - object-oriented interface
 * @export
 * @class BackofficeForceChangePasswordApi
 * @extends {BaseAPI}
 */
export class BackofficeForceChangePasswordApi extends BaseAPI {
  /**
   * Đổi mật khẩu tạm thời sau lần đăng nhập đầu tiên hoặc khi mật khẩu hết hạn (>180 ngày). Yêu cầu token đổi mật khẩu hợp lệ. Sau thành công, hủy tất cả phiên cũ.  Error codes: - `auth.session.not.found.or.expired` (401) — Token đổi mật khẩu không hợp lệ hoặc hết hạn - `auth.input.validation.failed` (400) — Mật khẩu không đáp ứng yêu cầu bảo mật
   * @summary Force Change Password
   * @param {BackofficeForceChangePasswordApiChangePasswordRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeForceChangePasswordApi
   */
  public changePassword(
    requestParameters: BackofficeForceChangePasswordApiChangePasswordRequest,
    options?: AxiosRequestConfig,
  ) {
    return BackofficeForceChangePasswordApiFp(this.configuration)
      .changePassword(requestParameters.boForceChangePasswordRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * BackofficeMerchantAccountManagementApi - axios parameter creator
 * @export
 */
export const BackofficeMerchantAccountManagementApiAxiosParamCreator =
  function (configuration?: Configuration) {
    return {
      /**
       * Full V26 entity fields including suspended/locked metadata + role_id.
       * @summary Get merchant account detail
       * @param {any} id merchant_user.id UUID
       * @param {*} [options] Override http request option.
       * @throws {RequiredError}
       */
      getDetail1: async (
        id: any,
        options: AxiosRequestConfig = {},
      ): Promise<RequestArgs> => {
        // verify required parameter 'id' is not null or undefined
        assertParamExists("getDetail1", "id", id);
        const localVarPath = `/bo/api/merchant-accounts/v1/{id}`.replace(
          `{${"id"}}`,
          encodeURIComponent(String(id)),
        );
        // use dummy base URL string because the URL constructor only accepts absolute URLs.
        const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
        let baseOptions;
        if (configuration) {
          baseOptions = configuration.baseOptions;
        }

        const localVarRequestOptions = {
          method: "GET",
          ...baseOptions,
          ...options,
        };
        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        setSearchParams(localVarUrlObj, localVarQueryParameter);
        let headersFromBaseOptions =
          baseOptions && baseOptions.headers ? baseOptions.headers : {};
        localVarRequestOptions.headers = {
          ...localVarHeaderParameter,
          ...headersFromBaseOptions,
          ...options.headers,
        };

        return {
          url: toPathString(localVarUrlObj),
          options: localVarRequestOptions,
        };
      },
      /**
       * Filter null-aware: keyword (fuzzy phone/email/full_name ILIKE), status, accountLevel, roleId. Pagination via ?page= &size=. DELETED excluded.
       * @summary List merchant accounts
       * @param {any} [keyword] Fuzzy match phone / email / full_name (ILIKE wildcard)
       * @param {any} [status] PENDING_ACTIVATION | ACTIVE | SUSPENDED | LOCKED (DELETED excluded)
       * @param {any} [accountLevel] MERCHANT | SUB_MERCHANT | TERMINAL
       * @param {any} [roleId] RBAC role FK filter (merchant_role.id)
       * @param {any} [page] Zero-based page index (0..N)
       * @param {any} [size] The size of the page to be returned
       * @param {any} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
       * @param {*} [options] Override http request option.
       * @throws {RequiredError}
       */
      list2: async (
        keyword?: any,
        status?: any,
        accountLevel?: any,
        roleId?: any,
        page?: any,
        size?: any,
        sort?: any,
        options: AxiosRequestConfig = {},
      ): Promise<RequestArgs> => {
        const localVarPath = `/bo/api/merchant-accounts/v1`;
        // use dummy base URL string because the URL constructor only accepts absolute URLs.
        const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
        let baseOptions;
        if (configuration) {
          baseOptions = configuration.baseOptions;
        }

        const localVarRequestOptions = {
          method: "GET",
          ...baseOptions,
          ...options,
        };
        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        if (keyword !== undefined) {
          localVarQueryParameter["keyword"] = keyword;
        }

        if (status !== undefined) {
          localVarQueryParameter["status"] = status;
        }

        if (accountLevel !== undefined) {
          localVarQueryParameter["accountLevel"] = accountLevel;
        }

        if (roleId !== undefined) {
          localVarQueryParameter["roleId"] = roleId;
        }

        if (page !== undefined) {
          localVarQueryParameter["page"] = page;
        }

        if (size !== undefined) {
          localVarQueryParameter["size"] = size;
        }

        if (sort !== undefined) {
          localVarQueryParameter["sort"] = sort;
        }

        setSearchParams(localVarUrlObj, localVarQueryParameter);
        let headersFromBaseOptions =
          baseOptions && baseOptions.headers ? baseOptions.headers : {};
        localVarRequestOptions.headers = {
          ...localVarHeaderParameter,
          ...headersFromBaseOptions,
          ...options.headers,
        };

        return {
          url: toPathString(localVarUrlObj),
          options: localVarRequestOptions,
        };
      },
      /**
       * ACTIVE | SUSPENDED → LOCKED. Reason mandatory. Terminal state preceding soft-delete.
       * @summary Khoá tài khoản (lock)
       * @param {any} id
       * @param {LockMerchantAccountRequest} lockMerchantAccountRequest
       * @param {*} [options] Override http request option.
       * @throws {RequiredError}
       */
      lock: async (
        id: any,
        lockMerchantAccountRequest: LockMerchantAccountRequest,
        options: AxiosRequestConfig = {},
      ): Promise<RequestArgs> => {
        // verify required parameter 'id' is not null or undefined
        assertParamExists("lock", "id", id);
        // verify required parameter 'lockMerchantAccountRequest' is not null or undefined
        assertParamExists(
          "lock",
          "lockMerchantAccountRequest",
          lockMerchantAccountRequest,
        );
        const localVarPath = `/bo/api/merchant-accounts/v1/{id}/lock`.replace(
          `{${"id"}}`,
          encodeURIComponent(String(id)),
        );
        // use dummy base URL string because the URL constructor only accepts absolute URLs.
        const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
        let baseOptions;
        if (configuration) {
          baseOptions = configuration.baseOptions;
        }

        const localVarRequestOptions = {
          method: "POST",
          ...baseOptions,
          ...options,
        };
        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        localVarHeaderParameter["Content-Type"] = "application/json";

        setSearchParams(localVarUrlObj, localVarQueryParameter);
        let headersFromBaseOptions =
          baseOptions && baseOptions.headers ? baseOptions.headers : {};
        localVarRequestOptions.headers = {
          ...localVarHeaderParameter,
          ...headersFromBaseOptions,
          ...options.headers,
        };
        localVarRequestOptions.data = serializeDataIfNeeded(
          lockMerchantAccountRequest,
          localVarRequestOptions,
          configuration,
        );

        return {
          url: toPathString(localVarUrlObj),
          options: localVarRequestOptions,
        };
      },
      /**
       * SUSPENDED → ACTIVE. Clears suspended_reason + suspended_at.
       * @summary Mở khoá đình chỉ (reactivate)
       * @param {any} id
       * @param {*} [options] Override http request option.
       * @throws {RequiredError}
       */
      reactivate: async (
        id: any,
        options: AxiosRequestConfig = {},
      ): Promise<RequestArgs> => {
        // verify required parameter 'id' is not null or undefined
        assertParamExists("reactivate", "id", id);
        const localVarPath =
          `/bo/api/merchant-accounts/v1/{id}/reactivate`.replace(
            `{${"id"}}`,
            encodeURIComponent(String(id)),
          );
        // use dummy base URL string because the URL constructor only accepts absolute URLs.
        const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
        let baseOptions;
        if (configuration) {
          baseOptions = configuration.baseOptions;
        }

        const localVarRequestOptions = {
          method: "POST",
          ...baseOptions,
          ...options,
        };
        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        setSearchParams(localVarUrlObj, localVarQueryParameter);
        let headersFromBaseOptions =
          baseOptions && baseOptions.headers ? baseOptions.headers : {};
        localVarRequestOptions.headers = {
          ...localVarHeaderParameter,
          ...headersFromBaseOptions,
          ...options.headers,
        };

        return {
          url: toPathString(localVarUrlObj),
          options: localVarRequestOptions,
        };
      },
      /**
       * LOCKED | PENDING_ACTIVATION → DELETED. Sets deleted_at. 7-year audit retention.
       * @summary Xoá mềm tài khoản (soft delete)
       * @param {any} id
       * @param {*} [options] Override http request option.
       * @throws {RequiredError}
       */
      softDelete1: async (
        id: any,
        options: AxiosRequestConfig = {},
      ): Promise<RequestArgs> => {
        // verify required parameter 'id' is not null or undefined
        assertParamExists("softDelete1", "id", id);
        const localVarPath = `/bo/api/merchant-accounts/v1/{id}`.replace(
          `{${"id"}}`,
          encodeURIComponent(String(id)),
        );
        // use dummy base URL string because the URL constructor only accepts absolute URLs.
        const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
        let baseOptions;
        if (configuration) {
          baseOptions = configuration.baseOptions;
        }

        const localVarRequestOptions = {
          method: "DELETE",
          ...baseOptions,
          ...options,
        };
        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        setSearchParams(localVarUrlObj, localVarQueryParameter);
        let headersFromBaseOptions =
          baseOptions && baseOptions.headers ? baseOptions.headers : {};
        localVarRequestOptions.headers = {
          ...localVarHeaderParameter,
          ...headersFromBaseOptions,
          ...options.headers,
        };

        return {
          url: toPathString(localVarUrlObj),
          options: localVarRequestOptions,
        };
      },
      /**
       * ACTIVE | PENDING_ACTIVATION → SUSPENDED. Reason 10-500 chars mandatory. Sets suspended_at + suspended_reason.
       * @summary Đình chỉ tài khoản (suspend)
       * @param {any} id
       * @param {SuspendMerchantAccountRequest} suspendMerchantAccountRequest
       * @param {*} [options] Override http request option.
       * @throws {RequiredError}
       */
      suspend: async (
        id: any,
        suspendMerchantAccountRequest: SuspendMerchantAccountRequest,
        options: AxiosRequestConfig = {},
      ): Promise<RequestArgs> => {
        // verify required parameter 'id' is not null or undefined
        assertParamExists("suspend", "id", id);
        // verify required parameter 'suspendMerchantAccountRequest' is not null or undefined
        assertParamExists(
          "suspend",
          "suspendMerchantAccountRequest",
          suspendMerchantAccountRequest,
        );
        const localVarPath =
          `/bo/api/merchant-accounts/v1/{id}/suspend`.replace(
            `{${"id"}}`,
            encodeURIComponent(String(id)),
          );
        // use dummy base URL string because the URL constructor only accepts absolute URLs.
        const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
        let baseOptions;
        if (configuration) {
          baseOptions = configuration.baseOptions;
        }

        const localVarRequestOptions = {
          method: "POST",
          ...baseOptions,
          ...options,
        };
        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        localVarHeaderParameter["Content-Type"] = "application/json";

        setSearchParams(localVarUrlObj, localVarQueryParameter);
        let headersFromBaseOptions =
          baseOptions && baseOptions.headers ? baseOptions.headers : {};
        localVarRequestOptions.headers = {
          ...localVarHeaderParameter,
          ...headersFromBaseOptions,
          ...options.headers,
        };
        localVarRequestOptions.data = serializeDataIfNeeded(
          suspendMerchantAccountRequest,
          localVarRequestOptions,
          configuration,
        );

        return {
          url: toPathString(localVarUrlObj),
          options: localVarRequestOptions,
        };
      },
      /**
       * Sets V26 role_id FK to merchant_role.id. Phase 3 (A3) seeds role catalog.
       * @summary Gán / đổi role RBAC
       * @param {any} id
       * @param {UpdateMerchantAccountRoleRequest} updateMerchantAccountRoleRequest
       * @param {*} [options] Override http request option.
       * @throws {RequiredError}
       */
      updateRole: async (
        id: any,
        updateMerchantAccountRoleRequest: UpdateMerchantAccountRoleRequest,
        options: AxiosRequestConfig = {},
      ): Promise<RequestArgs> => {
        // verify required parameter 'id' is not null or undefined
        assertParamExists("updateRole", "id", id);
        // verify required parameter 'updateMerchantAccountRoleRequest' is not null or undefined
        assertParamExists(
          "updateRole",
          "updateMerchantAccountRoleRequest",
          updateMerchantAccountRoleRequest,
        );
        const localVarPath = `/bo/api/merchant-accounts/v1/{id}/role`.replace(
          `{${"id"}}`,
          encodeURIComponent(String(id)),
        );
        // use dummy base URL string because the URL constructor only accepts absolute URLs.
        const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
        let baseOptions;
        if (configuration) {
          baseOptions = configuration.baseOptions;
        }

        const localVarRequestOptions = {
          method: "PUT",
          ...baseOptions,
          ...options,
        };
        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        localVarHeaderParameter["Content-Type"] = "application/json";

        setSearchParams(localVarUrlObj, localVarQueryParameter);
        let headersFromBaseOptions =
          baseOptions && baseOptions.headers ? baseOptions.headers : {};
        localVarRequestOptions.headers = {
          ...localVarHeaderParameter,
          ...headersFromBaseOptions,
          ...options.headers,
        };
        localVarRequestOptions.data = serializeDataIfNeeded(
          updateMerchantAccountRoleRequest,
          localVarRequestOptions,
          configuration,
        );

        return {
          url: toPathString(localVarUrlObj),
          options: localVarRequestOptions,
        };
      },
    };
  };

/**
 * BackofficeMerchantAccountManagementApi - functional programming interface
 * @export
 */
export const BackofficeMerchantAccountManagementApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    BackofficeMerchantAccountManagementApiAxiosParamCreator(configuration);
  return {
    /**
     * Full V26 entity fields including suspended/locked metadata + role_id.
     * @summary Get merchant account detail
     * @param {any} id merchant_user.id UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getDetail1(
      id: any,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<MerchantAccountResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getDetail1(
        id,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Filter null-aware: keyword (fuzzy phone/email/full_name ILIKE), status, accountLevel, roleId. Pagination via ?page= &size=. DELETED excluded.
     * @summary List merchant accounts
     * @param {any} [keyword] Fuzzy match phone / email / full_name (ILIKE wildcard)
     * @param {any} [status] PENDING_ACTIVATION | ACTIVE | SUSPENDED | LOCKED (DELETED excluded)
     * @param {any} [accountLevel] MERCHANT | SUB_MERCHANT | TERMINAL
     * @param {any} [roleId] RBAC role FK filter (merchant_role.id)
     * @param {any} [page] Zero-based page index (0..N)
     * @param {any} [size] The size of the page to be returned
     * @param {any} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async list2(
      keyword?: any,
      status?: any,
      accountLevel?: any,
      roleId?: any,
      page?: any,
      size?: any,
      sort?: any,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PageResponseMerchantAccountResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.list2(
        keyword,
        status,
        accountLevel,
        roleId,
        page,
        size,
        sort,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * ACTIVE | SUSPENDED → LOCKED. Reason mandatory. Terminal state preceding soft-delete.
     * @summary Khoá tài khoản (lock)
     * @param {any} id
     * @param {LockMerchantAccountRequest} lockMerchantAccountRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async lock(
      id: any,
      lockMerchantAccountRequest: LockMerchantAccountRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommonResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.lock(
        id,
        lockMerchantAccountRequest,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * SUSPENDED → ACTIVE. Clears suspended_reason + suspended_at.
     * @summary Mở khoá đình chỉ (reactivate)
     * @param {any} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async reactivate(
      id: any,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommonResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.reactivate(
        id,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * LOCKED | PENDING_ACTIVATION → DELETED. Sets deleted_at. 7-year audit retention.
     * @summary Xoá mềm tài khoản (soft delete)
     * @param {any} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async softDelete1(
      id: any,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommonResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.softDelete1(
        id,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * ACTIVE | PENDING_ACTIVATION → SUSPENDED. Reason 10-500 chars mandatory. Sets suspended_at + suspended_reason.
     * @summary Đình chỉ tài khoản (suspend)
     * @param {any} id
     * @param {SuspendMerchantAccountRequest} suspendMerchantAccountRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async suspend(
      id: any,
      suspendMerchantAccountRequest: SuspendMerchantAccountRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommonResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.suspend(
        id,
        suspendMerchantAccountRequest,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Sets V26 role_id FK to merchant_role.id. Phase 3 (A3) seeds role catalog.
     * @summary Gán / đổi role RBAC
     * @param {any} id
     * @param {UpdateMerchantAccountRoleRequest} updateMerchantAccountRoleRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateRole(
      id: any,
      updateMerchantAccountRoleRequest: UpdateMerchantAccountRoleRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommonResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateRole(
        id,
        updateMerchantAccountRoleRequest,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
  };
};

/**
 * BackofficeMerchantAccountManagementApi - factory interface
 * @export
 */
export const BackofficeMerchantAccountManagementApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = BackofficeMerchantAccountManagementApiFp(configuration);
  return {
    /**
     * Full V26 entity fields including suspended/locked metadata + role_id.
     * @summary Get merchant account detail
     * @param {any} id merchant_user.id UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDetail1(id: any, options?: any): AxiosPromise<MerchantAccountResponse> {
      return localVarFp
        .getDetail1(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Filter null-aware: keyword (fuzzy phone/email/full_name ILIKE), status, accountLevel, roleId. Pagination via ?page= &size=. DELETED excluded.
     * @summary List merchant accounts
     * @param {any} [keyword] Fuzzy match phone / email / full_name (ILIKE wildcard)
     * @param {any} [status] PENDING_ACTIVATION | ACTIVE | SUSPENDED | LOCKED (DELETED excluded)
     * @param {any} [accountLevel] MERCHANT | SUB_MERCHANT | TERMINAL
     * @param {any} [roleId] RBAC role FK filter (merchant_role.id)
     * @param {any} [page] Zero-based page index (0..N)
     * @param {any} [size] The size of the page to be returned
     * @param {any} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    list2(
      keyword?: any,
      status?: any,
      accountLevel?: any,
      roleId?: any,
      page?: any,
      size?: any,
      sort?: any,
      options?: any,
    ): AxiosPromise<PageResponseMerchantAccountResponse> {
      return localVarFp
        .list2(keyword, status, accountLevel, roleId, page, size, sort, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * ACTIVE | SUSPENDED → LOCKED. Reason mandatory. Terminal state preceding soft-delete.
     * @summary Khoá tài khoản (lock)
     * @param {any} id
     * @param {LockMerchantAccountRequest} lockMerchantAccountRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    lock(
      id: any,
      lockMerchantAccountRequest: LockMerchantAccountRequest,
      options?: any,
    ): AxiosPromise<CommonResponse> {
      return localVarFp
        .lock(id, lockMerchantAccountRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * SUSPENDED → ACTIVE. Clears suspended_reason + suspended_at.
     * @summary Mở khoá đình chỉ (reactivate)
     * @param {any} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reactivate(id: any, options?: any): AxiosPromise<CommonResponse> {
      return localVarFp
        .reactivate(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * LOCKED | PENDING_ACTIVATION → DELETED. Sets deleted_at. 7-year audit retention.
     * @summary Xoá mềm tài khoản (soft delete)
     * @param {any} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    softDelete1(id: any, options?: any): AxiosPromise<CommonResponse> {
      return localVarFp
        .softDelete1(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * ACTIVE | PENDING_ACTIVATION → SUSPENDED. Reason 10-500 chars mandatory. Sets suspended_at + suspended_reason.
     * @summary Đình chỉ tài khoản (suspend)
     * @param {any} id
     * @param {SuspendMerchantAccountRequest} suspendMerchantAccountRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    suspend(
      id: any,
      suspendMerchantAccountRequest: SuspendMerchantAccountRequest,
      options?: any,
    ): AxiosPromise<CommonResponse> {
      return localVarFp
        .suspend(id, suspendMerchantAccountRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Sets V26 role_id FK to merchant_role.id. Phase 3 (A3) seeds role catalog.
     * @summary Gán / đổi role RBAC
     * @param {any} id
     * @param {UpdateMerchantAccountRoleRequest} updateMerchantAccountRoleRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateRole(
      id: any,
      updateMerchantAccountRoleRequest: UpdateMerchantAccountRoleRequest,
      options?: any,
    ): AxiosPromise<CommonResponse> {
      return localVarFp
        .updateRole(id, updateMerchantAccountRoleRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for getDetail1 operation in BackofficeMerchantAccountManagementApi.
 * @export
 * @interface BackofficeMerchantAccountManagementApiGetDetail1Request
 */
export interface BackofficeMerchantAccountManagementApiGetDetail1Request {
  /**
   * merchant_user.id UUID
   * @type {any}
   * @memberof BackofficeMerchantAccountManagementApiGetDetail1
   */
  readonly id: any;
}

/**
 * Request parameters for list2 operation in BackofficeMerchantAccountManagementApi.
 * @export
 * @interface BackofficeMerchantAccountManagementApiList2Request
 */
export interface BackofficeMerchantAccountManagementApiList2Request {
  /**
   * Fuzzy match phone / email / full_name (ILIKE wildcard)
   * @type {any}
   * @memberof BackofficeMerchantAccountManagementApiList2
   */
  readonly keyword?: any;

  /**
   * PENDING_ACTIVATION | ACTIVE | SUSPENDED | LOCKED (DELETED excluded)
   * @type {any}
   * @memberof BackofficeMerchantAccountManagementApiList2
   */
  readonly status?: any;

  /**
   * MERCHANT | SUB_MERCHANT | TERMINAL
   * @type {any}
   * @memberof BackofficeMerchantAccountManagementApiList2
   */
  readonly accountLevel?: any;

  /**
   * RBAC role FK filter (merchant_role.id)
   * @type {any}
   * @memberof BackofficeMerchantAccountManagementApiList2
   */
  readonly roleId?: any;

  /**
   * Zero-based page index (0..N)
   * @type {any}
   * @memberof BackofficeMerchantAccountManagementApiList2
   */
  readonly page?: any;

  /**
   * The size of the page to be returned
   * @type {any}
   * @memberof BackofficeMerchantAccountManagementApiList2
   */
  readonly size?: any;

  /**
   * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @type {any}
   * @memberof BackofficeMerchantAccountManagementApiList2
   */
  readonly sort?: any;
}

/**
 * Request parameters for lock operation in BackofficeMerchantAccountManagementApi.
 * @export
 * @interface BackofficeMerchantAccountManagementApiLockRequest
 */
export interface BackofficeMerchantAccountManagementApiLockRequest {
  /**
   *
   * @type {any}
   * @memberof BackofficeMerchantAccountManagementApiLock
   */
  readonly id: any;

  /**
   *
   * @type {LockMerchantAccountRequest}
   * @memberof BackofficeMerchantAccountManagementApiLock
   */
  readonly lockMerchantAccountRequest: LockMerchantAccountRequest;
}

/**
 * Request parameters for reactivate operation in BackofficeMerchantAccountManagementApi.
 * @export
 * @interface BackofficeMerchantAccountManagementApiReactivateRequest
 */
export interface BackofficeMerchantAccountManagementApiReactivateRequest {
  /**
   *
   * @type {any}
   * @memberof BackofficeMerchantAccountManagementApiReactivate
   */
  readonly id: any;
}

/**
 * Request parameters for softDelete1 operation in BackofficeMerchantAccountManagementApi.
 * @export
 * @interface BackofficeMerchantAccountManagementApiSoftDelete1Request
 */
export interface BackofficeMerchantAccountManagementApiSoftDelete1Request {
  /**
   *
   * @type {any}
   * @memberof BackofficeMerchantAccountManagementApiSoftDelete1
   */
  readonly id: any;
}

/**
 * Request parameters for suspend operation in BackofficeMerchantAccountManagementApi.
 * @export
 * @interface BackofficeMerchantAccountManagementApiSuspendRequest
 */
export interface BackofficeMerchantAccountManagementApiSuspendRequest {
  /**
   *
   * @type {any}
   * @memberof BackofficeMerchantAccountManagementApiSuspend
   */
  readonly id: any;

  /**
   *
   * @type {SuspendMerchantAccountRequest}
   * @memberof BackofficeMerchantAccountManagementApiSuspend
   */
  readonly suspendMerchantAccountRequest: SuspendMerchantAccountRequest;
}

/**
 * Request parameters for updateRole operation in BackofficeMerchantAccountManagementApi.
 * @export
 * @interface BackofficeMerchantAccountManagementApiUpdateRoleRequest
 */
export interface BackofficeMerchantAccountManagementApiUpdateRoleRequest {
  /**
   *
   * @type {any}
   * @memberof BackofficeMerchantAccountManagementApiUpdateRole
   */
  readonly id: any;

  /**
   *
   * @type {UpdateMerchantAccountRoleRequest}
   * @memberof BackofficeMerchantAccountManagementApiUpdateRole
   */
  readonly updateMerchantAccountRoleRequest: UpdateMerchantAccountRoleRequest;
}

/**
 * BackofficeMerchantAccountManagementApi - object-oriented interface
 * @export
 * @class BackofficeMerchantAccountManagementApi
 * @extends {BaseAPI}
 */
export class BackofficeMerchantAccountManagementApi extends BaseAPI {
  /**
   * Full V26 entity fields including suspended/locked metadata + role_id.
   * @summary Get merchant account detail
   * @param {BackofficeMerchantAccountManagementApiGetDetail1Request} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeMerchantAccountManagementApi
   */
  public getDetail1(
    requestParameters: BackofficeMerchantAccountManagementApiGetDetail1Request,
    options?: AxiosRequestConfig,
  ) {
    return BackofficeMerchantAccountManagementApiFp(this.configuration)
      .getDetail1(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Filter null-aware: keyword (fuzzy phone/email/full_name ILIKE), status, accountLevel, roleId. Pagination via ?page= &size=. DELETED excluded.
   * @summary List merchant accounts
   * @param {BackofficeMerchantAccountManagementApiList2Request} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeMerchantAccountManagementApi
   */
  public list2(
    requestParameters: BackofficeMerchantAccountManagementApiList2Request = {},
    options?: AxiosRequestConfig,
  ) {
    return BackofficeMerchantAccountManagementApiFp(this.configuration)
      .list2(
        requestParameters.keyword,
        requestParameters.status,
        requestParameters.accountLevel,
        requestParameters.roleId,
        requestParameters.page,
        requestParameters.size,
        requestParameters.sort,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * ACTIVE | SUSPENDED → LOCKED. Reason mandatory. Terminal state preceding soft-delete.
   * @summary Khoá tài khoản (lock)
   * @param {BackofficeMerchantAccountManagementApiLockRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeMerchantAccountManagementApi
   */
  public lock(
    requestParameters: BackofficeMerchantAccountManagementApiLockRequest,
    options?: AxiosRequestConfig,
  ) {
    return BackofficeMerchantAccountManagementApiFp(this.configuration)
      .lock(
        requestParameters.id,
        requestParameters.lockMerchantAccountRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * SUSPENDED → ACTIVE. Clears suspended_reason + suspended_at.
   * @summary Mở khoá đình chỉ (reactivate)
   * @param {BackofficeMerchantAccountManagementApiReactivateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeMerchantAccountManagementApi
   */
  public reactivate(
    requestParameters: BackofficeMerchantAccountManagementApiReactivateRequest,
    options?: AxiosRequestConfig,
  ) {
    return BackofficeMerchantAccountManagementApiFp(this.configuration)
      .reactivate(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * LOCKED | PENDING_ACTIVATION → DELETED. Sets deleted_at. 7-year audit retention.
   * @summary Xoá mềm tài khoản (soft delete)
   * @param {BackofficeMerchantAccountManagementApiSoftDelete1Request} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeMerchantAccountManagementApi
   */
  public softDelete1(
    requestParameters: BackofficeMerchantAccountManagementApiSoftDelete1Request,
    options?: AxiosRequestConfig,
  ) {
    return BackofficeMerchantAccountManagementApiFp(this.configuration)
      .softDelete1(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * ACTIVE | PENDING_ACTIVATION → SUSPENDED. Reason 10-500 chars mandatory. Sets suspended_at + suspended_reason.
   * @summary Đình chỉ tài khoản (suspend)
   * @param {BackofficeMerchantAccountManagementApiSuspendRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeMerchantAccountManagementApi
   */
  public suspend(
    requestParameters: BackofficeMerchantAccountManagementApiSuspendRequest,
    options?: AxiosRequestConfig,
  ) {
    return BackofficeMerchantAccountManagementApiFp(this.configuration)
      .suspend(
        requestParameters.id,
        requestParameters.suspendMerchantAccountRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Sets V26 role_id FK to merchant_role.id. Phase 3 (A3) seeds role catalog.
   * @summary Gán / đổi role RBAC
   * @param {BackofficeMerchantAccountManagementApiUpdateRoleRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeMerchantAccountManagementApi
   */
  public updateRole(
    requestParameters: BackofficeMerchantAccountManagementApiUpdateRoleRequest,
    options?: AxiosRequestConfig,
  ) {
    return BackofficeMerchantAccountManagementApiFp(this.configuration)
      .updateRole(
        requestParameters.id,
        requestParameters.updateMerchantAccountRoleRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * BackofficeMerchantPermissionCatalogApi - axios parameter creator
 * @export
 */
export const BackofficeMerchantPermissionCatalogApiAxiosParamCreator =
  function (configuration?: Configuration) {
    return {
      /**
       * Idempotent (ON CONFLICT DO NOTHING).
       * @summary Grant permission to role
       * @param {any} roleId
       * @param {GrantRolePermissionRequest} grantRolePermissionRequest
       * @param {*} [options] Override http request option.
       * @throws {RequiredError}
       */
      grant: async (
        roleId: any,
        grantRolePermissionRequest: GrantRolePermissionRequest,
        options: AxiosRequestConfig = {},
      ): Promise<RequestArgs> => {
        // verify required parameter 'roleId' is not null or undefined
        assertParamExists("grant", "roleId", roleId);
        // verify required parameter 'grantRolePermissionRequest' is not null or undefined
        assertParamExists(
          "grant",
          "grantRolePermissionRequest",
          grantRolePermissionRequest,
        );
        const localVarPath =
          `/bo/api/merchant-permissions/v1/roles/{roleId}/grant`.replace(
            `{${"roleId"}}`,
            encodeURIComponent(String(roleId)),
          );
        // use dummy base URL string because the URL constructor only accepts absolute URLs.
        const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
        let baseOptions;
        if (configuration) {
          baseOptions = configuration.baseOptions;
        }

        const localVarRequestOptions = {
          method: "POST",
          ...baseOptions,
          ...options,
        };
        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        localVarHeaderParameter["Content-Type"] = "application/json";

        setSearchParams(localVarUrlObj, localVarQueryParameter);
        let headersFromBaseOptions =
          baseOptions && baseOptions.headers ? baseOptions.headers : {};
        localVarRequestOptions.headers = {
          ...localVarHeaderParameter,
          ...headersFromBaseOptions,
          ...options.headers,
        };
        localVarRequestOptions.data = serializeDataIfNeeded(
          grantRolePermissionRequest,
          localVarRequestOptions,
          configuration,
        );

        return {
          url: toPathString(localVarUrlObj),
          options: localVarRequestOptions,
        };
      },
      /**
       * Filter null-aware: keyword (code/name ILIKE), resource, action.
       * @summary List permissions
       * @param {any} [keyword] Fuzzy match code / name (ILIKE)
       * @param {any} [resource] Resource filter (e.g. mch_account, fee-mgmt)
       * @param {any} [action] Action filter (view|create|update|delete|approve|import|export)
       * @param {any} [page] Zero-based page index (0..N)
       * @param {any} [size] The size of the page to be returned
       * @param {any} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
       * @param {*} [options] Override http request option.
       * @throws {RequiredError}
       */
      list1: async (
        keyword?: any,
        resource?: any,
        action?: any,
        page?: any,
        size?: any,
        sort?: any,
        options: AxiosRequestConfig = {},
      ): Promise<RequestArgs> => {
        const localVarPath = `/bo/api/merchant-permissions/v1`;
        // use dummy base URL string because the URL constructor only accepts absolute URLs.
        const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
        let baseOptions;
        if (configuration) {
          baseOptions = configuration.baseOptions;
        }

        const localVarRequestOptions = {
          method: "GET",
          ...baseOptions,
          ...options,
        };
        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        if (keyword !== undefined) {
          localVarQueryParameter["keyword"] = keyword;
        }

        if (resource !== undefined) {
          localVarQueryParameter["resource"] = resource;
        }

        if (action !== undefined) {
          localVarQueryParameter["action"] = action;
        }

        if (page !== undefined) {
          localVarQueryParameter["page"] = page;
        }

        if (size !== undefined) {
          localVarQueryParameter["size"] = size;
        }

        if (sort !== undefined) {
          localVarQueryParameter["sort"] = sort;
        }

        setSearchParams(localVarUrlObj, localVarQueryParameter);
        let headersFromBaseOptions =
          baseOptions && baseOptions.headers ? baseOptions.headers : {};
        localVarRequestOptions.headers = {
          ...localVarHeaderParameter,
          ...headersFromBaseOptions,
          ...options.headers,
        };

        return {
          url: toPathString(localVarUrlObj),
          options: localVarRequestOptions,
        };
      },
      /**
       * Returns full permission list joined to role_id via merchant_role_permission.
       * @summary List permissions granted to role
       * @param {any} roleId merchant_role.id
       * @param {*} [options] Override http request option.
       * @throws {RequiredError}
       */
      listByRole: async (
        roleId: any,
        options: AxiosRequestConfig = {},
      ): Promise<RequestArgs> => {
        // verify required parameter 'roleId' is not null or undefined
        assertParamExists("listByRole", "roleId", roleId);
        const localVarPath =
          `/bo/api/merchant-permissions/v1/roles/{roleId}`.replace(
            `{${"roleId"}}`,
            encodeURIComponent(String(roleId)),
          );
        // use dummy base URL string because the URL constructor only accepts absolute URLs.
        const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
        let baseOptions;
        if (configuration) {
          baseOptions = configuration.baseOptions;
        }

        const localVarRequestOptions = {
          method: "GET",
          ...baseOptions,
          ...options,
        };
        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        setSearchParams(localVarUrlObj, localVarQueryParameter);
        let headersFromBaseOptions =
          baseOptions && baseOptions.headers ? baseOptions.headers : {};
        localVarRequestOptions.headers = {
          ...localVarHeaderParameter,
          ...headersFromBaseOptions,
          ...options.headers,
        };

        return {
          url: toPathString(localVarUrlObj),
          options: localVarRequestOptions,
        };
      },
      /**
       *
       * @summary Revoke permission from role
       * @param {any} roleId
       * @param {any} permissionId
       * @param {*} [options] Override http request option.
       * @throws {RequiredError}
       */
      revoke: async (
        roleId: any,
        permissionId: any,
        options: AxiosRequestConfig = {},
      ): Promise<RequestArgs> => {
        // verify required parameter 'roleId' is not null or undefined
        assertParamExists("revoke", "roleId", roleId);
        // verify required parameter 'permissionId' is not null or undefined
        assertParamExists("revoke", "permissionId", permissionId);
        const localVarPath =
          `/bo/api/merchant-permissions/v1/roles/{roleId}/permissions/{permissionId}`
            .replace(`{${"roleId"}}`, encodeURIComponent(String(roleId)))
            .replace(
              `{${"permissionId"}}`,
              encodeURIComponent(String(permissionId)),
            );
        // use dummy base URL string because the URL constructor only accepts absolute URLs.
        const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
        let baseOptions;
        if (configuration) {
          baseOptions = configuration.baseOptions;
        }

        const localVarRequestOptions = {
          method: "DELETE",
          ...baseOptions,
          ...options,
        };
        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        setSearchParams(localVarUrlObj, localVarQueryParameter);
        let headersFromBaseOptions =
          baseOptions && baseOptions.headers ? baseOptions.headers : {};
        localVarRequestOptions.headers = {
          ...localVarHeaderParameter,
          ...headersFromBaseOptions,
          ...options.headers,
        };

        return {
          url: toPathString(localVarUrlObj),
          options: localVarRequestOptions,
        };
      },
    };
  };

/**
 * BackofficeMerchantPermissionCatalogApi - functional programming interface
 * @export
 */
export const BackofficeMerchantPermissionCatalogApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    BackofficeMerchantPermissionCatalogApiAxiosParamCreator(configuration);
  return {
    /**
     * Idempotent (ON CONFLICT DO NOTHING).
     * @summary Grant permission to role
     * @param {any} roleId
     * @param {GrantRolePermissionRequest} grantRolePermissionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async grant(
      roleId: any,
      grantRolePermissionRequest: GrantRolePermissionRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommonResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.grant(
        roleId,
        grantRolePermissionRequest,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Filter null-aware: keyword (code/name ILIKE), resource, action.
     * @summary List permissions
     * @param {any} [keyword] Fuzzy match code / name (ILIKE)
     * @param {any} [resource] Resource filter (e.g. mch_account, fee-mgmt)
     * @param {any} [action] Action filter (view|create|update|delete|approve|import|export)
     * @param {any} [page] Zero-based page index (0..N)
     * @param {any} [size] The size of the page to be returned
     * @param {any} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async list1(
      keyword?: any,
      resource?: any,
      action?: any,
      page?: any,
      size?: any,
      sort?: any,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PageResponseMerchantPermissionResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.list1(
        keyword,
        resource,
        action,
        page,
        size,
        sort,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Returns full permission list joined to role_id via merchant_role_permission.
     * @summary List permissions granted to role
     * @param {any} roleId merchant_role.id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listByRole(
      roleId: any,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.listByRole(
        roleId,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     *
     * @summary Revoke permission from role
     * @param {any} roleId
     * @param {any} permissionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async revoke(
      roleId: any,
      permissionId: any,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommonResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.revoke(
        roleId,
        permissionId,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
  };
};

/**
 * BackofficeMerchantPermissionCatalogApi - factory interface
 * @export
 */
export const BackofficeMerchantPermissionCatalogApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = BackofficeMerchantPermissionCatalogApiFp(configuration);
  return {
    /**
     * Idempotent (ON CONFLICT DO NOTHING).
     * @summary Grant permission to role
     * @param {any} roleId
     * @param {GrantRolePermissionRequest} grantRolePermissionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    grant(
      roleId: any,
      grantRolePermissionRequest: GrantRolePermissionRequest,
      options?: any,
    ): AxiosPromise<CommonResponse> {
      return localVarFp
        .grant(roleId, grantRolePermissionRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Filter null-aware: keyword (code/name ILIKE), resource, action.
     * @summary List permissions
     * @param {any} [keyword] Fuzzy match code / name (ILIKE)
     * @param {any} [resource] Resource filter (e.g. mch_account, fee-mgmt)
     * @param {any} [action] Action filter (view|create|update|delete|approve|import|export)
     * @param {any} [page] Zero-based page index (0..N)
     * @param {any} [size] The size of the page to be returned
     * @param {any} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    list1(
      keyword?: any,
      resource?: any,
      action?: any,
      page?: any,
      size?: any,
      sort?: any,
      options?: any,
    ): AxiosPromise<PageResponseMerchantPermissionResponse> {
      return localVarFp
        .list1(keyword, resource, action, page, size, sort, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Returns full permission list joined to role_id via merchant_role_permission.
     * @summary List permissions granted to role
     * @param {any} roleId merchant_role.id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listByRole(roleId: any, options?: any): AxiosPromise<any> {
      return localVarFp
        .listByRole(roleId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Revoke permission from role
     * @param {any} roleId
     * @param {any} permissionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    revoke(
      roleId: any,
      permissionId: any,
      options?: any,
    ): AxiosPromise<CommonResponse> {
      return localVarFp
        .revoke(roleId, permissionId, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for grant operation in BackofficeMerchantPermissionCatalogApi.
 * @export
 * @interface BackofficeMerchantPermissionCatalogApiGrantRequest
 */
export interface BackofficeMerchantPermissionCatalogApiGrantRequest {
  /**
   *
   * @type {any}
   * @memberof BackofficeMerchantPermissionCatalogApiGrant
   */
  readonly roleId: any;

  /**
   *
   * @type {GrantRolePermissionRequest}
   * @memberof BackofficeMerchantPermissionCatalogApiGrant
   */
  readonly grantRolePermissionRequest: GrantRolePermissionRequest;
}

/**
 * Request parameters for list1 operation in BackofficeMerchantPermissionCatalogApi.
 * @export
 * @interface BackofficeMerchantPermissionCatalogApiList1Request
 */
export interface BackofficeMerchantPermissionCatalogApiList1Request {
  /**
   * Fuzzy match code / name (ILIKE)
   * @type {any}
   * @memberof BackofficeMerchantPermissionCatalogApiList1
   */
  readonly keyword?: any;

  /**
   * Resource filter (e.g. mch_account, fee-mgmt)
   * @type {any}
   * @memberof BackofficeMerchantPermissionCatalogApiList1
   */
  readonly resource?: any;

  /**
   * Action filter (view|create|update|delete|approve|import|export)
   * @type {any}
   * @memberof BackofficeMerchantPermissionCatalogApiList1
   */
  readonly action?: any;

  /**
   * Zero-based page index (0..N)
   * @type {any}
   * @memberof BackofficeMerchantPermissionCatalogApiList1
   */
  readonly page?: any;

  /**
   * The size of the page to be returned
   * @type {any}
   * @memberof BackofficeMerchantPermissionCatalogApiList1
   */
  readonly size?: any;

  /**
   * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @type {any}
   * @memberof BackofficeMerchantPermissionCatalogApiList1
   */
  readonly sort?: any;
}

/**
 * Request parameters for listByRole operation in BackofficeMerchantPermissionCatalogApi.
 * @export
 * @interface BackofficeMerchantPermissionCatalogApiListByRoleRequest
 */
export interface BackofficeMerchantPermissionCatalogApiListByRoleRequest {
  /**
   * merchant_role.id
   * @type {any}
   * @memberof BackofficeMerchantPermissionCatalogApiListByRole
   */
  readonly roleId: any;
}

/**
 * Request parameters for revoke operation in BackofficeMerchantPermissionCatalogApi.
 * @export
 * @interface BackofficeMerchantPermissionCatalogApiRevokeRequest
 */
export interface BackofficeMerchantPermissionCatalogApiRevokeRequest {
  /**
   *
   * @type {any}
   * @memberof BackofficeMerchantPermissionCatalogApiRevoke
   */
  readonly roleId: any;

  /**
   *
   * @type {any}
   * @memberof BackofficeMerchantPermissionCatalogApiRevoke
   */
  readonly permissionId: any;
}

/**
 * BackofficeMerchantPermissionCatalogApi - object-oriented interface
 * @export
 * @class BackofficeMerchantPermissionCatalogApi
 * @extends {BaseAPI}
 */
export class BackofficeMerchantPermissionCatalogApi extends BaseAPI {
  /**
   * Idempotent (ON CONFLICT DO NOTHING).
   * @summary Grant permission to role
   * @param {BackofficeMerchantPermissionCatalogApiGrantRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeMerchantPermissionCatalogApi
   */
  public grant(
    requestParameters: BackofficeMerchantPermissionCatalogApiGrantRequest,
    options?: AxiosRequestConfig,
  ) {
    return BackofficeMerchantPermissionCatalogApiFp(this.configuration)
      .grant(
        requestParameters.roleId,
        requestParameters.grantRolePermissionRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Filter null-aware: keyword (code/name ILIKE), resource, action.
   * @summary List permissions
   * @param {BackofficeMerchantPermissionCatalogApiList1Request} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeMerchantPermissionCatalogApi
   */
  public list1(
    requestParameters: BackofficeMerchantPermissionCatalogApiList1Request = {},
    options?: AxiosRequestConfig,
  ) {
    return BackofficeMerchantPermissionCatalogApiFp(this.configuration)
      .list1(
        requestParameters.keyword,
        requestParameters.resource,
        requestParameters.action,
        requestParameters.page,
        requestParameters.size,
        requestParameters.sort,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Returns full permission list joined to role_id via merchant_role_permission.
   * @summary List permissions granted to role
   * @param {BackofficeMerchantPermissionCatalogApiListByRoleRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeMerchantPermissionCatalogApi
   */
  public listByRole(
    requestParameters: BackofficeMerchantPermissionCatalogApiListByRoleRequest,
    options?: AxiosRequestConfig,
  ) {
    return BackofficeMerchantPermissionCatalogApiFp(this.configuration)
      .listByRole(requestParameters.roleId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Revoke permission from role
   * @param {BackofficeMerchantPermissionCatalogApiRevokeRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeMerchantPermissionCatalogApi
   */
  public revoke(
    requestParameters: BackofficeMerchantPermissionCatalogApiRevokeRequest,
    options?: AxiosRequestConfig,
  ) {
    return BackofficeMerchantPermissionCatalogApiFp(this.configuration)
      .revoke(requestParameters.roleId, requestParameters.permissionId, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * BackofficeMerchantRoleCatalogApi - axios parameter creator
 * @export
 */
export const BackofficeMerchantRoleCatalogApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * system_flag forced to false. code UNIQUE per realm + UPPER_SNAKE format. scope binds account_level eligibility.
     * @summary Tạo role mới (custom)
     * @param {CreateMerchantRoleRequest} createMerchantRoleRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    create1: async (
      createMerchantRoleRequest: CreateMerchantRoleRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'createMerchantRoleRequest' is not null or undefined
      assertParamExists(
        "create1",
        "createMerchantRoleRequest",
        createMerchantRoleRequest,
      );
      const localVarPath = `/bo/api/merchant-roles/v1`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createMerchantRoleRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get role detail
     * @param {any} id merchant_role.id UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDetail: async (
      id: any,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("getDetail", "id", id);
      const localVarPath = `/bo/api/merchant-roles/v1/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Filter null-aware: keyword (code/name ILIKE), scope (MERCHANT|SUB_MERCHANT|TERMINAL), status (ACTIVE|INACTIVE). DELETED excluded. ORDER BY system_flag DESC, code.
     * @summary List merchant roles
     * @param {any} [keyword] Fuzzy match code / name (ILIKE)
     * @param {any} [scope] MERCHANT | SUB_MERCHANT | TERMINAL
     * @param {any} [status] ACTIVE | INACTIVE (DELETED excluded)
     * @param {any} [page] Zero-based page index (0..N)
     * @param {any} [size] The size of the page to be returned
     * @param {any} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    list: async (
      keyword?: any,
      scope?: any,
      status?: any,
      page?: any,
      size?: any,
      sort?: any,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/bo/api/merchant-roles/v1`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (keyword !== undefined) {
        localVarQueryParameter["keyword"] = keyword;
      }

      if (scope !== undefined) {
        localVarQueryParameter["scope"] = scope;
      }

      if (status !== undefined) {
        localVarQueryParameter["status"] = status;
      }

      if (page !== undefined) {
        localVarQueryParameter["page"] = page;
      }

      if (size !== undefined) {
        localVarQueryParameter["size"] = size;
      }

      if (sort !== undefined) {
        localVarQueryParameter["sort"] = sort;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * system_flag=true forbidden. Sets status=DELETED + deleted_at.
     * @summary Xoá mềm role
     * @param {any} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    softDelete: async (
      id: any,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("softDelete", "id", id);
      const localVarPath = `/bo/api/merchant-roles/v1/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * name + description only. code + scope immutable.
     * @summary Cập nhật role
     * @param {any} id
     * @param {UpdateMerchantRoleRequest} updateMerchantRoleRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    update: async (
      id: any,
      updateMerchantRoleRequest: UpdateMerchantRoleRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("update", "id", id);
      // verify required parameter 'updateMerchantRoleRequest' is not null or undefined
      assertParamExists(
        "update",
        "updateMerchantRoleRequest",
        updateMerchantRoleRequest,
      );
      const localVarPath = `/bo/api/merchant-roles/v1/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateMerchantRoleRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * ACTIVE ↔ INACTIVE.
     * @summary Đổi trạng thái role
     * @param {any} id
     * @param {UpdateMerchantRoleStatusRequest} updateMerchantRoleStatusRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateStatus: async (
      id: any,
      updateMerchantRoleStatusRequest: UpdateMerchantRoleStatusRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("updateStatus", "id", id);
      // verify required parameter 'updateMerchantRoleStatusRequest' is not null or undefined
      assertParamExists(
        "updateStatus",
        "updateMerchantRoleStatusRequest",
        updateMerchantRoleStatusRequest,
      );
      const localVarPath = `/bo/api/merchant-roles/v1/{id}/status`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateMerchantRoleStatusRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * BackofficeMerchantRoleCatalogApi - functional programming interface
 * @export
 */
export const BackofficeMerchantRoleCatalogApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    BackofficeMerchantRoleCatalogApiAxiosParamCreator(configuration);
  return {
    /**
     * system_flag forced to false. code UNIQUE per realm + UPPER_SNAKE format. scope binds account_level eligibility.
     * @summary Tạo role mới (custom)
     * @param {CreateMerchantRoleRequest} createMerchantRoleRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async create1(
      createMerchantRoleRequest: CreateMerchantRoleRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<MerchantRoleResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.create1(
        createMerchantRoleRequest,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     *
     * @summary Get role detail
     * @param {any} id merchant_role.id UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getDetail(
      id: any,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<MerchantRoleResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getDetail(
        id,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Filter null-aware: keyword (code/name ILIKE), scope (MERCHANT|SUB_MERCHANT|TERMINAL), status (ACTIVE|INACTIVE). DELETED excluded. ORDER BY system_flag DESC, code.
     * @summary List merchant roles
     * @param {any} [keyword] Fuzzy match code / name (ILIKE)
     * @param {any} [scope] MERCHANT | SUB_MERCHANT | TERMINAL
     * @param {any} [status] ACTIVE | INACTIVE (DELETED excluded)
     * @param {any} [page] Zero-based page index (0..N)
     * @param {any} [size] The size of the page to be returned
     * @param {any} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async list(
      keyword?: any,
      scope?: any,
      status?: any,
      page?: any,
      size?: any,
      sort?: any,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PageResponseMerchantRoleResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.list(
        keyword,
        scope,
        status,
        page,
        size,
        sort,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * system_flag=true forbidden. Sets status=DELETED + deleted_at.
     * @summary Xoá mềm role
     * @param {any} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async softDelete(
      id: any,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommonResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.softDelete(
        id,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * name + description only. code + scope immutable.
     * @summary Cập nhật role
     * @param {any} id
     * @param {UpdateMerchantRoleRequest} updateMerchantRoleRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async update(
      id: any,
      updateMerchantRoleRequest: UpdateMerchantRoleRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommonResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.update(
        id,
        updateMerchantRoleRequest,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * ACTIVE ↔ INACTIVE.
     * @summary Đổi trạng thái role
     * @param {any} id
     * @param {UpdateMerchantRoleStatusRequest} updateMerchantRoleStatusRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateStatus(
      id: any,
      updateMerchantRoleStatusRequest: UpdateMerchantRoleStatusRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommonResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateStatus(
        id,
        updateMerchantRoleStatusRequest,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
  };
};

/**
 * BackofficeMerchantRoleCatalogApi - factory interface
 * @export
 */
export const BackofficeMerchantRoleCatalogApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = BackofficeMerchantRoleCatalogApiFp(configuration);
  return {
    /**
     * system_flag forced to false. code UNIQUE per realm + UPPER_SNAKE format. scope binds account_level eligibility.
     * @summary Tạo role mới (custom)
     * @param {CreateMerchantRoleRequest} createMerchantRoleRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    create1(
      createMerchantRoleRequest: CreateMerchantRoleRequest,
      options?: any,
    ): AxiosPromise<MerchantRoleResponse> {
      return localVarFp
        .create1(createMerchantRoleRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get role detail
     * @param {any} id merchant_role.id UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDetail(id: any, options?: any): AxiosPromise<MerchantRoleResponse> {
      return localVarFp
        .getDetail(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Filter null-aware: keyword (code/name ILIKE), scope (MERCHANT|SUB_MERCHANT|TERMINAL), status (ACTIVE|INACTIVE). DELETED excluded. ORDER BY system_flag DESC, code.
     * @summary List merchant roles
     * @param {any} [keyword] Fuzzy match code / name (ILIKE)
     * @param {any} [scope] MERCHANT | SUB_MERCHANT | TERMINAL
     * @param {any} [status] ACTIVE | INACTIVE (DELETED excluded)
     * @param {any} [page] Zero-based page index (0..N)
     * @param {any} [size] The size of the page to be returned
     * @param {any} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    list(
      keyword?: any,
      scope?: any,
      status?: any,
      page?: any,
      size?: any,
      sort?: any,
      options?: any,
    ): AxiosPromise<PageResponseMerchantRoleResponse> {
      return localVarFp
        .list(keyword, scope, status, page, size, sort, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * system_flag=true forbidden. Sets status=DELETED + deleted_at.
     * @summary Xoá mềm role
     * @param {any} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    softDelete(id: any, options?: any): AxiosPromise<CommonResponse> {
      return localVarFp
        .softDelete(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * name + description only. code + scope immutable.
     * @summary Cập nhật role
     * @param {any} id
     * @param {UpdateMerchantRoleRequest} updateMerchantRoleRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    update(
      id: any,
      updateMerchantRoleRequest: UpdateMerchantRoleRequest,
      options?: any,
    ): AxiosPromise<CommonResponse> {
      return localVarFp
        .update(id, updateMerchantRoleRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * ACTIVE ↔ INACTIVE.
     * @summary Đổi trạng thái role
     * @param {any} id
     * @param {UpdateMerchantRoleStatusRequest} updateMerchantRoleStatusRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateStatus(
      id: any,
      updateMerchantRoleStatusRequest: UpdateMerchantRoleStatusRequest,
      options?: any,
    ): AxiosPromise<CommonResponse> {
      return localVarFp
        .updateStatus(id, updateMerchantRoleStatusRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for create1 operation in BackofficeMerchantRoleCatalogApi.
 * @export
 * @interface BackofficeMerchantRoleCatalogApiCreate1Request
 */
export interface BackofficeMerchantRoleCatalogApiCreate1Request {
  /**
   *
   * @type {CreateMerchantRoleRequest}
   * @memberof BackofficeMerchantRoleCatalogApiCreate1
   */
  readonly createMerchantRoleRequest: CreateMerchantRoleRequest;
}

/**
 * Request parameters for getDetail operation in BackofficeMerchantRoleCatalogApi.
 * @export
 * @interface BackofficeMerchantRoleCatalogApiGetDetailRequest
 */
export interface BackofficeMerchantRoleCatalogApiGetDetailRequest {
  /**
   * merchant_role.id UUID
   * @type {any}
   * @memberof BackofficeMerchantRoleCatalogApiGetDetail
   */
  readonly id: any;
}

/**
 * Request parameters for list operation in BackofficeMerchantRoleCatalogApi.
 * @export
 * @interface BackofficeMerchantRoleCatalogApiListRequest
 */
export interface BackofficeMerchantRoleCatalogApiListRequest {
  /**
   * Fuzzy match code / name (ILIKE)
   * @type {any}
   * @memberof BackofficeMerchantRoleCatalogApiList
   */
  readonly keyword?: any;

  /**
   * MERCHANT | SUB_MERCHANT | TERMINAL
   * @type {any}
   * @memberof BackofficeMerchantRoleCatalogApiList
   */
  readonly scope?: any;

  /**
   * ACTIVE | INACTIVE (DELETED excluded)
   * @type {any}
   * @memberof BackofficeMerchantRoleCatalogApiList
   */
  readonly status?: any;

  /**
   * Zero-based page index (0..N)
   * @type {any}
   * @memberof BackofficeMerchantRoleCatalogApiList
   */
  readonly page?: any;

  /**
   * The size of the page to be returned
   * @type {any}
   * @memberof BackofficeMerchantRoleCatalogApiList
   */
  readonly size?: any;

  /**
   * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @type {any}
   * @memberof BackofficeMerchantRoleCatalogApiList
   */
  readonly sort?: any;
}

/**
 * Request parameters for softDelete operation in BackofficeMerchantRoleCatalogApi.
 * @export
 * @interface BackofficeMerchantRoleCatalogApiSoftDeleteRequest
 */
export interface BackofficeMerchantRoleCatalogApiSoftDeleteRequest {
  /**
   *
   * @type {any}
   * @memberof BackofficeMerchantRoleCatalogApiSoftDelete
   */
  readonly id: any;
}

/**
 * Request parameters for update operation in BackofficeMerchantRoleCatalogApi.
 * @export
 * @interface BackofficeMerchantRoleCatalogApiUpdateRequest
 */
export interface BackofficeMerchantRoleCatalogApiUpdateRequest {
  /**
   *
   * @type {any}
   * @memberof BackofficeMerchantRoleCatalogApiUpdate
   */
  readonly id: any;

  /**
   *
   * @type {UpdateMerchantRoleRequest}
   * @memberof BackofficeMerchantRoleCatalogApiUpdate
   */
  readonly updateMerchantRoleRequest: UpdateMerchantRoleRequest;
}

/**
 * Request parameters for updateStatus operation in BackofficeMerchantRoleCatalogApi.
 * @export
 * @interface BackofficeMerchantRoleCatalogApiUpdateStatusRequest
 */
export interface BackofficeMerchantRoleCatalogApiUpdateStatusRequest {
  /**
   *
   * @type {any}
   * @memberof BackofficeMerchantRoleCatalogApiUpdateStatus
   */
  readonly id: any;

  /**
   *
   * @type {UpdateMerchantRoleStatusRequest}
   * @memberof BackofficeMerchantRoleCatalogApiUpdateStatus
   */
  readonly updateMerchantRoleStatusRequest: UpdateMerchantRoleStatusRequest;
}

/**
 * BackofficeMerchantRoleCatalogApi - object-oriented interface
 * @export
 * @class BackofficeMerchantRoleCatalogApi
 * @extends {BaseAPI}
 */
export class BackofficeMerchantRoleCatalogApi extends BaseAPI {
  /**
   * system_flag forced to false. code UNIQUE per realm + UPPER_SNAKE format. scope binds account_level eligibility.
   * @summary Tạo role mới (custom)
   * @param {BackofficeMerchantRoleCatalogApiCreate1Request} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeMerchantRoleCatalogApi
   */
  public create1(
    requestParameters: BackofficeMerchantRoleCatalogApiCreate1Request,
    options?: AxiosRequestConfig,
  ) {
    return BackofficeMerchantRoleCatalogApiFp(this.configuration)
      .create1(requestParameters.createMerchantRoleRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get role detail
   * @param {BackofficeMerchantRoleCatalogApiGetDetailRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeMerchantRoleCatalogApi
   */
  public getDetail(
    requestParameters: BackofficeMerchantRoleCatalogApiGetDetailRequest,
    options?: AxiosRequestConfig,
  ) {
    return BackofficeMerchantRoleCatalogApiFp(this.configuration)
      .getDetail(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Filter null-aware: keyword (code/name ILIKE), scope (MERCHANT|SUB_MERCHANT|TERMINAL), status (ACTIVE|INACTIVE). DELETED excluded. ORDER BY system_flag DESC, code.
   * @summary List merchant roles
   * @param {BackofficeMerchantRoleCatalogApiListRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeMerchantRoleCatalogApi
   */
  public list(
    requestParameters: BackofficeMerchantRoleCatalogApiListRequest = {},
    options?: AxiosRequestConfig,
  ) {
    return BackofficeMerchantRoleCatalogApiFp(this.configuration)
      .list(
        requestParameters.keyword,
        requestParameters.scope,
        requestParameters.status,
        requestParameters.page,
        requestParameters.size,
        requestParameters.sort,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * system_flag=true forbidden. Sets status=DELETED + deleted_at.
   * @summary Xoá mềm role
   * @param {BackofficeMerchantRoleCatalogApiSoftDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeMerchantRoleCatalogApi
   */
  public softDelete(
    requestParameters: BackofficeMerchantRoleCatalogApiSoftDeleteRequest,
    options?: AxiosRequestConfig,
  ) {
    return BackofficeMerchantRoleCatalogApiFp(this.configuration)
      .softDelete(requestParameters.id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * name + description only. code + scope immutable.
   * @summary Cập nhật role
   * @param {BackofficeMerchantRoleCatalogApiUpdateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeMerchantRoleCatalogApi
   */
  public update(
    requestParameters: BackofficeMerchantRoleCatalogApiUpdateRequest,
    options?: AxiosRequestConfig,
  ) {
    return BackofficeMerchantRoleCatalogApiFp(this.configuration)
      .update(
        requestParameters.id,
        requestParameters.updateMerchantRoleRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * ACTIVE ↔ INACTIVE.
   * @summary Đổi trạng thái role
   * @param {BackofficeMerchantRoleCatalogApiUpdateStatusRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeMerchantRoleCatalogApi
   */
  public updateStatus(
    requestParameters: BackofficeMerchantRoleCatalogApiUpdateStatusRequest,
    options?: AxiosRequestConfig,
  ) {
    return BackofficeMerchantRoleCatalogApiFp(this.configuration)
      .updateStatus(
        requestParameters.id,
        requestParameters.updateMerchantRoleStatusRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * BackofficeMerchantRoleCatalogSyncApi - axios parameter creator
 * @export
 */
export const BackofficeMerchantRoleCatalogSyncApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * ORDER BY synced_at DESC LIMIT :limit. Default 20, max 100.
     * @summary List recent sync history
     * @param {any} [limit] Max rows to return. Default 20.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    history: async (
      limit?: any,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/bo/api/merchant-roles-sync/v1/history`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Bypasses Redis checksum-skip. Returns latest history row reflecting sync outcome.
     * @summary Trigger reload (force re-sync JSON → DB + Keycloak)
     * @param {ReloadMerchantRoleCatalogRequest} reloadMerchantRoleCatalogRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reload: async (
      reloadMerchantRoleCatalogRequest: ReloadMerchantRoleCatalogRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'reloadMerchantRoleCatalogRequest' is not null or undefined
      assertParamExists(
        "reload",
        "reloadMerchantRoleCatalogRequest",
        reloadMerchantRoleCatalogRequest,
      );
      const localVarPath = `/bo/api/merchant-roles-sync/v1/reload`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        reloadMerchantRoleCatalogRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * BackofficeMerchantRoleCatalogSyncApi - functional programming interface
 * @export
 */
export const BackofficeMerchantRoleCatalogSyncApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    BackofficeMerchantRoleCatalogSyncApiAxiosParamCreator(configuration);
  return {
    /**
     * ORDER BY synced_at DESC LIMIT :limit. Default 20, max 100.
     * @summary List recent sync history
     * @param {any} [limit] Max rows to return. Default 20.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async history(
      limit?: any,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.history(
        limit,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Bypasses Redis checksum-skip. Returns latest history row reflecting sync outcome.
     * @summary Trigger reload (force re-sync JSON → DB + Keycloak)
     * @param {ReloadMerchantRoleCatalogRequest} reloadMerchantRoleCatalogRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async reload(
      reloadMerchantRoleCatalogRequest: ReloadMerchantRoleCatalogRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<MerchantRoleCatalogSyncHistoryResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.reload(
        reloadMerchantRoleCatalogRequest,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
  };
};

/**
 * BackofficeMerchantRoleCatalogSyncApi - factory interface
 * @export
 */
export const BackofficeMerchantRoleCatalogSyncApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = BackofficeMerchantRoleCatalogSyncApiFp(configuration);
  return {
    /**
     * ORDER BY synced_at DESC LIMIT :limit. Default 20, max 100.
     * @summary List recent sync history
     * @param {any} [limit] Max rows to return. Default 20.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    history(limit?: any, options?: any): AxiosPromise<any> {
      return localVarFp
        .history(limit, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Bypasses Redis checksum-skip. Returns latest history row reflecting sync outcome.
     * @summary Trigger reload (force re-sync JSON → DB + Keycloak)
     * @param {ReloadMerchantRoleCatalogRequest} reloadMerchantRoleCatalogRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reload(
      reloadMerchantRoleCatalogRequest: ReloadMerchantRoleCatalogRequest,
      options?: any,
    ): AxiosPromise<MerchantRoleCatalogSyncHistoryResponse> {
      return localVarFp
        .reload(reloadMerchantRoleCatalogRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for history operation in BackofficeMerchantRoleCatalogSyncApi.
 * @export
 * @interface BackofficeMerchantRoleCatalogSyncApiHistoryRequest
 */
export interface BackofficeMerchantRoleCatalogSyncApiHistoryRequest {
  /**
   * Max rows to return. Default 20.
   * @type {any}
   * @memberof BackofficeMerchantRoleCatalogSyncApiHistory
   */
  readonly limit?: any;
}

/**
 * Request parameters for reload operation in BackofficeMerchantRoleCatalogSyncApi.
 * @export
 * @interface BackofficeMerchantRoleCatalogSyncApiReloadRequest
 */
export interface BackofficeMerchantRoleCatalogSyncApiReloadRequest {
  /**
   *
   * @type {ReloadMerchantRoleCatalogRequest}
   * @memberof BackofficeMerchantRoleCatalogSyncApiReload
   */
  readonly reloadMerchantRoleCatalogRequest: ReloadMerchantRoleCatalogRequest;
}

/**
 * BackofficeMerchantRoleCatalogSyncApi - object-oriented interface
 * @export
 * @class BackofficeMerchantRoleCatalogSyncApi
 * @extends {BaseAPI}
 */
export class BackofficeMerchantRoleCatalogSyncApi extends BaseAPI {
  /**
   * ORDER BY synced_at DESC LIMIT :limit. Default 20, max 100.
   * @summary List recent sync history
   * @param {BackofficeMerchantRoleCatalogSyncApiHistoryRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeMerchantRoleCatalogSyncApi
   */
  public history(
    requestParameters: BackofficeMerchantRoleCatalogSyncApiHistoryRequest = {},
    options?: AxiosRequestConfig,
  ) {
    return BackofficeMerchantRoleCatalogSyncApiFp(this.configuration)
      .history(requestParameters.limit, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Bypasses Redis checksum-skip. Returns latest history row reflecting sync outcome.
   * @summary Trigger reload (force re-sync JSON → DB + Keycloak)
   * @param {BackofficeMerchantRoleCatalogSyncApiReloadRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeMerchantRoleCatalogSyncApi
   */
  public reload(
    requestParameters: BackofficeMerchantRoleCatalogSyncApiReloadRequest,
    options?: AxiosRequestConfig,
  ) {
    return BackofficeMerchantRoleCatalogSyncApiFp(this.configuration)
      .reload(requestParameters.reloadMerchantRoleCatalogRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * BackofficeMyProfileApi - axios parameter creator
 * @export
 */
export const BackofficeMyProfileApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Xoá ảnh đại diện hiện tại. Idempotent — không lỗi nếu user chưa có avatar.
     * @summary Delete Avatar
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteAvatar: async (
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/bo/api/v1/me/avatar`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Lấy thông tin cá nhân người dùng đang đăng nhập: Họ tên, Email, SĐT, danh sách Portal và Vai trò được gán, ma trận phân quyền.
     * @summary Get My Profile
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMyProfile: async (
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/bo/api/v1/me`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Upload ảnh đại diện. Định dạng JPG/PNG, dung lượng ≤ 2MB. Trả về presigned URL của avatar mới (TTL 1h). Avatar cũ (nếu có) sẽ bị xoá best-effort sau khi avatar mới được commit.
     * @summary Upload Avatar
     * @param {any} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadAvatar: async (
      file: any,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'file' is not null or undefined
      assertParamExists("uploadAvatar", "file", file);
      const localVarPath = `/bo/api/v1/me/avatar`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration &&
        configuration.formDataCtor) ||
        FormData)();

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      if (file !== undefined) {
        localVarFormParams.append(
          "file",
          new Blob([JSON.stringify(file)], { type: "application/json" }),
        );
      }

      localVarHeaderParameter["Content-Type"] = "multipart/form-data";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * BackofficeMyProfileApi - functional programming interface
 * @export
 */
export const BackofficeMyProfileApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    BackofficeMyProfileApiAxiosParamCreator(configuration);
  return {
    /**
     * Xoá ảnh đại diện hiện tại. Idempotent — không lỗi nếu user chưa có avatar.
     * @summary Delete Avatar
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteAvatar(
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.deleteAvatar(options);
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Lấy thông tin cá nhân người dùng đang đăng nhập: Họ tên, Email, SĐT, danh sách Portal và Vai trò được gán, ma trận phân quyền.
     * @summary Get My Profile
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getMyProfile(
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<BoMyProfileResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getMyProfile(options);
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Upload ảnh đại diện. Định dạng JPG/PNG, dung lượng ≤ 2MB. Trả về presigned URL của avatar mới (TTL 1h). Avatar cũ (nếu có) sẽ bị xoá best-effort sau khi avatar mới được commit.
     * @summary Upload Avatar
     * @param {any} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async uploadAvatar(
      file: any,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<AvatarUploadResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.uploadAvatar(
        file,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
  };
};

/**
 * BackofficeMyProfileApi - factory interface
 * @export
 */
export const BackofficeMyProfileApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = BackofficeMyProfileApiFp(configuration);
  return {
    /**
     * Xoá ảnh đại diện hiện tại. Idempotent — không lỗi nếu user chưa có avatar.
     * @summary Delete Avatar
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteAvatar(options?: any): AxiosPromise<void> {
      return localVarFp
        .deleteAvatar(options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Lấy thông tin cá nhân người dùng đang đăng nhập: Họ tên, Email, SĐT, danh sách Portal và Vai trò được gán, ma trận phân quyền.
     * @summary Get My Profile
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMyProfile(options?: any): AxiosPromise<BoMyProfileResponse> {
      return localVarFp
        .getMyProfile(options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Upload ảnh đại diện. Định dạng JPG/PNG, dung lượng ≤ 2MB. Trả về presigned URL của avatar mới (TTL 1h). Avatar cũ (nếu có) sẽ bị xoá best-effort sau khi avatar mới được commit.
     * @summary Upload Avatar
     * @param {any} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadAvatar(file: any, options?: any): AxiosPromise<AvatarUploadResponse> {
      return localVarFp
        .uploadAvatar(file, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for uploadAvatar operation in BackofficeMyProfileApi.
 * @export
 * @interface BackofficeMyProfileApiUploadAvatarRequest
 */
export interface BackofficeMyProfileApiUploadAvatarRequest {
  /**
   *
   * @type {any}
   * @memberof BackofficeMyProfileApiUploadAvatar
   */
  readonly file: any;
}

/**
 * BackofficeMyProfileApi - object-oriented interface
 * @export
 * @class BackofficeMyProfileApi
 * @extends {BaseAPI}
 */
export class BackofficeMyProfileApi extends BaseAPI {
  /**
   * Xoá ảnh đại diện hiện tại. Idempotent — không lỗi nếu user chưa có avatar.
   * @summary Delete Avatar
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeMyProfileApi
   */
  public deleteAvatar(options?: AxiosRequestConfig) {
    return BackofficeMyProfileApiFp(this.configuration)
      .deleteAvatar(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Lấy thông tin cá nhân người dùng đang đăng nhập: Họ tên, Email, SĐT, danh sách Portal và Vai trò được gán, ma trận phân quyền.
   * @summary Get My Profile
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeMyProfileApi
   */
  public getMyProfile(options?: AxiosRequestConfig) {
    return BackofficeMyProfileApiFp(this.configuration)
      .getMyProfile(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Upload ảnh đại diện. Định dạng JPG/PNG, dung lượng ≤ 2MB. Trả về presigned URL của avatar mới (TTL 1h). Avatar cũ (nếu có) sẽ bị xoá best-effort sau khi avatar mới được commit.
   * @summary Upload Avatar
   * @param {BackofficeMyProfileApiUploadAvatarRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeMyProfileApi
   */
  public uploadAvatar(
    requestParameters: BackofficeMyProfileApiUploadAvatarRequest,
    options?: AxiosRequestConfig,
  ) {
    return BackofficeMyProfileApiFp(this.configuration)
      .uploadAvatar(requestParameters.file, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * BackofficePasswordResetApi - axios parameter creator
 * @export
 */
export const BackofficePasswordResetApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Bắt đầu luồng quên mật khẩu: kiểm tra rate limit (tối đa 3 lần/giờ), tìm user theo username, gửi OTP qua email. Luôn trả về success (bảo mật, không tiết lộ email có tồn tại hay không).  Response: - `action`: OTP_SENT_VIA_EMAIL - `remainSendAttempts`: số lần gửi lại OTP còn lại
     * @summary Initiate Forgot Password
     * @param {BoForgotPasswordRequest} boForgotPasswordRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    forgotPassword: async (
      boForgotPasswordRequest: BoForgotPasswordRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'boForgotPasswordRequest' is not null or undefined
      assertParamExists(
        "forgotPassword",
        "boForgotPasswordRequest",
        boForgotPasswordRequest,
      );
      const localVarPath = `/bo/api/v1/authorization/forgot-password`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        boForgotPasswordRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Gửi lại mã OTP cho luồng quên mật khẩu. Cooldown 60 giây, OTP cũ bị vô hiệu hóa.  Response: - `remainSendAttempts`: số lần gửi lại OTP còn lại  Error codes:     - `auth.otp.send.rate.limited` (400) — Chưa hết cooldown 60 giây - `auth.otp.temporarily.locked` (400) — Tạm khóa do nhập sai OTP quá nhiều
     * @summary Resend Forgot Password OTP
     * @param {BoResendOtpRequest} boResendOtpRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resendOtp: async (
      boResendOtpRequest: BoResendOtpRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'boResendOtpRequest' is not null or undefined
      assertParamExists("resendOtp", "boResendOtpRequest", boResendOtpRequest);
      const localVarPath = `/bo/api/v1/authorization/forgot-password/resend-otp`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        boResendOtpRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Đặt mật khẩu mới sau khi xác thực OTP thành công. - Mật khẩu tối thiểu 12 ký tự (chữ hoa, chữ thường, số, ký tự đặc biệt) - Sau thành công: hủy tất cả phiên đăng nhập cũ, ghi audit log  Error codes: - `auth.invalid.verification.token` (400) — Token xác thực OTP không hợp lệ - `auth.verification.token.has.expired` (400) — Token xác thực đã hết hạn - `auth.input.validation.failed` (400) — Mật khẩu không đáp ứng yêu cầu bảo mật
     * @summary Reset Password
     * @param {BoSetNewPasswordRequest} boSetNewPasswordRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resetPassword: async (
      boSetNewPasswordRequest: BoSetNewPasswordRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'boSetNewPasswordRequest' is not null or undefined
      assertParamExists(
        "resetPassword",
        "boSetNewPasswordRequest",
        boSetNewPasswordRequest,
      );
      const localVarPath = `/bo/api/v1/authorization/forgot-password/reset-password`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        boSetNewPasswordRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Xác thực mã OTP 6 chữ số (thời hạn 5 phút). Tối đa 5 lần nhập sai → khóa 15 phút.  Response: - `verifiedOtpCredential`: token xác thực dùng cho bước đặt mật khẩu mới  Error codes: - `auth.invalid.otp` (400) — Mã OTP không đúng, params[0] = số lần nhập còn lại - `auth.otp.has.expired` (400) — Mã OTP đã hết hạn - `auth.exceeded.maximum.otp.verification.attempts` (400) — Vượt quá 5 lần nhập sai - `auth.otp.temporarily.locked` (400) — Tạm khóa 15 phút do nhập sai quá nhiều
     * @summary Verify Forgot Password OTP
     * @param {BoVerifyOtpRequest} boVerifyOtpRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    verifyOtp1: async (
      boVerifyOtpRequest: BoVerifyOtpRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'boVerifyOtpRequest' is not null or undefined
      assertParamExists("verifyOtp1", "boVerifyOtpRequest", boVerifyOtpRequest);
      const localVarPath = `/bo/api/v1/authorization/forgot-password/verify-otp`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        boVerifyOtpRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * BackofficePasswordResetApi - functional programming interface
 * @export
 */
export const BackofficePasswordResetApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    BackofficePasswordResetApiAxiosParamCreator(configuration);
  return {
    /**
     * Bắt đầu luồng quên mật khẩu: kiểm tra rate limit (tối đa 3 lần/giờ), tìm user theo username, gửi OTP qua email. Luôn trả về success (bảo mật, không tiết lộ email có tồn tại hay không).  Response: - `action`: OTP_SENT_VIA_EMAIL - `remainSendAttempts`: số lần gửi lại OTP còn lại
     * @summary Initiate Forgot Password
     * @param {BoForgotPasswordRequest} boForgotPasswordRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async forgotPassword(
      boForgotPasswordRequest: BoForgotPasswordRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<BoForgotPasswordResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.forgotPassword(
        boForgotPasswordRequest,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Gửi lại mã OTP cho luồng quên mật khẩu. Cooldown 60 giây, OTP cũ bị vô hiệu hóa.  Response: - `remainSendAttempts`: số lần gửi lại OTP còn lại  Error codes:     - `auth.otp.send.rate.limited` (400) — Chưa hết cooldown 60 giây - `auth.otp.temporarily.locked` (400) — Tạm khóa do nhập sai OTP quá nhiều
     * @summary Resend Forgot Password OTP
     * @param {BoResendOtpRequest} boResendOtpRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async resendOtp(
      boResendOtpRequest: BoResendOtpRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResendResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.resendOtp(
        boResendOtpRequest,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Đặt mật khẩu mới sau khi xác thực OTP thành công. - Mật khẩu tối thiểu 12 ký tự (chữ hoa, chữ thường, số, ký tự đặc biệt) - Sau thành công: hủy tất cả phiên đăng nhập cũ, ghi audit log  Error codes: - `auth.invalid.verification.token` (400) — Token xác thực OTP không hợp lệ - `auth.verification.token.has.expired` (400) — Token xác thực đã hết hạn - `auth.input.validation.failed` (400) — Mật khẩu không đáp ứng yêu cầu bảo mật
     * @summary Reset Password
     * @param {BoSetNewPasswordRequest} boSetNewPasswordRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async resetPassword(
      boSetNewPasswordRequest: BoSetNewPasswordRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.resetPassword(
        boSetNewPasswordRequest,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Xác thực mã OTP 6 chữ số (thời hạn 5 phút). Tối đa 5 lần nhập sai → khóa 15 phút.  Response: - `verifiedOtpCredential`: token xác thực dùng cho bước đặt mật khẩu mới  Error codes: - `auth.invalid.otp` (400) — Mã OTP không đúng, params[0] = số lần nhập còn lại - `auth.otp.has.expired` (400) — Mã OTP đã hết hạn - `auth.exceeded.maximum.otp.verification.attempts` (400) — Vượt quá 5 lần nhập sai - `auth.otp.temporarily.locked` (400) — Tạm khóa 15 phút do nhập sai quá nhiều
     * @summary Verify Forgot Password OTP
     * @param {BoVerifyOtpRequest} boVerifyOtpRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async verifyOtp1(
      boVerifyOtpRequest: BoVerifyOtpRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<BoVerifyOtpResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.verifyOtp1(
        boVerifyOtpRequest,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
  };
};

/**
 * BackofficePasswordResetApi - factory interface
 * @export
 */
export const BackofficePasswordResetApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = BackofficePasswordResetApiFp(configuration);
  return {
    /**
     * Bắt đầu luồng quên mật khẩu: kiểm tra rate limit (tối đa 3 lần/giờ), tìm user theo username, gửi OTP qua email. Luôn trả về success (bảo mật, không tiết lộ email có tồn tại hay không).  Response: - `action`: OTP_SENT_VIA_EMAIL - `remainSendAttempts`: số lần gửi lại OTP còn lại
     * @summary Initiate Forgot Password
     * @param {BoForgotPasswordRequest} boForgotPasswordRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    forgotPassword(
      boForgotPasswordRequest: BoForgotPasswordRequest,
      options?: any,
    ): AxiosPromise<BoForgotPasswordResponse> {
      return localVarFp
        .forgotPassword(boForgotPasswordRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Gửi lại mã OTP cho luồng quên mật khẩu. Cooldown 60 giây, OTP cũ bị vô hiệu hóa.  Response: - `remainSendAttempts`: số lần gửi lại OTP còn lại  Error codes:     - `auth.otp.send.rate.limited` (400) — Chưa hết cooldown 60 giây - `auth.otp.temporarily.locked` (400) — Tạm khóa do nhập sai OTP quá nhiều
     * @summary Resend Forgot Password OTP
     * @param {BoResendOtpRequest} boResendOtpRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resendOtp(
      boResendOtpRequest: BoResendOtpRequest,
      options?: any,
    ): AxiosPromise<ResendResponse> {
      return localVarFp
        .resendOtp(boResendOtpRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Đặt mật khẩu mới sau khi xác thực OTP thành công. - Mật khẩu tối thiểu 12 ký tự (chữ hoa, chữ thường, số, ký tự đặc biệt) - Sau thành công: hủy tất cả phiên đăng nhập cũ, ghi audit log  Error codes: - `auth.invalid.verification.token` (400) — Token xác thực OTP không hợp lệ - `auth.verification.token.has.expired` (400) — Token xác thực đã hết hạn - `auth.input.validation.failed` (400) — Mật khẩu không đáp ứng yêu cầu bảo mật
     * @summary Reset Password
     * @param {BoSetNewPasswordRequest} boSetNewPasswordRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resetPassword(
      boSetNewPasswordRequest: BoSetNewPasswordRequest,
      options?: any,
    ): AxiosPromise<void> {
      return localVarFp
        .resetPassword(boSetNewPasswordRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Xác thực mã OTP 6 chữ số (thời hạn 5 phút). Tối đa 5 lần nhập sai → khóa 15 phút.  Response: - `verifiedOtpCredential`: token xác thực dùng cho bước đặt mật khẩu mới  Error codes: - `auth.invalid.otp` (400) — Mã OTP không đúng, params[0] = số lần nhập còn lại - `auth.otp.has.expired` (400) — Mã OTP đã hết hạn - `auth.exceeded.maximum.otp.verification.attempts` (400) — Vượt quá 5 lần nhập sai - `auth.otp.temporarily.locked` (400) — Tạm khóa 15 phút do nhập sai quá nhiều
     * @summary Verify Forgot Password OTP
     * @param {BoVerifyOtpRequest} boVerifyOtpRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    verifyOtp1(
      boVerifyOtpRequest: BoVerifyOtpRequest,
      options?: any,
    ): AxiosPromise<BoVerifyOtpResponse> {
      return localVarFp
        .verifyOtp1(boVerifyOtpRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for forgotPassword operation in BackofficePasswordResetApi.
 * @export
 * @interface BackofficePasswordResetApiForgotPasswordRequest
 */
export interface BackofficePasswordResetApiForgotPasswordRequest {
  /**
   *
   * @type {BoForgotPasswordRequest}
   * @memberof BackofficePasswordResetApiForgotPassword
   */
  readonly boForgotPasswordRequest: BoForgotPasswordRequest;
}

/**
 * Request parameters for resendOtp operation in BackofficePasswordResetApi.
 * @export
 * @interface BackofficePasswordResetApiResendOtpRequest
 */
export interface BackofficePasswordResetApiResendOtpRequest {
  /**
   *
   * @type {BoResendOtpRequest}
   * @memberof BackofficePasswordResetApiResendOtp
   */
  readonly boResendOtpRequest: BoResendOtpRequest;
}

/**
 * Request parameters for resetPassword operation in BackofficePasswordResetApi.
 * @export
 * @interface BackofficePasswordResetApiResetPasswordRequest
 */
export interface BackofficePasswordResetApiResetPasswordRequest {
  /**
   *
   * @type {BoSetNewPasswordRequest}
   * @memberof BackofficePasswordResetApiResetPassword
   */
  readonly boSetNewPasswordRequest: BoSetNewPasswordRequest;
}

/**
 * Request parameters for verifyOtp1 operation in BackofficePasswordResetApi.
 * @export
 * @interface BackofficePasswordResetApiVerifyOtp1Request
 */
export interface BackofficePasswordResetApiVerifyOtp1Request {
  /**
   *
   * @type {BoVerifyOtpRequest}
   * @memberof BackofficePasswordResetApiVerifyOtp1
   */
  readonly boVerifyOtpRequest: BoVerifyOtpRequest;
}

/**
 * BackofficePasswordResetApi - object-oriented interface
 * @export
 * @class BackofficePasswordResetApi
 * @extends {BaseAPI}
 */
export class BackofficePasswordResetApi extends BaseAPI {
  /**
   * Bắt đầu luồng quên mật khẩu: kiểm tra rate limit (tối đa 3 lần/giờ), tìm user theo username, gửi OTP qua email. Luôn trả về success (bảo mật, không tiết lộ email có tồn tại hay không).  Response: - `action`: OTP_SENT_VIA_EMAIL - `remainSendAttempts`: số lần gửi lại OTP còn lại
   * @summary Initiate Forgot Password
   * @param {BackofficePasswordResetApiForgotPasswordRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficePasswordResetApi
   */
  public forgotPassword(
    requestParameters: BackofficePasswordResetApiForgotPasswordRequest,
    options?: AxiosRequestConfig,
  ) {
    return BackofficePasswordResetApiFp(this.configuration)
      .forgotPassword(requestParameters.boForgotPasswordRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Gửi lại mã OTP cho luồng quên mật khẩu. Cooldown 60 giây, OTP cũ bị vô hiệu hóa.  Response: - `remainSendAttempts`: số lần gửi lại OTP còn lại  Error codes:     - `auth.otp.send.rate.limited` (400) — Chưa hết cooldown 60 giây - `auth.otp.temporarily.locked` (400) — Tạm khóa do nhập sai OTP quá nhiều
   * @summary Resend Forgot Password OTP
   * @param {BackofficePasswordResetApiResendOtpRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficePasswordResetApi
   */
  public resendOtp(
    requestParameters: BackofficePasswordResetApiResendOtpRequest,
    options?: AxiosRequestConfig,
  ) {
    return BackofficePasswordResetApiFp(this.configuration)
      .resendOtp(requestParameters.boResendOtpRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Đặt mật khẩu mới sau khi xác thực OTP thành công. - Mật khẩu tối thiểu 12 ký tự (chữ hoa, chữ thường, số, ký tự đặc biệt) - Sau thành công: hủy tất cả phiên đăng nhập cũ, ghi audit log  Error codes: - `auth.invalid.verification.token` (400) — Token xác thực OTP không hợp lệ - `auth.verification.token.has.expired` (400) — Token xác thực đã hết hạn - `auth.input.validation.failed` (400) — Mật khẩu không đáp ứng yêu cầu bảo mật
   * @summary Reset Password
   * @param {BackofficePasswordResetApiResetPasswordRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficePasswordResetApi
   */
  public resetPassword(
    requestParameters: BackofficePasswordResetApiResetPasswordRequest,
    options?: AxiosRequestConfig,
  ) {
    return BackofficePasswordResetApiFp(this.configuration)
      .resetPassword(requestParameters.boSetNewPasswordRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Xác thực mã OTP 6 chữ số (thời hạn 5 phút). Tối đa 5 lần nhập sai → khóa 15 phút.  Response: - `verifiedOtpCredential`: token xác thực dùng cho bước đặt mật khẩu mới  Error codes: - `auth.invalid.otp` (400) — Mã OTP không đúng, params[0] = số lần nhập còn lại - `auth.otp.has.expired` (400) — Mã OTP đã hết hạn - `auth.exceeded.maximum.otp.verification.attempts` (400) — Vượt quá 5 lần nhập sai - `auth.otp.temporarily.locked` (400) — Tạm khóa 15 phút do nhập sai quá nhiều
   * @summary Verify Forgot Password OTP
   * @param {BackofficePasswordResetApiVerifyOtp1Request} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficePasswordResetApi
   */
  public verifyOtp1(
    requestParameters: BackofficePasswordResetApiVerifyOtp1Request,
    options?: AxiosRequestConfig,
  ) {
    return BackofficePasswordResetApiFp(this.configuration)
      .verifyOtp1(requestParameters.boVerifyOtpRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * BackofficeResourcePortalManagementApi - axios parameter creator
 * @export
 */
export const BackofficeResourcePortalManagementApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Tạo Resource (Portal) mới với cấu hình chỉ định.  Error codes: - `client.already.exists` (500) — Resource đã tồn tại
     * @summary Create Resource
     * @param {CreateResourceRequest} createResourceRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createResource: async (
      createResourceRequest: CreateResourceRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'createResourceRequest' is not null or undefined
      assertParamExists(
        "createResource",
        "createResourceRequest",
        createResourceRequest,
      );
      const localVarPath = `/bo/api/v1/resources`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createResourceRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Tạo quyền (Role) mới cho một Resource (Portal)
     * @summary Create Resource Role
     * @param {any} resourceId
     * @param {CreateRoleRequest} createRoleRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createResourceRole: async (
      resourceId: any,
      createRoleRequest: CreateRoleRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'resourceId' is not null or undefined
      assertParamExists("createResourceRole", "resourceId", resourceId);
      // verify required parameter 'createRoleRequest' is not null or undefined
      assertParamExists(
        "createResourceRole",
        "createRoleRequest",
        createRoleRequest,
      );
      const localVarPath = `/bo/api/v1/resources/{resourceId}/roles`.replace(
        `{${"resourceId"}}`,
        encodeURIComponent(String(resourceId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createRoleRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Xóa một Resource (Portal) theo ID
     * @summary Delete Resource
     * @param {any} resourceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteResource: async (
      resourceId: any,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'resourceId' is not null or undefined
      assertParamExists("deleteResource", "resourceId", resourceId);
      const localVarPath = `/bo/api/v1/resources/{resourceId}`.replace(
        `{${"resourceId"}}`,
        encodeURIComponent(String(resourceId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Xóa một quyền (Role) khỏi Resource (Portal)
     * @summary Delete Resource Role
     * @param {any} resourceId
     * @param {any} roleName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteResourceRole: async (
      resourceId: any,
      roleName: any,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'resourceId' is not null or undefined
      assertParamExists("deleteResourceRole", "resourceId", resourceId);
      // verify required parameter 'roleName' is not null or undefined
      assertParamExists("deleteResourceRole", "roleName", roleName);
      const localVarPath = `/bo/api/v1/resources/{resourceId}/roles/{roleName}`
        .replace(`{${"resourceId"}}`, encodeURIComponent(String(resourceId)))
        .replace(`{${"roleName"}}`, encodeURIComponent(String(roleName)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Lấy thông tin chi tiết một Resource (Portal) theo ID.  Error codes: - `resource.not.found` (404) — Không tìm thấy Resource
     * @summary Get Resource
     * @param {any} resourceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getResource: async (
      resourceId: any,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'resourceId' is not null or undefined
      assertParamExists("getResource", "resourceId", resourceId);
      const localVarPath = `/bo/api/v1/resources/{resourceId}`.replace(
        `{${"resourceId"}}`,
        encodeURIComponent(String(resourceId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Lấy danh sách tất cả quyền (Role) thuộc một Resource (Portal).  Error codes: - `resource.not.found` (404) — Không tìm thấy Resource
     * @summary Get Resource Roles
     * @param {any} resourceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getResourceRoles: async (
      resourceId: any,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'resourceId' is not null or undefined
      assertParamExists("getResourceRoles", "resourceId", resourceId);
      const localVarPath = `/bo/api/v1/resources/{resourceId}/roles`.replace(
        `{${"resourceId"}}`,
        encodeURIComponent(String(resourceId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Lấy danh sách tất cả Resource (Portal) khả dụng
     * @summary Get All Resources
     * @param {any} [id]
     * @param {any} [code]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getResources: async (
      id?: any,
      code?: any,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/bo/api/v1/resources`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      if (id !== undefined) {
        localVarQueryParameter["id"] = id;
      }

      if (code !== undefined) {
        localVarQueryParameter["code"] = code;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * BackofficeResourcePortalManagementApi - functional programming interface
 * @export
 */
export const BackofficeResourcePortalManagementApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    BackofficeResourcePortalManagementApiAxiosParamCreator(configuration);
  return {
    /**
     * Tạo Resource (Portal) mới với cấu hình chỉ định.  Error codes: - `client.already.exists` (500) — Resource đã tồn tại
     * @summary Create Resource
     * @param {CreateResourceRequest} createResourceRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createResource(
      createResourceRequest: CreateResourceRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<AuthResourceLite>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createResource(
        createResourceRequest,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Tạo quyền (Role) mới cho một Resource (Portal)
     * @summary Create Resource Role
     * @param {any} resourceId
     * @param {CreateRoleRequest} createRoleRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createResourceRole(
      resourceId: any,
      createRoleRequest: CreateRoleRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.createResourceRole(
          resourceId,
          createRoleRequest,
          options,
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Xóa một Resource (Portal) theo ID
     * @summary Delete Resource
     * @param {any} resourceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteResource(
      resourceId: any,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deleteResource(
        resourceId,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Xóa một quyền (Role) khỏi Resource (Portal)
     * @summary Delete Resource Role
     * @param {any} resourceId
     * @param {any} roleName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteResourceRole(
      resourceId: any,
      roleName: any,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.deleteResourceRole(
          resourceId,
          roleName,
          options,
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Lấy thông tin chi tiết một Resource (Portal) theo ID.  Error codes: - `resource.not.found` (404) — Không tìm thấy Resource
     * @summary Get Resource
     * @param {any} resourceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getResource(
      resourceId: any,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<AuthResourceLite>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getResource(
        resourceId,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Lấy danh sách tất cả quyền (Role) thuộc một Resource (Portal).  Error codes: - `resource.not.found` (404) — Không tìm thấy Resource
     * @summary Get Resource Roles
     * @param {any} resourceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getResourceRoles(
      resourceId: any,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getResourceRoles(resourceId, options);
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Lấy danh sách tất cả Resource (Portal) khả dụng
     * @summary Get All Resources
     * @param {any} [id]
     * @param {any} [code]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getResources(
      id?: any,
      code?: any,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getResources(
        id,
        code,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
  };
};

/**
 * BackofficeResourcePortalManagementApi - factory interface
 * @export
 */
export const BackofficeResourcePortalManagementApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = BackofficeResourcePortalManagementApiFp(configuration);
  return {
    /**
     * Tạo Resource (Portal) mới với cấu hình chỉ định.  Error codes: - `client.already.exists` (500) — Resource đã tồn tại
     * @summary Create Resource
     * @param {CreateResourceRequest} createResourceRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createResource(
      createResourceRequest: CreateResourceRequest,
      options?: any,
    ): AxiosPromise<AuthResourceLite> {
      return localVarFp
        .createResource(createResourceRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Tạo quyền (Role) mới cho một Resource (Portal)
     * @summary Create Resource Role
     * @param {any} resourceId
     * @param {CreateRoleRequest} createRoleRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createResourceRole(
      resourceId: any,
      createRoleRequest: CreateRoleRequest,
      options?: any,
    ): AxiosPromise<void> {
      return localVarFp
        .createResourceRole(resourceId, createRoleRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Xóa một Resource (Portal) theo ID
     * @summary Delete Resource
     * @param {any} resourceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteResource(resourceId: any, options?: any): AxiosPromise<void> {
      return localVarFp
        .deleteResource(resourceId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Xóa một quyền (Role) khỏi Resource (Portal)
     * @summary Delete Resource Role
     * @param {any} resourceId
     * @param {any} roleName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteResourceRole(
      resourceId: any,
      roleName: any,
      options?: any,
    ): AxiosPromise<void> {
      return localVarFp
        .deleteResourceRole(resourceId, roleName, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Lấy thông tin chi tiết một Resource (Portal) theo ID.  Error codes: - `resource.not.found` (404) — Không tìm thấy Resource
     * @summary Get Resource
     * @param {any} resourceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getResource(
      resourceId: any,
      options?: any,
    ): AxiosPromise<AuthResourceLite> {
      return localVarFp
        .getResource(resourceId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Lấy danh sách tất cả quyền (Role) thuộc một Resource (Portal).  Error codes: - `resource.not.found` (404) — Không tìm thấy Resource
     * @summary Get Resource Roles
     * @param {any} resourceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getResourceRoles(resourceId: any, options?: any): AxiosPromise<any> {
      return localVarFp
        .getResourceRoles(resourceId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Lấy danh sách tất cả Resource (Portal) khả dụng
     * @summary Get All Resources
     * @param {any} [id]
     * @param {any} [code]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getResources(id?: any, code?: any, options?: any): AxiosPromise<any> {
      return localVarFp
        .getResources(id, code, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for createResource operation in BackofficeResourcePortalManagementApi.
 * @export
 * @interface BackofficeResourcePortalManagementApiCreateResourceRequest
 */
export interface BackofficeResourcePortalManagementApiCreateResourceRequest {
  /**
   *
   * @type {CreateResourceRequest}
   * @memberof BackofficeResourcePortalManagementApiCreateResource
   */
  readonly createResourceRequest: CreateResourceRequest;
}

/**
 * Request parameters for createResourceRole operation in BackofficeResourcePortalManagementApi.
 * @export
 * @interface BackofficeResourcePortalManagementApiCreateResourceRoleRequest
 */
export interface BackofficeResourcePortalManagementApiCreateResourceRoleRequest {
  /**
   *
   * @type {any}
   * @memberof BackofficeResourcePortalManagementApiCreateResourceRole
   */
  readonly resourceId: any;

  /**
   *
   * @type {CreateRoleRequest}
   * @memberof BackofficeResourcePortalManagementApiCreateResourceRole
   */
  readonly createRoleRequest: CreateRoleRequest;
}

/**
 * Request parameters for deleteResource operation in BackofficeResourcePortalManagementApi.
 * @export
 * @interface BackofficeResourcePortalManagementApiDeleteResourceRequest
 */
export interface BackofficeResourcePortalManagementApiDeleteResourceRequest {
  /**
   *
   * @type {any}
   * @memberof BackofficeResourcePortalManagementApiDeleteResource
   */
  readonly resourceId: any;
}

/**
 * Request parameters for deleteResourceRole operation in BackofficeResourcePortalManagementApi.
 * @export
 * @interface BackofficeResourcePortalManagementApiDeleteResourceRoleRequest
 */
export interface BackofficeResourcePortalManagementApiDeleteResourceRoleRequest {
  /**
   *
   * @type {any}
   * @memberof BackofficeResourcePortalManagementApiDeleteResourceRole
   */
  readonly resourceId: any;

  /**
   *
   * @type {any}
   * @memberof BackofficeResourcePortalManagementApiDeleteResourceRole
   */
  readonly roleName: any;
}

/**
 * Request parameters for getResource operation in BackofficeResourcePortalManagementApi.
 * @export
 * @interface BackofficeResourcePortalManagementApiGetResourceRequest
 */
export interface BackofficeResourcePortalManagementApiGetResourceRequest {
  /**
   *
   * @type {any}
   * @memberof BackofficeResourcePortalManagementApiGetResource
   */
  readonly resourceId: any;
}

/**
 * Request parameters for getResourceRoles operation in BackofficeResourcePortalManagementApi.
 * @export
 * @interface BackofficeResourcePortalManagementApiGetResourceRolesRequest
 */
export interface BackofficeResourcePortalManagementApiGetResourceRolesRequest {
  /**
   *
   * @type {any}
   * @memberof BackofficeResourcePortalManagementApiGetResourceRoles
   */
  readonly resourceId: any;
}

/**
 * Request parameters for getResources operation in BackofficeResourcePortalManagementApi.
 * @export
 * @interface BackofficeResourcePortalManagementApiGetResourcesRequest
 */
export interface BackofficeResourcePortalManagementApiGetResourcesRequest {
  /**
   *
   * @type {any}
   * @memberof BackofficeResourcePortalManagementApiGetResources
   */
  readonly id?: any;

  /**
   *
   * @type {any}
   * @memberof BackofficeResourcePortalManagementApiGetResources
   */
  readonly code?: any;
}

/**
 * BackofficeResourcePortalManagementApi - object-oriented interface
 * @export
 * @class BackofficeResourcePortalManagementApi
 * @extends {BaseAPI}
 */
export class BackofficeResourcePortalManagementApi extends BaseAPI {
  /**
   * Tạo Resource (Portal) mới với cấu hình chỉ định.  Error codes: - `client.already.exists` (500) — Resource đã tồn tại
   * @summary Create Resource
   * @param {BackofficeResourcePortalManagementApiCreateResourceRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeResourcePortalManagementApi
   */
  public createResource(
    requestParameters: BackofficeResourcePortalManagementApiCreateResourceRequest,
    options?: AxiosRequestConfig,
  ) {
    return BackofficeResourcePortalManagementApiFp(this.configuration)
      .createResource(requestParameters.createResourceRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Tạo quyền (Role) mới cho một Resource (Portal)
   * @summary Create Resource Role
   * @param {BackofficeResourcePortalManagementApiCreateResourceRoleRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeResourcePortalManagementApi
   */
  public createResourceRole(
    requestParameters: BackofficeResourcePortalManagementApiCreateResourceRoleRequest,
    options?: AxiosRequestConfig,
  ) {
    return BackofficeResourcePortalManagementApiFp(this.configuration)
      .createResourceRole(
        requestParameters.resourceId,
        requestParameters.createRoleRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Xóa một Resource (Portal) theo ID
   * @summary Delete Resource
   * @param {BackofficeResourcePortalManagementApiDeleteResourceRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeResourcePortalManagementApi
   */
  public deleteResource(
    requestParameters: BackofficeResourcePortalManagementApiDeleteResourceRequest,
    options?: AxiosRequestConfig,
  ) {
    return BackofficeResourcePortalManagementApiFp(this.configuration)
      .deleteResource(requestParameters.resourceId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Xóa một quyền (Role) khỏi Resource (Portal)
   * @summary Delete Resource Role
   * @param {BackofficeResourcePortalManagementApiDeleteResourceRoleRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeResourcePortalManagementApi
   */
  public deleteResourceRole(
    requestParameters: BackofficeResourcePortalManagementApiDeleteResourceRoleRequest,
    options?: AxiosRequestConfig,
  ) {
    return BackofficeResourcePortalManagementApiFp(this.configuration)
      .deleteResourceRole(
        requestParameters.resourceId,
        requestParameters.roleName,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Lấy thông tin chi tiết một Resource (Portal) theo ID.  Error codes: - `resource.not.found` (404) — Không tìm thấy Resource
   * @summary Get Resource
   * @param {BackofficeResourcePortalManagementApiGetResourceRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeResourcePortalManagementApi
   */
  public getResource(
    requestParameters: BackofficeResourcePortalManagementApiGetResourceRequest,
    options?: AxiosRequestConfig,
  ) {
    return BackofficeResourcePortalManagementApiFp(this.configuration)
      .getResource(requestParameters.resourceId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Lấy danh sách tất cả quyền (Role) thuộc một Resource (Portal).  Error codes: - `resource.not.found` (404) — Không tìm thấy Resource
   * @summary Get Resource Roles
   * @param {BackofficeResourcePortalManagementApiGetResourceRolesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeResourcePortalManagementApi
   */
  public getResourceRoles(
    requestParameters: BackofficeResourcePortalManagementApiGetResourceRolesRequest,
    options?: AxiosRequestConfig,
  ) {
    return BackofficeResourcePortalManagementApiFp(this.configuration)
      .getResourceRoles(requestParameters.resourceId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Lấy danh sách tất cả Resource (Portal) khả dụng
   * @summary Get All Resources
   * @param {BackofficeResourcePortalManagementApiGetResourcesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeResourcePortalManagementApi
   */
  public getResources(
    requestParameters: BackofficeResourcePortalManagementApiGetResourcesRequest = {},
    options?: AxiosRequestConfig,
  ) {
    return BackofficeResourcePortalManagementApiFp(this.configuration)
      .getResources(requestParameters.id, requestParameters.code, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * BackofficeRoleGroupManagementApi - axios parameter creator
 * @export
 */
export const BackofficeRoleGroupManagementApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Gán người dùng vào nhóm vai trò, cấp tất cả quyền liên kết với nhóm. - Một người dùng chỉ được gán một Vai trò trong mỗi Portal - Người dùng có thể được gán nhiều Portal khác nhau
     * @summary Add Group Member
     * @param {any} groupId
     * @param {any} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addGroupMember: async (
      groupId: any,
      userId: any,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'groupId' is not null or undefined
      assertParamExists("addGroupMember", "groupId", groupId);
      // verify required parameter 'userId' is not null or undefined
      assertParamExists("addGroupMember", "userId", userId);
      const localVarPath = `/bo/api/v1/role-groups/{groupId}/members/{userId}`
        .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
        .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Gán một quyền cụ thể từ Resource (Portal) vào nhóm vai trò
     * @summary Assign Role to Group
     * @param {any} groupId
     * @param {any} resourceId
     * @param {any} roleCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addRole: async (
      groupId: any,
      resourceId: any,
      roleCode: any,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'groupId' is not null or undefined
      assertParamExists("addRole", "groupId", groupId);
      // verify required parameter 'resourceId' is not null or undefined
      assertParamExists("addRole", "resourceId", resourceId);
      // verify required parameter 'roleCode' is not null or undefined
      assertParamExists("addRole", "roleCode", roleCode);
      const localVarPath =
        `/bo/api/v1/role-groups/{groupId}/resources/{resourceId}/roles/{roleCode}`
          .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
          .replace(`{${"resourceId"}}`, encodeURIComponent(String(resourceId)))
          .replace(`{${"roleCode"}}`, encodeURIComponent(String(roleCode)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Tạo nhóm vai trò mới: chọn Portal và Role Type → tự sinh mã vai trò [PORTAL_CODE]_[ROLE_TYPE]_[SEQ]. Vai trò tạo ở trạng thái INACTIVE, chờ Checker phê duyệt → chuyển sang ACTIVE.  Error codes: - `role.group.name.already.exists` (409) — Tên vai trò đã tồn tại - `role.group.create.request.with.name.already.exists` (409) — Đã có yêu cầu tạo vai trò cùng tên đang chờ duyệt - `resource.not.found` (404) — Không tìm thấy Portal
     * @summary Create Role Group
     * @param {CreateRoleGroupRequest} createRoleGroupRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createRoleGroup: async (
      createRoleGroupRequest: CreateRoleGroupRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'createRoleGroupRequest' is not null or undefined
      assertParamExists(
        "createRoleGroup",
        "createRoleGroupRequest",
        createRoleGroupRequest,
      );
      const localVarPath = `/bo/api/v1/role-groups`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createRoleGroupRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Xóa nhóm vai trò (tạo yêu cầu Maker/Checker): - INACTIVE chưa gán user → xóa cứng (hard delete) - Đã/đang gán user → chuyển trạng thái DELETED (soft delete), lưu cho audit  Error codes: - `role.group.not.found` (404) — Không tìm thấy nhóm vai trò         - `role.request.already.exists` (400) — Đã có yêu cầu xóa đang chờ duyệt
     * @summary Delete Role Group
     * @param {any} groupId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteRoleGroup: async (
      groupId: any,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'groupId' is not null or undefined
      assertParamExists("deleteRoleGroup", "groupId", groupId);
      const localVarPath = `/bo/api/v1/role-groups/{groupId}`.replace(
        `{${"groupId"}}`,
        encodeURIComponent(String(groupId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Lấy danh sách quyền khả dụng từ một Resource (Portal) để gán cho nhóm vai trò
     * @summary Get Available Roles
     * @param {any} groupId
     * @param {any} resourceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAvailableRoles: async (
      groupId: any,
      resourceId: any,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'groupId' is not null or undefined
      assertParamExists("getAvailableRoles", "groupId", groupId);
      // verify required parameter 'resourceId' is not null or undefined
      assertParamExists("getAvailableRoles", "resourceId", resourceId);
      const localVarPath =
        `/bo/api/v1/role-groups/{groupId}/resources/{resourceId}/available-roles`
          .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
          .replace(`{${"resourceId"}}`, encodeURIComponent(String(resourceId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Lấy thông tin chi tiết nhóm vai trò đã xóa: - Thông tin vai trò, ma trận phân quyền tại thời điểm xóa - Số lượng user đã được gán, thông tin quản trị  Error codes: - `role.group.not.found` (404) — Không tìm thấy nhóm vai trò đã xóa
     * @summary Get Deleted Role Group Details
     * @param {any} groupId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDeletedRoleGroup: async (
      groupId: any,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'groupId' is not null or undefined
      assertParamExists("getDeletedRoleGroup", "groupId", groupId);
      const localVarPath = `/bo/api/v1/role-groups/deleted/{groupId}`.replace(
        `{${"groupId"}}`,
        encodeURIComponent(String(groupId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Lấy danh sách nhóm vai trò đã xóa từ bảng lưu trữ (deleted_keycloak_group). Hỗ trợ lọc theo: mã vai trò, tên vai trò, Portal, loại vai trò. Dữ liệu được trích xuất từ bản snapshot JSONB lưu tại thời điểm xóa.
     * @summary List Deleted Role Groups
     * @param {any} [search] Search term to match against code or name (contains, case-insensitive)
     * @param {any} [name] Exact role group name to match
     * @param {any} [resourceIds] Associated resource type to filter by
     * @param {any} [roleType] Role type to filter (e.g. PORTAL, SERVICE)
     * @param {any} [page] Zero-based page index (0..N)
     * @param {any} [size] The size of the page to be returned
     * @param {any} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDeletedRoleGroups: async (
      search?: any,
      name?: any,
      resourceIds?: any,
      roleType?: any,
      page?: any,
      size?: any,
      sort?: any,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/bo/api/v1/role-groups/deleted`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (name !== undefined) {
        localVarQueryParameter["name"] = name;
      }

      if (resourceIds !== undefined) {
        localVarQueryParameter["resourceIds"] = resourceIds;
      }

      if (roleType !== undefined) {
        localVarQueryParameter["roleType"] = roleType;
      }

      if (page !== undefined) {
        localVarQueryParameter["page"] = page;
      }

      if (size !== undefined) {
        localVarQueryParameter["size"] = size;
      }

      if (sort !== undefined) {
        localVarQueryParameter["sort"] = sort;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Deprecated API - use /{groupId}/group-members
     * @summary Get Group Members
     * @param {any} groupId
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    getGroupMembers: async (
      groupId: any,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'groupId' is not null or undefined
      assertParamExists("getGroupMembers", "groupId", groupId);
      const localVarPath = `/bo/api/v1/role-groups/{groupId}/members`.replace(
        `{${"groupId"}}`,
        encodeURIComponent(String(groupId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Lấy danh sách người dùng được gán vào nhóm vai trò với tìm kiếm
     * @summary Get Group Members
     * @param {any} groupId
     * @param {any} [search] Search by username, email, first name, last name, or phone number (case-insensitive contains)
     * @param {any} [page] Zero-based page index (0..N)
     * @param {any} [size] The size of the page to be returned
     * @param {any} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMembersInGroup: async (
      groupId: any,
      search?: any,
      page?: any,
      size?: any,
      sort?: any,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'groupId' is not null or undefined
      assertParamExists("getMembersInGroup", "groupId", groupId);
      const localVarPath =
        `/bo/api/v1/role-groups/{groupId}/group-members`.replace(
          `{${"groupId"}}`,
          encodeURIComponent(String(groupId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (page !== undefined) {
        localVarQueryParameter["page"] = page;
      }

      if (size !== undefined) {
        localVarQueryParameter["size"] = size;
      }

      if (sort !== undefined) {
        localVarQueryParameter["sort"] = sort;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Lấy thông tin chi tiết vai trò: - Tab 1: Thông tin vai trò + Ma trận phân quyền - Tab 2: Danh sách user được gán, thông tin quản trị (tạo bởi, cập nhật bởi, phê duyệt bởi)  Error codes: - `role.group.not.found` (404) — Không tìm thấy nhóm vai trò
     * @summary Get Role Group Details
     * @param {any} groupId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRoleGroup: async (
      groupId: any,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'groupId' is not null or undefined
      assertParamExists("getRoleGroup", "groupId", groupId);
      const localVarPath = `/bo/api/v1/role-groups/{groupId}`.replace(
        `{${"groupId"}}`,
        encodeURIComponent(String(groupId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Lấy danh sách nhóm vai trò có phân trang. Hỗ trợ lọc theo: mã vai trò, tên vai trò, Portal, trạng thái (ACTIVE/INACTIVE/DELETED).
     * @summary List Role Groups
     * @param {any} [search] Search term to match against code or name (contains, case-insensitive)
     * @param {any} [name] Exact role group name to match
     * @param {any} [resourceIds] Associated resource type to filter by
     * @param {any} [roleType] Role type to filter (e.g. PORTAL, SERVICE)
     * @param {any} [page] Zero-based page index (0..N)
     * @param {any} [size] The size of the page to be returned
     * @param {any} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRoleGroups: async (
      search?: any,
      name?: any,
      resourceIds?: any,
      roleType?: any,
      page?: any,
      size?: any,
      sort?: any,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/bo/api/v1/role-groups`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (name !== undefined) {
        localVarQueryParameter["name"] = name;
      }

      if (resourceIds !== undefined) {
        localVarQueryParameter["resourceIds"] = resourceIds;
      }

      if (roleType !== undefined) {
        localVarQueryParameter["roleType"] = roleType;
      }

      if (page !== undefined) {
        localVarQueryParameter["page"] = page;
      }

      if (size !== undefined) {
        localVarQueryParameter["size"] = size;
      }

      if (sort !== undefined) {
        localVarQueryParameter["sort"] = sort;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Xóa người dùng khỏi nhóm vai trò, thu hồi tất cả quyền liên kết với nhóm
     * @summary Remove Group Member
     * @param {any} groupId
     * @param {any} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removeGroupMember: async (
      groupId: any,
      userId: any,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'groupId' is not null or undefined
      assertParamExists("removeGroupMember", "groupId", groupId);
      // verify required parameter 'userId' is not null or undefined
      assertParamExists("removeGroupMember", "userId", userId);
      const localVarPath = `/bo/api/v1/role-groups/{groupId}/members/{userId}`
        .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
        .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Xóa một quyền cụ thể khỏi nhóm vai trò.  Error codes: - `role.not.found.in.group` (404) — Quyền không tồn tại trong nhóm vai trò
     * @summary Remove Role from Group
     * @param {any} groupId
     * @param {any} resourceId
     * @param {any} roleCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removeRole: async (
      groupId: any,
      resourceId: any,
      roleCode: any,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'groupId' is not null or undefined
      assertParamExists("removeRole", "groupId", groupId);
      // verify required parameter 'resourceId' is not null or undefined
      assertParamExists("removeRole", "resourceId", resourceId);
      // verify required parameter 'roleCode' is not null or undefined
      assertParamExists("removeRole", "roleCode", roleCode);
      const localVarPath =
        `/bo/api/v1/role-groups/{groupId}/resources/{resourceId}/roles/{roleCode}`
          .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
          .replace(`{${"resourceId"}}`, encodeURIComponent(String(resourceId)))
          .replace(`{${"roleCode"}}`, encodeURIComponent(String(roleCode)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Cập nhật Tên vai trò, Mô tả, Ma trận phân quyền (không sửa Mã, Portal, Role Type). Vai trò vẫn hoạt động bình thường trong khi chờ duyệt. Không cho sửa vai trò trạng thái DELETED. Sau khi Checker phê duyệt: force logout tất cả user gán vai trò này.  Error codes: - `role.group.name.already.exists` (400) — Tên vai trò đã tồn tại - `role.group.update.request.with.name.already.exists` (400) — Đã có yêu cầu cập nhật cùng tên đang chờ duyệt - `resource.not.found` (404) — Không tìm thấy Portal
     * @summary Update Role Group
     * @param {any} groupId
     * @param {UpdateRoleGroupRequest} updateRoleGroupRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateRoleGroup: async (
      groupId: any,
      updateRoleGroupRequest: UpdateRoleGroupRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'groupId' is not null or undefined
      assertParamExists("updateRoleGroup", "groupId", groupId);
      // verify required parameter 'updateRoleGroupRequest' is not null or undefined
      assertParamExists(
        "updateRoleGroup",
        "updateRoleGroupRequest",
        updateRoleGroupRequest,
      );
      const localVarPath = `/bo/api/v1/role-groups/{groupId}`.replace(
        `{${"groupId"}}`,
        encodeURIComponent(String(groupId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateRoleGroupRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Cập nhật danh sách quyền từ Resource (Portal) cho nhóm vai trò (thay thế toàn bộ danh sách quyền hiện tại)
     * @summary Assign Roles to Group
     * @param {any} groupId
     * @param {any} resourceId
     * @param {PutRolesRequest} putRolesRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateRoles: async (
      groupId: any,
      resourceId: any,
      putRolesRequest: PutRolesRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'groupId' is not null or undefined
      assertParamExists("updateRoles", "groupId", groupId);
      // verify required parameter 'resourceId' is not null or undefined
      assertParamExists("updateRoles", "resourceId", resourceId);
      // verify required parameter 'putRolesRequest' is not null or undefined
      assertParamExists("updateRoles", "putRolesRequest", putRolesRequest);
      const localVarPath =
        `/bo/api/v1/role-groups/{groupId}/resources/{resourceId}/roles`
          .replace(`{${"groupId"}}`, encodeURIComponent(String(groupId)))
          .replace(`{${"resourceId"}}`, encodeURIComponent(String(resourceId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        putRolesRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * BackofficeRoleGroupManagementApi - functional programming interface
 * @export
 */
export const BackofficeRoleGroupManagementApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    BackofficeRoleGroupManagementApiAxiosParamCreator(configuration);
  return {
    /**
     * Gán người dùng vào nhóm vai trò, cấp tất cả quyền liên kết với nhóm. - Một người dùng chỉ được gán một Vai trò trong mỗi Portal - Người dùng có thể được gán nhiều Portal khác nhau
     * @summary Add Group Member
     * @param {any} groupId
     * @param {any} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addGroupMember(
      groupId: any,
      userId: any,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.addGroupMember(
        groupId,
        userId,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Gán một quyền cụ thể từ Resource (Portal) vào nhóm vai trò
     * @summary Assign Role to Group
     * @param {any} groupId
     * @param {any} resourceId
     * @param {any} roleCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addRole(
      groupId: any,
      resourceId: any,
      roleCode: any,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.addRole(
        groupId,
        resourceId,
        roleCode,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Tạo nhóm vai trò mới: chọn Portal và Role Type → tự sinh mã vai trò [PORTAL_CODE]_[ROLE_TYPE]_[SEQ]. Vai trò tạo ở trạng thái INACTIVE, chờ Checker phê duyệt → chuyển sang ACTIVE.  Error codes: - `role.group.name.already.exists` (409) — Tên vai trò đã tồn tại - `role.group.create.request.with.name.already.exists` (409) — Đã có yêu cầu tạo vai trò cùng tên đang chờ duyệt - `resource.not.found` (404) — Không tìm thấy Portal
     * @summary Create Role Group
     * @param {CreateRoleGroupRequest} createRoleGroupRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createRoleGroup(
      createRoleGroupRequest: CreateRoleGroupRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<CreateApprovalRequestResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createRoleGroup(
        createRoleGroupRequest,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Xóa nhóm vai trò (tạo yêu cầu Maker/Checker): - INACTIVE chưa gán user → xóa cứng (hard delete) - Đã/đang gán user → chuyển trạng thái DELETED (soft delete), lưu cho audit  Error codes: - `role.group.not.found` (404) — Không tìm thấy nhóm vai trò         - `role.request.already.exists` (400) — Đã có yêu cầu xóa đang chờ duyệt
     * @summary Delete Role Group
     * @param {any} groupId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteRoleGroup(
      groupId: any,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<CreateApprovalRequestResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRoleGroup(
        groupId,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Lấy danh sách quyền khả dụng từ một Resource (Portal) để gán cho nhóm vai trò
     * @summary Get Available Roles
     * @param {any} groupId
     * @param {any} resourceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getAvailableRoles(
      groupId: any,
      resourceId: any,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getAvailableRoles(
          groupId,
          resourceId,
          options,
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Lấy thông tin chi tiết nhóm vai trò đã xóa: - Thông tin vai trò, ma trận phân quyền tại thời điểm xóa - Số lượng user đã được gán, thông tin quản trị  Error codes: - `role.group.not.found` (404) — Không tìm thấy nhóm vai trò đã xóa
     * @summary Get Deleted Role Group Details
     * @param {any} groupId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getDeletedRoleGroup(
      groupId: any,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<AuthRoleGroupDetails>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getDeletedRoleGroup(groupId, options);
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Lấy danh sách nhóm vai trò đã xóa từ bảng lưu trữ (deleted_keycloak_group). Hỗ trợ lọc theo: mã vai trò, tên vai trò, Portal, loại vai trò. Dữ liệu được trích xuất từ bản snapshot JSONB lưu tại thời điểm xóa.
     * @summary List Deleted Role Groups
     * @param {any} [search] Search term to match against code or name (contains, case-insensitive)
     * @param {any} [name] Exact role group name to match
     * @param {any} [resourceIds] Associated resource type to filter by
     * @param {any} [roleType] Role type to filter (e.g. PORTAL, SERVICE)
     * @param {any} [page] Zero-based page index (0..N)
     * @param {any} [size] The size of the page to be returned
     * @param {any} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getDeletedRoleGroups(
      search?: any,
      name?: any,
      resourceIds?: any,
      roleType?: any,
      page?: any,
      size?: any,
      sort?: any,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PageAuthRoleGroupLite>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getDeletedRoleGroups(
          search,
          name,
          resourceIds,
          roleType,
          page,
          size,
          sort,
          options,
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Deprecated API - use /{groupId}/group-members
     * @summary Get Group Members
     * @param {any} groupId
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async getGroupMembers(
      groupId: any,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getGroupMembers(
        groupId,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Lấy danh sách người dùng được gán vào nhóm vai trò với tìm kiếm
     * @summary Get Group Members
     * @param {any} groupId
     * @param {any} [search] Search by username, email, first name, last name, or phone number (case-insensitive contains)
     * @param {any} [page] Zero-based page index (0..N)
     * @param {any} [size] The size of the page to be returned
     * @param {any} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getMembersInGroup(
      groupId: any,
      search?: any,
      page?: any,
      size?: any,
      sort?: any,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageUserLite>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getMembersInGroup(
          groupId,
          search,
          page,
          size,
          sort,
          options,
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Lấy thông tin chi tiết vai trò: - Tab 1: Thông tin vai trò + Ma trận phân quyền - Tab 2: Danh sách user được gán, thông tin quản trị (tạo bởi, cập nhật bởi, phê duyệt bởi)  Error codes: - `role.group.not.found` (404) — Không tìm thấy nhóm vai trò
     * @summary Get Role Group Details
     * @param {any} groupId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getRoleGroup(
      groupId: any,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<AuthRoleGroupDetails>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getRoleGroup(
        groupId,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Lấy danh sách nhóm vai trò có phân trang. Hỗ trợ lọc theo: mã vai trò, tên vai trò, Portal, trạng thái (ACTIVE/INACTIVE/DELETED).
     * @summary List Role Groups
     * @param {any} [search] Search term to match against code or name (contains, case-insensitive)
     * @param {any} [name] Exact role group name to match
     * @param {any} [resourceIds] Associated resource type to filter by
     * @param {any} [roleType] Role type to filter (e.g. PORTAL, SERVICE)
     * @param {any} [page] Zero-based page index (0..N)
     * @param {any} [size] The size of the page to be returned
     * @param {any} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getRoleGroups(
      search?: any,
      name?: any,
      resourceIds?: any,
      roleType?: any,
      page?: any,
      size?: any,
      sort?: any,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PageAuthRoleGroupLite>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getRoleGroups(
        search,
        name,
        resourceIds,
        roleType,
        page,
        size,
        sort,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Xóa người dùng khỏi nhóm vai trò, thu hồi tất cả quyền liên kết với nhóm
     * @summary Remove Group Member
     * @param {any} groupId
     * @param {any} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async removeGroupMember(
      groupId: any,
      userId: any,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.removeGroupMember(
          groupId,
          userId,
          options,
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Xóa một quyền cụ thể khỏi nhóm vai trò.  Error codes: - `role.not.found.in.group` (404) — Quyền không tồn tại trong nhóm vai trò
     * @summary Remove Role from Group
     * @param {any} groupId
     * @param {any} resourceId
     * @param {any} roleCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async removeRole(
      groupId: any,
      resourceId: any,
      roleCode: any,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.removeRole(
        groupId,
        resourceId,
        roleCode,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Cập nhật Tên vai trò, Mô tả, Ma trận phân quyền (không sửa Mã, Portal, Role Type). Vai trò vẫn hoạt động bình thường trong khi chờ duyệt. Không cho sửa vai trò trạng thái DELETED. Sau khi Checker phê duyệt: force logout tất cả user gán vai trò này.  Error codes: - `role.group.name.already.exists` (400) — Tên vai trò đã tồn tại - `role.group.update.request.with.name.already.exists` (400) — Đã có yêu cầu cập nhật cùng tên đang chờ duyệt - `resource.not.found` (404) — Không tìm thấy Portal
     * @summary Update Role Group
     * @param {any} groupId
     * @param {UpdateRoleGroupRequest} updateRoleGroupRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateRoleGroup(
      groupId: any,
      updateRoleGroupRequest: UpdateRoleGroupRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<CreateApprovalRequestResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateRoleGroup(
        groupId,
        updateRoleGroupRequest,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Cập nhật danh sách quyền từ Resource (Portal) cho nhóm vai trò (thay thế toàn bộ danh sách quyền hiện tại)
     * @summary Assign Roles to Group
     * @param {any} groupId
     * @param {any} resourceId
     * @param {PutRolesRequest} putRolesRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateRoles(
      groupId: any,
      resourceId: any,
      putRolesRequest: PutRolesRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateRoles(
        groupId,
        resourceId,
        putRolesRequest,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
  };
};

/**
 * BackofficeRoleGroupManagementApi - factory interface
 * @export
 */
export const BackofficeRoleGroupManagementApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = BackofficeRoleGroupManagementApiFp(configuration);
  return {
    /**
     * Gán người dùng vào nhóm vai trò, cấp tất cả quyền liên kết với nhóm. - Một người dùng chỉ được gán một Vai trò trong mỗi Portal - Người dùng có thể được gán nhiều Portal khác nhau
     * @summary Add Group Member
     * @param {any} groupId
     * @param {any} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addGroupMember(
      groupId: any,
      userId: any,
      options?: any,
    ): AxiosPromise<void> {
      return localVarFp
        .addGroupMember(groupId, userId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Gán một quyền cụ thể từ Resource (Portal) vào nhóm vai trò
     * @summary Assign Role to Group
     * @param {any} groupId
     * @param {any} resourceId
     * @param {any} roleCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addRole(
      groupId: any,
      resourceId: any,
      roleCode: any,
      options?: any,
    ): AxiosPromise<void> {
      return localVarFp
        .addRole(groupId, resourceId, roleCode, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Tạo nhóm vai trò mới: chọn Portal và Role Type → tự sinh mã vai trò [PORTAL_CODE]_[ROLE_TYPE]_[SEQ]. Vai trò tạo ở trạng thái INACTIVE, chờ Checker phê duyệt → chuyển sang ACTIVE.  Error codes: - `role.group.name.already.exists` (409) — Tên vai trò đã tồn tại - `role.group.create.request.with.name.already.exists` (409) — Đã có yêu cầu tạo vai trò cùng tên đang chờ duyệt - `resource.not.found` (404) — Không tìm thấy Portal
     * @summary Create Role Group
     * @param {CreateRoleGroupRequest} createRoleGroupRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createRoleGroup(
      createRoleGroupRequest: CreateRoleGroupRequest,
      options?: any,
    ): AxiosPromise<CreateApprovalRequestResponse> {
      return localVarFp
        .createRoleGroup(createRoleGroupRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Xóa nhóm vai trò (tạo yêu cầu Maker/Checker): - INACTIVE chưa gán user → xóa cứng (hard delete) - Đã/đang gán user → chuyển trạng thái DELETED (soft delete), lưu cho audit  Error codes: - `role.group.not.found` (404) — Không tìm thấy nhóm vai trò         - `role.request.already.exists` (400) — Đã có yêu cầu xóa đang chờ duyệt
     * @summary Delete Role Group
     * @param {any} groupId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteRoleGroup(
      groupId: any,
      options?: any,
    ): AxiosPromise<CreateApprovalRequestResponse> {
      return localVarFp
        .deleteRoleGroup(groupId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Lấy danh sách quyền khả dụng từ một Resource (Portal) để gán cho nhóm vai trò
     * @summary Get Available Roles
     * @param {any} groupId
     * @param {any} resourceId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAvailableRoles(
      groupId: any,
      resourceId: any,
      options?: any,
    ): AxiosPromise<any> {
      return localVarFp
        .getAvailableRoles(groupId, resourceId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Lấy thông tin chi tiết nhóm vai trò đã xóa: - Thông tin vai trò, ma trận phân quyền tại thời điểm xóa - Số lượng user đã được gán, thông tin quản trị  Error codes: - `role.group.not.found` (404) — Không tìm thấy nhóm vai trò đã xóa
     * @summary Get Deleted Role Group Details
     * @param {any} groupId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDeletedRoleGroup(
      groupId: any,
      options?: any,
    ): AxiosPromise<AuthRoleGroupDetails> {
      return localVarFp
        .getDeletedRoleGroup(groupId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Lấy danh sách nhóm vai trò đã xóa từ bảng lưu trữ (deleted_keycloak_group). Hỗ trợ lọc theo: mã vai trò, tên vai trò, Portal, loại vai trò. Dữ liệu được trích xuất từ bản snapshot JSONB lưu tại thời điểm xóa.
     * @summary List Deleted Role Groups
     * @param {any} [search] Search term to match against code or name (contains, case-insensitive)
     * @param {any} [name] Exact role group name to match
     * @param {any} [resourceIds] Associated resource type to filter by
     * @param {any} [roleType] Role type to filter (e.g. PORTAL, SERVICE)
     * @param {any} [page] Zero-based page index (0..N)
     * @param {any} [size] The size of the page to be returned
     * @param {any} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDeletedRoleGroups(
      search?: any,
      name?: any,
      resourceIds?: any,
      roleType?: any,
      page?: any,
      size?: any,
      sort?: any,
      options?: any,
    ): AxiosPromise<PageAuthRoleGroupLite> {
      return localVarFp
        .getDeletedRoleGroups(
          search,
          name,
          resourceIds,
          roleType,
          page,
          size,
          sort,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Deprecated API - use /{groupId}/group-members
     * @summary Get Group Members
     * @param {any} groupId
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    getGroupMembers(groupId: any, options?: any): AxiosPromise<any> {
      return localVarFp
        .getGroupMembers(groupId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Lấy danh sách người dùng được gán vào nhóm vai trò với tìm kiếm
     * @summary Get Group Members
     * @param {any} groupId
     * @param {any} [search] Search by username, email, first name, last name, or phone number (case-insensitive contains)
     * @param {any} [page] Zero-based page index (0..N)
     * @param {any} [size] The size of the page to be returned
     * @param {any} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMembersInGroup(
      groupId: any,
      search?: any,
      page?: any,
      size?: any,
      sort?: any,
      options?: any,
    ): AxiosPromise<PageUserLite> {
      return localVarFp
        .getMembersInGroup(groupId, search, page, size, sort, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Lấy thông tin chi tiết vai trò: - Tab 1: Thông tin vai trò + Ma trận phân quyền - Tab 2: Danh sách user được gán, thông tin quản trị (tạo bởi, cập nhật bởi, phê duyệt bởi)  Error codes: - `role.group.not.found` (404) — Không tìm thấy nhóm vai trò
     * @summary Get Role Group Details
     * @param {any} groupId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRoleGroup(
      groupId: any,
      options?: any,
    ): AxiosPromise<AuthRoleGroupDetails> {
      return localVarFp
        .getRoleGroup(groupId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Lấy danh sách nhóm vai trò có phân trang. Hỗ trợ lọc theo: mã vai trò, tên vai trò, Portal, trạng thái (ACTIVE/INACTIVE/DELETED).
     * @summary List Role Groups
     * @param {any} [search] Search term to match against code or name (contains, case-insensitive)
     * @param {any} [name] Exact role group name to match
     * @param {any} [resourceIds] Associated resource type to filter by
     * @param {any} [roleType] Role type to filter (e.g. PORTAL, SERVICE)
     * @param {any} [page] Zero-based page index (0..N)
     * @param {any} [size] The size of the page to be returned
     * @param {any} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRoleGroups(
      search?: any,
      name?: any,
      resourceIds?: any,
      roleType?: any,
      page?: any,
      size?: any,
      sort?: any,
      options?: any,
    ): AxiosPromise<PageAuthRoleGroupLite> {
      return localVarFp
        .getRoleGroups(
          search,
          name,
          resourceIds,
          roleType,
          page,
          size,
          sort,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Xóa người dùng khỏi nhóm vai trò, thu hồi tất cả quyền liên kết với nhóm
     * @summary Remove Group Member
     * @param {any} groupId
     * @param {any} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removeGroupMember(
      groupId: any,
      userId: any,
      options?: any,
    ): AxiosPromise<void> {
      return localVarFp
        .removeGroupMember(groupId, userId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Xóa một quyền cụ thể khỏi nhóm vai trò.  Error codes: - `role.not.found.in.group` (404) — Quyền không tồn tại trong nhóm vai trò
     * @summary Remove Role from Group
     * @param {any} groupId
     * @param {any} resourceId
     * @param {any} roleCode
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    removeRole(
      groupId: any,
      resourceId: any,
      roleCode: any,
      options?: any,
    ): AxiosPromise<void> {
      return localVarFp
        .removeRole(groupId, resourceId, roleCode, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Cập nhật Tên vai trò, Mô tả, Ma trận phân quyền (không sửa Mã, Portal, Role Type). Vai trò vẫn hoạt động bình thường trong khi chờ duyệt. Không cho sửa vai trò trạng thái DELETED. Sau khi Checker phê duyệt: force logout tất cả user gán vai trò này.  Error codes: - `role.group.name.already.exists` (400) — Tên vai trò đã tồn tại - `role.group.update.request.with.name.already.exists` (400) — Đã có yêu cầu cập nhật cùng tên đang chờ duyệt - `resource.not.found` (404) — Không tìm thấy Portal
     * @summary Update Role Group
     * @param {any} groupId
     * @param {UpdateRoleGroupRequest} updateRoleGroupRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateRoleGroup(
      groupId: any,
      updateRoleGroupRequest: UpdateRoleGroupRequest,
      options?: any,
    ): AxiosPromise<CreateApprovalRequestResponse> {
      return localVarFp
        .updateRoleGroup(groupId, updateRoleGroupRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Cập nhật danh sách quyền từ Resource (Portal) cho nhóm vai trò (thay thế toàn bộ danh sách quyền hiện tại)
     * @summary Assign Roles to Group
     * @param {any} groupId
     * @param {any} resourceId
     * @param {PutRolesRequest} putRolesRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateRoles(
      groupId: any,
      resourceId: any,
      putRolesRequest: PutRolesRequest,
      options?: any,
    ): AxiosPromise<void> {
      return localVarFp
        .updateRoles(groupId, resourceId, putRolesRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for addGroupMember operation in BackofficeRoleGroupManagementApi.
 * @export
 * @interface BackofficeRoleGroupManagementApiAddGroupMemberRequest
 */
export interface BackofficeRoleGroupManagementApiAddGroupMemberRequest {
  /**
   *
   * @type {any}
   * @memberof BackofficeRoleGroupManagementApiAddGroupMember
   */
  readonly groupId: any;

  /**
   *
   * @type {any}
   * @memberof BackofficeRoleGroupManagementApiAddGroupMember
   */
  readonly userId: any;
}

/**
 * Request parameters for addRole operation in BackofficeRoleGroupManagementApi.
 * @export
 * @interface BackofficeRoleGroupManagementApiAddRoleRequest
 */
export interface BackofficeRoleGroupManagementApiAddRoleRequest {
  /**
   *
   * @type {any}
   * @memberof BackofficeRoleGroupManagementApiAddRole
   */
  readonly groupId: any;

  /**
   *
   * @type {any}
   * @memberof BackofficeRoleGroupManagementApiAddRole
   */
  readonly resourceId: any;

  /**
   *
   * @type {any}
   * @memberof BackofficeRoleGroupManagementApiAddRole
   */
  readonly roleCode: any;
}

/**
 * Request parameters for createRoleGroup operation in BackofficeRoleGroupManagementApi.
 * @export
 * @interface BackofficeRoleGroupManagementApiCreateRoleGroupRequest
 */
export interface BackofficeRoleGroupManagementApiCreateRoleGroupRequest {
  /**
   *
   * @type {CreateRoleGroupRequest}
   * @memberof BackofficeRoleGroupManagementApiCreateRoleGroup
   */
  readonly createRoleGroupRequest: CreateRoleGroupRequest;
}

/**
 * Request parameters for deleteRoleGroup operation in BackofficeRoleGroupManagementApi.
 * @export
 * @interface BackofficeRoleGroupManagementApiDeleteRoleGroupRequest
 */
export interface BackofficeRoleGroupManagementApiDeleteRoleGroupRequest {
  /**
   *
   * @type {any}
   * @memberof BackofficeRoleGroupManagementApiDeleteRoleGroup
   */
  readonly groupId: any;
}

/**
 * Request parameters for getAvailableRoles operation in BackofficeRoleGroupManagementApi.
 * @export
 * @interface BackofficeRoleGroupManagementApiGetAvailableRolesRequest
 */
export interface BackofficeRoleGroupManagementApiGetAvailableRolesRequest {
  /**
   *
   * @type {any}
   * @memberof BackofficeRoleGroupManagementApiGetAvailableRoles
   */
  readonly groupId: any;

  /**
   *
   * @type {any}
   * @memberof BackofficeRoleGroupManagementApiGetAvailableRoles
   */
  readonly resourceId: any;
}

/**
 * Request parameters for getDeletedRoleGroup operation in BackofficeRoleGroupManagementApi.
 * @export
 * @interface BackofficeRoleGroupManagementApiGetDeletedRoleGroupRequest
 */
export interface BackofficeRoleGroupManagementApiGetDeletedRoleGroupRequest {
  /**
   *
   * @type {any}
   * @memberof BackofficeRoleGroupManagementApiGetDeletedRoleGroup
   */
  readonly groupId: any;
}

/**
 * Request parameters for getDeletedRoleGroups operation in BackofficeRoleGroupManagementApi.
 * @export
 * @interface BackofficeRoleGroupManagementApiGetDeletedRoleGroupsRequest
 */
export interface BackofficeRoleGroupManagementApiGetDeletedRoleGroupsRequest {
  /**
   * Search term to match against code or name (contains, case-insensitive)
   * @type {any}
   * @memberof BackofficeRoleGroupManagementApiGetDeletedRoleGroups
   */
  readonly search?: any;

  /**
   * Exact role group name to match
   * @type {any}
   * @memberof BackofficeRoleGroupManagementApiGetDeletedRoleGroups
   */
  readonly name?: any;

  /**
   * Associated resource type to filter by
   * @type {any}
   * @memberof BackofficeRoleGroupManagementApiGetDeletedRoleGroups
   */
  readonly resourceIds?: any;

  /**
   * Role type to filter (e.g. PORTAL, SERVICE)
   * @type {any}
   * @memberof BackofficeRoleGroupManagementApiGetDeletedRoleGroups
   */
  readonly roleType?: any;

  /**
   * Zero-based page index (0..N)
   * @type {any}
   * @memberof BackofficeRoleGroupManagementApiGetDeletedRoleGroups
   */
  readonly page?: any;

  /**
   * The size of the page to be returned
   * @type {any}
   * @memberof BackofficeRoleGroupManagementApiGetDeletedRoleGroups
   */
  readonly size?: any;

  /**
   * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @type {any}
   * @memberof BackofficeRoleGroupManagementApiGetDeletedRoleGroups
   */
  readonly sort?: any;
}

/**
 * Request parameters for getGroupMembers operation in BackofficeRoleGroupManagementApi.
 * @export
 * @interface BackofficeRoleGroupManagementApiGetGroupMembersRequest
 */
export interface BackofficeRoleGroupManagementApiGetGroupMembersRequest {
  /**
   *
   * @type {any}
   * @memberof BackofficeRoleGroupManagementApiGetGroupMembers
   */
  readonly groupId: any;
}

/**
 * Request parameters for getMembersInGroup operation in BackofficeRoleGroupManagementApi.
 * @export
 * @interface BackofficeRoleGroupManagementApiGetMembersInGroupRequest
 */
export interface BackofficeRoleGroupManagementApiGetMembersInGroupRequest {
  /**
   *
   * @type {any}
   * @memberof BackofficeRoleGroupManagementApiGetMembersInGroup
   */
  readonly groupId: any;

  /**
   * Search by username, email, first name, last name, or phone number (case-insensitive contains)
   * @type {any}
   * @memberof BackofficeRoleGroupManagementApiGetMembersInGroup
   */
  readonly search?: any;

  /**
   * Zero-based page index (0..N)
   * @type {any}
   * @memberof BackofficeRoleGroupManagementApiGetMembersInGroup
   */
  readonly page?: any;

  /**
   * The size of the page to be returned
   * @type {any}
   * @memberof BackofficeRoleGroupManagementApiGetMembersInGroup
   */
  readonly size?: any;

  /**
   * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @type {any}
   * @memberof BackofficeRoleGroupManagementApiGetMembersInGroup
   */
  readonly sort?: any;
}

/**
 * Request parameters for getRoleGroup operation in BackofficeRoleGroupManagementApi.
 * @export
 * @interface BackofficeRoleGroupManagementApiGetRoleGroupRequest
 */
export interface BackofficeRoleGroupManagementApiGetRoleGroupRequest {
  /**
   *
   * @type {any}
   * @memberof BackofficeRoleGroupManagementApiGetRoleGroup
   */
  readonly groupId: any;
}

/**
 * Request parameters for getRoleGroups operation in BackofficeRoleGroupManagementApi.
 * @export
 * @interface BackofficeRoleGroupManagementApiGetRoleGroupsRequest
 */
export interface BackofficeRoleGroupManagementApiGetRoleGroupsRequest {
  /**
   * Search term to match against code or name (contains, case-insensitive)
   * @type {any}
   * @memberof BackofficeRoleGroupManagementApiGetRoleGroups
   */
  readonly search?: any;

  /**
   * Exact role group name to match
   * @type {any}
   * @memberof BackofficeRoleGroupManagementApiGetRoleGroups
   */
  readonly name?: any;

  /**
   * Associated resource type to filter by
   * @type {any}
   * @memberof BackofficeRoleGroupManagementApiGetRoleGroups
   */
  readonly resourceIds?: any;

  /**
   * Role type to filter (e.g. PORTAL, SERVICE)
   * @type {any}
   * @memberof BackofficeRoleGroupManagementApiGetRoleGroups
   */
  readonly roleType?: any;

  /**
   * Zero-based page index (0..N)
   * @type {any}
   * @memberof BackofficeRoleGroupManagementApiGetRoleGroups
   */
  readonly page?: any;

  /**
   * The size of the page to be returned
   * @type {any}
   * @memberof BackofficeRoleGroupManagementApiGetRoleGroups
   */
  readonly size?: any;

  /**
   * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @type {any}
   * @memberof BackofficeRoleGroupManagementApiGetRoleGroups
   */
  readonly sort?: any;
}

/**
 * Request parameters for removeGroupMember operation in BackofficeRoleGroupManagementApi.
 * @export
 * @interface BackofficeRoleGroupManagementApiRemoveGroupMemberRequest
 */
export interface BackofficeRoleGroupManagementApiRemoveGroupMemberRequest {
  /**
   *
   * @type {any}
   * @memberof BackofficeRoleGroupManagementApiRemoveGroupMember
   */
  readonly groupId: any;

  /**
   *
   * @type {any}
   * @memberof BackofficeRoleGroupManagementApiRemoveGroupMember
   */
  readonly userId: any;
}

/**
 * Request parameters for removeRole operation in BackofficeRoleGroupManagementApi.
 * @export
 * @interface BackofficeRoleGroupManagementApiRemoveRoleRequest
 */
export interface BackofficeRoleGroupManagementApiRemoveRoleRequest {
  /**
   *
   * @type {any}
   * @memberof BackofficeRoleGroupManagementApiRemoveRole
   */
  readonly groupId: any;

  /**
   *
   * @type {any}
   * @memberof BackofficeRoleGroupManagementApiRemoveRole
   */
  readonly resourceId: any;

  /**
   *
   * @type {any}
   * @memberof BackofficeRoleGroupManagementApiRemoveRole
   */
  readonly roleCode: any;
}

/**
 * Request parameters for updateRoleGroup operation in BackofficeRoleGroupManagementApi.
 * @export
 * @interface BackofficeRoleGroupManagementApiUpdateRoleGroupRequest
 */
export interface BackofficeRoleGroupManagementApiUpdateRoleGroupRequest {
  /**
   *
   * @type {any}
   * @memberof BackofficeRoleGroupManagementApiUpdateRoleGroup
   */
  readonly groupId: any;

  /**
   *
   * @type {UpdateRoleGroupRequest}
   * @memberof BackofficeRoleGroupManagementApiUpdateRoleGroup
   */
  readonly updateRoleGroupRequest: UpdateRoleGroupRequest;
}

/**
 * Request parameters for updateRoles operation in BackofficeRoleGroupManagementApi.
 * @export
 * @interface BackofficeRoleGroupManagementApiUpdateRolesRequest
 */
export interface BackofficeRoleGroupManagementApiUpdateRolesRequest {
  /**
   *
   * @type {any}
   * @memberof BackofficeRoleGroupManagementApiUpdateRoles
   */
  readonly groupId: any;

  /**
   *
   * @type {any}
   * @memberof BackofficeRoleGroupManagementApiUpdateRoles
   */
  readonly resourceId: any;

  /**
   *
   * @type {PutRolesRequest}
   * @memberof BackofficeRoleGroupManagementApiUpdateRoles
   */
  readonly putRolesRequest: PutRolesRequest;
}

/**
 * BackofficeRoleGroupManagementApi - object-oriented interface
 * @export
 * @class BackofficeRoleGroupManagementApi
 * @extends {BaseAPI}
 */
export class BackofficeRoleGroupManagementApi extends BaseAPI {
  /**
   * Gán người dùng vào nhóm vai trò, cấp tất cả quyền liên kết với nhóm. - Một người dùng chỉ được gán một Vai trò trong mỗi Portal - Người dùng có thể được gán nhiều Portal khác nhau
   * @summary Add Group Member
   * @param {BackofficeRoleGroupManagementApiAddGroupMemberRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeRoleGroupManagementApi
   */
  public addGroupMember(
    requestParameters: BackofficeRoleGroupManagementApiAddGroupMemberRequest,
    options?: AxiosRequestConfig,
  ) {
    return BackofficeRoleGroupManagementApiFp(this.configuration)
      .addGroupMember(
        requestParameters.groupId,
        requestParameters.userId,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Gán một quyền cụ thể từ Resource (Portal) vào nhóm vai trò
   * @summary Assign Role to Group
   * @param {BackofficeRoleGroupManagementApiAddRoleRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeRoleGroupManagementApi
   */
  public addRole(
    requestParameters: BackofficeRoleGroupManagementApiAddRoleRequest,
    options?: AxiosRequestConfig,
  ) {
    return BackofficeRoleGroupManagementApiFp(this.configuration)
      .addRole(
        requestParameters.groupId,
        requestParameters.resourceId,
        requestParameters.roleCode,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Tạo nhóm vai trò mới: chọn Portal và Role Type → tự sinh mã vai trò [PORTAL_CODE]_[ROLE_TYPE]_[SEQ]. Vai trò tạo ở trạng thái INACTIVE, chờ Checker phê duyệt → chuyển sang ACTIVE.  Error codes: - `role.group.name.already.exists` (409) — Tên vai trò đã tồn tại - `role.group.create.request.with.name.already.exists` (409) — Đã có yêu cầu tạo vai trò cùng tên đang chờ duyệt - `resource.not.found` (404) — Không tìm thấy Portal
   * @summary Create Role Group
   * @param {BackofficeRoleGroupManagementApiCreateRoleGroupRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeRoleGroupManagementApi
   */
  public createRoleGroup(
    requestParameters: BackofficeRoleGroupManagementApiCreateRoleGroupRequest,
    options?: AxiosRequestConfig,
  ) {
    return BackofficeRoleGroupManagementApiFp(this.configuration)
      .createRoleGroup(requestParameters.createRoleGroupRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Xóa nhóm vai trò (tạo yêu cầu Maker/Checker): - INACTIVE chưa gán user → xóa cứng (hard delete) - Đã/đang gán user → chuyển trạng thái DELETED (soft delete), lưu cho audit  Error codes: - `role.group.not.found` (404) — Không tìm thấy nhóm vai trò         - `role.request.already.exists` (400) — Đã có yêu cầu xóa đang chờ duyệt
   * @summary Delete Role Group
   * @param {BackofficeRoleGroupManagementApiDeleteRoleGroupRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeRoleGroupManagementApi
   */
  public deleteRoleGroup(
    requestParameters: BackofficeRoleGroupManagementApiDeleteRoleGroupRequest,
    options?: AxiosRequestConfig,
  ) {
    return BackofficeRoleGroupManagementApiFp(this.configuration)
      .deleteRoleGroup(requestParameters.groupId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Lấy danh sách quyền khả dụng từ một Resource (Portal) để gán cho nhóm vai trò
   * @summary Get Available Roles
   * @param {BackofficeRoleGroupManagementApiGetAvailableRolesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeRoleGroupManagementApi
   */
  public getAvailableRoles(
    requestParameters: BackofficeRoleGroupManagementApiGetAvailableRolesRequest,
    options?: AxiosRequestConfig,
  ) {
    return BackofficeRoleGroupManagementApiFp(this.configuration)
      .getAvailableRoles(
        requestParameters.groupId,
        requestParameters.resourceId,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Lấy thông tin chi tiết nhóm vai trò đã xóa: - Thông tin vai trò, ma trận phân quyền tại thời điểm xóa - Số lượng user đã được gán, thông tin quản trị  Error codes: - `role.group.not.found` (404) — Không tìm thấy nhóm vai trò đã xóa
   * @summary Get Deleted Role Group Details
   * @param {BackofficeRoleGroupManagementApiGetDeletedRoleGroupRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeRoleGroupManagementApi
   */
  public getDeletedRoleGroup(
    requestParameters: BackofficeRoleGroupManagementApiGetDeletedRoleGroupRequest,
    options?: AxiosRequestConfig,
  ) {
    return BackofficeRoleGroupManagementApiFp(this.configuration)
      .getDeletedRoleGroup(requestParameters.groupId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Lấy danh sách nhóm vai trò đã xóa từ bảng lưu trữ (deleted_keycloak_group). Hỗ trợ lọc theo: mã vai trò, tên vai trò, Portal, loại vai trò. Dữ liệu được trích xuất từ bản snapshot JSONB lưu tại thời điểm xóa.
   * @summary List Deleted Role Groups
   * @param {BackofficeRoleGroupManagementApiGetDeletedRoleGroupsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeRoleGroupManagementApi
   */
  public getDeletedRoleGroups(
    requestParameters: BackofficeRoleGroupManagementApiGetDeletedRoleGroupsRequest = {},
    options?: AxiosRequestConfig,
  ) {
    return BackofficeRoleGroupManagementApiFp(this.configuration)
      .getDeletedRoleGroups(
        requestParameters.search,
        requestParameters.name,
        requestParameters.resourceIds,
        requestParameters.roleType,
        requestParameters.page,
        requestParameters.size,
        requestParameters.sort,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Deprecated API - use /{groupId}/group-members
   * @summary Get Group Members
   * @param {BackofficeRoleGroupManagementApiGetGroupMembersRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof BackofficeRoleGroupManagementApi
   */
  public getGroupMembers(
    requestParameters: BackofficeRoleGroupManagementApiGetGroupMembersRequest,
    options?: AxiosRequestConfig,
  ) {
    return BackofficeRoleGroupManagementApiFp(this.configuration)
      .getGroupMembers(requestParameters.groupId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Lấy danh sách người dùng được gán vào nhóm vai trò với tìm kiếm
   * @summary Get Group Members
   * @param {BackofficeRoleGroupManagementApiGetMembersInGroupRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeRoleGroupManagementApi
   */
  public getMembersInGroup(
    requestParameters: BackofficeRoleGroupManagementApiGetMembersInGroupRequest,
    options?: AxiosRequestConfig,
  ) {
    return BackofficeRoleGroupManagementApiFp(this.configuration)
      .getMembersInGroup(
        requestParameters.groupId,
        requestParameters.search,
        requestParameters.page,
        requestParameters.size,
        requestParameters.sort,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Lấy thông tin chi tiết vai trò: - Tab 1: Thông tin vai trò + Ma trận phân quyền - Tab 2: Danh sách user được gán, thông tin quản trị (tạo bởi, cập nhật bởi, phê duyệt bởi)  Error codes: - `role.group.not.found` (404) — Không tìm thấy nhóm vai trò
   * @summary Get Role Group Details
   * @param {BackofficeRoleGroupManagementApiGetRoleGroupRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeRoleGroupManagementApi
   */
  public getRoleGroup(
    requestParameters: BackofficeRoleGroupManagementApiGetRoleGroupRequest,
    options?: AxiosRequestConfig,
  ) {
    return BackofficeRoleGroupManagementApiFp(this.configuration)
      .getRoleGroup(requestParameters.groupId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Lấy danh sách nhóm vai trò có phân trang. Hỗ trợ lọc theo: mã vai trò, tên vai trò, Portal, trạng thái (ACTIVE/INACTIVE/DELETED).
   * @summary List Role Groups
   * @param {BackofficeRoleGroupManagementApiGetRoleGroupsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeRoleGroupManagementApi
   */
  public getRoleGroups(
    requestParameters: BackofficeRoleGroupManagementApiGetRoleGroupsRequest = {},
    options?: AxiosRequestConfig,
  ) {
    return BackofficeRoleGroupManagementApiFp(this.configuration)
      .getRoleGroups(
        requestParameters.search,
        requestParameters.name,
        requestParameters.resourceIds,
        requestParameters.roleType,
        requestParameters.page,
        requestParameters.size,
        requestParameters.sort,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Xóa người dùng khỏi nhóm vai trò, thu hồi tất cả quyền liên kết với nhóm
   * @summary Remove Group Member
   * @param {BackofficeRoleGroupManagementApiRemoveGroupMemberRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeRoleGroupManagementApi
   */
  public removeGroupMember(
    requestParameters: BackofficeRoleGroupManagementApiRemoveGroupMemberRequest,
    options?: AxiosRequestConfig,
  ) {
    return BackofficeRoleGroupManagementApiFp(this.configuration)
      .removeGroupMember(
        requestParameters.groupId,
        requestParameters.userId,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Xóa một quyền cụ thể khỏi nhóm vai trò.  Error codes: - `role.not.found.in.group` (404) — Quyền không tồn tại trong nhóm vai trò
   * @summary Remove Role from Group
   * @param {BackofficeRoleGroupManagementApiRemoveRoleRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeRoleGroupManagementApi
   */
  public removeRole(
    requestParameters: BackofficeRoleGroupManagementApiRemoveRoleRequest,
    options?: AxiosRequestConfig,
  ) {
    return BackofficeRoleGroupManagementApiFp(this.configuration)
      .removeRole(
        requestParameters.groupId,
        requestParameters.resourceId,
        requestParameters.roleCode,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Cập nhật Tên vai trò, Mô tả, Ma trận phân quyền (không sửa Mã, Portal, Role Type). Vai trò vẫn hoạt động bình thường trong khi chờ duyệt. Không cho sửa vai trò trạng thái DELETED. Sau khi Checker phê duyệt: force logout tất cả user gán vai trò này.  Error codes: - `role.group.name.already.exists` (400) — Tên vai trò đã tồn tại - `role.group.update.request.with.name.already.exists` (400) — Đã có yêu cầu cập nhật cùng tên đang chờ duyệt - `resource.not.found` (404) — Không tìm thấy Portal
   * @summary Update Role Group
   * @param {BackofficeRoleGroupManagementApiUpdateRoleGroupRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeRoleGroupManagementApi
   */
  public updateRoleGroup(
    requestParameters: BackofficeRoleGroupManagementApiUpdateRoleGroupRequest,
    options?: AxiosRequestConfig,
  ) {
    return BackofficeRoleGroupManagementApiFp(this.configuration)
      .updateRoleGroup(
        requestParameters.groupId,
        requestParameters.updateRoleGroupRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Cập nhật danh sách quyền từ Resource (Portal) cho nhóm vai trò (thay thế toàn bộ danh sách quyền hiện tại)
   * @summary Assign Roles to Group
   * @param {BackofficeRoleGroupManagementApiUpdateRolesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeRoleGroupManagementApi
   */
  public updateRoles(
    requestParameters: BackofficeRoleGroupManagementApiUpdateRolesRequest,
    options?: AxiosRequestConfig,
  ) {
    return BackofficeRoleGroupManagementApiFp(this.configuration)
      .updateRoles(
        requestParameters.groupId,
        requestParameters.resourceId,
        requestParameters.putRolesRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * BackofficeSessionManagementApi - axios parameter creator
 * @export
 */
export const BackofficeSessionManagementApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Returns active sessions for the current authenticated user
     * @summary List Active Sessions
     * @param {any} [limit] Maximum number of sessions to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getActiveSessions: async (
      limit?: any,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/bo/api/v1/sessions`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      if (limit !== undefined) {
        localVarQueryParameter["limit"] = limit;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Revokes all active sessions for the current user (logout from all devices)
     * @summary Revoke All Sessions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    revokeAllSessions: async (
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/bo/api/v1/sessions`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Revokes a specific session by its ID
     * @summary Revoke Session
     * @param {any} sessionId Session ID to revoke
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    revokeSession: async (
      sessionId: any,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'sessionId' is not null or undefined
      assertParamExists("revokeSession", "sessionId", sessionId);
      const localVarPath = `/bo/api/v1/sessions/{sessionId}`.replace(
        `{${"sessionId"}}`,
        encodeURIComponent(String(sessionId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Server-Sent Events stream for real-time force logout notifications. Events are sent when the user\'s sessions are forcefully revoked due to role changes, account locking, or password resets. Auth via ?token=<jwt> query parameter.
     * @summary Subscribe to Force Logout Events (SSE)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    subscribeForceLogoutEvents: async (
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/bo/api/v1/public/sse/sessions/events`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication sseTokenQuery required
      await setApiKeyToObject(localVarQueryParameter, "token", configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * BackofficeSessionManagementApi - functional programming interface
 * @export
 */
export const BackofficeSessionManagementApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    BackofficeSessionManagementApiAxiosParamCreator(configuration);
  return {
    /**
     * Returns active sessions for the current authenticated user
     * @summary List Active Sessions
     * @param {any} [limit] Maximum number of sessions to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getActiveSessions(
      limit?: any,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PageSessionInfo>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getActiveSessions(limit, options);
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Revokes all active sessions for the current user (logout from all devices)
     * @summary Revoke All Sessions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async revokeAllSessions(
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.revokeAllSessions(options);
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Revokes a specific session by its ID
     * @summary Revoke Session
     * @param {any} sessionId Session ID to revoke
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async revokeSession(
      sessionId: any,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.revokeSession(
        sessionId,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Server-Sent Events stream for real-time force logout notifications. Events are sent when the user\'s sessions are forcefully revoked due to role changes, account locking, or password resets. Auth via ?token=<jwt> query parameter.
     * @summary Subscribe to Force Logout Events (SSE)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async subscribeForceLogoutEvents(
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.subscribeForceLogoutEvents(options);
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
  };
};

/**
 * BackofficeSessionManagementApi - factory interface
 * @export
 */
export const BackofficeSessionManagementApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = BackofficeSessionManagementApiFp(configuration);
  return {
    /**
     * Returns active sessions for the current authenticated user
     * @summary List Active Sessions
     * @param {any} [limit] Maximum number of sessions to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getActiveSessions(
      limit?: any,
      options?: any,
    ): AxiosPromise<PageSessionInfo> {
      return localVarFp
        .getActiveSessions(limit, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Revokes all active sessions for the current user (logout from all devices)
     * @summary Revoke All Sessions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    revokeAllSessions(options?: any): AxiosPromise<void> {
      return localVarFp
        .revokeAllSessions(options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Revokes a specific session by its ID
     * @summary Revoke Session
     * @param {any} sessionId Session ID to revoke
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    revokeSession(sessionId: any, options?: any): AxiosPromise<void> {
      return localVarFp
        .revokeSession(sessionId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Server-Sent Events stream for real-time force logout notifications. Events are sent when the user\'s sessions are forcefully revoked due to role changes, account locking, or password resets. Auth via ?token=<jwt> query parameter.
     * @summary Subscribe to Force Logout Events (SSE)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    subscribeForceLogoutEvents(options?: any): AxiosPromise<any> {
      return localVarFp
        .subscribeForceLogoutEvents(options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for getActiveSessions operation in BackofficeSessionManagementApi.
 * @export
 * @interface BackofficeSessionManagementApiGetActiveSessionsRequest
 */
export interface BackofficeSessionManagementApiGetActiveSessionsRequest {
  /**
   * Maximum number of sessions to return
   * @type {any}
   * @memberof BackofficeSessionManagementApiGetActiveSessions
   */
  readonly limit?: any;
}

/**
 * Request parameters for revokeSession operation in BackofficeSessionManagementApi.
 * @export
 * @interface BackofficeSessionManagementApiRevokeSessionRequest
 */
export interface BackofficeSessionManagementApiRevokeSessionRequest {
  /**
   * Session ID to revoke
   * @type {any}
   * @memberof BackofficeSessionManagementApiRevokeSession
   */
  readonly sessionId: any;
}

/**
 * BackofficeSessionManagementApi - object-oriented interface
 * @export
 * @class BackofficeSessionManagementApi
 * @extends {BaseAPI}
 */
export class BackofficeSessionManagementApi extends BaseAPI {
  /**
   * Returns active sessions for the current authenticated user
   * @summary List Active Sessions
   * @param {BackofficeSessionManagementApiGetActiveSessionsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeSessionManagementApi
   */
  public getActiveSessions(
    requestParameters: BackofficeSessionManagementApiGetActiveSessionsRequest = {},
    options?: AxiosRequestConfig,
  ) {
    return BackofficeSessionManagementApiFp(this.configuration)
      .getActiveSessions(requestParameters.limit, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Revokes all active sessions for the current user (logout from all devices)
   * @summary Revoke All Sessions
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeSessionManagementApi
   */
  public revokeAllSessions(options?: AxiosRequestConfig) {
    return BackofficeSessionManagementApiFp(this.configuration)
      .revokeAllSessions(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Revokes a specific session by its ID
   * @summary Revoke Session
   * @param {BackofficeSessionManagementApiRevokeSessionRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeSessionManagementApi
   */
  public revokeSession(
    requestParameters: BackofficeSessionManagementApiRevokeSessionRequest,
    options?: AxiosRequestConfig,
  ) {
    return BackofficeSessionManagementApiFp(this.configuration)
      .revokeSession(requestParameters.sessionId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Server-Sent Events stream for real-time force logout notifications. Events are sent when the user\'s sessions are forcefully revoked due to role changes, account locking, or password resets. Auth via ?token=<jwt> query parameter.
   * @summary Subscribe to Force Logout Events (SSE)
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeSessionManagementApi
   */
  public subscribeForceLogoutEvents(options?: AxiosRequestConfig) {
    return BackofficeSessionManagementApiFp(this.configuration)
      .subscribeForceLogoutEvents(options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * BackofficeUsersManagementApi - axios parameter creator
 * @export
 */
export const BackofficeUsersManagementApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Admin đặt lại mật khẩu cho người dùng. Tất cả phiên đăng nhập hiện tại sẽ bị hủy. Thông tin đăng nhập mới được gửi qua email.  Error codes: - `user.not.found` (404) — Không tìm thấy người dùng - `failed.to.reset.password` (500) — Lỗi khi đặt lại mật khẩu
     * @summary Admin Reset Password
     * @param {any} userId User ID
     * @param {BoAdminResetPasswordRequest} boAdminResetPasswordRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminResetPassword: async (
      userId: any,
      boAdminResetPasswordRequest: BoAdminResetPasswordRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      assertParamExists("adminResetPassword", "userId", userId);
      // verify required parameter 'boAdminResetPasswordRequest' is not null or undefined
      assertParamExists(
        "adminResetPassword",
        "boAdminResetPasswordRequest",
        boAdminResetPasswordRequest,
      );
      const localVarPath = `/bo/api/v1/users/{userId}/reset-password`.replace(
        `{${"userId"}}`,
        encodeURIComponent(String(userId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        boAdminResetPasswordRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Tạo yêu cầu tạo tài khoản người dùng mới (Maker/Checker). Maker nhập Họ tên, Email, SĐT, Mật khẩu, chọn Portal và Vai trò → tạo yêu cầu phê duyệt. Sau khi Checker phê duyệt: tạo tài khoản trạng thái ACTIVE, gửi thông tin đăng nhập qua email.  Error codes: - `user.already.exists` (400) — Username đã tồn tại - `user.email.already.exists` (400) — Email đã được sử dụng     - `user.request.already.exists` (400) — Đã có yêu cầu tạo user đang chờ duyệt
     * @summary Create User
     * @param {BoCreateUserRequest} boCreateUserRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createUser: async (
      boCreateUserRequest: BoCreateUserRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'boCreateUserRequest' is not null or undefined
      assertParamExists(
        "createUser",
        "boCreateUserRequest",
        boCreateUserRequest,
      );
      const localVarPath = `/bo/api/v1/users`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        boCreateUserRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Lấy thông tin chung của người dùng (Tab 1): Họ tên, Email, SĐT, Ngày tạo, Đăng nhập lần cuối, Thời điểm đổi mật khẩu gần nhất.  Error codes: - `user.not.found` (404) — Không tìm thấy người dùng
     * @summary Get User Info
     * @param {any} userId User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserInfo: async (
      userId: any,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      assertParamExists("getUserInfo", "userId", userId);
      const localVarPath = `/bo/api/v1/users/{userId}`.replace(
        `{${"userId"}}`,
        encodeURIComponent(String(userId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Lấy chi tiết phân quyền của người dùng theo Portal (Tab 2): Tên Portal, Role Code, Role Name, Ma trận phân quyền. Một người dùng chỉ được gán một Vai trò trong mỗi Portal.
     * @summary Get User Role Groups
     * @param {any} userId User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserRoleGroups: async (
      userId: any,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      assertParamExists("getUserRoleGroups", "userId", userId);
      const localVarPath = `/bo/api/v1/users/{userId}/role-groups`.replace(
        `{${"userId"}}`,
        encodeURIComponent(String(userId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Lấy thông tin bảo mật (Tab 3): IP đăng nhập gần nhất, Số lần đăng nhập thất bại liên tiếp, Thời điểm đổi mật khẩu gần nhất. Chỉ Super Admin thấy nút Đặt lại mật khẩu.  Error codes: - `user.not.found` (404) — Không tìm thấy người dùng
     * @summary Get User Security Info
     * @param {any} userId User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserSecurity: async (
      userId: any,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      assertParamExists("getUserSecurity", "userId", userId);
      const localVarPath = `/bo/api/v1/users/{userId}/security`.replace(
        `{${"userId"}}`,
        encodeURIComponent(String(userId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Lấy danh sách người dùng backoffice có phân trang. Hỗ trợ lọc theo: Username, Họ tên, Email, SĐT, Tên vai trò, Trạng thái, Portal, khoảng ngày tạo.
     * @summary List Users
     * @param {any} [search] Search by username, email, first name, last name, phone number, or role name
     * @param {any} [statuses] Filter by user statuses: ACTIVE, INACTIVE, LOCKED
     * @param {any} [resourceIds] Filter by resource ids
     * @param {any} [createdDateFrom] Filter by created date from (inclusive)
     * @param {any} [createdDateTo] Filter by created date to (inclusive)
     * @param {any} [page] Zero-based page index (0..N)
     * @param {any} [size] The size of the page to be returned
     * @param {any} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUsers: async (
      search?: any,
      statuses?: any,
      resourceIds?: any,
      createdDateFrom?: any,
      createdDateTo?: any,
      page?: any,
      size?: any,
      sort?: any,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/bo/api/v1/users`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      if (search !== undefined) {
        localVarQueryParameter["search"] = search;
      }

      if (statuses !== undefined) {
        localVarQueryParameter["statuses"] = statuses;
      }

      if (resourceIds !== undefined) {
        localVarQueryParameter["resourceIds"] = resourceIds;
      }

      if (createdDateFrom !== undefined) {
        localVarQueryParameter["createdDateFrom"] = createdDateFrom;
      }

      if (createdDateTo !== undefined) {
        localVarQueryParameter["createdDateTo"] = createdDateTo;
      }

      if (page !== undefined) {
        localVarQueryParameter["page"] = page;
      }

      if (size !== undefined) {
        localVarQueryParameter["size"] = size;
      }

      if (sort !== undefined) {
        localVarQueryParameter["sort"] = sort;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Gửi yêu cầu khóa tài khoản người dùng (Maker/Checker). Sau khi Checker phê duyệt: tất cả phiên đăng nhập bị hủy, người dùng không thể đăng nhập.  Error codes: - `user.not.found` (404) — Không tìm thấy người dùng - `user.already.locked` (400) — Tài khoản đã bị khóa     - `user.request.already.exists` (400) — Đã có yêu cầu khóa đang chờ duyệt
     * @summary Lock User
     * @param {any} userId User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    lockUser: async (
      userId: any,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      assertParamExists("lockUser", "userId", userId);
      const localVarPath = `/bo/api/v1/users/{userId}/lock`.replace(
        `{${"userId"}}`,
        encodeURIComponent(String(userId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Gửi yêu cầu mở khóa tài khoản người dùng (Maker/Checker). Sau khi Checker phê duyệt: chuyển trạng thái LOCKED → ACTIVE, người dùng có thể đăng nhập lại.  Error codes: - `user.not.found` (404) — Không tìm thấy người dùng - `user.not.locked` (400) — Tài khoản chưa bị khóa     - `user.request.already.exists` (400) — Đã có yêu cầu mở khóa đang chờ duyệt
     * @summary Unlock User
     * @param {any} userId User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    unlockUser: async (
      userId: any,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      assertParamExists("unlockUser", "userId", userId);
      const localVarPath = `/bo/api/v1/users/{userId}/unlock`.replace(
        `{${"userId"}}`,
        encodeURIComponent(String(userId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Cập nhật thông tin người dùng (Họ tên, Email, SĐT, Portal, Vai trò) → tạo yêu cầu phê duyệt. Username, Mật khẩu, Trạng thái không được chỉnh sửa trực tiếp. Sau khi Checker phê duyệt: cập nhật thông tin, force logout nếu có thay đổi quyền.  Error codes: - `user.not.found` (404) — Không tìm thấy người dùng - `user.email.already.exists.for.another.user` (400) — Email đã được sử dụng bởi user khác     - `user.request.already.exists` (400) — Đã có yêu cầu cập nhật đang chờ duyệt
     * @summary Update User
     * @param {any} userId User ID
     * @param {BoUpdateUserRequest} boUpdateUserRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateUser: async (
      userId: any,
      boUpdateUserRequest: BoUpdateUserRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      assertParamExists("updateUser", "userId", userId);
      // verify required parameter 'boUpdateUserRequest' is not null or undefined
      assertParamExists(
        "updateUser",
        "boUpdateUserRequest",
        boUpdateUserRequest,
      );
      const localVarPath = `/bo/api/v1/users/{userId}`.replace(
        `{${"userId"}}`,
        encodeURIComponent(String(userId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        boUpdateUserRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * BackofficeUsersManagementApi - functional programming interface
 * @export
 */
export const BackofficeUsersManagementApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    BackofficeUsersManagementApiAxiosParamCreator(configuration);
  return {
    /**
     * Admin đặt lại mật khẩu cho người dùng. Tất cả phiên đăng nhập hiện tại sẽ bị hủy. Thông tin đăng nhập mới được gửi qua email.  Error codes: - `user.not.found` (404) — Không tìm thấy người dùng - `failed.to.reset.password` (500) — Lỗi khi đặt lại mật khẩu
     * @summary Admin Reset Password
     * @param {any} userId User ID
     * @param {BoAdminResetPasswordRequest} boAdminResetPasswordRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async adminResetPassword(
      userId: any,
      boAdminResetPasswordRequest: BoAdminResetPasswordRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.adminResetPassword(
          userId,
          boAdminResetPasswordRequest,
          options,
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Tạo yêu cầu tạo tài khoản người dùng mới (Maker/Checker). Maker nhập Họ tên, Email, SĐT, Mật khẩu, chọn Portal và Vai trò → tạo yêu cầu phê duyệt. Sau khi Checker phê duyệt: tạo tài khoản trạng thái ACTIVE, gửi thông tin đăng nhập qua email.  Error codes: - `user.already.exists` (400) — Username đã tồn tại - `user.email.already.exists` (400) — Email đã được sử dụng     - `user.request.already.exists` (400) — Đã có yêu cầu tạo user đang chờ duyệt
     * @summary Create User
     * @param {BoCreateUserRequest} boCreateUserRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createUser(
      boCreateUserRequest: BoCreateUserRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<CreateApprovalRequestResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createUser(
        boCreateUserRequest,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Lấy thông tin chung của người dùng (Tab 1): Họ tên, Email, SĐT, Ngày tạo, Đăng nhập lần cuối, Thời điểm đổi mật khẩu gần nhất.  Error codes: - `user.not.found` (404) — Không tìm thấy người dùng
     * @summary Get User Info
     * @param {any} userId User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getUserInfo(
      userId: any,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<BoUserInfo>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getUserInfo(
        userId,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Lấy chi tiết phân quyền của người dùng theo Portal (Tab 2): Tên Portal, Role Code, Role Name, Ma trận phân quyền. Một người dùng chỉ được gán một Vai trò trong mỗi Portal.
     * @summary Get User Role Groups
     * @param {any} userId User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getUserRoleGroups(
      userId: any,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<BoUserRoleGroups>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getUserRoleGroups(userId, options);
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Lấy thông tin bảo mật (Tab 3): IP đăng nhập gần nhất, Số lần đăng nhập thất bại liên tiếp, Thời điểm đổi mật khẩu gần nhất. Chỉ Super Admin thấy nút Đặt lại mật khẩu.  Error codes: - `user.not.found` (404) — Không tìm thấy người dùng
     * @summary Get User Security Info
     * @param {any} userId User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getUserSecurity(
      userId: any,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<BoUserSecurity>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getUserSecurity(
        userId,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Lấy danh sách người dùng backoffice có phân trang. Hỗ trợ lọc theo: Username, Họ tên, Email, SĐT, Tên vai trò, Trạng thái, Portal, khoảng ngày tạo.
     * @summary List Users
     * @param {any} [search] Search by username, email, first name, last name, phone number, or role name
     * @param {any} [statuses] Filter by user statuses: ACTIVE, INACTIVE, LOCKED
     * @param {any} [resourceIds] Filter by resource ids
     * @param {any} [createdDateFrom] Filter by created date from (inclusive)
     * @param {any} [createdDateTo] Filter by created date to (inclusive)
     * @param {any} [page] Zero-based page index (0..N)
     * @param {any} [size] The size of the page to be returned
     * @param {any} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getUsers(
      search?: any,
      statuses?: any,
      resourceIds?: any,
      createdDateFrom?: any,
      createdDateTo?: any,
      page?: any,
      size?: any,
      sort?: any,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageBoUserLite>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getUsers(
        search,
        statuses,
        resourceIds,
        createdDateFrom,
        createdDateTo,
        page,
        size,
        sort,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Gửi yêu cầu khóa tài khoản người dùng (Maker/Checker). Sau khi Checker phê duyệt: tất cả phiên đăng nhập bị hủy, người dùng không thể đăng nhập.  Error codes: - `user.not.found` (404) — Không tìm thấy người dùng - `user.already.locked` (400) — Tài khoản đã bị khóa     - `user.request.already.exists` (400) — Đã có yêu cầu khóa đang chờ duyệt
     * @summary Lock User
     * @param {any} userId User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async lockUser(
      userId: any,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<CreateApprovalRequestResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.lockUser(
        userId,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Gửi yêu cầu mở khóa tài khoản người dùng (Maker/Checker). Sau khi Checker phê duyệt: chuyển trạng thái LOCKED → ACTIVE, người dùng có thể đăng nhập lại.  Error codes: - `user.not.found` (404) — Không tìm thấy người dùng - `user.not.locked` (400) — Tài khoản chưa bị khóa     - `user.request.already.exists` (400) — Đã có yêu cầu mở khóa đang chờ duyệt
     * @summary Unlock User
     * @param {any} userId User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async unlockUser(
      userId: any,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<CreateApprovalRequestResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.unlockUser(
        userId,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Cập nhật thông tin người dùng (Họ tên, Email, SĐT, Portal, Vai trò) → tạo yêu cầu phê duyệt. Username, Mật khẩu, Trạng thái không được chỉnh sửa trực tiếp. Sau khi Checker phê duyệt: cập nhật thông tin, force logout nếu có thay đổi quyền.  Error codes: - `user.not.found` (404) — Không tìm thấy người dùng - `user.email.already.exists.for.another.user` (400) — Email đã được sử dụng bởi user khác     - `user.request.already.exists` (400) — Đã có yêu cầu cập nhật đang chờ duyệt
     * @summary Update User
     * @param {any} userId User ID
     * @param {BoUpdateUserRequest} boUpdateUserRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateUser(
      userId: any,
      boUpdateUserRequest: BoUpdateUserRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<CreateApprovalRequestResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateUser(
        userId,
        boUpdateUserRequest,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
  };
};

/**
 * BackofficeUsersManagementApi - factory interface
 * @export
 */
export const BackofficeUsersManagementApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = BackofficeUsersManagementApiFp(configuration);
  return {
    /**
     * Admin đặt lại mật khẩu cho người dùng. Tất cả phiên đăng nhập hiện tại sẽ bị hủy. Thông tin đăng nhập mới được gửi qua email.  Error codes: - `user.not.found` (404) — Không tìm thấy người dùng - `failed.to.reset.password` (500) — Lỗi khi đặt lại mật khẩu
     * @summary Admin Reset Password
     * @param {any} userId User ID
     * @param {BoAdminResetPasswordRequest} boAdminResetPasswordRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    adminResetPassword(
      userId: any,
      boAdminResetPasswordRequest: BoAdminResetPasswordRequest,
      options?: any,
    ): AxiosPromise<void> {
      return localVarFp
        .adminResetPassword(userId, boAdminResetPasswordRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Tạo yêu cầu tạo tài khoản người dùng mới (Maker/Checker). Maker nhập Họ tên, Email, SĐT, Mật khẩu, chọn Portal và Vai trò → tạo yêu cầu phê duyệt. Sau khi Checker phê duyệt: tạo tài khoản trạng thái ACTIVE, gửi thông tin đăng nhập qua email.  Error codes: - `user.already.exists` (400) — Username đã tồn tại - `user.email.already.exists` (400) — Email đã được sử dụng     - `user.request.already.exists` (400) — Đã có yêu cầu tạo user đang chờ duyệt
     * @summary Create User
     * @param {BoCreateUserRequest} boCreateUserRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createUser(
      boCreateUserRequest: BoCreateUserRequest,
      options?: any,
    ): AxiosPromise<CreateApprovalRequestResponse> {
      return localVarFp
        .createUser(boCreateUserRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Lấy thông tin chung của người dùng (Tab 1): Họ tên, Email, SĐT, Ngày tạo, Đăng nhập lần cuối, Thời điểm đổi mật khẩu gần nhất.  Error codes: - `user.not.found` (404) — Không tìm thấy người dùng
     * @summary Get User Info
     * @param {any} userId User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserInfo(userId: any, options?: any): AxiosPromise<BoUserInfo> {
      return localVarFp
        .getUserInfo(userId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Lấy chi tiết phân quyền của người dùng theo Portal (Tab 2): Tên Portal, Role Code, Role Name, Ma trận phân quyền. Một người dùng chỉ được gán một Vai trò trong mỗi Portal.
     * @summary Get User Role Groups
     * @param {any} userId User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserRoleGroups(
      userId: any,
      options?: any,
    ): AxiosPromise<BoUserRoleGroups> {
      return localVarFp
        .getUserRoleGroups(userId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Lấy thông tin bảo mật (Tab 3): IP đăng nhập gần nhất, Số lần đăng nhập thất bại liên tiếp, Thời điểm đổi mật khẩu gần nhất. Chỉ Super Admin thấy nút Đặt lại mật khẩu.  Error codes: - `user.not.found` (404) — Không tìm thấy người dùng
     * @summary Get User Security Info
     * @param {any} userId User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserSecurity(userId: any, options?: any): AxiosPromise<BoUserSecurity> {
      return localVarFp
        .getUserSecurity(userId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Lấy danh sách người dùng backoffice có phân trang. Hỗ trợ lọc theo: Username, Họ tên, Email, SĐT, Tên vai trò, Trạng thái, Portal, khoảng ngày tạo.
     * @summary List Users
     * @param {any} [search] Search by username, email, first name, last name, phone number, or role name
     * @param {any} [statuses] Filter by user statuses: ACTIVE, INACTIVE, LOCKED
     * @param {any} [resourceIds] Filter by resource ids
     * @param {any} [createdDateFrom] Filter by created date from (inclusive)
     * @param {any} [createdDateTo] Filter by created date to (inclusive)
     * @param {any} [page] Zero-based page index (0..N)
     * @param {any} [size] The size of the page to be returned
     * @param {any} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUsers(
      search?: any,
      statuses?: any,
      resourceIds?: any,
      createdDateFrom?: any,
      createdDateTo?: any,
      page?: any,
      size?: any,
      sort?: any,
      options?: any,
    ): AxiosPromise<PageBoUserLite> {
      return localVarFp
        .getUsers(
          search,
          statuses,
          resourceIds,
          createdDateFrom,
          createdDateTo,
          page,
          size,
          sort,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Gửi yêu cầu khóa tài khoản người dùng (Maker/Checker). Sau khi Checker phê duyệt: tất cả phiên đăng nhập bị hủy, người dùng không thể đăng nhập.  Error codes: - `user.not.found` (404) — Không tìm thấy người dùng - `user.already.locked` (400) — Tài khoản đã bị khóa     - `user.request.already.exists` (400) — Đã có yêu cầu khóa đang chờ duyệt
     * @summary Lock User
     * @param {any} userId User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    lockUser(
      userId: any,
      options?: any,
    ): AxiosPromise<CreateApprovalRequestResponse> {
      return localVarFp
        .lockUser(userId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Gửi yêu cầu mở khóa tài khoản người dùng (Maker/Checker). Sau khi Checker phê duyệt: chuyển trạng thái LOCKED → ACTIVE, người dùng có thể đăng nhập lại.  Error codes: - `user.not.found` (404) — Không tìm thấy người dùng - `user.not.locked` (400) — Tài khoản chưa bị khóa     - `user.request.already.exists` (400) — Đã có yêu cầu mở khóa đang chờ duyệt
     * @summary Unlock User
     * @param {any} userId User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    unlockUser(
      userId: any,
      options?: any,
    ): AxiosPromise<CreateApprovalRequestResponse> {
      return localVarFp
        .unlockUser(userId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Cập nhật thông tin người dùng (Họ tên, Email, SĐT, Portal, Vai trò) → tạo yêu cầu phê duyệt. Username, Mật khẩu, Trạng thái không được chỉnh sửa trực tiếp. Sau khi Checker phê duyệt: cập nhật thông tin, force logout nếu có thay đổi quyền.  Error codes: - `user.not.found` (404) — Không tìm thấy người dùng - `user.email.already.exists.for.another.user` (400) — Email đã được sử dụng bởi user khác     - `user.request.already.exists` (400) — Đã có yêu cầu cập nhật đang chờ duyệt
     * @summary Update User
     * @param {any} userId User ID
     * @param {BoUpdateUserRequest} boUpdateUserRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateUser(
      userId: any,
      boUpdateUserRequest: BoUpdateUserRequest,
      options?: any,
    ): AxiosPromise<CreateApprovalRequestResponse> {
      return localVarFp
        .updateUser(userId, boUpdateUserRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for adminResetPassword operation in BackofficeUsersManagementApi.
 * @export
 * @interface BackofficeUsersManagementApiAdminResetPasswordRequest
 */
export interface BackofficeUsersManagementApiAdminResetPasswordRequest {
  /**
   * User ID
   * @type {any}
   * @memberof BackofficeUsersManagementApiAdminResetPassword
   */
  readonly userId: any;

  /**
   *
   * @type {BoAdminResetPasswordRequest}
   * @memberof BackofficeUsersManagementApiAdminResetPassword
   */
  readonly boAdminResetPasswordRequest: BoAdminResetPasswordRequest;
}

/**
 * Request parameters for createUser operation in BackofficeUsersManagementApi.
 * @export
 * @interface BackofficeUsersManagementApiCreateUserRequest
 */
export interface BackofficeUsersManagementApiCreateUserRequest {
  /**
   *
   * @type {BoCreateUserRequest}
   * @memberof BackofficeUsersManagementApiCreateUser
   */
  readonly boCreateUserRequest: BoCreateUserRequest;
}

/**
 * Request parameters for getUserInfo operation in BackofficeUsersManagementApi.
 * @export
 * @interface BackofficeUsersManagementApiGetUserInfoRequest
 */
export interface BackofficeUsersManagementApiGetUserInfoRequest {
  /**
   * User ID
   * @type {any}
   * @memberof BackofficeUsersManagementApiGetUserInfo
   */
  readonly userId: any;
}

/**
 * Request parameters for getUserRoleGroups operation in BackofficeUsersManagementApi.
 * @export
 * @interface BackofficeUsersManagementApiGetUserRoleGroupsRequest
 */
export interface BackofficeUsersManagementApiGetUserRoleGroupsRequest {
  /**
   * User ID
   * @type {any}
   * @memberof BackofficeUsersManagementApiGetUserRoleGroups
   */
  readonly userId: any;
}

/**
 * Request parameters for getUserSecurity operation in BackofficeUsersManagementApi.
 * @export
 * @interface BackofficeUsersManagementApiGetUserSecurityRequest
 */
export interface BackofficeUsersManagementApiGetUserSecurityRequest {
  /**
   * User ID
   * @type {any}
   * @memberof BackofficeUsersManagementApiGetUserSecurity
   */
  readonly userId: any;
}

/**
 * Request parameters for getUsers operation in BackofficeUsersManagementApi.
 * @export
 * @interface BackofficeUsersManagementApiGetUsersRequest
 */
export interface BackofficeUsersManagementApiGetUsersRequest {
  /**
   * Search by username, email, first name, last name, phone number, or role name
   * @type {any}
   * @memberof BackofficeUsersManagementApiGetUsers
   */
  readonly search?: any;

  /**
   * Filter by user statuses: ACTIVE, INACTIVE, LOCKED
   * @type {any}
   * @memberof BackofficeUsersManagementApiGetUsers
   */
  readonly statuses?: any;

  /**
   * Filter by resource ids
   * @type {any}
   * @memberof BackofficeUsersManagementApiGetUsers
   */
  readonly resourceIds?: any;

  /**
   * Filter by created date from (inclusive)
   * @type {any}
   * @memberof BackofficeUsersManagementApiGetUsers
   */
  readonly createdDateFrom?: any;

  /**
   * Filter by created date to (inclusive)
   * @type {any}
   * @memberof BackofficeUsersManagementApiGetUsers
   */
  readonly createdDateTo?: any;

  /**
   * Zero-based page index (0..N)
   * @type {any}
   * @memberof BackofficeUsersManagementApiGetUsers
   */
  readonly page?: any;

  /**
   * The size of the page to be returned
   * @type {any}
   * @memberof BackofficeUsersManagementApiGetUsers
   */
  readonly size?: any;

  /**
   * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
   * @type {any}
   * @memberof BackofficeUsersManagementApiGetUsers
   */
  readonly sort?: any;
}

/**
 * Request parameters for lockUser operation in BackofficeUsersManagementApi.
 * @export
 * @interface BackofficeUsersManagementApiLockUserRequest
 */
export interface BackofficeUsersManagementApiLockUserRequest {
  /**
   * User ID
   * @type {any}
   * @memberof BackofficeUsersManagementApiLockUser
   */
  readonly userId: any;
}

/**
 * Request parameters for unlockUser operation in BackofficeUsersManagementApi.
 * @export
 * @interface BackofficeUsersManagementApiUnlockUserRequest
 */
export interface BackofficeUsersManagementApiUnlockUserRequest {
  /**
   * User ID
   * @type {any}
   * @memberof BackofficeUsersManagementApiUnlockUser
   */
  readonly userId: any;
}

/**
 * Request parameters for updateUser operation in BackofficeUsersManagementApi.
 * @export
 * @interface BackofficeUsersManagementApiUpdateUserRequest
 */
export interface BackofficeUsersManagementApiUpdateUserRequest {
  /**
   * User ID
   * @type {any}
   * @memberof BackofficeUsersManagementApiUpdateUser
   */
  readonly userId: any;

  /**
   *
   * @type {BoUpdateUserRequest}
   * @memberof BackofficeUsersManagementApiUpdateUser
   */
  readonly boUpdateUserRequest: BoUpdateUserRequest;
}

/**
 * BackofficeUsersManagementApi - object-oriented interface
 * @export
 * @class BackofficeUsersManagementApi
 * @extends {BaseAPI}
 */
export class BackofficeUsersManagementApi extends BaseAPI {
  /**
   * Admin đặt lại mật khẩu cho người dùng. Tất cả phiên đăng nhập hiện tại sẽ bị hủy. Thông tin đăng nhập mới được gửi qua email.  Error codes: - `user.not.found` (404) — Không tìm thấy người dùng - `failed.to.reset.password` (500) — Lỗi khi đặt lại mật khẩu
   * @summary Admin Reset Password
   * @param {BackofficeUsersManagementApiAdminResetPasswordRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeUsersManagementApi
   */
  public adminResetPassword(
    requestParameters: BackofficeUsersManagementApiAdminResetPasswordRequest,
    options?: AxiosRequestConfig,
  ) {
    return BackofficeUsersManagementApiFp(this.configuration)
      .adminResetPassword(
        requestParameters.userId,
        requestParameters.boAdminResetPasswordRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Tạo yêu cầu tạo tài khoản người dùng mới (Maker/Checker). Maker nhập Họ tên, Email, SĐT, Mật khẩu, chọn Portal và Vai trò → tạo yêu cầu phê duyệt. Sau khi Checker phê duyệt: tạo tài khoản trạng thái ACTIVE, gửi thông tin đăng nhập qua email.  Error codes: - `user.already.exists` (400) — Username đã tồn tại - `user.email.already.exists` (400) — Email đã được sử dụng     - `user.request.already.exists` (400) — Đã có yêu cầu tạo user đang chờ duyệt
   * @summary Create User
   * @param {BackofficeUsersManagementApiCreateUserRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeUsersManagementApi
   */
  public createUser(
    requestParameters: BackofficeUsersManagementApiCreateUserRequest,
    options?: AxiosRequestConfig,
  ) {
    return BackofficeUsersManagementApiFp(this.configuration)
      .createUser(requestParameters.boCreateUserRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Lấy thông tin chung của người dùng (Tab 1): Họ tên, Email, SĐT, Ngày tạo, Đăng nhập lần cuối, Thời điểm đổi mật khẩu gần nhất.  Error codes: - `user.not.found` (404) — Không tìm thấy người dùng
   * @summary Get User Info
   * @param {BackofficeUsersManagementApiGetUserInfoRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeUsersManagementApi
   */
  public getUserInfo(
    requestParameters: BackofficeUsersManagementApiGetUserInfoRequest,
    options?: AxiosRequestConfig,
  ) {
    return BackofficeUsersManagementApiFp(this.configuration)
      .getUserInfo(requestParameters.userId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Lấy chi tiết phân quyền của người dùng theo Portal (Tab 2): Tên Portal, Role Code, Role Name, Ma trận phân quyền. Một người dùng chỉ được gán một Vai trò trong mỗi Portal.
   * @summary Get User Role Groups
   * @param {BackofficeUsersManagementApiGetUserRoleGroupsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeUsersManagementApi
   */
  public getUserRoleGroups(
    requestParameters: BackofficeUsersManagementApiGetUserRoleGroupsRequest,
    options?: AxiosRequestConfig,
  ) {
    return BackofficeUsersManagementApiFp(this.configuration)
      .getUserRoleGroups(requestParameters.userId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Lấy thông tin bảo mật (Tab 3): IP đăng nhập gần nhất, Số lần đăng nhập thất bại liên tiếp, Thời điểm đổi mật khẩu gần nhất. Chỉ Super Admin thấy nút Đặt lại mật khẩu.  Error codes: - `user.not.found` (404) — Không tìm thấy người dùng
   * @summary Get User Security Info
   * @param {BackofficeUsersManagementApiGetUserSecurityRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeUsersManagementApi
   */
  public getUserSecurity(
    requestParameters: BackofficeUsersManagementApiGetUserSecurityRequest,
    options?: AxiosRequestConfig,
  ) {
    return BackofficeUsersManagementApiFp(this.configuration)
      .getUserSecurity(requestParameters.userId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Lấy danh sách người dùng backoffice có phân trang. Hỗ trợ lọc theo: Username, Họ tên, Email, SĐT, Tên vai trò, Trạng thái, Portal, khoảng ngày tạo.
   * @summary List Users
   * @param {BackofficeUsersManagementApiGetUsersRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeUsersManagementApi
   */
  public getUsers(
    requestParameters: BackofficeUsersManagementApiGetUsersRequest = {},
    options?: AxiosRequestConfig,
  ) {
    return BackofficeUsersManagementApiFp(this.configuration)
      .getUsers(
        requestParameters.search,
        requestParameters.statuses,
        requestParameters.resourceIds,
        requestParameters.createdDateFrom,
        requestParameters.createdDateTo,
        requestParameters.page,
        requestParameters.size,
        requestParameters.sort,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Gửi yêu cầu khóa tài khoản người dùng (Maker/Checker). Sau khi Checker phê duyệt: tất cả phiên đăng nhập bị hủy, người dùng không thể đăng nhập.  Error codes: - `user.not.found` (404) — Không tìm thấy người dùng - `user.already.locked` (400) — Tài khoản đã bị khóa     - `user.request.already.exists` (400) — Đã có yêu cầu khóa đang chờ duyệt
   * @summary Lock User
   * @param {BackofficeUsersManagementApiLockUserRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeUsersManagementApi
   */
  public lockUser(
    requestParameters: BackofficeUsersManagementApiLockUserRequest,
    options?: AxiosRequestConfig,
  ) {
    return BackofficeUsersManagementApiFp(this.configuration)
      .lockUser(requestParameters.userId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Gửi yêu cầu mở khóa tài khoản người dùng (Maker/Checker). Sau khi Checker phê duyệt: chuyển trạng thái LOCKED → ACTIVE, người dùng có thể đăng nhập lại.  Error codes: - `user.not.found` (404) — Không tìm thấy người dùng - `user.not.locked` (400) — Tài khoản chưa bị khóa     - `user.request.already.exists` (400) — Đã có yêu cầu mở khóa đang chờ duyệt
   * @summary Unlock User
   * @param {BackofficeUsersManagementApiUnlockUserRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeUsersManagementApi
   */
  public unlockUser(
    requestParameters: BackofficeUsersManagementApiUnlockUserRequest,
    options?: AxiosRequestConfig,
  ) {
    return BackofficeUsersManagementApiFp(this.configuration)
      .unlockUser(requestParameters.userId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Cập nhật thông tin người dùng (Họ tên, Email, SĐT, Portal, Vai trò) → tạo yêu cầu phê duyệt. Username, Mật khẩu, Trạng thái không được chỉnh sửa trực tiếp. Sau khi Checker phê duyệt: cập nhật thông tin, force logout nếu có thay đổi quyền.  Error codes: - `user.not.found` (404) — Không tìm thấy người dùng - `user.email.already.exists.for.another.user` (400) — Email đã được sử dụng bởi user khác     - `user.request.already.exists` (400) — Đã có yêu cầu cập nhật đang chờ duyệt
   * @summary Update User
   * @param {BackofficeUsersManagementApiUpdateUserRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BackofficeUsersManagementApi
   */
  public updateUser(
    requestParameters: BackofficeUsersManagementApiUpdateUserRequest,
    options?: AxiosRequestConfig,
  ) {
    return BackofficeUsersManagementApiFp(this.configuration)
      .updateUser(
        requestParameters.userId,
        requestParameters.boUpdateUserRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * EndUserAuthenticationApi - axios parameter creator
 * @export
 */
export const EndUserAuthenticationApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Authenticate end users with phone number and password
     * @summary End User Login
     * @param {EndUserAuthRequest} endUserAuthRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    login1: async (
      endUserAuthRequest: EndUserAuthRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'endUserAuthRequest' is not null or undefined
      assertParamExists("login1", "endUserAuthRequest", endUserAuthRequest);
      const localVarPath = `/api/v1/auth/login`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        endUserAuthRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Invalidate end user sessions and tokens
     * @summary End User Logout
     * @param {LogoutRequest} [logoutRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    logout1: async (
      logoutRequest?: LogoutRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/auth/logout`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        logoutRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Refresh end user access tokens using refresh tokens
     * @summary Refresh Access Token
     * @param {RefreshTokenRequest} refreshTokenRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    refresh1: async (
      refreshTokenRequest: RefreshTokenRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'refreshTokenRequest' is not null or undefined
      assertParamExists("refresh1", "refreshTokenRequest", refreshTokenRequest);
      const localVarPath = `/api/v1/auth/refresh`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        refreshTokenRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Resend OTP for login MFA verification. Subject to 60-second cooldown and max 3 send attempts.
     * @summary Resend Login OTP
     * @param {EndUserResendLoginOtpRequest} endUserResendLoginOtpRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resendLoginOtp: async (
      endUserResendLoginOtpRequest: EndUserResendLoginOtpRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'endUserResendLoginOtpRequest' is not null or undefined
      assertParamExists(
        "resendLoginOtp",
        "endUserResendLoginOtpRequest",
        endUserResendLoginOtpRequest,
      );
      const localVarPath = `/api/v1/auth/login/resend-otp`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        endUserResendLoginOtpRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * EndUserAuthenticationApi - functional programming interface
 * @export
 */
export const EndUserAuthenticationApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    EndUserAuthenticationApiAxiosParamCreator(configuration);
  return {
    /**
     * Authenticate end users with phone number and password
     * @summary End User Login
     * @param {EndUserAuthRequest} endUserAuthRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async login1(
      endUserAuthRequest: EndUserAuthRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<EndUserAuthResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.login1(
        endUserAuthRequest,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Invalidate end user sessions and tokens
     * @summary End User Logout
     * @param {LogoutRequest} [logoutRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async logout1(
      logoutRequest?: LogoutRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.logout1(
        logoutRequest,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Refresh end user access tokens using refresh tokens
     * @summary Refresh Access Token
     * @param {RefreshTokenRequest} refreshTokenRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async refresh1(
      refreshTokenRequest: RefreshTokenRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<EndUserAuthResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.refresh1(
        refreshTokenRequest,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Resend OTP for login MFA verification. Subject to 60-second cooldown and max 3 send attempts.
     * @summary Resend Login OTP
     * @param {EndUserResendLoginOtpRequest} endUserResendLoginOtpRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async resendLoginOtp(
      endUserResendLoginOtpRequest: EndUserResendLoginOtpRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<EndUserResendOtpResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.resendLoginOtp(
        endUserResendLoginOtpRequest,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
  };
};

/**
 * EndUserAuthenticationApi - factory interface
 * @export
 */
export const EndUserAuthenticationApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = EndUserAuthenticationApiFp(configuration);
  return {
    /**
     * Authenticate end users with phone number and password
     * @summary End User Login
     * @param {EndUserAuthRequest} endUserAuthRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    login1(
      endUserAuthRequest: EndUserAuthRequest,
      options?: any,
    ): AxiosPromise<EndUserAuthResponse> {
      return localVarFp
        .login1(endUserAuthRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Invalidate end user sessions and tokens
     * @summary End User Logout
     * @param {LogoutRequest} [logoutRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    logout1(logoutRequest?: LogoutRequest, options?: any): AxiosPromise<void> {
      return localVarFp
        .logout1(logoutRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Refresh end user access tokens using refresh tokens
     * @summary Refresh Access Token
     * @param {RefreshTokenRequest} refreshTokenRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    refresh1(
      refreshTokenRequest: RefreshTokenRequest,
      options?: any,
    ): AxiosPromise<EndUserAuthResponse> {
      return localVarFp
        .refresh1(refreshTokenRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Resend OTP for login MFA verification. Subject to 60-second cooldown and max 3 send attempts.
     * @summary Resend Login OTP
     * @param {EndUserResendLoginOtpRequest} endUserResendLoginOtpRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resendLoginOtp(
      endUserResendLoginOtpRequest: EndUserResendLoginOtpRequest,
      options?: any,
    ): AxiosPromise<EndUserResendOtpResponse> {
      return localVarFp
        .resendLoginOtp(endUserResendLoginOtpRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for login1 operation in EndUserAuthenticationApi.
 * @export
 * @interface EndUserAuthenticationApiLogin1Request
 */
export interface EndUserAuthenticationApiLogin1Request {
  /**
   *
   * @type {EndUserAuthRequest}
   * @memberof EndUserAuthenticationApiLogin1
   */
  readonly endUserAuthRequest: EndUserAuthRequest;
}

/**
 * Request parameters for logout1 operation in EndUserAuthenticationApi.
 * @export
 * @interface EndUserAuthenticationApiLogout1Request
 */
export interface EndUserAuthenticationApiLogout1Request {
  /**
   *
   * @type {LogoutRequest}
   * @memberof EndUserAuthenticationApiLogout1
   */
  readonly logoutRequest?: LogoutRequest;
}

/**
 * Request parameters for refresh1 operation in EndUserAuthenticationApi.
 * @export
 * @interface EndUserAuthenticationApiRefresh1Request
 */
export interface EndUserAuthenticationApiRefresh1Request {
  /**
   *
   * @type {RefreshTokenRequest}
   * @memberof EndUserAuthenticationApiRefresh1
   */
  readonly refreshTokenRequest: RefreshTokenRequest;
}

/**
 * Request parameters for resendLoginOtp operation in EndUserAuthenticationApi.
 * @export
 * @interface EndUserAuthenticationApiResendLoginOtpRequest
 */
export interface EndUserAuthenticationApiResendLoginOtpRequest {
  /**
   *
   * @type {EndUserResendLoginOtpRequest}
   * @memberof EndUserAuthenticationApiResendLoginOtp
   */
  readonly endUserResendLoginOtpRequest: EndUserResendLoginOtpRequest;
}

/**
 * EndUserAuthenticationApi - object-oriented interface
 * @export
 * @class EndUserAuthenticationApi
 * @extends {BaseAPI}
 */
export class EndUserAuthenticationApi extends BaseAPI {
  /**
   * Authenticate end users with phone number and password
   * @summary End User Login
   * @param {EndUserAuthenticationApiLogin1Request} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EndUserAuthenticationApi
   */
  public login1(
    requestParameters: EndUserAuthenticationApiLogin1Request,
    options?: AxiosRequestConfig,
  ) {
    return EndUserAuthenticationApiFp(this.configuration)
      .login1(requestParameters.endUserAuthRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Invalidate end user sessions and tokens
   * @summary End User Logout
   * @param {EndUserAuthenticationApiLogout1Request} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EndUserAuthenticationApi
   */
  public logout1(
    requestParameters: EndUserAuthenticationApiLogout1Request = {},
    options?: AxiosRequestConfig,
  ) {
    return EndUserAuthenticationApiFp(this.configuration)
      .logout1(requestParameters.logoutRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Refresh end user access tokens using refresh tokens
   * @summary Refresh Access Token
   * @param {EndUserAuthenticationApiRefresh1Request} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EndUserAuthenticationApi
   */
  public refresh1(
    requestParameters: EndUserAuthenticationApiRefresh1Request,
    options?: AxiosRequestConfig,
  ) {
    return EndUserAuthenticationApiFp(this.configuration)
      .refresh1(requestParameters.refreshTokenRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Resend OTP for login MFA verification. Subject to 60-second cooldown and max 3 send attempts.
   * @summary Resend Login OTP
   * @param {EndUserAuthenticationApiResendLoginOtpRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EndUserAuthenticationApi
   */
  public resendLoginOtp(
    requestParameters: EndUserAuthenticationApiResendLoginOtpRequest,
    options?: AxiosRequestConfig,
  ) {
    return EndUserAuthenticationApiFp(this.configuration)
      .resendLoginOtp(requestParameters.endUserResendLoginOtpRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * EndUserChangePasswordApi - axios parameter creator
 * @export
 */
export const EndUserChangePasswordApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Change user password directly without OTP verification.  **Flow**: Verify Current Password → Update Password → (Optional) Logout All Sessions  **Requirements**: - Bearer token (authenticated user) - Current password must be correct - New password must be different from current password - Password format: exactly 6 digits - Confirm password must match new password  **Features**: - Direct password update (no OTP required) - Optional logout from all sessions (default: true) - Automatic session invalidation when logoutAllSessions=true  **Rate Limiting**: 5 attempts per 15 minutes
     * @summary Change Password (Direct Update)
     * @param {ChangePasswordRequest} changePasswordRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    changePassword1: async (
      changePasswordRequest: ChangePasswordRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'changePasswordRequest' is not null or undefined
      assertParamExists(
        "changePassword1",
        "changePasswordRequest",
        changePasswordRequest,
      );
      const localVarPath = `/api/v1/users/change-password`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        changePasswordRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * EndUserChangePasswordApi - functional programming interface
 * @export
 */
export const EndUserChangePasswordApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    EndUserChangePasswordApiAxiosParamCreator(configuration);
  return {
    /**
     * Change user password directly without OTP verification.  **Flow**: Verify Current Password → Update Password → (Optional) Logout All Sessions  **Requirements**: - Bearer token (authenticated user) - Current password must be correct - New password must be different from current password - Password format: exactly 6 digits - Confirm password must match new password  **Features**: - Direct password update (no OTP required) - Optional logout from all sessions (default: true) - Automatic session invalidation when logoutAllSessions=true  **Rate Limiting**: 5 attempts per 15 minutes
     * @summary Change Password (Direct Update)
     * @param {ChangePasswordRequest} changePasswordRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async changePassword1(
      changePasswordRequest: ChangePasswordRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<ChangePasswordResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.changePassword1(
        changePasswordRequest,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
  };
};

/**
 * EndUserChangePasswordApi - factory interface
 * @export
 */
export const EndUserChangePasswordApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = EndUserChangePasswordApiFp(configuration);
  return {
    /**
     * Change user password directly without OTP verification.  **Flow**: Verify Current Password → Update Password → (Optional) Logout All Sessions  **Requirements**: - Bearer token (authenticated user) - Current password must be correct - New password must be different from current password - Password format: exactly 6 digits - Confirm password must match new password  **Features**: - Direct password update (no OTP required) - Optional logout from all sessions (default: true) - Automatic session invalidation when logoutAllSessions=true  **Rate Limiting**: 5 attempts per 15 minutes
     * @summary Change Password (Direct Update)
     * @param {ChangePasswordRequest} changePasswordRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    changePassword1(
      changePasswordRequest: ChangePasswordRequest,
      options?: any,
    ): AxiosPromise<ChangePasswordResponse> {
      return localVarFp
        .changePassword1(changePasswordRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for changePassword1 operation in EndUserChangePasswordApi.
 * @export
 * @interface EndUserChangePasswordApiChangePassword1Request
 */
export interface EndUserChangePasswordApiChangePassword1Request {
  /**
   *
   * @type {ChangePasswordRequest}
   * @memberof EndUserChangePasswordApiChangePassword1
   */
  readonly changePasswordRequest: ChangePasswordRequest;
}

/**
 * EndUserChangePasswordApi - object-oriented interface
 * @export
 * @class EndUserChangePasswordApi
 * @extends {BaseAPI}
 */
export class EndUserChangePasswordApi extends BaseAPI {
  /**
   * Change user password directly without OTP verification.  **Flow**: Verify Current Password → Update Password → (Optional) Logout All Sessions  **Requirements**: - Bearer token (authenticated user) - Current password must be correct - New password must be different from current password - Password format: exactly 6 digits - Confirm password must match new password  **Features**: - Direct password update (no OTP required) - Optional logout from all sessions (default: true) - Automatic session invalidation when logoutAllSessions=true  **Rate Limiting**: 5 attempts per 15 minutes
   * @summary Change Password (Direct Update)
   * @param {EndUserChangePasswordApiChangePassword1Request} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EndUserChangePasswordApi
   */
  public changePassword1(
    requestParameters: EndUserChangePasswordApiChangePassword1Request,
    options?: AxiosRequestConfig,
  ) {
    return EndUserChangePasswordApiFp(this.configuration)
      .changePassword1(requestParameters.changePasswordRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * EndUserForgotPasswordApi - axios parameter creator
 * @export
 */
export const EndUserForgotPasswordApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Send OTP via SMS to the registered phone number. Maximum 3 send attempts per hour with 60-second cooldown between sends.  Error codes: - `auth.otp.temporarily.locked` (400) — Temporarily locked due to too many invalid OTP attempts
     * @summary Initiate Forgot Password
     * @param {EndUserForgotPasswordRequest} endUserForgotPasswordRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    initiateForgotPassword: async (
      endUserForgotPasswordRequest: EndUserForgotPasswordRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'endUserForgotPasswordRequest' is not null or undefined
      assertParamExists(
        "initiateForgotPassword",
        "endUserForgotPasswordRequest",
        endUserForgotPasswordRequest,
      );
      const localVarPath = `/api/v1/auth/forgot-password`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        endUserForgotPasswordRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Resend OTP via SMS. Subject to same rate limits as initial send (60-second cooldown, max 3 attempts).  Error codes:     - `auth.otp.send.rate.limited` (400) — Cooldown not elapsed - `auth.otp.temporarily.locked` (400) — Temporarily locked due to too many invalid OTP attempts
     * @summary Resend OTP
     * @param {EndUserResendOtpRequest} endUserResendOtpRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resendOtp2: async (
      endUserResendOtpRequest: EndUserResendOtpRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'endUserResendOtpRequest' is not null or undefined
      assertParamExists(
        "resendOtp2",
        "endUserResendOtpRequest",
        endUserResendOtpRequest,
      );
      const localVarPath = `/api/v1/auth/forgot-password/resend-otp`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        endUserResendOtpRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Set a new password using the verifiedOtpCredential from verify-otp step. Password must be exactly 6 digits. The credential is single-use and expires in 10 minutes.
     * @summary Reset Password
     * @param {EndUserResetPasswordRequest} endUserResetPasswordRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resetPassword1: async (
      endUserResetPasswordRequest: EndUserResetPasswordRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'endUserResetPasswordRequest' is not null or undefined
      assertParamExists(
        "resetPassword1",
        "endUserResetPasswordRequest",
        endUserResetPasswordRequest,
      );
      const localVarPath = `/api/v1/auth/forgot-password/reset-password`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        endUserResetPasswordRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Verify the OTP received via SMS. Returns a verifiedOtpCredential token valid for 10 minutes (single-use). Maximum 5 verification attempts.  Error codes: - `auth.invalid.otp` (400) — Invalid OTP, params[0] = remaining attempts - `auth.otp.has.expired` (400) — OTP has expired - `auth.exceeded.maximum.otp.verification.attempts` (400) — Exceeded max verification attempts - `auth.otp.temporarily.locked` (400) — Temporarily locked due to too many invalid OTP attempts
     * @summary Verify OTP
     * @param {EndUserVerifyOtpRequest} endUserVerifyOtpRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    verifyOtp3: async (
      endUserVerifyOtpRequest: EndUserVerifyOtpRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'endUserVerifyOtpRequest' is not null or undefined
      assertParamExists(
        "verifyOtp3",
        "endUserVerifyOtpRequest",
        endUserVerifyOtpRequest,
      );
      const localVarPath = `/api/v1/auth/forgot-password/verify-otp`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        endUserVerifyOtpRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * EndUserForgotPasswordApi - functional programming interface
 * @export
 */
export const EndUserForgotPasswordApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    EndUserForgotPasswordApiAxiosParamCreator(configuration);
  return {
    /**
     * Send OTP via SMS to the registered phone number. Maximum 3 send attempts per hour with 60-second cooldown between sends.  Error codes: - `auth.otp.temporarily.locked` (400) — Temporarily locked due to too many invalid OTP attempts
     * @summary Initiate Forgot Password
     * @param {EndUserForgotPasswordRequest} endUserForgotPasswordRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async initiateForgotPassword(
      endUserForgotPasswordRequest: EndUserForgotPasswordRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<EndUserForgotPasswordResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.initiateForgotPassword(
          endUserForgotPasswordRequest,
          options,
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Resend OTP via SMS. Subject to same rate limits as initial send (60-second cooldown, max 3 attempts).  Error codes:     - `auth.otp.send.rate.limited` (400) — Cooldown not elapsed - `auth.otp.temporarily.locked` (400) — Temporarily locked due to too many invalid OTP attempts
     * @summary Resend OTP
     * @param {EndUserResendOtpRequest} endUserResendOtpRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async resendOtp2(
      endUserResendOtpRequest: EndUserResendOtpRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<EndUserResendOtpResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.resendOtp2(
        endUserResendOtpRequest,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Set a new password using the verifiedOtpCredential from verify-otp step. Password must be exactly 6 digits. The credential is single-use and expires in 10 minutes.
     * @summary Reset Password
     * @param {EndUserResetPasswordRequest} endUserResetPasswordRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async resetPassword1(
      endUserResetPasswordRequest: EndUserResetPasswordRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<EndUserResetPasswordResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.resetPassword1(
        endUserResetPasswordRequest,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Verify the OTP received via SMS. Returns a verifiedOtpCredential token valid for 10 minutes (single-use). Maximum 5 verification attempts.  Error codes: - `auth.invalid.otp` (400) — Invalid OTP, params[0] = remaining attempts - `auth.otp.has.expired` (400) — OTP has expired - `auth.exceeded.maximum.otp.verification.attempts` (400) — Exceeded max verification attempts - `auth.otp.temporarily.locked` (400) — Temporarily locked due to too many invalid OTP attempts
     * @summary Verify OTP
     * @param {EndUserVerifyOtpRequest} endUserVerifyOtpRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async verifyOtp3(
      endUserVerifyOtpRequest: EndUserVerifyOtpRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<EndUserVerifyOtpResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.verifyOtp3(
        endUserVerifyOtpRequest,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
  };
};

/**
 * EndUserForgotPasswordApi - factory interface
 * @export
 */
export const EndUserForgotPasswordApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = EndUserForgotPasswordApiFp(configuration);
  return {
    /**
     * Send OTP via SMS to the registered phone number. Maximum 3 send attempts per hour with 60-second cooldown between sends.  Error codes: - `auth.otp.temporarily.locked` (400) — Temporarily locked due to too many invalid OTP attempts
     * @summary Initiate Forgot Password
     * @param {EndUserForgotPasswordRequest} endUserForgotPasswordRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    initiateForgotPassword(
      endUserForgotPasswordRequest: EndUserForgotPasswordRequest,
      options?: any,
    ): AxiosPromise<EndUserForgotPasswordResponse> {
      return localVarFp
        .initiateForgotPassword(endUserForgotPasswordRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Resend OTP via SMS. Subject to same rate limits as initial send (60-second cooldown, max 3 attempts).  Error codes:     - `auth.otp.send.rate.limited` (400) — Cooldown not elapsed - `auth.otp.temporarily.locked` (400) — Temporarily locked due to too many invalid OTP attempts
     * @summary Resend OTP
     * @param {EndUserResendOtpRequest} endUserResendOtpRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resendOtp2(
      endUserResendOtpRequest: EndUserResendOtpRequest,
      options?: any,
    ): AxiosPromise<EndUserResendOtpResponse> {
      return localVarFp
        .resendOtp2(endUserResendOtpRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Set a new password using the verifiedOtpCredential from verify-otp step. Password must be exactly 6 digits. The credential is single-use and expires in 10 minutes.
     * @summary Reset Password
     * @param {EndUserResetPasswordRequest} endUserResetPasswordRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resetPassword1(
      endUserResetPasswordRequest: EndUserResetPasswordRequest,
      options?: any,
    ): AxiosPromise<EndUserResetPasswordResponse> {
      return localVarFp
        .resetPassword1(endUserResetPasswordRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Verify the OTP received via SMS. Returns a verifiedOtpCredential token valid for 10 minutes (single-use). Maximum 5 verification attempts.  Error codes: - `auth.invalid.otp` (400) — Invalid OTP, params[0] = remaining attempts - `auth.otp.has.expired` (400) — OTP has expired - `auth.exceeded.maximum.otp.verification.attempts` (400) — Exceeded max verification attempts - `auth.otp.temporarily.locked` (400) — Temporarily locked due to too many invalid OTP attempts
     * @summary Verify OTP
     * @param {EndUserVerifyOtpRequest} endUserVerifyOtpRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    verifyOtp3(
      endUserVerifyOtpRequest: EndUserVerifyOtpRequest,
      options?: any,
    ): AxiosPromise<EndUserVerifyOtpResponse> {
      return localVarFp
        .verifyOtp3(endUserVerifyOtpRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for initiateForgotPassword operation in EndUserForgotPasswordApi.
 * @export
 * @interface EndUserForgotPasswordApiInitiateForgotPasswordRequest
 */
export interface EndUserForgotPasswordApiInitiateForgotPasswordRequest {
  /**
   *
   * @type {EndUserForgotPasswordRequest}
   * @memberof EndUserForgotPasswordApiInitiateForgotPassword
   */
  readonly endUserForgotPasswordRequest: EndUserForgotPasswordRequest;
}

/**
 * Request parameters for resendOtp2 operation in EndUserForgotPasswordApi.
 * @export
 * @interface EndUserForgotPasswordApiResendOtp2Request
 */
export interface EndUserForgotPasswordApiResendOtp2Request {
  /**
   *
   * @type {EndUserResendOtpRequest}
   * @memberof EndUserForgotPasswordApiResendOtp2
   */
  readonly endUserResendOtpRequest: EndUserResendOtpRequest;
}

/**
 * Request parameters for resetPassword1 operation in EndUserForgotPasswordApi.
 * @export
 * @interface EndUserForgotPasswordApiResetPassword1Request
 */
export interface EndUserForgotPasswordApiResetPassword1Request {
  /**
   *
   * @type {EndUserResetPasswordRequest}
   * @memberof EndUserForgotPasswordApiResetPassword1
   */
  readonly endUserResetPasswordRequest: EndUserResetPasswordRequest;
}

/**
 * Request parameters for verifyOtp3 operation in EndUserForgotPasswordApi.
 * @export
 * @interface EndUserForgotPasswordApiVerifyOtp3Request
 */
export interface EndUserForgotPasswordApiVerifyOtp3Request {
  /**
   *
   * @type {EndUserVerifyOtpRequest}
   * @memberof EndUserForgotPasswordApiVerifyOtp3
   */
  readonly endUserVerifyOtpRequest: EndUserVerifyOtpRequest;
}

/**
 * EndUserForgotPasswordApi - object-oriented interface
 * @export
 * @class EndUserForgotPasswordApi
 * @extends {BaseAPI}
 */
export class EndUserForgotPasswordApi extends BaseAPI {
  /**
   * Send OTP via SMS to the registered phone number. Maximum 3 send attempts per hour with 60-second cooldown between sends.  Error codes: - `auth.otp.temporarily.locked` (400) — Temporarily locked due to too many invalid OTP attempts
   * @summary Initiate Forgot Password
   * @param {EndUserForgotPasswordApiInitiateForgotPasswordRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EndUserForgotPasswordApi
   */
  public initiateForgotPassword(
    requestParameters: EndUserForgotPasswordApiInitiateForgotPasswordRequest,
    options?: AxiosRequestConfig,
  ) {
    return EndUserForgotPasswordApiFp(this.configuration)
      .initiateForgotPassword(
        requestParameters.endUserForgotPasswordRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Resend OTP via SMS. Subject to same rate limits as initial send (60-second cooldown, max 3 attempts).  Error codes:     - `auth.otp.send.rate.limited` (400) — Cooldown not elapsed - `auth.otp.temporarily.locked` (400) — Temporarily locked due to too many invalid OTP attempts
   * @summary Resend OTP
   * @param {EndUserForgotPasswordApiResendOtp2Request} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EndUserForgotPasswordApi
   */
  public resendOtp2(
    requestParameters: EndUserForgotPasswordApiResendOtp2Request,
    options?: AxiosRequestConfig,
  ) {
    return EndUserForgotPasswordApiFp(this.configuration)
      .resendOtp2(requestParameters.endUserResendOtpRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Set a new password using the verifiedOtpCredential from verify-otp step. Password must be exactly 6 digits. The credential is single-use and expires in 10 minutes.
   * @summary Reset Password
   * @param {EndUserForgotPasswordApiResetPassword1Request} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EndUserForgotPasswordApi
   */
  public resetPassword1(
    requestParameters: EndUserForgotPasswordApiResetPassword1Request,
    options?: AxiosRequestConfig,
  ) {
    return EndUserForgotPasswordApiFp(this.configuration)
      .resetPassword1(requestParameters.endUserResetPasswordRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Verify the OTP received via SMS. Returns a verifiedOtpCredential token valid for 10 minutes (single-use). Maximum 5 verification attempts.  Error codes: - `auth.invalid.otp` (400) — Invalid OTP, params[0] = remaining attempts - `auth.otp.has.expired` (400) — OTP has expired - `auth.exceeded.maximum.otp.verification.attempts` (400) — Exceeded max verification attempts - `auth.otp.temporarily.locked` (400) — Temporarily locked due to too many invalid OTP attempts
   * @summary Verify OTP
   * @param {EndUserForgotPasswordApiVerifyOtp3Request} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EndUserForgotPasswordApi
   */
  public verifyOtp3(
    requestParameters: EndUserForgotPasswordApiVerifyOtp3Request,
    options?: AxiosRequestConfig,
  ) {
    return EndUserForgotPasswordApiFp(this.configuration)
      .verifyOtp3(requestParameters.endUserVerifyOtpRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * EndUserTransactionAuthApi - axios parameter creator
 * @export
 */
export const EndUserTransactionAuthApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Verify a single step in the transaction auth flow. App calls this for each step in the steps[] array.
     * @summary Verify transaction auth step
     * @param {TxnAuthVerifyRequest} txnAuthVerifyRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    verify: async (
      txnAuthVerifyRequest: TxnAuthVerifyRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'txnAuthVerifyRequest' is not null or undefined
      assertParamExists("verify", "txnAuthVerifyRequest", txnAuthVerifyRequest);
      const localVarPath = `/api/v1/transaction-auth/verify`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        txnAuthVerifyRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * EndUserTransactionAuthApi - functional programming interface
 * @export
 */
export const EndUserTransactionAuthApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    EndUserTransactionAuthApiAxiosParamCreator(configuration);
  return {
    /**
     * Verify a single step in the transaction auth flow. App calls this for each step in the steps[] array.
     * @summary Verify transaction auth step
     * @param {TxnAuthVerifyRequest} txnAuthVerifyRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async verify(
      txnAuthVerifyRequest: TxnAuthVerifyRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<TxnAuthVerifyResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.verify(
        txnAuthVerifyRequest,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
  };
};

/**
 * EndUserTransactionAuthApi - factory interface
 * @export
 */
export const EndUserTransactionAuthApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = EndUserTransactionAuthApiFp(configuration);
  return {
    /**
     * Verify a single step in the transaction auth flow. App calls this for each step in the steps[] array.
     * @summary Verify transaction auth step
     * @param {TxnAuthVerifyRequest} txnAuthVerifyRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    verify(
      txnAuthVerifyRequest: TxnAuthVerifyRequest,
      options?: any,
    ): AxiosPromise<TxnAuthVerifyResponse> {
      return localVarFp
        .verify(txnAuthVerifyRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for verify operation in EndUserTransactionAuthApi.
 * @export
 * @interface EndUserTransactionAuthApiVerifyRequest
 */
export interface EndUserTransactionAuthApiVerifyRequest {
  /**
   *
   * @type {TxnAuthVerifyRequest}
   * @memberof EndUserTransactionAuthApiVerify
   */
  readonly txnAuthVerifyRequest: TxnAuthVerifyRequest;
}

/**
 * EndUserTransactionAuthApi - object-oriented interface
 * @export
 * @class EndUserTransactionAuthApi
 * @extends {BaseAPI}
 */
export class EndUserTransactionAuthApi extends BaseAPI {
  /**
   * Verify a single step in the transaction auth flow. App calls this for each step in the steps[] array.
   * @summary Verify transaction auth step
   * @param {EndUserTransactionAuthApiVerifyRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EndUserTransactionAuthApi
   */
  public verify(
    requestParameters: EndUserTransactionAuthApiVerifyRequest,
    options?: AxiosRequestConfig,
  ) {
    return EndUserTransactionAuthApiFp(this.configuration)
      .verify(requestParameters.txnAuthVerifyRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * EndUserUsersManagementApi - axios parameter creator
 * @export
 */
export const EndUserUsersManagementApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Retrieve profile information for end users
     * @summary Get End User Profile
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProfile: async (
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/users/profile`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Update profile information for end users
     * @summary Update End User Profile
     * @param {UpdateProfileRequest} updateProfileRequest
     * @param {any} [xForwardedFor]
     * @param {any} [userAgent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateProfile: async (
      updateProfileRequest: UpdateProfileRequest,
      xForwardedFor?: any,
      userAgent?: any,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'updateProfileRequest' is not null or undefined
      assertParamExists(
        "updateProfile",
        "updateProfileRequest",
        updateProfileRequest,
      );
      const localVarPath = `/api/v1/users`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      if (xForwardedFor != null) {
        localVarHeaderParameter["X-Forwarded-For"] =
          typeof xForwardedFor === "string"
            ? xForwardedFor
            : JSON.stringify(xForwardedFor);
      }

      if (userAgent != null) {
        localVarHeaderParameter["User-Agent"] =
          typeof userAgent === "string" ? userAgent : JSON.stringify(userAgent);
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateProfileRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * EndUserUsersManagementApi - functional programming interface
 * @export
 */
export const EndUserUsersManagementApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    EndUserUsersManagementApiAxiosParamCreator(configuration);
  return {
    /**
     * Retrieve profile information for end users
     * @summary Get End User Profile
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getProfile(
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<UserInfoResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getProfile(options);
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Update profile information for end users
     * @summary Update End User Profile
     * @param {UpdateProfileRequest} updateProfileRequest
     * @param {any} [xForwardedFor]
     * @param {any} [userAgent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateProfile(
      updateProfileRequest: UpdateProfileRequest,
      xForwardedFor?: any,
      userAgent?: any,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<UpdateProfileResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateProfile(
        updateProfileRequest,
        xForwardedFor,
        userAgent,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
  };
};

/**
 * EndUserUsersManagementApi - factory interface
 * @export
 */
export const EndUserUsersManagementApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = EndUserUsersManagementApiFp(configuration);
  return {
    /**
     * Retrieve profile information for end users
     * @summary Get End User Profile
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProfile(options?: any): AxiosPromise<UserInfoResponse> {
      return localVarFp
        .getProfile(options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Update profile information for end users
     * @summary Update End User Profile
     * @param {UpdateProfileRequest} updateProfileRequest
     * @param {any} [xForwardedFor]
     * @param {any} [userAgent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateProfile(
      updateProfileRequest: UpdateProfileRequest,
      xForwardedFor?: any,
      userAgent?: any,
      options?: any,
    ): AxiosPromise<UpdateProfileResponse> {
      return localVarFp
        .updateProfile(updateProfileRequest, xForwardedFor, userAgent, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for updateProfile operation in EndUserUsersManagementApi.
 * @export
 * @interface EndUserUsersManagementApiUpdateProfileRequest
 */
export interface EndUserUsersManagementApiUpdateProfileRequest {
  /**
   *
   * @type {UpdateProfileRequest}
   * @memberof EndUserUsersManagementApiUpdateProfile
   */
  readonly updateProfileRequest: UpdateProfileRequest;

  /**
   *
   * @type {any}
   * @memberof EndUserUsersManagementApiUpdateProfile
   */
  readonly xForwardedFor?: any;

  /**
   *
   * @type {any}
   * @memberof EndUserUsersManagementApiUpdateProfile
   */
  readonly userAgent?: any;
}

/**
 * EndUserUsersManagementApi - object-oriented interface
 * @export
 * @class EndUserUsersManagementApi
 * @extends {BaseAPI}
 */
export class EndUserUsersManagementApi extends BaseAPI {
  /**
   * Retrieve profile information for end users
   * @summary Get End User Profile
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EndUserUsersManagementApi
   */
  public getProfile(options?: AxiosRequestConfig) {
    return EndUserUsersManagementApiFp(this.configuration)
      .getProfile(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Update profile information for end users
   * @summary Update End User Profile
   * @param {EndUserUsersManagementApiUpdateProfileRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EndUserUsersManagementApi
   */
  public updateProfile(
    requestParameters: EndUserUsersManagementApiUpdateProfileRequest,
    options?: AxiosRequestConfig,
  ) {
    return EndUserUsersManagementApiFp(this.configuration)
      .updateProfile(
        requestParameters.updateProfileRequest,
        requestParameters.xForwardedFor,
        requestParameters.userAgent,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * EndUserVerifyPasswordApi - axios parameter creator
 * @export
 */
export const EndUserVerifyPasswordApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Verify the user\'s current password. Used before change PIN, enable Smart OTP, etc. 5 consecutive wrong attempts locks this feature for 30 minutes.
     * @summary Verify Password
     * @param {VerifyPasswordRequest} verifyPasswordRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    verifyPassword: async (
      verifyPasswordRequest: VerifyPasswordRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'verifyPasswordRequest' is not null or undefined
      assertParamExists(
        "verifyPassword",
        "verifyPasswordRequest",
        verifyPasswordRequest,
      );
      const localVarPath = `/api/v1/users/verify-password`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        verifyPasswordRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * EndUserVerifyPasswordApi - functional programming interface
 * @export
 */
export const EndUserVerifyPasswordApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    EndUserVerifyPasswordApiAxiosParamCreator(configuration);
  return {
    /**
     * Verify the user\'s current password. Used before change PIN, enable Smart OTP, etc. 5 consecutive wrong attempts locks this feature for 30 minutes.
     * @summary Verify Password
     * @param {VerifyPasswordRequest} verifyPasswordRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async verifyPassword(
      verifyPasswordRequest: VerifyPasswordRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<VerifyPasswordResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.verifyPassword(
        verifyPasswordRequest,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
  };
};

/**
 * EndUserVerifyPasswordApi - factory interface
 * @export
 */
export const EndUserVerifyPasswordApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = EndUserVerifyPasswordApiFp(configuration);
  return {
    /**
     * Verify the user\'s current password. Used before change PIN, enable Smart OTP, etc. 5 consecutive wrong attempts locks this feature for 30 minutes.
     * @summary Verify Password
     * @param {VerifyPasswordRequest} verifyPasswordRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    verifyPassword(
      verifyPasswordRequest: VerifyPasswordRequest,
      options?: any,
    ): AxiosPromise<VerifyPasswordResponse> {
      return localVarFp
        .verifyPassword(verifyPasswordRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for verifyPassword operation in EndUserVerifyPasswordApi.
 * @export
 * @interface EndUserVerifyPasswordApiVerifyPasswordRequest
 */
export interface EndUserVerifyPasswordApiVerifyPasswordRequest {
  /**
   *
   * @type {VerifyPasswordRequest}
   * @memberof EndUserVerifyPasswordApiVerifyPassword
   */
  readonly verifyPasswordRequest: VerifyPasswordRequest;
}

/**
 * EndUserVerifyPasswordApi - object-oriented interface
 * @export
 * @class EndUserVerifyPasswordApi
 * @extends {BaseAPI}
 */
export class EndUserVerifyPasswordApi extends BaseAPI {
  /**
   * Verify the user\'s current password. Used before change PIN, enable Smart OTP, etc. 5 consecutive wrong attempts locks this feature for 30 minutes.
   * @summary Verify Password
   * @param {EndUserVerifyPasswordApiVerifyPasswordRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EndUserVerifyPasswordApi
   */
  public verifyPassword(
    requestParameters: EndUserVerifyPasswordApiVerifyPasswordRequest,
    options?: AxiosRequestConfig,
  ) {
    return EndUserVerifyPasswordApiFp(this.configuration)
      .verifyPassword(requestParameters.verifyPasswordRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * InternalMerchantCredentialApi - axios parameter creator
 * @export
 */
export const InternalMerchantCredentialApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Generates HMAC + AES keys, inserts merchant_credential row, publishes CREDENTIAL_ISSUED event. Idempotent: returns secretKey=null if active credential already exists.
     * @summary Issue M2M API credential for merchant
     * @param {IssueMerchantCredentialRequest} issueMerchantCredentialRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    issue: async (
      issueMerchantCredentialRequest: IssueMerchantCredentialRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'issueMerchantCredentialRequest' is not null or undefined
      assertParamExists(
        "issue",
        "issueMerchantCredentialRequest",
        issueMerchantCredentialRequest,
      );
      const localVarPath = `/internal/api/merchant-credentials/v1/issue`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        issueMerchantCredentialRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * InternalMerchantCredentialApi - functional programming interface
 * @export
 */
export const InternalMerchantCredentialApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    InternalMerchantCredentialApiAxiosParamCreator(configuration);
  return {
    /**
     * Generates HMAC + AES keys, inserts merchant_credential row, publishes CREDENTIAL_ISSUED event. Idempotent: returns secretKey=null if active credential already exists.
     * @summary Issue M2M API credential for merchant
     * @param {IssueMerchantCredentialRequest} issueMerchantCredentialRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async issue(
      issueMerchantCredentialRequest: IssueMerchantCredentialRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<IssueMerchantCredentialResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.issue(
        issueMerchantCredentialRequest,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
  };
};

/**
 * InternalMerchantCredentialApi - factory interface
 * @export
 */
export const InternalMerchantCredentialApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = InternalMerchantCredentialApiFp(configuration);
  return {
    /**
     * Generates HMAC + AES keys, inserts merchant_credential row, publishes CREDENTIAL_ISSUED event. Idempotent: returns secretKey=null if active credential already exists.
     * @summary Issue M2M API credential for merchant
     * @param {IssueMerchantCredentialRequest} issueMerchantCredentialRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    issue(
      issueMerchantCredentialRequest: IssueMerchantCredentialRequest,
      options?: any,
    ): AxiosPromise<IssueMerchantCredentialResponse> {
      return localVarFp
        .issue(issueMerchantCredentialRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for issue operation in InternalMerchantCredentialApi.
 * @export
 * @interface InternalMerchantCredentialApiIssueRequest
 */
export interface InternalMerchantCredentialApiIssueRequest {
  /**
   *
   * @type {IssueMerchantCredentialRequest}
   * @memberof InternalMerchantCredentialApiIssue
   */
  readonly issueMerchantCredentialRequest: IssueMerchantCredentialRequest;
}

/**
 * InternalMerchantCredentialApi - object-oriented interface
 * @export
 * @class InternalMerchantCredentialApi
 * @extends {BaseAPI}
 */
export class InternalMerchantCredentialApi extends BaseAPI {
  /**
   * Generates HMAC + AES keys, inserts merchant_credential row, publishes CREDENTIAL_ISSUED event. Idempotent: returns secretKey=null if active credential already exists.
   * @summary Issue M2M API credential for merchant
   * @param {InternalMerchantCredentialApiIssueRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InternalMerchantCredentialApi
   */
  public issue(
    requestParameters: InternalMerchantCredentialApiIssueRequest,
    options?: AxiosRequestConfig,
  ) {
    return InternalMerchantCredentialApiFp(this.configuration)
      .issue(requestParameters.issueMerchantCredentialRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * InternalMerchantUserApi - axios parameter creator
 * @export
 */
export const InternalMerchantUserApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Hard deletes Keycloak user + DB row. Used by party-ms saga rollback only.
     * @summary Delete merchant user (saga compensation)
     * @param {any} merchantUserId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    _delete: async (
      merchantUserId: any,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'merchantUserId' is not null or undefined
      assertParamExists("_delete", "merchantUserId", merchantUserId);
      const localVarPath =
        `/internal/api/merchant-users/v1/{merchantUserId}`.replace(
          `{${"merchantUserId"}}`,
          encodeURIComponent(String(merchantUserId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Creates merchant owner in Keycloak ewallet_merchant realm + DB. Idempotent: returns alreadyExists=true if email already registered under same merchant.
     * @summary Create merchant owner user
     * @param {CreateMerchantUserRequest} createMerchantUserRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    create: async (
      createMerchantUserRequest: CreateMerchantUserRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'createMerchantUserRequest' is not null or undefined
      assertParamExists(
        "create",
        "createMerchantUserRequest",
        createMerchantUserRequest,
      );
      const localVarPath = `/internal/api/merchant-users/v1`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createMerchantUserRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * InternalMerchantUserApi - functional programming interface
 * @export
 */
export const InternalMerchantUserApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    InternalMerchantUserApiAxiosParamCreator(configuration);
  return {
    /**
     * Hard deletes Keycloak user + DB row. Used by party-ms saga rollback only.
     * @summary Delete merchant user (saga compensation)
     * @param {any} merchantUserId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async _delete(
      merchantUserId: any,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator._delete(
        merchantUserId,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Creates merchant owner in Keycloak ewallet_merchant realm + DB. Idempotent: returns alreadyExists=true if email already registered under same merchant.
     * @summary Create merchant owner user
     * @param {CreateMerchantUserRequest} createMerchantUserRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async create(
      createMerchantUserRequest: CreateMerchantUserRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<CreateMerchantUserResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.create(
        createMerchantUserRequest,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
  };
};

/**
 * InternalMerchantUserApi - factory interface
 * @export
 */
export const InternalMerchantUserApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = InternalMerchantUserApiFp(configuration);
  return {
    /**
     * Hard deletes Keycloak user + DB row. Used by party-ms saga rollback only.
     * @summary Delete merchant user (saga compensation)
     * @param {any} merchantUserId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    _delete(merchantUserId: any, options?: any): AxiosPromise<void> {
      return localVarFp
        ._delete(merchantUserId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Creates merchant owner in Keycloak ewallet_merchant realm + DB. Idempotent: returns alreadyExists=true if email already registered under same merchant.
     * @summary Create merchant owner user
     * @param {CreateMerchantUserRequest} createMerchantUserRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    create(
      createMerchantUserRequest: CreateMerchantUserRequest,
      options?: any,
    ): AxiosPromise<CreateMerchantUserResponse> {
      return localVarFp
        .create(createMerchantUserRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for _delete operation in InternalMerchantUserApi.
 * @export
 * @interface InternalMerchantUserApiDeleteRequest
 */
export interface InternalMerchantUserApiDeleteRequest {
  /**
   *
   * @type {any}
   * @memberof InternalMerchantUserApiDelete
   */
  readonly merchantUserId: any;
}

/**
 * Request parameters for create operation in InternalMerchantUserApi.
 * @export
 * @interface InternalMerchantUserApiCreateRequest
 */
export interface InternalMerchantUserApiCreateRequest {
  /**
   *
   * @type {CreateMerchantUserRequest}
   * @memberof InternalMerchantUserApiCreate
   */
  readonly createMerchantUserRequest: CreateMerchantUserRequest;
}

/**
 * InternalMerchantUserApi - object-oriented interface
 * @export
 * @class InternalMerchantUserApi
 * @extends {BaseAPI}
 */
export class InternalMerchantUserApi extends BaseAPI {
  /**
   * Hard deletes Keycloak user + DB row. Used by party-ms saga rollback only.
   * @summary Delete merchant user (saga compensation)
   * @param {InternalMerchantUserApiDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InternalMerchantUserApi
   */
  public _delete(
    requestParameters: InternalMerchantUserApiDeleteRequest,
    options?: AxiosRequestConfig,
  ) {
    return InternalMerchantUserApiFp(this.configuration)
      ._delete(requestParameters.merchantUserId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Creates merchant owner in Keycloak ewallet_merchant realm + DB. Idempotent: returns alreadyExists=true if email already registered under same merchant.
   * @summary Create merchant owner user
   * @param {InternalMerchantUserApiCreateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InternalMerchantUserApi
   */
  public create(
    requestParameters: InternalMerchantUserApiCreateRequest,
    options?: AxiosRequestConfig,
  ) {
    return InternalMerchantUserApiFp(this.configuration)
      .create(requestParameters.createMerchantUserRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * InternalRegistrationApi - axios parameter creator
 * @export
 */
export const InternalRegistrationApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Register new users - Internal API only, should be called by internal services
     * @summary User Registration (Internal)
     * @param {RegisterRequest} registerRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    register: async (
      registerRequest: RegisterRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'registerRequest' is not null or undefined
      assertParamExists("register", "registerRequest", registerRequest);
      const localVarPath = `/internal/api/v1/registration/submit`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        registerRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {SendOtpRequest} sendOtpRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sendOtp: async (
      sendOtpRequest: SendOtpRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'sendOtpRequest' is not null or undefined
      assertParamExists("sendOtp", "sendOtpRequest", sendOtpRequest);
      const localVarPath = `/internal/api/v1/registration/send-otp`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        sendOtpRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {VerifyOtpRequest} verifyOtpRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    verifyOtp: async (
      verifyOtpRequest: VerifyOtpRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'verifyOtpRequest' is not null or undefined
      assertParamExists("verifyOtp", "verifyOtpRequest", verifyOtpRequest);
      const localVarPath = `/internal/api/v1/registration/verify-otp`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        verifyOtpRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * InternalRegistrationApi - functional programming interface
 * @export
 */
export const InternalRegistrationApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    InternalRegistrationApiAxiosParamCreator(configuration);
  return {
    /**
     * Register new users - Internal API only, should be called by internal services
     * @summary User Registration (Internal)
     * @param {RegisterRequest} registerRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async register(
      registerRequest: RegisterRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<EndUserAuthResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.register(
        registerRequest,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     *
     * @param {SendOtpRequest} sendOtpRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async sendOtp(
      sendOtpRequest: SendOtpRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<SendOtpResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.sendOtp(
        sendOtpRequest,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     *
     * @param {VerifyOtpRequest} verifyOtpRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async verifyOtp(
      verifyOtpRequest: VerifyOtpRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<VerifyOtpResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.verifyOtp(
        verifyOtpRequest,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
  };
};

/**
 * InternalRegistrationApi - factory interface
 * @export
 */
export const InternalRegistrationApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = InternalRegistrationApiFp(configuration);
  return {
    /**
     * Register new users - Internal API only, should be called by internal services
     * @summary User Registration (Internal)
     * @param {RegisterRequest} registerRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    register(
      registerRequest: RegisterRequest,
      options?: any,
    ): AxiosPromise<EndUserAuthResponse> {
      return localVarFp
        .register(registerRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {SendOtpRequest} sendOtpRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    sendOtp(
      sendOtpRequest: SendOtpRequest,
      options?: any,
    ): AxiosPromise<SendOtpResponse> {
      return localVarFp
        .sendOtp(sendOtpRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {VerifyOtpRequest} verifyOtpRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    verifyOtp(
      verifyOtpRequest: VerifyOtpRequest,
      options?: any,
    ): AxiosPromise<VerifyOtpResponse> {
      return localVarFp
        .verifyOtp(verifyOtpRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for register operation in InternalRegistrationApi.
 * @export
 * @interface InternalRegistrationApiRegisterRequest
 */
export interface InternalRegistrationApiRegisterRequest {
  /**
   *
   * @type {RegisterRequest}
   * @memberof InternalRegistrationApiRegister
   */
  readonly registerRequest: RegisterRequest;
}

/**
 * Request parameters for sendOtp operation in InternalRegistrationApi.
 * @export
 * @interface InternalRegistrationApiSendOtpRequest
 */
export interface InternalRegistrationApiSendOtpRequest {
  /**
   *
   * @type {SendOtpRequest}
   * @memberof InternalRegistrationApiSendOtp
   */
  readonly sendOtpRequest: SendOtpRequest;
}

/**
 * Request parameters for verifyOtp operation in InternalRegistrationApi.
 * @export
 * @interface InternalRegistrationApiVerifyOtpRequest
 */
export interface InternalRegistrationApiVerifyOtpRequest {
  /**
   *
   * @type {VerifyOtpRequest}
   * @memberof InternalRegistrationApiVerifyOtp
   */
  readonly verifyOtpRequest: VerifyOtpRequest;
}

/**
 * InternalRegistrationApi - object-oriented interface
 * @export
 * @class InternalRegistrationApi
 * @extends {BaseAPI}
 */
export class InternalRegistrationApi extends BaseAPI {
  /**
   * Register new users - Internal API only, should be called by internal services
   * @summary User Registration (Internal)
   * @param {InternalRegistrationApiRegisterRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InternalRegistrationApi
   */
  public register(
    requestParameters: InternalRegistrationApiRegisterRequest,
    options?: AxiosRequestConfig,
  ) {
    return InternalRegistrationApiFp(this.configuration)
      .register(requestParameters.registerRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {InternalRegistrationApiSendOtpRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InternalRegistrationApi
   */
  public sendOtp(
    requestParameters: InternalRegistrationApiSendOtpRequest,
    options?: AxiosRequestConfig,
  ) {
    return InternalRegistrationApiFp(this.configuration)
      .sendOtp(requestParameters.sendOtpRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {InternalRegistrationApiVerifyOtpRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InternalRegistrationApi
   */
  public verifyOtp(
    requestParameters: InternalRegistrationApiVerifyOtpRequest,
    options?: AxiosRequestConfig,
  ) {
    return InternalRegistrationApiFp(this.configuration)
      .verifyOtp(requestParameters.verifyOtpRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * InternalTransactionAuthApi - axios parameter creator
 * @export
 */
export const InternalTransactionAuthApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Called by PO to check transaction auth session status and cross-check verifyLevel.
     * @summary Get session status (Internal)
     * @param {any} verifySessionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessionStatus: async (
      verifySessionId: any,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'verifySessionId' is not null or undefined
      assertParamExists("getSessionStatus", "verifySessionId", verifySessionId);
      const localVarPath =
        `/internal/api/v1/transaction-auth/sessions/{verifySessionId}/status`.replace(
          `{${"verifySessionId"}}`,
          encodeURIComponent(String(verifySessionId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Called by wallet-ms during preview to create a transaction auth session. Returns session ID, auth method, and verification steps.
     * @summary Initiate transaction auth (Internal)
     * @param {TxnAuthInitiateRequest} txnAuthInitiateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    initiate: async (
      txnAuthInitiateRequest: TxnAuthInitiateRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'txnAuthInitiateRequest' is not null or undefined
      assertParamExists(
        "initiate",
        "txnAuthInitiateRequest",
        txnAuthInitiateRequest,
      );
      const localVarPath = `/internal/api/v1/transaction-auth/initiate`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        txnAuthInitiateRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * InternalTransactionAuthApi - functional programming interface
 * @export
 */
export const InternalTransactionAuthApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    InternalTransactionAuthApiAxiosParamCreator(configuration);
  return {
    /**
     * Called by PO to check transaction auth session status and cross-check verifyLevel.
     * @summary Get session status (Internal)
     * @param {any} verifySessionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getSessionStatus(
      verifySessionId: any,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<TxnAuthSessionStatusResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getSessionStatus(
          verifySessionId,
          options,
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Called by wallet-ms during preview to create a transaction auth session. Returns session ID, auth method, and verification steps.
     * @summary Initiate transaction auth (Internal)
     * @param {TxnAuthInitiateRequest} txnAuthInitiateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async initiate(
      txnAuthInitiateRequest: TxnAuthInitiateRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<TxnAuthInitiateResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.initiate(
        txnAuthInitiateRequest,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
  };
};

/**
 * InternalTransactionAuthApi - factory interface
 * @export
 */
export const InternalTransactionAuthApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = InternalTransactionAuthApiFp(configuration);
  return {
    /**
     * Called by PO to check transaction auth session status and cross-check verifyLevel.
     * @summary Get session status (Internal)
     * @param {any} verifySessionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessionStatus(
      verifySessionId: any,
      options?: any,
    ): AxiosPromise<TxnAuthSessionStatusResponse> {
      return localVarFp
        .getSessionStatus(verifySessionId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Called by wallet-ms during preview to create a transaction auth session. Returns session ID, auth method, and verification steps.
     * @summary Initiate transaction auth (Internal)
     * @param {TxnAuthInitiateRequest} txnAuthInitiateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    initiate(
      txnAuthInitiateRequest: TxnAuthInitiateRequest,
      options?: any,
    ): AxiosPromise<TxnAuthInitiateResponse> {
      return localVarFp
        .initiate(txnAuthInitiateRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for getSessionStatus operation in InternalTransactionAuthApi.
 * @export
 * @interface InternalTransactionAuthApiGetSessionStatusRequest
 */
export interface InternalTransactionAuthApiGetSessionStatusRequest {
  /**
   *
   * @type {any}
   * @memberof InternalTransactionAuthApiGetSessionStatus
   */
  readonly verifySessionId: any;
}

/**
 * Request parameters for initiate operation in InternalTransactionAuthApi.
 * @export
 * @interface InternalTransactionAuthApiInitiateRequest
 */
export interface InternalTransactionAuthApiInitiateRequest {
  /**
   *
   * @type {TxnAuthInitiateRequest}
   * @memberof InternalTransactionAuthApiInitiate
   */
  readonly txnAuthInitiateRequest: TxnAuthInitiateRequest;
}

/**
 * InternalTransactionAuthApi - object-oriented interface
 * @export
 * @class InternalTransactionAuthApi
 * @extends {BaseAPI}
 */
export class InternalTransactionAuthApi extends BaseAPI {
  /**
   * Called by PO to check transaction auth session status and cross-check verifyLevel.
   * @summary Get session status (Internal)
   * @param {InternalTransactionAuthApiGetSessionStatusRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InternalTransactionAuthApi
   */
  public getSessionStatus(
    requestParameters: InternalTransactionAuthApiGetSessionStatusRequest,
    options?: AxiosRequestConfig,
  ) {
    return InternalTransactionAuthApiFp(this.configuration)
      .getSessionStatus(requestParameters.verifySessionId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Called by wallet-ms during preview to create a transaction auth session. Returns session ID, auth method, and verification steps.
   * @summary Initiate transaction auth (Internal)
   * @param {InternalTransactionAuthApiInitiateRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InternalTransactionAuthApi
   */
  public initiate(
    requestParameters: InternalTransactionAuthApiInitiateRequest,
    options?: AxiosRequestConfig,
  ) {
    return InternalTransactionAuthApiFp(this.configuration)
      .initiate(requestParameters.txnAuthInitiateRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * InternalUserManagementApi - axios parameter creator
 * @export
 */
export const InternalUserManagementApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Disable a Keycloak end-user account and revoke all active sessions. Called by party-ms when suspending or blocking a user from CMS.
     * @summary Disable user (Internal)
     * @param {any} keycloakUserId
     * @param {DisableEnableUserRequest} disableEnableUserRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    disableUser: async (
      keycloakUserId: any,
      disableEnableUserRequest: DisableEnableUserRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'keycloakUserId' is not null or undefined
      assertParamExists("disableUser", "keycloakUserId", keycloakUserId);
      // verify required parameter 'disableEnableUserRequest' is not null or undefined
      assertParamExists(
        "disableUser",
        "disableEnableUserRequest",
        disableEnableUserRequest,
      );
      const localVarPath =
        `/internal/api/v1/users/{keycloakUserId}/disable`.replace(
          `{${"keycloakUserId"}}`,
          encodeURIComponent(String(keycloakUserId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        disableEnableUserRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Re-enable a Keycloak end-user account. Called by party-ms when reactivating a user from CMS.
     * @summary Enable user (Internal)
     * @param {any} keycloakUserId
     * @param {DisableEnableUserRequest} disableEnableUserRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    enableUser: async (
      keycloakUserId: any,
      disableEnableUserRequest: DisableEnableUserRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'keycloakUserId' is not null or undefined
      assertParamExists("enableUser", "keycloakUserId", keycloakUserId);
      // verify required parameter 'disableEnableUserRequest' is not null or undefined
      assertParamExists(
        "enableUser",
        "disableEnableUserRequest",
        disableEnableUserRequest,
      );
      const localVarPath =
        `/internal/api/v1/users/{keycloakUserId}/enable`.replace(
          `{${"keycloakUserId"}}`,
          encodeURIComponent(String(keycloakUserId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        disableEnableUserRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * InternalUserManagementApi - functional programming interface
 * @export
 */
export const InternalUserManagementApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    InternalUserManagementApiAxiosParamCreator(configuration);
  return {
    /**
     * Disable a Keycloak end-user account and revoke all active sessions. Called by party-ms when suspending or blocking a user from CMS.
     * @summary Disable user (Internal)
     * @param {any} keycloakUserId
     * @param {DisableEnableUserRequest} disableEnableUserRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async disableUser(
      keycloakUserId: any,
      disableEnableUserRequest: DisableEnableUserRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<DisableUserResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.disableUser(
        keycloakUserId,
        disableEnableUserRequest,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Re-enable a Keycloak end-user account. Called by party-ms when reactivating a user from CMS.
     * @summary Enable user (Internal)
     * @param {any} keycloakUserId
     * @param {DisableEnableUserRequest} disableEnableUserRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async enableUser(
      keycloakUserId: any,
      disableEnableUserRequest: DisableEnableUserRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<EnableUserResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.enableUser(
        keycloakUserId,
        disableEnableUserRequest,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
  };
};

/**
 * InternalUserManagementApi - factory interface
 * @export
 */
export const InternalUserManagementApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = InternalUserManagementApiFp(configuration);
  return {
    /**
     * Disable a Keycloak end-user account and revoke all active sessions. Called by party-ms when suspending or blocking a user from CMS.
     * @summary Disable user (Internal)
     * @param {any} keycloakUserId
     * @param {DisableEnableUserRequest} disableEnableUserRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    disableUser(
      keycloakUserId: any,
      disableEnableUserRequest: DisableEnableUserRequest,
      options?: any,
    ): AxiosPromise<DisableUserResponse> {
      return localVarFp
        .disableUser(keycloakUserId, disableEnableUserRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Re-enable a Keycloak end-user account. Called by party-ms when reactivating a user from CMS.
     * @summary Enable user (Internal)
     * @param {any} keycloakUserId
     * @param {DisableEnableUserRequest} disableEnableUserRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    enableUser(
      keycloakUserId: any,
      disableEnableUserRequest: DisableEnableUserRequest,
      options?: any,
    ): AxiosPromise<EnableUserResponse> {
      return localVarFp
        .enableUser(keycloakUserId, disableEnableUserRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for disableUser operation in InternalUserManagementApi.
 * @export
 * @interface InternalUserManagementApiDisableUserRequest
 */
export interface InternalUserManagementApiDisableUserRequest {
  /**
   *
   * @type {any}
   * @memberof InternalUserManagementApiDisableUser
   */
  readonly keycloakUserId: any;

  /**
   *
   * @type {DisableEnableUserRequest}
   * @memberof InternalUserManagementApiDisableUser
   */
  readonly disableEnableUserRequest: DisableEnableUserRequest;
}

/**
 * Request parameters for enableUser operation in InternalUserManagementApi.
 * @export
 * @interface InternalUserManagementApiEnableUserRequest
 */
export interface InternalUserManagementApiEnableUserRequest {
  /**
   *
   * @type {any}
   * @memberof InternalUserManagementApiEnableUser
   */
  readonly keycloakUserId: any;

  /**
   *
   * @type {DisableEnableUserRequest}
   * @memberof InternalUserManagementApiEnableUser
   */
  readonly disableEnableUserRequest: DisableEnableUserRequest;
}

/**
 * InternalUserManagementApi - object-oriented interface
 * @export
 * @class InternalUserManagementApi
 * @extends {BaseAPI}
 */
export class InternalUserManagementApi extends BaseAPI {
  /**
   * Disable a Keycloak end-user account and revoke all active sessions. Called by party-ms when suspending or blocking a user from CMS.
   * @summary Disable user (Internal)
   * @param {InternalUserManagementApiDisableUserRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InternalUserManagementApi
   */
  public disableUser(
    requestParameters: InternalUserManagementApiDisableUserRequest,
    options?: AxiosRequestConfig,
  ) {
    return InternalUserManagementApiFp(this.configuration)
      .disableUser(
        requestParameters.keycloakUserId,
        requestParameters.disableEnableUserRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Re-enable a Keycloak end-user account. Called by party-ms when reactivating a user from CMS.
   * @summary Enable user (Internal)
   * @param {InternalUserManagementApiEnableUserRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof InternalUserManagementApi
   */
  public enableUser(
    requestParameters: InternalUserManagementApiEnableUserRequest,
    options?: AxiosRequestConfig,
  ) {
    return InternalUserManagementApiFp(this.configuration)
      .enableUser(
        requestParameters.keycloakUserId,
        requestParameters.disableEnableUserRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * MFASessionManagementApi - axios parameter creator
 * @export
 */
export const MFASessionManagementApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Cancels and invalidates an active MFA session
     * @summary Cancel MFA Session
     * @param {any} sessionId MFA Session ID
     * @param {CancelMfaSessionRequest} [cancelMfaSessionRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cancelSession: async (
      sessionId: any,
      cancelMfaSessionRequest?: CancelMfaSessionRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'sessionId' is not null or undefined
      assertParamExists("cancelSession", "sessionId", sessionId);
      const localVarPath = `/api/v1/auth/2fa/sessions/{sessionId}`.replace(
        `{${"sessionId"}}`,
        encodeURIComponent(String(sessionId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        cancelMfaSessionRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Initiates a new MFA session for specified source type (LOGIN, CHANGE_PASSWORD, WITHDRAW)
     * @summary Create MFA Session
     * @param {CreateMfaSessionRequest} createMfaSessionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createMfaSession: async (
      createMfaSessionRequest: CreateMfaSessionRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'createMfaSessionRequest' is not null or undefined
      assertParamExists(
        "createMfaSession",
        "createMfaSessionRequest",
        createMfaSessionRequest,
      );
      const localVarPath = `/api/v1/auth/2fa/sessions`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createMfaSessionRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Retrieves the current statuses and details of an MFA session
     * @summary Get MFA Session Status
     * @param {any} sessionId MFA Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessionStatus1: async (
      sessionId: any,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'sessionId' is not null or undefined
      assertParamExists("getSessionStatus1", "sessionId", sessionId);
      const localVarPath =
        `/api/v1/auth/2fa/sessions/{sessionId}/status`.replace(
          `{${"sessionId"}}`,
          encodeURIComponent(String(sessionId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Verifies the MFA code and executes the associated business logic based on source type
     * @summary Verify MFA Session
     * @param {any} sessionId MFA Session ID
     * @param {VerifyMfaSessionRequest} verifyMfaSessionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    verifyMfaSession: async (
      sessionId: any,
      verifyMfaSessionRequest: VerifyMfaSessionRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'sessionId' is not null or undefined
      assertParamExists("verifyMfaSession", "sessionId", sessionId);
      // verify required parameter 'verifyMfaSessionRequest' is not null or undefined
      assertParamExists(
        "verifyMfaSession",
        "verifyMfaSessionRequest",
        verifyMfaSessionRequest,
      );
      const localVarPath =
        `/api/v1/auth/2fa/sessions/{sessionId}/verify`.replace(
          `{${"sessionId"}}`,
          encodeURIComponent(String(sessionId)),
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        verifyMfaSessionRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * MFASessionManagementApi - functional programming interface
 * @export
 */
export const MFASessionManagementApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    MFASessionManagementApiAxiosParamCreator(configuration);
  return {
    /**
     * Cancels and invalidates an active MFA session
     * @summary Cancel MFA Session
     * @param {any} sessionId MFA Session ID
     * @param {CancelMfaSessionRequest} [cancelMfaSessionRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cancelSession(
      sessionId: any,
      cancelMfaSessionRequest?: CancelMfaSessionRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.cancelSession(
        sessionId,
        cancelMfaSessionRequest,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Initiates a new MFA session for specified source type (LOGIN, CHANGE_PASSWORD, WITHDRAW)
     * @summary Create MFA Session
     * @param {CreateMfaSessionRequest} createMfaSessionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createMfaSession(
      createMfaSessionRequest: CreateMfaSessionRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<CreateMfaSessionResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.createMfaSession(
          createMfaSessionRequest,
          options,
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Retrieves the current statuses and details of an MFA session
     * @summary Get MFA Session Status
     * @param {any} sessionId MFA Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getSessionStatus1(
      sessionId: any,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<MfaSessionStatusResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getSessionStatus1(sessionId, options);
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Verifies the MFA code and executes the associated business logic based on source type
     * @summary Verify MFA Session
     * @param {any} sessionId MFA Session ID
     * @param {VerifyMfaSessionRequest} verifyMfaSessionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async verifyMfaSession(
      sessionId: any,
      verifyMfaSessionRequest: VerifyMfaSessionRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<MfaVerificationResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.verifyMfaSession(
          sessionId,
          verifyMfaSessionRequest,
          options,
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
  };
};

/**
 * MFASessionManagementApi - factory interface
 * @export
 */
export const MFASessionManagementApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = MFASessionManagementApiFp(configuration);
  return {
    /**
     * Cancels and invalidates an active MFA session
     * @summary Cancel MFA Session
     * @param {any} sessionId MFA Session ID
     * @param {CancelMfaSessionRequest} [cancelMfaSessionRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cancelSession(
      sessionId: any,
      cancelMfaSessionRequest?: CancelMfaSessionRequest,
      options?: any,
    ): AxiosPromise<void> {
      return localVarFp
        .cancelSession(sessionId, cancelMfaSessionRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Initiates a new MFA session for specified source type (LOGIN, CHANGE_PASSWORD, WITHDRAW)
     * @summary Create MFA Session
     * @param {CreateMfaSessionRequest} createMfaSessionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createMfaSession(
      createMfaSessionRequest: CreateMfaSessionRequest,
      options?: any,
    ): AxiosPromise<CreateMfaSessionResponse> {
      return localVarFp
        .createMfaSession(createMfaSessionRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Retrieves the current statuses and details of an MFA session
     * @summary Get MFA Session Status
     * @param {any} sessionId MFA Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessionStatus1(
      sessionId: any,
      options?: any,
    ): AxiosPromise<MfaSessionStatusResponse> {
      return localVarFp
        .getSessionStatus1(sessionId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Verifies the MFA code and executes the associated business logic based on source type
     * @summary Verify MFA Session
     * @param {any} sessionId MFA Session ID
     * @param {VerifyMfaSessionRequest} verifyMfaSessionRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    verifyMfaSession(
      sessionId: any,
      verifyMfaSessionRequest: VerifyMfaSessionRequest,
      options?: any,
    ): AxiosPromise<MfaVerificationResponse> {
      return localVarFp
        .verifyMfaSession(sessionId, verifyMfaSessionRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for cancelSession operation in MFASessionManagementApi.
 * @export
 * @interface MFASessionManagementApiCancelSessionRequest
 */
export interface MFASessionManagementApiCancelSessionRequest {
  /**
   * MFA Session ID
   * @type {any}
   * @memberof MFASessionManagementApiCancelSession
   */
  readonly sessionId: any;

  /**
   *
   * @type {CancelMfaSessionRequest}
   * @memberof MFASessionManagementApiCancelSession
   */
  readonly cancelMfaSessionRequest?: CancelMfaSessionRequest;
}

/**
 * Request parameters for createMfaSession operation in MFASessionManagementApi.
 * @export
 * @interface MFASessionManagementApiCreateMfaSessionRequest
 */
export interface MFASessionManagementApiCreateMfaSessionRequest {
  /**
   *
   * @type {CreateMfaSessionRequest}
   * @memberof MFASessionManagementApiCreateMfaSession
   */
  readonly createMfaSessionRequest: CreateMfaSessionRequest;
}

/**
 * Request parameters for getSessionStatus1 operation in MFASessionManagementApi.
 * @export
 * @interface MFASessionManagementApiGetSessionStatus1Request
 */
export interface MFASessionManagementApiGetSessionStatus1Request {
  /**
   * MFA Session ID
   * @type {any}
   * @memberof MFASessionManagementApiGetSessionStatus1
   */
  readonly sessionId: any;
}

/**
 * Request parameters for verifyMfaSession operation in MFASessionManagementApi.
 * @export
 * @interface MFASessionManagementApiVerifyMfaSessionRequest
 */
export interface MFASessionManagementApiVerifyMfaSessionRequest {
  /**
   * MFA Session ID
   * @type {any}
   * @memberof MFASessionManagementApiVerifyMfaSession
   */
  readonly sessionId: any;

  /**
   *
   * @type {VerifyMfaSessionRequest}
   * @memberof MFASessionManagementApiVerifyMfaSession
   */
  readonly verifyMfaSessionRequest: VerifyMfaSessionRequest;
}

/**
 * MFASessionManagementApi - object-oriented interface
 * @export
 * @class MFASessionManagementApi
 * @extends {BaseAPI}
 */
export class MFASessionManagementApi extends BaseAPI {
  /**
   * Cancels and invalidates an active MFA session
   * @summary Cancel MFA Session
   * @param {MFASessionManagementApiCancelSessionRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MFASessionManagementApi
   */
  public cancelSession(
    requestParameters: MFASessionManagementApiCancelSessionRequest,
    options?: AxiosRequestConfig,
  ) {
    return MFASessionManagementApiFp(this.configuration)
      .cancelSession(
        requestParameters.sessionId,
        requestParameters.cancelMfaSessionRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Initiates a new MFA session for specified source type (LOGIN, CHANGE_PASSWORD, WITHDRAW)
   * @summary Create MFA Session
   * @param {MFASessionManagementApiCreateMfaSessionRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MFASessionManagementApi
   */
  public createMfaSession(
    requestParameters: MFASessionManagementApiCreateMfaSessionRequest,
    options?: AxiosRequestConfig,
  ) {
    return MFASessionManagementApiFp(this.configuration)
      .createMfaSession(requestParameters.createMfaSessionRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Retrieves the current statuses and details of an MFA session
   * @summary Get MFA Session Status
   * @param {MFASessionManagementApiGetSessionStatus1Request} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MFASessionManagementApi
   */
  public getSessionStatus1(
    requestParameters: MFASessionManagementApiGetSessionStatus1Request,
    options?: AxiosRequestConfig,
  ) {
    return MFASessionManagementApiFp(this.configuration)
      .getSessionStatus1(requestParameters.sessionId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Verifies the MFA code and executes the associated business logic based on source type
   * @summary Verify MFA Session
   * @param {MFASessionManagementApiVerifyMfaSessionRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MFASessionManagementApi
   */
  public verifyMfaSession(
    requestParameters: MFASessionManagementApiVerifyMfaSessionRequest,
    options?: AxiosRequestConfig,
  ) {
    return MFASessionManagementApiFp(this.configuration)
      .verifyMfaSession(
        requestParameters.sessionId,
        requestParameters.verifyMfaSessionRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * MerchantAuthFirstLoginApi - axios parameter creator
 * @export
 */
export const MerchantAuthFirstLoginApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Atomic single-use session token (Redis GETDEL TTL 5min). On hit, Keycloak resetPassword(temporary=false) + clear UPDATE_PASSWORD requiredAction. Subsequent submission with same token returns 401 (session.invalid).
     * @summary Change merchant password on first login
     * @param {MerchantFirstLoginChangePasswordRequest} merchantFirstLoginChangePasswordRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    changePassword2: async (
      merchantFirstLoginChangePasswordRequest: MerchantFirstLoginChangePasswordRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'merchantFirstLoginChangePasswordRequest' is not null or undefined
      assertParamExists(
        "changePassword2",
        "merchantFirstLoginChangePasswordRequest",
        merchantFirstLoginChangePasswordRequest,
      );
      const localVarPath = `/api/merchant-auth/v1/first-login/change-password`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        merchantFirstLoginChangePasswordRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * MerchantAuthFirstLoginApi - functional programming interface
 * @export
 */
export const MerchantAuthFirstLoginApiFp = function (
  configuration?: Configuration,
) {
  const localVarAxiosParamCreator =
    MerchantAuthFirstLoginApiAxiosParamCreator(configuration);
  return {
    /**
     * Atomic single-use session token (Redis GETDEL TTL 5min). On hit, Keycloak resetPassword(temporary=false) + clear UPDATE_PASSWORD requiredAction. Subsequent submission with same token returns 401 (session.invalid).
     * @summary Change merchant password on first login
     * @param {MerchantFirstLoginChangePasswordRequest} merchantFirstLoginChangePasswordRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async changePassword2(
      merchantFirstLoginChangePasswordRequest: MerchantFirstLoginChangePasswordRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<FirstLoginChangePasswordResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.changePassword2(
        merchantFirstLoginChangePasswordRequest,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
  };
};

/**
 * MerchantAuthFirstLoginApi - factory interface
 * @export
 */
export const MerchantAuthFirstLoginApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = MerchantAuthFirstLoginApiFp(configuration);
  return {
    /**
     * Atomic single-use session token (Redis GETDEL TTL 5min). On hit, Keycloak resetPassword(temporary=false) + clear UPDATE_PASSWORD requiredAction. Subsequent submission with same token returns 401 (session.invalid).
     * @summary Change merchant password on first login
     * @param {MerchantFirstLoginChangePasswordRequest} merchantFirstLoginChangePasswordRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    changePassword2(
      merchantFirstLoginChangePasswordRequest: MerchantFirstLoginChangePasswordRequest,
      options?: any,
    ): AxiosPromise<FirstLoginChangePasswordResponse> {
      return localVarFp
        .changePassword2(merchantFirstLoginChangePasswordRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for changePassword2 operation in MerchantAuthFirstLoginApi.
 * @export
 * @interface MerchantAuthFirstLoginApiChangePassword2Request
 */
export interface MerchantAuthFirstLoginApiChangePassword2Request {
  /**
   *
   * @type {MerchantFirstLoginChangePasswordRequest}
   * @memberof MerchantAuthFirstLoginApiChangePassword2
   */
  readonly merchantFirstLoginChangePasswordRequest: MerchantFirstLoginChangePasswordRequest;
}

/**
 * MerchantAuthFirstLoginApi - object-oriented interface
 * @export
 * @class MerchantAuthFirstLoginApi
 * @extends {BaseAPI}
 */
export class MerchantAuthFirstLoginApi extends BaseAPI {
  /**
   * Atomic single-use session token (Redis GETDEL TTL 5min). On hit, Keycloak resetPassword(temporary=false) + clear UPDATE_PASSWORD requiredAction. Subsequent submission with same token returns 401 (session.invalid).
   * @summary Change merchant password on first login
   * @param {MerchantAuthFirstLoginApiChangePassword2Request} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MerchantAuthFirstLoginApi
   */
  public changePassword2(
    requestParameters: MerchantAuthFirstLoginApiChangePassword2Request,
    options?: AxiosRequestConfig,
  ) {
    return MerchantAuthFirstLoginApiFp(this.configuration)
      .changePassword2(
        requestParameters.merchantFirstLoginChangePasswordRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * MerchantAuthLoginApi - axios parameter creator
 * @export
 */
export const MerchantAuthLoginApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Bước 1/3 quên mật khẩu. Anti-enumeration: trả 200 silent kể cả phone không tồn tại. Phát OTP 6 số TTL 5 phút qua email channel (D15). Rate limit 3 lần / 24h / phone.
     * @summary Yêu cầu OTP quên mật khẩu
     * @param {MerchantForgotPasswordRequestOtpRequest} merchantForgotPasswordRequestOtpRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    forgotPasswordRequestOtp: async (
      merchantForgotPasswordRequestOtpRequest: MerchantForgotPasswordRequestOtpRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'merchantForgotPasswordRequestOtpRequest' is not null or undefined
      assertParamExists(
        "forgotPasswordRequestOtp",
        "merchantForgotPasswordRequestOtpRequest",
        merchantForgotPasswordRequestOtpRequest,
      );
      const localVarPath = `/api/merchant-auth/v1/forgot-password/request-otp`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        merchantForgotPasswordRequestOtpRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Bước 3/3. Atomic GETDEL resetSessionToken → Keycloak admin resetPassword. Password complexity check + confirm match check.
     * @summary Đặt lại mật khẩu
     * @param {MerchantForgotPasswordSubmitRequest} merchantForgotPasswordSubmitRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    forgotPasswordSubmit: async (
      merchantForgotPasswordSubmitRequest: MerchantForgotPasswordSubmitRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'merchantForgotPasswordSubmitRequest' is not null or undefined
      assertParamExists(
        "forgotPasswordSubmit",
        "merchantForgotPasswordSubmitRequest",
        merchantForgotPasswordSubmitRequest,
      );
      const localVarPath = `/api/merchant-auth/v1/forgot-password/submit`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        merchantForgotPasswordSubmitRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Bước 2/3. Atomic GETDEL Redis OTP. Trả resetSessionToken (32-byte opaque base64url, TTL 5 phút, single-use) dùng cho bước 3 submit.
     * @summary Xác thực OTP quên mật khẩu
     * @param {MerchantForgotPasswordVerifyOtpRequest} merchantForgotPasswordVerifyOtpRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    forgotPasswordVerifyOtp: async (
      merchantForgotPasswordVerifyOtpRequest: MerchantForgotPasswordVerifyOtpRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'merchantForgotPasswordVerifyOtpRequest' is not null or undefined
      assertParamExists(
        "forgotPasswordVerifyOtp",
        "merchantForgotPasswordVerifyOtpRequest",
        merchantForgotPasswordVerifyOtpRequest,
      );
      const localVarPath = `/api/merchant-auth/v1/forgot-password/verify-otp`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        merchantForgotPasswordVerifyOtpRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * merchant-auth-improvements 2026-05-12: 2-step login OTP per legacy neo-pay parity. Status PENDING_ACTIVATION → trả sessionToken + redirect /change-password (first-login). Status ACTIVE → verify password qua Keycloak grantToken → send SMS OTP (TTL 5min) → trả OTP_REQUIRED. Client gọi step 2 /v1/verify-otp với phone+password+otp để nhận token. LOCKED/SUSPENDED/DELETED → 423/403.
     * @summary Đăng nhập merchant portal (step 1 — gửi SMS OTP)
     * @param {MerchantLoginRequest} merchantLoginRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    login2: async (
      merchantLoginRequest: MerchantLoginRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'merchantLoginRequest' is not null or undefined
      assertParamExists("login2", "merchantLoginRequest", merchantLoginRequest);
      const localVarPath = `/api/merchant-auth/v1`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        merchantLoginRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Revoke Keycloak session via refresh token. Fail-soft: Keycloak unavailable still returns success (client clears token regardless per spec §2.6 D27 resilience mandate).
     * @summary Đăng xuất
     * @param {MerchantLogoutRequest} merchantLogoutRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    logout2: async (
      merchantLogoutRequest: MerchantLogoutRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'merchantLogoutRequest' is not null or undefined
      assertParamExists(
        "logout2",
        "merchantLogoutRequest",
        merchantLogoutRequest,
      );
      const localVarPath = `/api/merchant-auth/v1/logout`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        merchantLogoutRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * DEPRECATED — sunset Fri, 12 Jun 2026 00:00:00 GMT. Dùng 2-step flow /v1/me/change-password/verify + /submit để match legacy neo-pay parity. JWT-authenticated endpoint. User extracted từ Reactor SecurityContext (Member.id = keycloakUserId). Verify currentPassword qua Keycloak grantToken, reset to newPassword, revoke all sessions. Rate limit 5/15min per user. D19: NOT in SecurityConfig permitAll (JWT required).
     * @summary (DEPRECATED) Đổi mật khẩu self-service 1-step
     * @param {MerchantChangePasswordRequest} merchantChangePasswordRequest
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    meChangePassword: async (
      merchantChangePasswordRequest: MerchantChangePasswordRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'merchantChangePasswordRequest' is not null or undefined
      assertParamExists(
        "meChangePassword",
        "merchantChangePasswordRequest",
        merchantChangePasswordRequest,
      );
      const localVarPath = `/api/merchant-auth/v1/me/change-password`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        merchantChangePasswordRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * merchant-auth-improvements 2026-05-12. JWT-authenticated. Atomic GETDEL Redis session → constant-time verify sessionId+token → newPassword==confirmNewPassword + complexity check → KC admin resetPassword + revoke all sessions (logout).
     * @summary Đổi mật khẩu self-service (step 2 — submit new password)
     * @param {MerchantChangePasswordSubmitRequest} merchantChangePasswordSubmitRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meChangePasswordSubmit: async (
      merchantChangePasswordSubmitRequest: MerchantChangePasswordSubmitRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'merchantChangePasswordSubmitRequest' is not null or undefined
      assertParamExists(
        "meChangePasswordSubmit",
        "merchantChangePasswordSubmitRequest",
        merchantChangePasswordSubmitRequest,
      );
      const localVarPath = `/api/merchant-auth/v1/me/change-password/submit`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        merchantChangePasswordSubmitRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * merchant-auth-improvements 2026-05-12. JWT-authenticated. Verify currentPassword qua Keycloak grantToken → mint Redis sessionId+token (15min TTL, single-use GETDEL). Step 2 /submit dùng sessionId+token + newPassword.
     * @summary Đổi mật khẩu self-service (step 1 — verify current password)
     * @param {MerchantChangePasswordVerifyRequest} merchantChangePasswordVerifyRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meChangePasswordVerify: async (
      merchantChangePasswordVerifyRequest: MerchantChangePasswordVerifyRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'merchantChangePasswordVerifyRequest' is not null or undefined
      assertParamExists(
        "meChangePasswordVerify",
        "merchantChangePasswordVerifyRequest",
        merchantChangePasswordVerifyRequest,
      );
      const localVarPath = `/api/merchant-auth/v1/me/change-password/verify`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        merchantChangePasswordVerifyRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * OAuth2 refresh_token grant via Keycloak realm ewallet_merchant. Returns new access + refresh pair.
     * @summary Refresh access token
     * @param {MerchantRefreshTokenRequest} merchantRefreshTokenRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    refresh2: async (
      merchantRefreshTokenRequest: MerchantRefreshTokenRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'merchantRefreshTokenRequest' is not null or undefined
      assertParamExists(
        "refresh2",
        "merchantRefreshTokenRequest",
        merchantRefreshTokenRequest,
      );
      const localVarPath = `/api/merchant-auth/v1/refresh`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        merchantRefreshTokenRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * merchant-auth-improvements 2026-05-12. Phone-only. 60s cooldown (D4) + 4 sends per 20min (D5). Sinh OTP MỚI (không reuse) per legacy parity.
     * @summary Resend OTP đăng nhập merchant portal
     * @param {MerchantResendLoginOtpRequest} merchantResendLoginOtpRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resendLoginOtp1: async (
      merchantResendLoginOtpRequest: MerchantResendLoginOtpRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'merchantResendLoginOtpRequest' is not null or undefined
      assertParamExists(
        "resendLoginOtp1",
        "merchantResendLoginOtpRequest",
        merchantResendLoginOtpRequest,
      );
      const localVarPath = `/api/merchant-auth/v1/resend-otp`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        merchantResendLoginOtpRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * merchant-auth-improvements 2026-05-12 step 2. Atomic GETDEL Redis OTP. Client re-supplies phone + password (D11) + OTP (6 số). Server verify OTP + re-grant Keycloak → trả token.
     * @summary Đăng nhập merchant portal (step 2 — verify OTP)
     * @param {MerchantVerifyLoginOtpRequest} merchantVerifyLoginOtpRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    verifyLoginOtp: async (
      merchantVerifyLoginOtpRequest: MerchantVerifyLoginOtpRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'merchantVerifyLoginOtpRequest' is not null or undefined
      assertParamExists(
        "verifyLoginOtp",
        "merchantVerifyLoginOtpRequest",
        merchantVerifyLoginOtpRequest,
      );
      const localVarPath = `/api/merchant-auth/v1/verify-otp`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        merchantVerifyLoginOtpRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * MerchantAuthLoginApi - functional programming interface
 * @export
 */
export const MerchantAuthLoginApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    MerchantAuthLoginApiAxiosParamCreator(configuration);
  return {
    /**
     * Bước 1/3 quên mật khẩu. Anti-enumeration: trả 200 silent kể cả phone không tồn tại. Phát OTP 6 số TTL 5 phút qua email channel (D15). Rate limit 3 lần / 24h / phone.
     * @summary Yêu cầu OTP quên mật khẩu
     * @param {MerchantForgotPasswordRequestOtpRequest} merchantForgotPasswordRequestOtpRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async forgotPasswordRequestOtp(
      merchantForgotPasswordRequestOtpRequest: MerchantForgotPasswordRequestOtpRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommonResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.forgotPasswordRequestOtp(
          merchantForgotPasswordRequestOtpRequest,
          options,
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Bước 3/3. Atomic GETDEL resetSessionToken → Keycloak admin resetPassword. Password complexity check + confirm match check.
     * @summary Đặt lại mật khẩu
     * @param {MerchantForgotPasswordSubmitRequest} merchantForgotPasswordSubmitRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async forgotPasswordSubmit(
      merchantForgotPasswordSubmitRequest: MerchantForgotPasswordSubmitRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommonResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.forgotPasswordSubmit(
          merchantForgotPasswordSubmitRequest,
          options,
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Bước 2/3. Atomic GETDEL Redis OTP. Trả resetSessionToken (32-byte opaque base64url, TTL 5 phút, single-use) dùng cho bước 3 submit.
     * @summary Xác thực OTP quên mật khẩu
     * @param {MerchantForgotPasswordVerifyOtpRequest} merchantForgotPasswordVerifyOtpRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async forgotPasswordVerifyOtp(
      merchantForgotPasswordVerifyOtpRequest: MerchantForgotPasswordVerifyOtpRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<MerchantForgotPasswordVerifyOtpResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.forgotPasswordVerifyOtp(
          merchantForgotPasswordVerifyOtpRequest,
          options,
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * merchant-auth-improvements 2026-05-12: 2-step login OTP per legacy neo-pay parity. Status PENDING_ACTIVATION → trả sessionToken + redirect /change-password (first-login). Status ACTIVE → verify password qua Keycloak grantToken → send SMS OTP (TTL 5min) → trả OTP_REQUIRED. Client gọi step 2 /v1/verify-otp với phone+password+otp để nhận token. LOCKED/SUSPENDED/DELETED → 423/403.
     * @summary Đăng nhập merchant portal (step 1 — gửi SMS OTP)
     * @param {MerchantLoginRequest} merchantLoginRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async login2(
      merchantLoginRequest: MerchantLoginRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<MerchantLoginResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.login2(
        merchantLoginRequest,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Revoke Keycloak session via refresh token. Fail-soft: Keycloak unavailable still returns success (client clears token regardless per spec §2.6 D27 resilience mandate).
     * @summary Đăng xuất
     * @param {MerchantLogoutRequest} merchantLogoutRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async logout2(
      merchantLogoutRequest: MerchantLogoutRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommonResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.logout2(
        merchantLogoutRequest,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * DEPRECATED — sunset Fri, 12 Jun 2026 00:00:00 GMT. Dùng 2-step flow /v1/me/change-password/verify + /submit để match legacy neo-pay parity. JWT-authenticated endpoint. User extracted từ Reactor SecurityContext (Member.id = keycloakUserId). Verify currentPassword qua Keycloak grantToken, reset to newPassword, revoke all sessions. Rate limit 5/15min per user. D19: NOT in SecurityConfig permitAll (JWT required).
     * @summary (DEPRECATED) Đổi mật khẩu self-service 1-step
     * @param {MerchantChangePasswordRequest} merchantChangePasswordRequest
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async meChangePassword(
      merchantChangePasswordRequest: MerchantChangePasswordRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommonResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.meChangePassword(
          merchantChangePasswordRequest,
          options,
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * merchant-auth-improvements 2026-05-12. JWT-authenticated. Atomic GETDEL Redis session → constant-time verify sessionId+token → newPassword==confirmNewPassword + complexity check → KC admin resetPassword + revoke all sessions (logout).
     * @summary Đổi mật khẩu self-service (step 2 — submit new password)
     * @param {MerchantChangePasswordSubmitRequest} merchantChangePasswordSubmitRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async meChangePasswordSubmit(
      merchantChangePasswordSubmitRequest: MerchantChangePasswordSubmitRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommonResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.meChangePasswordSubmit(
          merchantChangePasswordSubmitRequest,
          options,
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * merchant-auth-improvements 2026-05-12. JWT-authenticated. Verify currentPassword qua Keycloak grantToken → mint Redis sessionId+token (15min TTL, single-use GETDEL). Step 2 /submit dùng sessionId+token + newPassword.
     * @summary Đổi mật khẩu self-service (step 1 — verify current password)
     * @param {MerchantChangePasswordVerifyRequest} merchantChangePasswordVerifyRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async meChangePasswordVerify(
      merchantChangePasswordVerifyRequest: MerchantChangePasswordVerifyRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<MerchantChangePasswordVerifyResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.meChangePasswordVerify(
          merchantChangePasswordVerifyRequest,
          options,
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * OAuth2 refresh_token grant via Keycloak realm ewallet_merchant. Returns new access + refresh pair.
     * @summary Refresh access token
     * @param {MerchantRefreshTokenRequest} merchantRefreshTokenRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async refresh2(
      merchantRefreshTokenRequest: MerchantRefreshTokenRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<MerchantLoginResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.refresh2(
        merchantRefreshTokenRequest,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * merchant-auth-improvements 2026-05-12. Phone-only. 60s cooldown (D4) + 4 sends per 20min (D5). Sinh OTP MỚI (không reuse) per legacy parity.
     * @summary Resend OTP đăng nhập merchant portal
     * @param {MerchantResendLoginOtpRequest} merchantResendLoginOtpRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async resendLoginOtp1(
      merchantResendLoginOtpRequest: MerchantResendLoginOtpRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<MerchantLoginResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.resendLoginOtp1(
        merchantResendLoginOtpRequest,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * merchant-auth-improvements 2026-05-12 step 2. Atomic GETDEL Redis OTP. Client re-supplies phone + password (D11) + OTP (6 số). Server verify OTP + re-grant Keycloak → trả token.
     * @summary Đăng nhập merchant portal (step 2 — verify OTP)
     * @param {MerchantVerifyLoginOtpRequest} merchantVerifyLoginOtpRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async verifyLoginOtp(
      merchantVerifyLoginOtpRequest: MerchantVerifyLoginOtpRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<MerchantLoginResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.verifyLoginOtp(
        merchantVerifyLoginOtpRequest,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
  };
};

/**
 * MerchantAuthLoginApi - factory interface
 * @export
 */
export const MerchantAuthLoginApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = MerchantAuthLoginApiFp(configuration);
  return {
    /**
     * Bước 1/3 quên mật khẩu. Anti-enumeration: trả 200 silent kể cả phone không tồn tại. Phát OTP 6 số TTL 5 phút qua email channel (D15). Rate limit 3 lần / 24h / phone.
     * @summary Yêu cầu OTP quên mật khẩu
     * @param {MerchantForgotPasswordRequestOtpRequest} merchantForgotPasswordRequestOtpRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    forgotPasswordRequestOtp(
      merchantForgotPasswordRequestOtpRequest: MerchantForgotPasswordRequestOtpRequest,
      options?: any,
    ): AxiosPromise<CommonResponse> {
      return localVarFp
        .forgotPasswordRequestOtp(
          merchantForgotPasswordRequestOtpRequest,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Bước 3/3. Atomic GETDEL resetSessionToken → Keycloak admin resetPassword. Password complexity check + confirm match check.
     * @summary Đặt lại mật khẩu
     * @param {MerchantForgotPasswordSubmitRequest} merchantForgotPasswordSubmitRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    forgotPasswordSubmit(
      merchantForgotPasswordSubmitRequest: MerchantForgotPasswordSubmitRequest,
      options?: any,
    ): AxiosPromise<CommonResponse> {
      return localVarFp
        .forgotPasswordSubmit(merchantForgotPasswordSubmitRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Bước 2/3. Atomic GETDEL Redis OTP. Trả resetSessionToken (32-byte opaque base64url, TTL 5 phút, single-use) dùng cho bước 3 submit.
     * @summary Xác thực OTP quên mật khẩu
     * @param {MerchantForgotPasswordVerifyOtpRequest} merchantForgotPasswordVerifyOtpRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    forgotPasswordVerifyOtp(
      merchantForgotPasswordVerifyOtpRequest: MerchantForgotPasswordVerifyOtpRequest,
      options?: any,
    ): AxiosPromise<MerchantForgotPasswordVerifyOtpResponse> {
      return localVarFp
        .forgotPasswordVerifyOtp(
          merchantForgotPasswordVerifyOtpRequest,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * merchant-auth-improvements 2026-05-12: 2-step login OTP per legacy neo-pay parity. Status PENDING_ACTIVATION → trả sessionToken + redirect /change-password (first-login). Status ACTIVE → verify password qua Keycloak grantToken → send SMS OTP (TTL 5min) → trả OTP_REQUIRED. Client gọi step 2 /v1/verify-otp với phone+password+otp để nhận token. LOCKED/SUSPENDED/DELETED → 423/403.
     * @summary Đăng nhập merchant portal (step 1 — gửi SMS OTP)
     * @param {MerchantLoginRequest} merchantLoginRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    login2(
      merchantLoginRequest: MerchantLoginRequest,
      options?: any,
    ): AxiosPromise<MerchantLoginResponse> {
      return localVarFp
        .login2(merchantLoginRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Revoke Keycloak session via refresh token. Fail-soft: Keycloak unavailable still returns success (client clears token regardless per spec §2.6 D27 resilience mandate).
     * @summary Đăng xuất
     * @param {MerchantLogoutRequest} merchantLogoutRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    logout2(
      merchantLogoutRequest: MerchantLogoutRequest,
      options?: any,
    ): AxiosPromise<CommonResponse> {
      return localVarFp
        .logout2(merchantLogoutRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * DEPRECATED — sunset Fri, 12 Jun 2026 00:00:00 GMT. Dùng 2-step flow /v1/me/change-password/verify + /submit để match legacy neo-pay parity. JWT-authenticated endpoint. User extracted từ Reactor SecurityContext (Member.id = keycloakUserId). Verify currentPassword qua Keycloak grantToken, reset to newPassword, revoke all sessions. Rate limit 5/15min per user. D19: NOT in SecurityConfig permitAll (JWT required).
     * @summary (DEPRECATED) Đổi mật khẩu self-service 1-step
     * @param {MerchantChangePasswordRequest} merchantChangePasswordRequest
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    meChangePassword(
      merchantChangePasswordRequest: MerchantChangePasswordRequest,
      options?: any,
    ): AxiosPromise<CommonResponse> {
      return localVarFp
        .meChangePassword(merchantChangePasswordRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * merchant-auth-improvements 2026-05-12. JWT-authenticated. Atomic GETDEL Redis session → constant-time verify sessionId+token → newPassword==confirmNewPassword + complexity check → KC admin resetPassword + revoke all sessions (logout).
     * @summary Đổi mật khẩu self-service (step 2 — submit new password)
     * @param {MerchantChangePasswordSubmitRequest} merchantChangePasswordSubmitRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meChangePasswordSubmit(
      merchantChangePasswordSubmitRequest: MerchantChangePasswordSubmitRequest,
      options?: any,
    ): AxiosPromise<CommonResponse> {
      return localVarFp
        .meChangePasswordSubmit(merchantChangePasswordSubmitRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * merchant-auth-improvements 2026-05-12. JWT-authenticated. Verify currentPassword qua Keycloak grantToken → mint Redis sessionId+token (15min TTL, single-use GETDEL). Step 2 /submit dùng sessionId+token + newPassword.
     * @summary Đổi mật khẩu self-service (step 1 — verify current password)
     * @param {MerchantChangePasswordVerifyRequest} merchantChangePasswordVerifyRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meChangePasswordVerify(
      merchantChangePasswordVerifyRequest: MerchantChangePasswordVerifyRequest,
      options?: any,
    ): AxiosPromise<MerchantChangePasswordVerifyResponse> {
      return localVarFp
        .meChangePasswordVerify(merchantChangePasswordVerifyRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * OAuth2 refresh_token grant via Keycloak realm ewallet_merchant. Returns new access + refresh pair.
     * @summary Refresh access token
     * @param {MerchantRefreshTokenRequest} merchantRefreshTokenRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    refresh2(
      merchantRefreshTokenRequest: MerchantRefreshTokenRequest,
      options?: any,
    ): AxiosPromise<MerchantLoginResponse> {
      return localVarFp
        .refresh2(merchantRefreshTokenRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * merchant-auth-improvements 2026-05-12. Phone-only. 60s cooldown (D4) + 4 sends per 20min (D5). Sinh OTP MỚI (không reuse) per legacy parity.
     * @summary Resend OTP đăng nhập merchant portal
     * @param {MerchantResendLoginOtpRequest} merchantResendLoginOtpRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resendLoginOtp1(
      merchantResendLoginOtpRequest: MerchantResendLoginOtpRequest,
      options?: any,
    ): AxiosPromise<MerchantLoginResponse> {
      return localVarFp
        .resendLoginOtp1(merchantResendLoginOtpRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * merchant-auth-improvements 2026-05-12 step 2. Atomic GETDEL Redis OTP. Client re-supplies phone + password (D11) + OTP (6 số). Server verify OTP + re-grant Keycloak → trả token.
     * @summary Đăng nhập merchant portal (step 2 — verify OTP)
     * @param {MerchantVerifyLoginOtpRequest} merchantVerifyLoginOtpRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    verifyLoginOtp(
      merchantVerifyLoginOtpRequest: MerchantVerifyLoginOtpRequest,
      options?: any,
    ): AxiosPromise<MerchantLoginResponse> {
      return localVarFp
        .verifyLoginOtp(merchantVerifyLoginOtpRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for forgotPasswordRequestOtp operation in MerchantAuthLoginApi.
 * @export
 * @interface MerchantAuthLoginApiForgotPasswordRequestOtpRequest
 */
export interface MerchantAuthLoginApiForgotPasswordRequestOtpRequest {
  /**
   *
   * @type {MerchantForgotPasswordRequestOtpRequest}
   * @memberof MerchantAuthLoginApiForgotPasswordRequestOtp
   */
  readonly merchantForgotPasswordRequestOtpRequest: MerchantForgotPasswordRequestOtpRequest;
}

/**
 * Request parameters for forgotPasswordSubmit operation in MerchantAuthLoginApi.
 * @export
 * @interface MerchantAuthLoginApiForgotPasswordSubmitRequest
 */
export interface MerchantAuthLoginApiForgotPasswordSubmitRequest {
  /**
   *
   * @type {MerchantForgotPasswordSubmitRequest}
   * @memberof MerchantAuthLoginApiForgotPasswordSubmit
   */
  readonly merchantForgotPasswordSubmitRequest: MerchantForgotPasswordSubmitRequest;
}

/**
 * Request parameters for forgotPasswordVerifyOtp operation in MerchantAuthLoginApi.
 * @export
 * @interface MerchantAuthLoginApiForgotPasswordVerifyOtpRequest
 */
export interface MerchantAuthLoginApiForgotPasswordVerifyOtpRequest {
  /**
   *
   * @type {MerchantForgotPasswordVerifyOtpRequest}
   * @memberof MerchantAuthLoginApiForgotPasswordVerifyOtp
   */
  readonly merchantForgotPasswordVerifyOtpRequest: MerchantForgotPasswordVerifyOtpRequest;
}

/**
 * Request parameters for login2 operation in MerchantAuthLoginApi.
 * @export
 * @interface MerchantAuthLoginApiLogin2Request
 */
export interface MerchantAuthLoginApiLogin2Request {
  /**
   *
   * @type {MerchantLoginRequest}
   * @memberof MerchantAuthLoginApiLogin2
   */
  readonly merchantLoginRequest: MerchantLoginRequest;
}

/**
 * Request parameters for logout2 operation in MerchantAuthLoginApi.
 * @export
 * @interface MerchantAuthLoginApiLogout2Request
 */
export interface MerchantAuthLoginApiLogout2Request {
  /**
   *
   * @type {MerchantLogoutRequest}
   * @memberof MerchantAuthLoginApiLogout2
   */
  readonly merchantLogoutRequest: MerchantLogoutRequest;
}

/**
 * Request parameters for meChangePassword operation in MerchantAuthLoginApi.
 * @export
 * @interface MerchantAuthLoginApiMeChangePasswordRequest
 */
export interface MerchantAuthLoginApiMeChangePasswordRequest {
  /**
   *
   * @type {MerchantChangePasswordRequest}
   * @memberof MerchantAuthLoginApiMeChangePassword
   */
  readonly merchantChangePasswordRequest: MerchantChangePasswordRequest;
}

/**
 * Request parameters for meChangePasswordSubmit operation in MerchantAuthLoginApi.
 * @export
 * @interface MerchantAuthLoginApiMeChangePasswordSubmitRequest
 */
export interface MerchantAuthLoginApiMeChangePasswordSubmitRequest {
  /**
   *
   * @type {MerchantChangePasswordSubmitRequest}
   * @memberof MerchantAuthLoginApiMeChangePasswordSubmit
   */
  readonly merchantChangePasswordSubmitRequest: MerchantChangePasswordSubmitRequest;
}

/**
 * Request parameters for meChangePasswordVerify operation in MerchantAuthLoginApi.
 * @export
 * @interface MerchantAuthLoginApiMeChangePasswordVerifyRequest
 */
export interface MerchantAuthLoginApiMeChangePasswordVerifyRequest {
  /**
   *
   * @type {MerchantChangePasswordVerifyRequest}
   * @memberof MerchantAuthLoginApiMeChangePasswordVerify
   */
  readonly merchantChangePasswordVerifyRequest: MerchantChangePasswordVerifyRequest;
}

/**
 * Request parameters for refresh2 operation in MerchantAuthLoginApi.
 * @export
 * @interface MerchantAuthLoginApiRefresh2Request
 */
export interface MerchantAuthLoginApiRefresh2Request {
  /**
   *
   * @type {MerchantRefreshTokenRequest}
   * @memberof MerchantAuthLoginApiRefresh2
   */
  readonly merchantRefreshTokenRequest: MerchantRefreshTokenRequest;
}

/**
 * Request parameters for resendLoginOtp1 operation in MerchantAuthLoginApi.
 * @export
 * @interface MerchantAuthLoginApiResendLoginOtp1Request
 */
export interface MerchantAuthLoginApiResendLoginOtp1Request {
  /**
   *
   * @type {MerchantResendLoginOtpRequest}
   * @memberof MerchantAuthLoginApiResendLoginOtp1
   */
  readonly merchantResendLoginOtpRequest: MerchantResendLoginOtpRequest;
}

/**
 * Request parameters for verifyLoginOtp operation in MerchantAuthLoginApi.
 * @export
 * @interface MerchantAuthLoginApiVerifyLoginOtpRequest
 */
export interface MerchantAuthLoginApiVerifyLoginOtpRequest {
  /**
   *
   * @type {MerchantVerifyLoginOtpRequest}
   * @memberof MerchantAuthLoginApiVerifyLoginOtp
   */
  readonly merchantVerifyLoginOtpRequest: MerchantVerifyLoginOtpRequest;
}

/**
 * MerchantAuthLoginApi - object-oriented interface
 * @export
 * @class MerchantAuthLoginApi
 * @extends {BaseAPI}
 */
export class MerchantAuthLoginApi extends BaseAPI {
  /**
   * Bước 1/3 quên mật khẩu. Anti-enumeration: trả 200 silent kể cả phone không tồn tại. Phát OTP 6 số TTL 5 phút qua email channel (D15). Rate limit 3 lần / 24h / phone.
   * @summary Yêu cầu OTP quên mật khẩu
   * @param {MerchantAuthLoginApiForgotPasswordRequestOtpRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MerchantAuthLoginApi
   */
  public forgotPasswordRequestOtp(
    requestParameters: MerchantAuthLoginApiForgotPasswordRequestOtpRequest,
    options?: AxiosRequestConfig,
  ) {
    return MerchantAuthLoginApiFp(this.configuration)
      .forgotPasswordRequestOtp(
        requestParameters.merchantForgotPasswordRequestOtpRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Bước 3/3. Atomic GETDEL resetSessionToken → Keycloak admin resetPassword. Password complexity check + confirm match check.
   * @summary Đặt lại mật khẩu
   * @param {MerchantAuthLoginApiForgotPasswordSubmitRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MerchantAuthLoginApi
   */
  public forgotPasswordSubmit(
    requestParameters: MerchantAuthLoginApiForgotPasswordSubmitRequest,
    options?: AxiosRequestConfig,
  ) {
    return MerchantAuthLoginApiFp(this.configuration)
      .forgotPasswordSubmit(
        requestParameters.merchantForgotPasswordSubmitRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Bước 2/3. Atomic GETDEL Redis OTP. Trả resetSessionToken (32-byte opaque base64url, TTL 5 phút, single-use) dùng cho bước 3 submit.
   * @summary Xác thực OTP quên mật khẩu
   * @param {MerchantAuthLoginApiForgotPasswordVerifyOtpRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MerchantAuthLoginApi
   */
  public forgotPasswordVerifyOtp(
    requestParameters: MerchantAuthLoginApiForgotPasswordVerifyOtpRequest,
    options?: AxiosRequestConfig,
  ) {
    return MerchantAuthLoginApiFp(this.configuration)
      .forgotPasswordVerifyOtp(
        requestParameters.merchantForgotPasswordVerifyOtpRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * merchant-auth-improvements 2026-05-12: 2-step login OTP per legacy neo-pay parity. Status PENDING_ACTIVATION → trả sessionToken + redirect /change-password (first-login). Status ACTIVE → verify password qua Keycloak grantToken → send SMS OTP (TTL 5min) → trả OTP_REQUIRED. Client gọi step 2 /v1/verify-otp với phone+password+otp để nhận token. LOCKED/SUSPENDED/DELETED → 423/403.
   * @summary Đăng nhập merchant portal (step 1 — gửi SMS OTP)
   * @param {MerchantAuthLoginApiLogin2Request} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MerchantAuthLoginApi
   */
  public login2(
    requestParameters: MerchantAuthLoginApiLogin2Request,
    options?: AxiosRequestConfig,
  ) {
    return MerchantAuthLoginApiFp(this.configuration)
      .login2(requestParameters.merchantLoginRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Revoke Keycloak session via refresh token. Fail-soft: Keycloak unavailable still returns success (client clears token regardless per spec §2.6 D27 resilience mandate).
   * @summary Đăng xuất
   * @param {MerchantAuthLoginApiLogout2Request} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MerchantAuthLoginApi
   */
  public logout2(
    requestParameters: MerchantAuthLoginApiLogout2Request,
    options?: AxiosRequestConfig,
  ) {
    return MerchantAuthLoginApiFp(this.configuration)
      .logout2(requestParameters.merchantLogoutRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * DEPRECATED — sunset Fri, 12 Jun 2026 00:00:00 GMT. Dùng 2-step flow /v1/me/change-password/verify + /submit để match legacy neo-pay parity. JWT-authenticated endpoint. User extracted từ Reactor SecurityContext (Member.id = keycloakUserId). Verify currentPassword qua Keycloak grantToken, reset to newPassword, revoke all sessions. Rate limit 5/15min per user. D19: NOT in SecurityConfig permitAll (JWT required).
   * @summary (DEPRECATED) Đổi mật khẩu self-service 1-step
   * @param {MerchantAuthLoginApiMeChangePasswordRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof MerchantAuthLoginApi
   */
  public meChangePassword(
    requestParameters: MerchantAuthLoginApiMeChangePasswordRequest,
    options?: AxiosRequestConfig,
  ) {
    return MerchantAuthLoginApiFp(this.configuration)
      .meChangePassword(
        requestParameters.merchantChangePasswordRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * merchant-auth-improvements 2026-05-12. JWT-authenticated. Atomic GETDEL Redis session → constant-time verify sessionId+token → newPassword==confirmNewPassword + complexity check → KC admin resetPassword + revoke all sessions (logout).
   * @summary Đổi mật khẩu self-service (step 2 — submit new password)
   * @param {MerchantAuthLoginApiMeChangePasswordSubmitRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MerchantAuthLoginApi
   */
  public meChangePasswordSubmit(
    requestParameters: MerchantAuthLoginApiMeChangePasswordSubmitRequest,
    options?: AxiosRequestConfig,
  ) {
    return MerchantAuthLoginApiFp(this.configuration)
      .meChangePasswordSubmit(
        requestParameters.merchantChangePasswordSubmitRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * merchant-auth-improvements 2026-05-12. JWT-authenticated. Verify currentPassword qua Keycloak grantToken → mint Redis sessionId+token (15min TTL, single-use GETDEL). Step 2 /submit dùng sessionId+token + newPassword.
   * @summary Đổi mật khẩu self-service (step 1 — verify current password)
   * @param {MerchantAuthLoginApiMeChangePasswordVerifyRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MerchantAuthLoginApi
   */
  public meChangePasswordVerify(
    requestParameters: MerchantAuthLoginApiMeChangePasswordVerifyRequest,
    options?: AxiosRequestConfig,
  ) {
    return MerchantAuthLoginApiFp(this.configuration)
      .meChangePasswordVerify(
        requestParameters.merchantChangePasswordVerifyRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * OAuth2 refresh_token grant via Keycloak realm ewallet_merchant. Returns new access + refresh pair.
   * @summary Refresh access token
   * @param {MerchantAuthLoginApiRefresh2Request} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MerchantAuthLoginApi
   */
  public refresh2(
    requestParameters: MerchantAuthLoginApiRefresh2Request,
    options?: AxiosRequestConfig,
  ) {
    return MerchantAuthLoginApiFp(this.configuration)
      .refresh2(requestParameters.merchantRefreshTokenRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * merchant-auth-improvements 2026-05-12. Phone-only. 60s cooldown (D4) + 4 sends per 20min (D5). Sinh OTP MỚI (không reuse) per legacy parity.
   * @summary Resend OTP đăng nhập merchant portal
   * @param {MerchantAuthLoginApiResendLoginOtp1Request} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MerchantAuthLoginApi
   */
  public resendLoginOtp1(
    requestParameters: MerchantAuthLoginApiResendLoginOtp1Request,
    options?: AxiosRequestConfig,
  ) {
    return MerchantAuthLoginApiFp(this.configuration)
      .resendLoginOtp1(requestParameters.merchantResendLoginOtpRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * merchant-auth-improvements 2026-05-12 step 2. Atomic GETDEL Redis OTP. Client re-supplies phone + password (D11) + OTP (6 số). Server verify OTP + re-grant Keycloak → trả token.
   * @summary Đăng nhập merchant portal (step 2 — verify OTP)
   * @param {MerchantAuthLoginApiVerifyLoginOtpRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MerchantAuthLoginApi
   */
  public verifyLoginOtp(
    requestParameters: MerchantAuthLoginApiVerifyLoginOtpRequest,
    options?: AxiosRequestConfig,
  ) {
    return MerchantAuthLoginApiFp(this.configuration)
      .verifyLoginOtp(requestParameters.merchantVerifyLoginOtpRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * MfaControllerApi - axios parameter creator
 * @export
 */
export const MfaControllerApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Enroll TOTP (Smart OTP). Requires PIN verification. 5 consecutive wrong PINs locks MFA enrollment for 30 minutes.
     * @summary Enroll MFA Method
     * @param {MfaEnrollRequest} mfaEnrollRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    enrollMfa: async (
      mfaEnrollRequest: MfaEnrollRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'mfaEnrollRequest' is not null or undefined
      assertParamExists("enrollMfa", "mfaEnrollRequest", mfaEnrollRequest);
      const localVarPath = `/api/v1/auth/2fa/enroll`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        mfaEnrollRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Resend SMS OTP during TOTP enrollment. Max 3 sends, 60s cooldown.
     * @summary Resend OTP for TOTP Enrollment
     * @param {MfaEnrollResendOtpRequest} mfaEnrollResendOtpRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resendEnrollOtp: async (
      mfaEnrollResendOtpRequest: MfaEnrollResendOtpRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'mfaEnrollResendOtpRequest' is not null or undefined
      assertParamExists(
        "resendEnrollOtp",
        "mfaEnrollResendOtpRequest",
        mfaEnrollResendOtpRequest,
      );
      const localVarPath = `/api/v1/auth/2fa/enroll/resend-otp`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        mfaEnrollResendOtpRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Submit OTP code to proceed with TOTP enrollment.
     * @summary Verify OTP for TOTP Enrollment
     * @param {MfaEnrollOtpRequest} mfaEnrollOtpRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    verifyEnrollOtp: async (
      mfaEnrollOtpRequest: MfaEnrollOtpRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'mfaEnrollOtpRequest' is not null or undefined
      assertParamExists(
        "verifyEnrollOtp",
        "mfaEnrollOtpRequest",
        mfaEnrollOtpRequest,
      );
      const localVarPath = `/api/v1/auth/2fa/enroll/verify-otp`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        mfaEnrollOtpRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Verify TOTP enrollment by submitting a valid TOTP code.
     * @summary Verify MFA Enrollment
     * @param {MfaVerifyRequest} mfaVerifyRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    verifyMfa: async (
      mfaVerifyRequest: MfaVerifyRequest,
      options: AxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'mfaVerifyRequest' is not null or undefined
      assertParamExists("verifyMfa", "mfaVerifyRequest", mfaVerifyRequest);
      const localVarPath = `/api/v1/auth/2fa/verify`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication userInfo required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "X-Userinfo",
        configuration,
      );

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        mfaVerifyRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * MfaControllerApi - functional programming interface
 * @export
 */
export const MfaControllerApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    MfaControllerApiAxiosParamCreator(configuration);
  return {
    /**
     * Enroll TOTP (Smart OTP). Requires PIN verification. 5 consecutive wrong PINs locks MFA enrollment for 30 minutes.
     * @summary Enroll MFA Method
     * @param {MfaEnrollRequest} mfaEnrollRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async enrollMfa(
      mfaEnrollRequest: MfaEnrollRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<MfaEnrollResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.enrollMfa(
        mfaEnrollRequest,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Resend SMS OTP during TOTP enrollment. Max 3 sends, 60s cooldown.
     * @summary Resend OTP for TOTP Enrollment
     * @param {MfaEnrollResendOtpRequest} mfaEnrollResendOtpRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async resendEnrollOtp(
      mfaEnrollResendOtpRequest: MfaEnrollResendOtpRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<MfaEnrollResendOtpResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.resendEnrollOtp(
        mfaEnrollResendOtpRequest,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Submit OTP code to proceed with TOTP enrollment.
     * @summary Verify OTP for TOTP Enrollment
     * @param {MfaEnrollOtpRequest} mfaEnrollOtpRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async verifyEnrollOtp(
      mfaEnrollOtpRequest: MfaEnrollOtpRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<MfaEnrollResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.verifyEnrollOtp(
        mfaEnrollOtpRequest,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
    /**
     * Verify TOTP enrollment by submitting a valid TOTP code.
     * @summary Verify MFA Enrollment
     * @param {MfaVerifyRequest} mfaVerifyRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async verifyMfa(
      mfaVerifyRequest: MfaVerifyRequest,
      options?: AxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<MfaEnrollVerifyResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.verifyMfa(
        mfaVerifyRequest,
        options,
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      );
    },
  };
};

/**
 * MfaControllerApi - factory interface
 * @export
 */
export const MfaControllerApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = MfaControllerApiFp(configuration);
  return {
    /**
     * Enroll TOTP (Smart OTP). Requires PIN verification. 5 consecutive wrong PINs locks MFA enrollment for 30 minutes.
     * @summary Enroll MFA Method
     * @param {MfaEnrollRequest} mfaEnrollRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    enrollMfa(
      mfaEnrollRequest: MfaEnrollRequest,
      options?: any,
    ): AxiosPromise<MfaEnrollResponse> {
      return localVarFp
        .enrollMfa(mfaEnrollRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Resend SMS OTP during TOTP enrollment. Max 3 sends, 60s cooldown.
     * @summary Resend OTP for TOTP Enrollment
     * @param {MfaEnrollResendOtpRequest} mfaEnrollResendOtpRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resendEnrollOtp(
      mfaEnrollResendOtpRequest: MfaEnrollResendOtpRequest,
      options?: any,
    ): AxiosPromise<MfaEnrollResendOtpResponse> {
      return localVarFp
        .resendEnrollOtp(mfaEnrollResendOtpRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Submit OTP code to proceed with TOTP enrollment.
     * @summary Verify OTP for TOTP Enrollment
     * @param {MfaEnrollOtpRequest} mfaEnrollOtpRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    verifyEnrollOtp(
      mfaEnrollOtpRequest: MfaEnrollOtpRequest,
      options?: any,
    ): AxiosPromise<MfaEnrollResponse> {
      return localVarFp
        .verifyEnrollOtp(mfaEnrollOtpRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Verify TOTP enrollment by submitting a valid TOTP code.
     * @summary Verify MFA Enrollment
     * @param {MfaVerifyRequest} mfaVerifyRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    verifyMfa(
      mfaVerifyRequest: MfaVerifyRequest,
      options?: any,
    ): AxiosPromise<MfaEnrollVerifyResponse> {
      return localVarFp
        .verifyMfa(mfaVerifyRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for enrollMfa operation in MfaControllerApi.
 * @export
 * @interface MfaControllerApiEnrollMfaRequest
 */
export interface MfaControllerApiEnrollMfaRequest {
  /**
   *
   * @type {MfaEnrollRequest}
   * @memberof MfaControllerApiEnrollMfa
   */
  readonly mfaEnrollRequest: MfaEnrollRequest;
}

/**
 * Request parameters for resendEnrollOtp operation in MfaControllerApi.
 * @export
 * @interface MfaControllerApiResendEnrollOtpRequest
 */
export interface MfaControllerApiResendEnrollOtpRequest {
  /**
   *
   * @type {MfaEnrollResendOtpRequest}
   * @memberof MfaControllerApiResendEnrollOtp
   */
  readonly mfaEnrollResendOtpRequest: MfaEnrollResendOtpRequest;
}

/**
 * Request parameters for verifyEnrollOtp operation in MfaControllerApi.
 * @export
 * @interface MfaControllerApiVerifyEnrollOtpRequest
 */
export interface MfaControllerApiVerifyEnrollOtpRequest {
  /**
   *
   * @type {MfaEnrollOtpRequest}
   * @memberof MfaControllerApiVerifyEnrollOtp
   */
  readonly mfaEnrollOtpRequest: MfaEnrollOtpRequest;
}

/**
 * Request parameters for verifyMfa operation in MfaControllerApi.
 * @export
 * @interface MfaControllerApiVerifyMfaRequest
 */
export interface MfaControllerApiVerifyMfaRequest {
  /**
   *
   * @type {MfaVerifyRequest}
   * @memberof MfaControllerApiVerifyMfa
   */
  readonly mfaVerifyRequest: MfaVerifyRequest;
}

/**
 * MfaControllerApi - object-oriented interface
 * @export
 * @class MfaControllerApi
 * @extends {BaseAPI}
 */
export class MfaControllerApi extends BaseAPI {
  /**
   * Enroll TOTP (Smart OTP). Requires PIN verification. 5 consecutive wrong PINs locks MFA enrollment for 30 minutes.
   * @summary Enroll MFA Method
   * @param {MfaControllerApiEnrollMfaRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MfaControllerApi
   */
  public enrollMfa(
    requestParameters: MfaControllerApiEnrollMfaRequest,
    options?: AxiosRequestConfig,
  ) {
    return MfaControllerApiFp(this.configuration)
      .enrollMfa(requestParameters.mfaEnrollRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Resend SMS OTP during TOTP enrollment. Max 3 sends, 60s cooldown.
   * @summary Resend OTP for TOTP Enrollment
   * @param {MfaControllerApiResendEnrollOtpRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MfaControllerApi
   */
  public resendEnrollOtp(
    requestParameters: MfaControllerApiResendEnrollOtpRequest,
    options?: AxiosRequestConfig,
  ) {
    return MfaControllerApiFp(this.configuration)
      .resendEnrollOtp(requestParameters.mfaEnrollResendOtpRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Submit OTP code to proceed with TOTP enrollment.
   * @summary Verify OTP for TOTP Enrollment
   * @param {MfaControllerApiVerifyEnrollOtpRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MfaControllerApi
   */
  public verifyEnrollOtp(
    requestParameters: MfaControllerApiVerifyEnrollOtpRequest,
    options?: AxiosRequestConfig,
  ) {
    return MfaControllerApiFp(this.configuration)
      .verifyEnrollOtp(requestParameters.mfaEnrollOtpRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Verify TOTP enrollment by submitting a valid TOTP code.
   * @summary Verify MFA Enrollment
   * @param {MfaControllerApiVerifyMfaRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MfaControllerApi
   */
  public verifyMfa(
    requestParameters: MfaControllerApiVerifyMfaRequest,
    options?: AxiosRequestConfig,
  ) {
    return MfaControllerApiFp(this.configuration)
      .verifyMfa(requestParameters.mfaVerifyRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
